(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/api-authorization/login-menu/login-menu.component.html":
/*!**********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/api-authorization/login-menu/login-menu.component.html ***!
  \**********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<ul class=\"navbar-nav ml-md-auto\" *ngIf=\"isAuthenticated | async\">\r\n  <li class=\"nav-item dropdown\">\r\n    <button class=\"btn btn-link nav-item nav-link mr-md-2\" (click)=\"openBrandPicker()\">\r\n      <span class=\"ion ion-ios-people\"></span> Brands\r\n    </button>\r\n  </li>\r\n  <li class=\"nav-item\">\r\n    <a class=\"nav-link text-dark\" [routerLink]='[\"/authentication/profile\"]' title=\"Manage\">Hello {{ userName | async }}</a>\r\n  </li>\r\n  <li class=\"nav-item\">\r\n    <a class=\"nav-link text-dark\" [routerLink]='[\"/authentication/logout\"]' [state]='{ local: true }' title=\"Logout\">Logout</a>\r\n  </li>\r\n</ul>\r\n\r\n<ul class=\"navbar-nav ml-md-auto\" *ngIf=\"!(isAuthenticated | async)\">\r\n  <!--<li class=\"nav-item\">\r\n    <a class=\"nav-link text-dark\" [routerLink]='[\"/authentication/register\"]'>Register</a>\r\n  </li>\r\n  -->\r\n  <li class=\"nav-item\">\r\n    <a class=\"nav-link text-dark\" [routerLink]='[\"/authentication/login\"]'>Login</a>\r\n  </li>\r\n</ul>\r\n \r\n<!--\r\n\r\n<ul class=\"navbar-nav ml-md-auto\">\r\n  <li class=\"nav-item dropdown\">\r\n    <a class=\"nav-item nav-link dropdown-toggle mr-md-2\" href=\"#selectBrandModal\" data-toggle=\"modal\" id=\"brands-select\" aria-haspopup=\"true\" aria-expanded=\"false\">\r\n      <span class=\"ion ion-ios-people\"></span> Brands\r\n    </a>\r\n  </li>\r\n  <li class=\"nav-item dropdown\">\r\n    <a class=\"nav-item nav-link dropdown-toggle mr-md-2\" href=\"#\" id=\"bd-versions\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\r\n      <span class=\"ion ion-ios-settings\"></span> Account\r\n    </a>\r\n    <div class=\"dropdown-menu dropdown-menu-md-right\" aria-labelledby=\"bd-versions\">\r\n      <a class=\"dropdown-item\" href=\"#\">Change Password</a>\r\n      <a class=\"dropdown-item\" href=\"/\">Logout</a>\r\n    </div>\r\n  </li>\r\n</ul>-->\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/api-authorization/login/login.component.html":
/*!************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/api-authorization/login/login.component.html ***!
  \************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>{{ message | async }}</p>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/api-authorization/logout/logout.component.html":
/*!**************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/api-authorization/logout/logout.component.html ***!
  \**************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p>{{ message | async }}</p>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<app-nav-menu></app-nav-menu>\r\n  \r\n<div class=\"container\">\r\n  <main role=\"main\" class=\"pb-3\">\r\n    <router-outlet></router-outlet>\r\n  </main>\r\n</div>\r\n\r\n<footer class=\"footer text-center\">\r\n  <div class=\"container py-5\">\r\n    <p>&copy; {{year}} OptiPort. All rights reserved.</p>\r\n  </div>\r\n</footer> \r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/billing/billing.component.html":
/*!*************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/billing/billing.component.html ***!
  \*************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\r\n<div class=\"py-3\">\r\n\r\n    <h1 class=\"mb-4\">Billing</h1>\r\n \r\n\r\n    <div class=\"row mb-3\">\r\n      <div class=\"col-sm-12\">\r\n\r\n        \r\n      </div>  \r\n    </div>\r\n\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/brand-details/brand-details.component.html":
/*!*************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/brand-details/brand-details.component.html ***!
  \*************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"py-3\" *ngIf=\"brand\">\r\n\r\n    <h1>{{brand.name}}</h1>\r\n    <p *ngIf=\"brand.brandId == 0\" class=\"lead mt-0 mb-4\"><span class=\"text-muted\">(Master)</span></p>\r\n    <!-- header actions -->\r\n    <div class=\"row mb-4\">\r\n      <div class=\"col justify-content-md-end\">\r\n        <a [routerLink]=\"['/brands']\" class=\"mr-3 btn btn-secondary btn-sm\">All brands</a>\r\n        <a *ngIf=\"brand.brandId > 0\" href=\"/brand/{{brand.brandId}}\" class=\"btn btn-secondary btn-sm\">Parent Brand</a>\r\n      </div>\r\n    </div>\r\n    <!-- end header actions -->\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-sm-12 mb-4\">\r\n\r\n        <!-- tabs -->\r\n        <div class=\"card tab-card\">\r\n          <div class=\"card-header tab-card-header\">\r\n            <ul class=\"nav nav-tabs card-header-tabs\" id=\"myTab\" role=\"tablist\">\r\n              <li class=\"nav-item\">\r\n                <a class=\"nav-link active\" id=\"brand-tab\" data-toggle=\"tab\" href=\"#brandaccount\" role=\"tab\" aria-controls=\"member\" aria-selected=\"true\">Brand</a>\r\n              </li>\r\n              <li class=\"nav-item {{brand.brandId > 0 ? 'd-none' : ''}}\">\r\n                <a class=\"nav-link\" id=\"subrands-tab\" data-toggle=\"tab\" href=\"#subbrands\" role=\"tab\" aria-controls=\"subbrands\" aria-selected=\"false\">Sub Brands</a>\r\n              </li>\r\n              <li class=\"nav-item\">\r\n                <a class=\"nav-link\" id=\"offermatrix-tab\" data-toggle=\"tab\" href=\"#offermatrix\" role=\"tab\" aria-controls=\"offermatrix\" aria-selected=\"false\">Offer Matrix</a>\r\n              </li>\r\n              <li class=\"nav-item\">\r\n                <a class=\"nav-link\" id=\"mastermatrix-tab\" data-toggle=\"tab\" href=\"#mastermatrix\" role=\"tab\" aria-controls=\"mastermatrix\" aria-selected=\"false\">Master Matrix</a>\r\n              </li>\r\n              <li class=\"nav-item\">\r\n                <a class=\"nav-link\" id=\"overriderules-tab\" data-toggle=\"tab\" href=\"#overriderules\" role=\"tab\" aria-controls=\"overriderules\" aria-selected=\"false\">Override Rules</a>\r\n              </li>\r\n              <li class=\"nav-item\">\r\n                <a class=\"nav-link\" id=\"locations-tab\" data-toggle=\"tab\" href=\"#locations\" role=\"tab\" aria-controls=\"locations\" aria-selected=\"false\">Locations</a>\r\n              </li>\r\n              <li class=\"nav-item\">\r\n                <a class=\"nav-link\" id=\"locationoverrides-tab\" data-toggle=\"tab\" href=\"#locationoverrides\" role=\"tab\" aria-controls=\"locationoverrides\" aria-selected=\"false\">Location Overrides</a>\r\n              </li>\r\n              <li class=\"nav-item\">\r\n                <a class=\"nav-link\" id=\"monthconversions-tab\" data-toggle=\"tab\" href=\"#monthconversions\" role=\"tab\" aria-controls=\"monthconversions\" aria-selected=\"false\">Month Conversions</a>\r\n              </li>\r\n              <li class=\"nav-item\">\r\n                <a class=\"nav-link\" id=\"seeds-tab\" data-toggle=\"tab\" href=\"#seeds\" role=\"tab\" aria-controls=\"locations\" aria-selected=\"false\">Seeds</a>\r\n              </li>\r\n              <li class=\"nav-item\">\r\n                <a class=\"nav-link\" id=\"notes-tab\" data-toggle=\"tab\" href=\"#notes\" role=\"tab\" aria-controls=\"notes\" aria-selected=\"false\">Notes</a>\r\n              </li>\r\n            </ul>\r\n          </div>\r\n          <div class=\"tab-content\" id=\"myTabContent\">\r\n\r\n            <!-- brand account tab -->\r\n\r\n            <div class=\"tab-pane fade show active p-3\" id=\"brandaccount\" role=\"tabpanel\" aria-labelledby=\"brand-tab\">\r\n\r\n\r\n              <form [formGroup]=\"editBrandForm\" (ngSubmit)=\"updateBrand()\" *ngIf=\"brand\">\r\n                <div class=\"row\">\r\n                  <div class=\"col-12 col-md-6\">\r\n                    <h5 class=\"card-title\">Brand</h5>\r\n                  </div>\r\n                  <div class=\"col-12 col-md-6 text-right\">\r\n                    <div class=\"form-group\">\r\n                      <input type=\"checkbox\" id=\"isActive\" name=\"isActive\" class=\"tgl tgl-light\" [attr.checked]=\"editBrandForm.controls.isActive\" formControlName=\"isActive\" [ngClass]=\"{'is-invalid': editBrandFormSubmitted && editBrandForm.controls.isActive.errors}\" />\r\n                      <label class=\"tgl-btn\" for=\"isActive\"></label>  Account active\r\n                      <div *ngIf=\"editBrandFormSubmitted && editBrandForm.controls.isActive.errors\" class=\"invalid-feedback\">\r\n                        <div *ngIf=\"editBrandForm.controls.isActive.errors.required\">Is Active is required</div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"row\">\r\n                  <div class=\"col-12 col-md-6\">\r\n\r\n                    <div class=\"form-group\">\r\n                      <label>Practice Name <span class=\"text-danger\">*</span></label>\r\n                      <input type=\"text\" class=\"form-control\" formControlName=\"name\" [ngClass]=\"{ 'is-invalid': editBrandFormSubmitted &&  editBrandForm.controls.name.errors}\" />\r\n                      <div *ngIf=\"editBrandFormSubmitted && editBrandForm.controls.name.errors\" class=\"invalid-feedback\">\r\n                        <div *ngIf=\"editBrandForm.controls.name.errors.required\">Name is required</div>\r\n                      </div>\r\n                    </div>\r\n\r\n                    <div class=\"form-group\">\r\n\r\n\r\n                      <div class=\"row\">\r\n                        <div class=\"col\">\r\n                          <label>Contact First Name</label>\r\n                          <input type=\"text\" class=\"form-control\" formControlName=\"firstName\" [ngClass]=\"{ 'is-invalid': editBrandFormSubmitted &&  editBrandForm.controls.firstName.errors}\" />\r\n                          <div *ngIf=\"editBrandFormSubmitted && editBrandForm.controls.firstName.errors\" class=\"invalid-feedback\">\r\n                            <div *ngIf=\"editBrandForm.controls.firstName.errors.required\">First name is required</div>\r\n                          </div>\r\n                        </div>\r\n                        <div class=\"col\">\r\n                          <label>Contact Last Name</label>\r\n                          <input type=\"text\" class=\"form-control\" formControlName=\"lastName\" [ngClass]=\"{ 'is-invalid': editBrandFormSubmitted &&  editBrandForm.controls.lastName.errors}\" />\r\n                          <div *ngIf=\"editBrandFormSubmitted && editBrandForm.controls.lastName.errors\" class=\"invalid-feedback\">\r\n                            <div *ngIf=\"editBrandForm.controls.lastName.errors.required\">Last name is required</div>\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n\r\n                    <div class=\"form-group\">\r\n                      <label>Address</label>\r\n                      <input type=\"text\" class=\"form-control\" formControlName=\"address1\" [ngClass]=\"{ 'is-invalid': editBrandFormSubmitted &&  editBrandForm.controls.address1.errors}\" />\r\n                      <div *ngIf=\"editBrandFormSubmitted && editBrandForm.controls.address1.errors\" class=\"invalid-feedback\">\r\n                        <div *ngIf=\"editBrandForm.controls.address1.errors.required\">Address is required</div>\r\n                      </div>\r\n                    </div>\r\n\r\n                    <div class=\"form-group\">\r\n                      <label>Address 2</label>\r\n                      <input type=\"text\" class=\"form-control\" formControlName=\"address2\" [ngClass]=\"{ 'is-invalid': editBrandFormSubmitted &&  editBrandForm.controls.address2.errors}\" />\r\n                      <div *ngIf=\"editBrandFormSubmitted && editBrandForm.controls.address2.errors\" class=\"invalid-feedback\">\r\n                        <div *ngIf=\"editBrandForm.controls.address2.errors.required\">Address 2 is required</div>\r\n                      </div>\r\n                    </div>\r\n\r\n                    <div class=\"row\">\r\n                      <div class=\"col-sm-5\">\r\n                        <div class=\"form-group\">\r\n                          <label>City</label>\r\n                          <input type=\"text\" class=\"form-control\" formControlName=\"city\" [ngClass]=\"{ 'is-invalid': editBrandFormSubmitted &&  editBrandForm.controls.city.errors}\" />\r\n                          <div *ngIf=\"editBrandFormSubmitted && editBrandForm.controls.city.errors\" class=\"invalid-feedback\">\r\n                            <div *ngIf=\"editBrandForm.controls.city.errors.required\">City is required</div>\r\n                            <div *ngIf=\"editBrandForm.controls.city.errors.alphaNumericSpecialCharacters\">City contains invalid characters</div>\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                      <div class=\"col-sm-4\">\r\n                        <div class=\"form-group\">\r\n                          <label>State</label>\r\n                          <select formControlName=\"state\" class=\"form-control\" [ngClass]=\"{'is-invalid': editBrandFormSubmitted &&  editBrandForm.controls.state.errors}\">\r\n                            <option [value]=\"\">Choose...</option>\r\n                            <option *ngFor=\"let state of stateList\" [value]=\"state.abbreviation\">{{state.abbreviation}}</option>\r\n                          </select>\r\n                          <div *ngIf=\"editBrandFormSubmitted && editBrandForm.controls.state.errors\" class=\"invalid-feedback\">\r\n                            <div *ngIf=\"editBrandForm.controls.state.errors.required\">State is required</div>\r\n                          </div>\r\n                        </div>\r\n\r\n                      </div>\r\n                      <div class=\"col-sm-3\">\r\n                        <div class=\"form-group\">\r\n                          <label>Zip Code</label>\r\n                          <input type=\"text\" class=\"form-control\" formControlName=\"zipCode\" [ngClass]=\"{'is-invalid': editBrandFormSubmitted &&  editBrandForm.controls.zipCode.errors}\" />\r\n                          <div *ngIf=\"editBrandFormSubmitted && editBrandForm.controls.zipCode.errors\" class=\"invalid-feedback\">\r\n                            <div *ngIf=\"editBrandForm.controls.zipCode.errors.required\">Zip Code is required</div>\r\n                            <div *ngIf=\"editBrandForm.controls.zipCode.errors.zipCode\">Zip Code must be five digits</div>\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n\r\n                    <div class=\"form-group\">\r\n                      <label>Email</label>\r\n                      <input type=\"text\" class=\"form-control\" formControlName=\"email\" [ngClass]=\"{'is-invalid': editBrandFormSubmitted && editBrandForm.controls.email.errors}\" />\r\n                      <div *ngIf=\"editBrandFormSubmitted && editBrandForm.controls.email.errors\" class=\"invalid-feedback\">\r\n                        <div *ngIf=\"editBrandForm.controls.email.errors.required\">Email is required</div>\r\n                        <div *ngIf=\"editBrandForm.controls.email.errors.email\">Email is invalid</div>\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"form-group\">\r\n                      <label>Phone</label>\r\n                      <input type=\"text\" class=\"form-control\" placeholder=\"000-000-0000\" formControlName=\"phone\" [ngClass]=\"{'is-invalid': editBrandFormSubmitted && editBrandForm.controls.phone.errors}\" />\r\n                      <div *ngIf=\"editBrandFormSubmitted && editBrandForm.controls.phone.errors\" class=\"invalid-feedback\">\r\n                        <div *ngIf=\"editBrandForm.controls.phone.errors.required\">Phone is required</div>\r\n                        <div *ngIf=\"editBrandForm.controls.phone.errors.phone\">Phone is invalid</div>\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"form-group\">\r\n                      <label>URL</label>\r\n                      <input type=\"text\" class=\"form-control\" formControlName=\"url\" [ngClass]=\"{'is-invalid': editBrandFormSubmitted && editBrandForm.controls.url.errors}\" />\r\n                      <div *ngIf=\"editBrandFormSubmitted && editBrandForm.controls.url.errors\" class=\"invalid-feedback\">\r\n                        <div *ngIf=\"editBrandForm.controls.url.errors.required\">Url is required</div>\r\n                        <div *ngIf=\"editBrandForm.controls.url.errors.url\">Url format is invalid</div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n\r\n                  <div class=\"col-12 col-md-6\">\r\n\r\n                    <div class=\"form-group\">\r\n                      <label>Start Date <span class=\"text-danger\">*</span></label>\r\n                      <div class=\"input-group date\">\r\n                        <input class=\"form-control\" [matDatepicker]=\"startDatePicker\" placeholder=\"mm/dd/yyyy\" formControlName=\"startDate\" (dateChange)=\"formatDate($event, 'startDate')\" [ngClass]=\"{'is-invalid': editBrandFormSubmitted && editBrandForm.controls.startDate.errors}\">\r\n                        <mat-datepicker #startDatePicker></mat-datepicker>\r\n\r\n                        <div class=\"input-group-append input-group-addon\">\r\n                          <button class=\"btn btn-outline-secondary calendar\" (focus)=\"startDatePicker.open()\" type=\"button\"><span class=\"ion ion-md-calendar\"></span></button>\r\n                        </div>\r\n\r\n                        <div *ngIf=\"editBrandFormSubmitted && editBrandForm.controls.startDate.errors\" class=\"invalid-feedback\">\r\n                          <div *ngIf=\"editBrandForm.controls.startDate.errors.required\">Start Date is required</div>\r\n                          <div *ngIf=\"editBrandForm.controls.startDate.errors.date\">Start Date is invalid</div>\r\n                        </div>\r\n\r\n                      </div>\r\n                    </div>\r\n                    <!--\r\n          <div class=\"form-group\">\r\n            <label>Start Date</label>\r\n            <div class=\"input-group date\">\r\n              <input type=\"date\" class=\"form-control calendar\" placeholder=\"yyyy-mm-dd\" value=\"{{editBrandForm.controls.startDate.value | date:'yyyy-MM-dd'}}\" formControlName=\"startDate\" [ngClass]=\"{'is-invalid': editBrandFormSubmitted && editBrandForm.controls.startDate.errors}\">\r\n\r\n              <div *ngIf=\"editBrandFormSubmitted && editBrandForm.controls.startDate.errors\" class=\"invalid-feedback\">\r\n                <div *ngIf=\"editBrandForm.controls.startDate.errors.required\">Start Date is required</div>\r\n              </div>\r\n\r\n            </div>\r\n          </div>-->\r\n\r\n                    <div class=\"form-group\">\r\n                      <label>Practice Management</label>\r\n                      <input type=\"text\" class=\"form-control\" formControlName=\"management\" [ngClass]=\"{'is-invalid': editBrandFormSubmitted && editBrandForm.controls.management.errors}\" />\r\n                      <div *ngIf=\"editBrandFormSubmitted && editBrandForm.controls.management.errors\" class=\"invalid-feedback\">\r\n                        <div *ngIf=\"editBrandForm.controls.management.errors.required\">Practice Management is required</div>\r\n                      </div>\r\n                    </div>\r\n\r\n                    <div class=\"form-group\">\r\n                      <label>Parent Brand <span class=\"text-danger\">*</span></label>\r\n                      <select formControlName=\"brandId\" class=\"form-control\" [ngClass]=\"{'is-invalid': editBrandFormSubmitted &&  editBrandForm.controls.brandId.errors}\">\r\n                        <option value=\"0\">Choose...</option>\r\n                        <option *ngFor=\"let parentbrand of parentBrands;\" [value]=\"parentbrand.id\">{{parentbrand.name}}</option>\r\n                      </select>\r\n                      <div *ngIf=\"editBrandFormSubmitted && editBrandForm.controls.brandId.errors\" class=\"invalid-feedback\">\r\n                        <div *ngIf=\"editBrandForm.controls.brandId.errors.required\">Parent Brand is required</div>\r\n                      </div>\r\n                    </div>\r\n\r\n                    <div class=\"form-group\">\r\n                      <label>Template # <span class=\"text-danger\">*</span></label>\r\n                      <select class=\"form-control\" formControlName=\"templateId\" name=\"templateId\" id=\"templateId\">\r\n                        <option value=\"0\">Choose...</option>\r\n                        <option *ngFor=\"let template of templates;\" [value]=\"template.id\">{{template.name}}</option>\r\n                      </select>\r\n                      <div *ngIf=\"editBrandFormSubmitted && editBrandForm.controls.templateId.errors\" class=\"invalid-feedback\">\r\n                        <div *ngIf=\"editBrandForm.controls.templateId.errors.required\">Practice Management is required</div>\r\n                      </div>\r\n                    </div>\r\n\r\n                  </div>\r\n                </div>\r\n                <div class=\"text-right m-3\">\r\n                  <button type=\"submit\" class=\"btn btn-primary\">Save Changes</button>\r\n                  <div class=\"text-success\">{{msg}}</div>\r\n                </div>\r\n              </form>\r\n            </div>\r\n\r\n            <!-- matrix -->\r\n            <div class=\"tab-pane fade p-3\" id=\"offermatrix\" role=\"tabpanel\" aria-labelledby=\"offermatrix-tab\">\r\n              <h5 class=\"card-title\">Offer Matrix</h5>\r\n              <p class=\"card-text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc venenatis venenatis leo, non porttitor metus euismod id. Morbi nec augue elit. Proin pulvinar ex eu facilisis dignissim.</p>\r\n            </div>\r\n            <div class=\"tab-pane fade p-3\" id=\"mastermatrix\" role=\"tabpanel\" aria-labelledby=\"mastermatrix-tab\">\r\n              <app-matrix [id]=\"brand.id\"></app-matrix>\r\n            </div>\r\n\r\n            <!-- subbrands -->\r\n            <div class=\"tab-pane fade p-3\" id=\"subbrands\" role=\"tabpanel\" aria-labelledby=\"subbrands-tab\">\r\n              <app-subbrands [id]=\"brand.id\"></app-subbrands>\r\n            </div>\r\n\r\n            <!-- locations tab -->\r\n            <div class=\"tab-pane fade p-3\" id=\"locations\" role=\"tabpanel\" aria-labelledby=\"locations-tab\">\r\n              <app-locations [id]=\"brand.id\"></app-locations>\r\n            </div>\r\n            <!-- end locations tab -->\r\n            <!-- location overrides tab -->\r\n            <div class=\"tab-pane fade p-3\" id=\"locationoverrides\" role=\"tabpanel\" aria-labelledby=\"locationoverrides-tab\">\r\n              <app-location-overrides [id]=\"brand.id\"></app-location-overrides>\r\n            </div>\r\n            <!-- end locations tab -->\r\n\r\n            <!-- override rules tab -->\r\n            <div class=\"tab-pane fade p-3\" id=\"overriderules\" role=\"tabpanel\" aria-labelledby=\"overriderules-tab\">\r\n              <app-overriderules [id]=\"brand.id\"></app-overriderules>\r\n            </div>\r\n            <!-- end override rules tab -->\r\n\r\n            <!-- seeds tab -->\r\n            <div class=\"tab-pane fade p-3\" id=\"seeds\" role=\"tabpanel\" aria-labelledby=\"seeds-tab\">\r\n              <app-brand-seeds [id]=\"brand.id\"></app-brand-seeds>\r\n            </div>\r\n            <!-- end seeds tab -->\r\n\r\n            <!-- month conversions tab -->\r\n            <div class=\"tab-pane fade p-3\" id=\"monthconversions\" role=\"tabpanel\" aria-labelledby=\"monthconversions-tab\">\r\n              <app-month-conversions [id]=\"brand.id\"></app-month-conversions>\r\n            </div>\r\n            <!-- end month conversions tab -->\r\n\r\n            <!-- notes tab -->\r\n            <div class=\"tab-pane fade p-3\" id=\"notes\" role=\"tabpanel\" aria-labelledby=\"notes-tab\">\r\n              <!-- heading -->\r\n              <h5 class=\"card-title\">Notes</h5>\r\n              <app-notes [contentId]=\"brand.id\" [contentType]=\"0\" ></app-notes>\r\n            </div>\r\n            <!-- end notes tab -->\r\n\r\n          </div>\r\n        </div>\r\n        <!-- end tabs -->\r\n\r\n      </div> \r\n    </div> \r\n</div>\r\n\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/brand-seeds/brand-seeds.component.html":
/*!*********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/brand-seeds/brand-seeds.component.html ***!
  \*********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- heading -->\r\n<h5 class=\"card-title\">Seeds</h5>\r\n\r\n<!-- filter -->\r\n<div class=\"input-group mb-3\">\r\n  <input type=\"text\" class=\"form-control\" (keyup)=\"applyFilter($event)\" placeholder=\"Search records...\">\r\n</div>\r\n<!-- end filter -->\r\n<div class=\"row\">\r\n  <div class=\"col\">\r\n    <table mat-table matSort [dataSource]=\"dataSource\" class=\"small table-striped\">\r\n\r\n      <!-- actions -->\r\n      <ng-container matColumnDef=\"actions\">\r\n        <th *matHeaderCellDef class=\"text-left\">Action</th>\r\n        <td *matCellDef=\"let item\" class=\"left\">\r\n          <!-- mailing more settings -->\r\n          <div class=\"float-left rounded-0 ml-2\">\r\n            <button class=\"btn text-dark btn-sm py-0\" type=\"button\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\r\n              <span class=\"ion ion-md-more\"></span>\r\n            </button>\r\n            <div class=\"dropdown-menu small\">\r\n              <a href=\"javascript:void(0)\" class=\"dropdown-item btn btn-sm\" (click)=\"editItem(item)\" data-toggle=\"modal\" title=\"Edit\"><span class=\"ion ion-md-create\"></span> Edit</a>\r\n              <a href=\"javascript:void(0)\" class=\"dropdown-item btn btn-sm\" (click)=\"copyItem(item)\" title=\"Copy\"><span class=\"ion ion-md-copy\"></span> Copy</a>\r\n              <a href=\"javascript:void(0)\" class=\"dropdown-item btn btn-sm\" (click)=\"deleteItem(item.id)\" title=\"Delete\"><span class=\"ion ion-md-trash\"></span> Delete</a>\r\n            </div>\r\n          </div>\r\n\r\n        </td>\r\n      </ng-container>\r\n\r\n\r\n      <!-- id Column -->\r\n      <ng-container matColumnDef=\"id\">\r\n        <th mat-header-cell *matHeaderCellDef mat-sort-header>Id </th>\r\n        <td mat-cell *matCellDef=\"let item\">{{item.id}}</td>\r\n      </ng-container>\r\n\r\n      <!-- patient id Column -->\r\n      <ng-container matColumnDef=\"patientId\">\r\n        <th mat-header-cell *matHeaderCellDef mat-sort-header>Patient Id </th>\r\n        <td mat-cell *matCellDef=\"let item\">{{item.patientId}}</td>\r\n      </ng-container>\r\n\r\n\r\n      <!-- patient name Column -->\r\n      <ng-container matColumnDef=\"fullName\">\r\n        <th mat-header-cell *matHeaderCellDef>Patient name</th>\r\n        <td mat-cell *matCellDef=\"let item\"> {{item.firstName}} {{item.lastName}} </td>\r\n      </ng-container>\r\n\r\n      <!-- patient dob Column -->\r\n      <ng-container matColumnDef=\"dateOfBirth\">\r\n        <th mat-header-cell *matHeaderCellDef>DOB</th>\r\n        <td mat-cell *matCellDef=\"let item\"> {{item.dateOfBirth | date: 'MM/dd/yyyy'}} </td>\r\n      </ng-container>\r\n\r\n      <!-- patient gender Column -->\r\n      <ng-container matColumnDef=\"gender\">\r\n        <th mat-header-cell *matHeaderCellDef>Gender</th>\r\n        <td mat-cell *matCellDef=\"let item\"> {{item.gender}} </td>\r\n      </ng-container>\r\n\r\n      <!-- last exam date Column -->\r\n      <!--<ng-container matColumnDef=\"lastExamDate\">\r\n        <th mat-header-cell *matHeaderCellDef>Last exam date</th>\r\n        <td mat-cell *matCellDef=\"let item\"> {{item.lastExamDate | date: 'MM/dd/yyyy'}} </td>\r\n      </ng-container>-->\r\n\r\n      <!-- months Column -->\r\n      <ng-container matColumnDef=\"months\">\r\n        <th mat-header-cell *matHeaderCellDef>Months since last exam</th>\r\n        <td mat-cell *matCellDef=\"let item\"> {{item.months}} </td>\r\n      </ng-container>\r\n\r\n\r\n\r\n      <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n      <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\"></tr>\r\n\r\n    </table>\r\n\r\n    <mat-paginator [length]=\"length\"\r\n                   [pageSize]=\"pageSize\"\r\n                   [pageSizeOptions]=\"pageSizeOptions\">\r\n    </mat-paginator>\r\n  </div>\r\n</div>\r\n\r\n<!-- footer actions -->\r\n<div class=\"row mb-3\">\r\n  <div class=\"col justify-content-md-end text-right\">\r\n    <button class=\"btn btn-primary\" (click)=\"openAddModal()\">Add Seed</button>\r\n  </div>\r\n</div>\r\n<!-- end footer actions -->\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/brands/brands.component.html":
/*!***********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/brands/brands.component.html ***!
  \***********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<p *ngIf=\"!dataSource.data\"><em>Loading...</em></p>\r\n \r\n<div class=\"py-3\">\r\n  <h1 id=\"tableBrands\">Brands</h1>\r\n\r\n  <!-- header actions -->\r\n  <div class=\"row mb-3\">\r\n    <div class=\"col justify-content-md-end text-right\">\r\n      <button class=\"btn btn-primary\" data-toggle=\"modal\" data-target=\"#addBrandModal\">Add Brand</button>\r\n    </div>\r\n  </div>\r\n  <!-- end header actions -->\r\n\r\n  <div class=\"row mb-4\">\r\n    <div class=\"col-sm-12\">\r\n\r\n      <div class=\"input-group mb-3\">\r\n        <input type=\"text\" class=\"form-control\" (keyup)=\"applyFilter($event)\" placeholder=\"Search brands by name...\" aria-label=\"Enter location name\" aria-describedby=\"button-addon2\">\r\n      </div>\r\n\r\n      <div class=\"card\">\r\n        <div class=\"card-header\">\r\n          Brand Profiles\r\n          <div class=\"float-right ml-2\">\r\n            <div class=\"form-group text-right\">\r\n              <input type=\"checkbox\" id=\"showInactive\" (click)=\"showInactive($event)\" name=\"showInactive\" class=\"tgl tgl-light\" />\r\n              <label class=\"tgl-btn\" for=\"showInactive\"></label> Show Inactive\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n       \r\n\r\n        <div class=\"card-body\">\r\n           \r\n          <table mat-table matSort [dataSource]=\"dataSource\" class=\"small table-striped\">\r\n\r\n            <!-- Name Column -->\r\n            <ng-container matColumnDef=\"name\">\r\n              <th *matHeaderCellDef mat-sort-header>Name</th>\r\n              <td mat-cell *matCellDef=\"let brand\"><a class=\"btn btn-link\" [routerLink]=\"['/brand', brand.id]\">{{brand.name}}</a> <span class=\"badge text-light badge-info ml-1\" *ngIf=\"brand.brandId == 0\">Master</span></td>\r\n            </ng-container>\r\n\r\n            <!-- template id Column -->\r\n            <ng-container matColumnDef=\"templateId\">\r\n              <th *matHeaderCellDef> Template Id</th>\r\n              <td mat-cell *matCellDef=\"let brand\"> {{brand.templateId}} </td>\r\n            </ng-container>\r\n\r\n            <!-- is master Column -->\r\n            <ng-container matColumnDef=\"brandId\">\r\n              <th *matHeaderCellDef mat-sort-header>Is Master </th>\r\n              <td mat-cell *matCellDef=\"let brand\"> {{brand.brandId == 0 | yesNo}} </td>\r\n            </ng-container>\r\n\r\n            <!-- template id Column -->\r\n            <ng-container matColumnDef=\"brandsCount\">\r\n              <th *matHeaderCellDef> # of Brands</th>\r\n              <td mat-cell *matCellDef=\"let brand\"> {{brand.brandsCount}} </td>\r\n            </ng-container>\r\n\r\n            <!-- template id Column -->\r\n            <ng-container matColumnDef=\"locationsNo\">\r\n              <th *matHeaderCellDef> # of Locations</th>\r\n              <td mat-cell *matCellDef=\"let brand\"> {{brand.locationsCount}} </td>\r\n            </ng-container>\r\n\r\n            <!-- start date Column -->\r\n            <ng-container matColumnDef=\"startDate\">\r\n              <th *matHeaderCellDef mat-sort-header>Member Since</th>\r\n              <td mat-cell *matCellDef=\"let brand\"> {{brand.startDate | date: 'yyyy'}} </td>\r\n            </ng-container>\r\n\r\n            <!-- is master Column -->\r\n            <!--<ng-container matColumnDef=\"isActive\">\r\n        <th *matHeaderCellDef mat-sort-header>Is Active?</th>\r\n        <td mat-cell *matCellDef=\"let brand\"> {{brand.isActive | yesNo}} </td>\r\n      </ng-container>-->\r\n\r\n            <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n            <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\"></tr>\r\n\r\n          </table>\r\n\r\n          <mat-paginator [length]=\"length\"\r\n                         [pageSize]=\"pageSize\"\r\n                         [pageSizeOptions]=\"pageSizeOptions\"\r\n                         (page)=\"pageEvent = $event\">\r\n          </mat-paginator>\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n \r\n\r\n<!-- add Brand Modal -->\r\n<div class=\"modal fade\" id=\"addBrandModal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\r\n  <div class=\"modal-dialog\" role=\"document\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <h5 class=\"modal-title\">Add a Brand</h5>\r\n        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-labbtn-primaryel=\"Close\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <div class=\"form-group\">\r\n          <label>Brand name <span class=\"text-danger\">*</span></label>\r\n          <input class=\"form-control\" #brandName required />  \r\n        </div>\r\n      </div>\r\n      <div class=\"modal-footer\">\r\n        <button type=\"button\" class=\"btn btn-outline-primary\" data-dismiss=\"modal\">Cancel</button>\r\n        <button class=\"btn btn-primary\" (click)=\"add(brandName.value); brandName.value=''\">\r\n          Submit\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<!-- end add Brand Modal-->\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/dashboard/dashboard.component.html":
/*!*****************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/dashboard/dashboard.component.html ***!
  \*****************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"py-3\">\r\n\r\n  <h1>Dashboard</h1>\r\n\r\n\r\n  <div class=\"row mb-4\">\r\n\r\n    <!-- top brands added -->\r\n    <div class=\"col-sm-6\">\r\n\r\n      <div class=\"card\">\r\n        <div class=\"card-header bg-primary\">Most Recent Brands</div>\r\n        <div class=\"card-body\">\r\n          <table class=\"mb-0 table-striped small mat-table\">\r\n            <thead role=\"rowgroup\">\r\n              <tr class=\"mat-header-row\" role=\"row\">\r\n                <th>Name</th>\r\n                <th># of Locations</th>\r\n                <th>Date Created</th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <tr class=\"mat-row\" *ngFor=\"let brand of brands\">\r\n                <td class=\"mat-cell cdk-column-description mat-column-description\">\r\n                  <strong><a href=\"/brand/{{brand.id}}\">{{brand.name}} <span class=\"badge text-light badge-info ml-1\">{{brand.brandId == 0 ? 'Master' : ''}}</span></a></strong>\r\n                </td>\r\n                <td class=\"mat-cell cdk-column-description mat-column-description\">{{brand.locationsCount}}</td>\r\n                <td class=\"mat-cell cdk-column-description mat-column-description\">{{brand.createDate | date: 'MM/dd/yyyy'}}</td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n    <!-- end top brands added -->\r\n    <!-- top mailings added -->\r\n    <div class=\"col-sm-6\">\r\n\r\n      <div class=\"card\">\r\n        <div class=\"card-header bg-info\">Most Recent Mailings</div>\r\n        <div class=\"card-body\">\r\n          <table class=\"mb-0 table-striped small mat-table\">\r\n            <thead role=\"rowgroup\">\r\n              <tr class=\"mat-header-row\" role=\"row\">\r\n                <th>Name</th>\r\n                <th>Status</th>\r\n                <th>Date Created</th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <tr class=\"mat-row\" *ngFor=\"let mailing of mailings\">\r\n                <td  class=\"mat-cell cdk-column-description mat-column-description\">\r\n                  <strong><a [routerLink]=\"['/mailing', mailing.id]\">{{mailing.name}}</a></strong>\r\n                </td>\r\n                <td class=\"mat-cell cdk-column-description mat-column-description\"><span class=\"badge {{mailing.isApproved ? 'badge-success' : 'badge-warning'}}\">{{mailing.isApproved ? 'Approved' : 'In progress'}}</span></td>\r\n                <td class=\"mat-cell cdk-column-description mat-column-description\">{{mailing.createDate | date: 'MM/dd/yyyy'}}</td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n    <!-- end top mailings added -->\r\n  </div>\r\n\r\n  <!-- notes -->\r\n  <div class=\"card\">\r\n    <div class=\"card-header bg-warning\">Recent Notes</div>\r\n    <div class=\"card-body\">\r\n      <app-notes [contentId]=\"0\" [contentType]=\"2\" [total]=\"30\"></app-notes>\r\n    </div>\r\n  </div> \r\n\r\n</div>\r\n\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/home/home.component.html":
/*!*******************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/home/home.component.html ***!
  \*******************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/location-overrides/location-overrides.component.html":
/*!***********************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/location-overrides/location-overrides.component.html ***!
  \***********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- heading -->\r\n<h5 class=\"card-title\">Location Overrides</h5>\r\n\r\n<!-- filter -->\r\n<div class=\"input-group mb-3\">\r\n  <input type=\"text\" class=\"form-control\" (keyup)=\"applyFilter($event)\" placeholder=\"Search stores by name...\" aria-label=\"Enter location name\">\r\n</div>\r\n<!-- end filter -->\r\n\r\n<!-- locations grid -->\r\n<div class=\"row\">\r\n  <div class=\"col\"> \r\n     \r\n    <table mat-table matSort [dataSource]=\"dataSource\" class=\"small table-striped\">\r\n\r\n      <!-- actions -->\r\n      <ng-container matColumnDef=\"actions\">\r\n        <th *matHeaderCellDef class=\"text-left\">Action</th>\r\n        <td *matCellDef=\"let location\" class=\"left\">\r\n          <!-- mailing more settings -->\r\n          <div class=\"float-left rounded-0 ml-2\">\r\n            <button class=\"btn text-dark btn-sm py-0\" type=\"button\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\r\n              <span class=\"ion ion-md-more\"></span>\r\n            </button>\r\n            <div class=\"dropdown-menu small\">\r\n              <a href=\"javascript:void(0)\" class=\"dropdown-item btn btn-sm\" (click)=\"editItem(location)\" data-toggle=\"modal\" title=\"Edit\"><span class=\"ion ion-md-create\"></span> Edit</a>\r\n              <a href=\"javascript:void(0)\" class=\"dropdown-item btn btn-sm\" (click)=\"deleteItem(location.id)\" title=\"Delete\"><span class=\"ion ion-md-trash\"></span> Delete</a>\r\n            </div>\r\n          </div>\r\n\r\n        </td>\r\n      </ng-container>\r\n\r\n      <!-- name column -->\r\n      <ng-container matColumnDef=\"sourceName\">\r\n        <th *matHeaderCellDef mat-sort-header>From Location</th>\r\n        <td mat-cell *matCellDef=\"let location\">{{location.sourceName}}</td>\r\n      </ng-container>\r\n\r\n      <!-- store number column -->\r\n      <ng-container matColumnDef=\"destinationName\">\r\n        <th *matHeaderCellDef>To Location</th>\r\n        <td mat-cell *matCellDef=\"let location\"> {{location.destinationName}} </td>\r\n      </ng-container>\r\n\r\n      <!-- start column -->\r\n      <ng-container matColumnDef=\"startDate\">\r\n        <th *matHeaderCellDef mat-sort-header>Star Date</th>\r\n        <td mat-cell *matCellDef=\"let location\"> {{location.startDate | date: 'MM/dd/yyyy'}} </td>\r\n      </ng-container>\r\n\r\n      <!-- end column -->\r\n      <ng-container matColumnDef=\"endDate\">\r\n        <th *matHeaderCellDef mat-sort-header>End Date</th>\r\n        <td mat-cell *matCellDef=\"let location\"> {{location.endDate | date: 'MM/dd/yyyy'}} </td>\r\n      </ng-container>\r\n\r\n      <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n      <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\"></tr>\r\n\r\n    </table>\r\n\r\n    <mat-paginator [length]=\"length\"\r\n                   [pageSize]=\"pageSize\"\r\n                   [pageSizeOptions]=\"pageSizeOptions\"\r\n                   (page)=\"pageEvent = $event\">\r\n    </mat-paginator>\r\n\r\n  </div>\r\n</div>\r\n\r\n<!-- footer actions -->\r\n<div class=\"row mb-3\">\r\n  <div class=\"col justify-content-md-end text-right\">\r\n    <button class=\"btn btn-primary\" (click)=\"openAddModal()\" >Add Location Override</button>\r\n  </div>\r\n</div>\r\n<!-- end header actions --> \r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/locations/locations.component.html":
/*!*****************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/locations/locations.component.html ***!
  \*****************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- heading -->\r\n<h5 class=\"card-title\">Locations</h5>\r\n\r\n<!-- filter -->\r\n<div class=\"input-group mb-3\">\r\n  <input type=\"text\" class=\"form-control\" (keyup)=\"applyFilter($event)\" placeholder=\"Search stores by name...\" aria-label=\"Enter location name\">\r\n</div>\r\n<!-- end filter -->\r\n\r\n<!-- locations grid -->\r\n<div class=\"row\">\r\n  <div class=\"col\"> \r\n     \r\n    <table mat-table matSort [dataSource]=\"dataSource\" class=\"small table-striped\">\r\n\r\n      <!-- actions -->\r\n      <ng-container matColumnDef=\"actions\">\r\n        <th *matHeaderCellDef class=\"text-left\">Action</th>\r\n        <td *matCellDef=\"let location\" class=\"left\">\r\n          <!-- mailing more settings -->\r\n          <div class=\"float-left rounded-0 ml-2\">\r\n            <button class=\"btn text-dark btn-sm py-0\" type=\"button\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\r\n              <span class=\"ion ion-md-more\"></span>\r\n            </button>\r\n            <div class=\"dropdown-menu small\">\r\n              <a href=\"javascript:void(0)\" class=\"dropdown-item btn btn-sm\" (click)=\"editLocation(location)\" data-toggle=\"modal\" title=\"Edit\"><span class=\"ion ion-md-create\"></span> Edit</a>\r\n              <a href=\"javascript:void(0)\" class=\"dropdown-item btn btn-sm\" (click)=\"deleteLocation(location.id)\" title=\"Delete\"><span class=\"ion ion-md-trash\"></span> Delete</a>\r\n            </div>\r\n          </div>\r\n\r\n        </td>\r\n      </ng-container>\r\n\r\n      <!-- name column -->\r\n      <ng-container matColumnDef=\"name\">\r\n        <th *matHeaderCellDef mat-sort-header>Name</th>\r\n        <td mat-cell *matCellDef=\"let location\">{{location.name}}</td>\r\n      </ng-container>\r\n\r\n      <!-- store number column -->\r\n      <ng-container matColumnDef=\"storeId\">\r\n        <th *matHeaderCellDef>Store ID</th>\r\n        <td mat-cell *matCellDef=\"let location\"> {{location.storeId}} </td>\r\n      </ng-container>\r\n\r\n      <!-- address column -->\r\n      <ng-container matColumnDef=\"address\">\r\n        <th *matHeaderCellDef>Address </th>\r\n        <td mat-cell *matCellDef=\"let location\">\r\n          {{location.address1}} {{location.address2}}<br />\r\n          {{location.city}}, {{location.state}} {{location.zipCode}}\r\n        </td>\r\n      </ng-container>\r\n\r\n      <!-- phone column -->\r\n      <ng-container matColumnDef=\"phone\">\r\n        <th *matHeaderCellDef>Phone</th>\r\n        <td mat-cell *matCellDef=\"let location\"> {{location.phone}} </td>\r\n      </ng-container>\r\n\r\n      <!-- email column -->\r\n      <ng-container matColumnDef=\"email\">\r\n        <th *matHeaderCellDef mat-sort-header>Email</th>\r\n        <td mat-cell *matCellDef=\"let location\"> {{location.email}} </td>\r\n      </ng-container>\r\n\r\n      <!-- url column -->\r\n      <ng-container matColumnDef=\"url\">\r\n        <th *matHeaderCellDef mat-sort-header>Url</th>\r\n        <td mat-cell *matCellDef=\"let location\"> {{location.url}} </td>\r\n      </ng-container>\r\n \r\n\r\n      <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n      <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\"></tr>\r\n\r\n    </table>\r\n\r\n    <mat-paginator [length]=\"length\"\r\n                   [pageSize]=\"pageSize\"\r\n                   [pageSizeOptions]=\"pageSizeOptions\"\r\n                   (page)=\"pageEvent = $event\">\r\n    </mat-paginator>\r\n\r\n  </div>\r\n</div>\r\n\r\n<!-- footer actions -->\r\n<div class=\"row mb-3\">\r\n  <div class=\"col justify-content-md-end text-right\">\r\n    <button class=\"btn btn-primary\" (click)=\"openAddModal()\" >Add Location</button>\r\n  </div>\r\n</div>\r\n<!-- end header actions --> \r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/mailing-details/mailing-details.component.html":
/*!*****************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/mailing-details/mailing-details.component.html ***!
  \*****************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!--<div *ngFor=\"let export of exports\">\r\n  <div>{{export.id}} - {{export.firstName}} {{export.lastName}} - {{export.member}}</div>\r\n</div>-->\r\n\r\n\r\n<div *ngIf=\"mailing\">\r\n  <div class=\"py-3\">\r\n\r\n    <h1>{{mailing.name}}  <span *ngIf=\"mailing.isApproved\" class=\"text-success\">(Approved)</span></h1>\r\n\r\n\r\n    <!-- header actions -->\r\n    <div class=\"row mb-4\">\r\n      <div class=\"col justify-content-md-end\">\r\n        <a [routerLink]=\"['/mailings']\" class=\"mr-3 btn btn-secondary btn-sm\">All mailings</a>\r\n      </div>\r\n    </div>\r\n    <!-- end header actions -->\r\n\r\n    <div class=\"card tab-card\">\r\n      <div class=\"card-header tab-card-header\">\r\n        <ul class=\"nav nav-tabs card-header-tabs\" id=\"myTab\" role=\"tablist\">\r\n          <li class=\"nav-item\">\r\n            <a class=\"nav-link active\" id=\"mailingdetails-tab\" [routerLink]=\"['/mailing', mailing.id]\" role=\"tab\" aria-selected=\"true\">Mailing Details</a>\r\n          </li>\r\n          <li class=\"nav-item\">\r\n            <a class=\"nav-link\" id=\"mailingfiles-tab\" [routerLink]=\"['/mailing/files', mailing.id]\" role=\"tab\" aria-selected=\"false\">Mailing Files</a>\r\n          </li>\r\n          <li class=\"nav-item\" *ngIf=\"dataSource.data.length > 0\">\r\n            <a class=\"nav-link\" id=\"qcreport-tab\" [routerLink]=\"['/mailing/report', mailing.id]\" role=\"tab\" aria-selected=\"false\">QC Report</a>\r\n          </li>\r\n          <li class=\"nav-item\">\r\n            <a class=\"nav-link\" id=\"notes-tab\" [routerLink]=\"['/mailing/notes', mailing.id]\" role=\"tab\" aria-selected=\"false\">Notes</a>\r\n          </li>\r\n        </ul>\r\n      </div>\r\n      <div class=\"tab-content position-relative\" id=\"myTabContent\">\r\n\r\n        <!-- mailing details -->\r\n        <div class=\"tab-pane fade show active p-3\" id=\"mailingdetails\" role=\"tabpanel\">\r\n\r\n          <h5 class=\"card-title\">Mailing Details</h5>\r\n\r\n          <!-- mailing more settings -->\r\n          <div class=\"float-right rounded-0 ml-2\" *ngIf=\"mailing.isApproved == false\">\r\n            <button class=\"btn text-dark btn-sm py-0\" type=\"button\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\r\n              <span class=\"ion ion-md-more\"></span>\r\n            </button>\r\n            <div class=\"dropdown-menu dropdown-menu-left\">\r\n              <a href=\"javascript:void(0);\" type=\"button\" (click)=\"deleteMailing()\" class=\"nav-link\">Delete Mailing</a>\r\n            </div>\r\n          </div>\r\n          <span class=\"small float-right text-muted\">Created on: <span class=\"form-text1\">{{mailing?.createDate | date: 'MM/dd/yyyy'}}</span>, <span>By: {{mailing?.createdBy}}</span></span>\r\n\r\n          <form [formGroup]=\"mailingForm\" (ngSubmit)=\"updateMailing()\" *ngIf=\"mailing\">\r\n\r\n            <div class=\"form-group\">\r\n              <label>Mailing name <span class=\"text-danger\">*</span></label>\r\n              <input type=\"text\" class=\"form-control\" [attr.readonly]=\"mailing.isApproved ? '' : null\" formControlName=\"name\" [ngClass]=\"{ 'is-invalid': mailingFormSubmitted && mailingForm.controls.name.errors}\" />\r\n              <div *ngIf=\"mailingFormSubmitted && mailingForm.controls.name.errors\" class=\"invalid-feedback\">\r\n                <div *ngIf=\"mailingForm.controls.name.errors.required\">Mailing Name is required</div>\r\n                <div *ngIf=\"mailingForm.controls.name.errors.alphaNumeric\">Mailing Name contains invalid characters</div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\">\r\n              <label>Brand: <span class=\"form-text\"><a class=\"text-link\" href=\"/brand/{{mailing.brand.id}}\">{{mailing.brand.name}}</a></span></label>\r\n            </div>\r\n\r\n            <div class=\"form-group\">\r\n              <label>Mailing Date: <span class=\"form-text\">{{mailing.startDate | date: 'MM/yyyy'}}</span></label>\r\n            </div>\r\n\r\n            <div class=\"form-group justify-content-md-end text-right\">\r\n              <!-- archive file for production -->\r\n              <button *ngIf=\"dataSource.data.length && mailing.isApproved == false\" type=\"button\" class=\"btn btn-outline-primary mr-2\" (click)=\"approveMailing(mailing.id)\"><span class=\"ion ion-md-checkmark\"></span> Approve Mailing</button>\r\n\r\n              <!-- Export File for Production -->\r\n              <button *ngIf=\"dataSource.data.length && isMailingReady\" type=\"button\" class=\"btn btn-outline-primary mr-2\" (click)=\"exportForProduction(mailing.id)\"><span class=\"ion ion-md-document\"></span> Export Mail File</button>\r\n\r\n              <!-- save changes to mailing -->\r\n              <button *ngIf=\"mailing.isApproved == false\" type=\"submit\" class=\"btn btn-primary\">Save Changes</button>\r\n\r\n            </div>\r\n          </form>\r\n\r\n        </div>\r\n\r\n\r\n      </div>\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n\r\n\r\n\r\n\r\n\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/mailing-files/mailing-files.component.html":
/*!*************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/mailing-files/mailing-files.component.html ***!
  \*************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div *ngIf=\"mailing\">\r\n  <div class=\"py-3\">\r\n\r\n    <h1>{{mailing.name}}  <span *ngIf=\"mailing.isApproved\" class=\"text-success\">(Approved)</span></h1>\r\n\r\n    <!-- header actions -->\r\n    <div class=\"row mb-4\">\r\n      <div class=\"col justify-content-md-end\">\r\n        <a [routerLink]=\"['/mailings']\" class=\"mr-3 btn btn-secondary btn-sm\">All mailings</a>\r\n      </div>\r\n    </div>\r\n    <!-- end header actions -->\r\n\r\n    <div class=\"card tab-card\">\r\n      <div class=\"card-header tab-card-header\">\r\n        <ul class=\"nav nav-tabs card-header-tabs\" id=\"myTab\" role=\"tablist\">\r\n          <li class=\"nav-item\">\r\n            <a class=\"nav-link\" [routerLink]=\"['/mailing', mailing.id]\" role=\"tab\">Mailing Details</a>\r\n          </li>\r\n          <li class=\"nav-item\">\r\n            <a class=\"nav-link active\" [routerLink]=\"['/mailing/files', mailing.id]\" role=\"tab\" aria-selected=\"true\">Mailing Files</a>\r\n          </li>\r\n          <li class=\"nav-item\">\r\n            <a class=\"nav-link\" [routerLink]=\"['/mailing/report', mailing.id]\" role=\"tab\" aria-selected=\"false\">QC Report</a>\r\n          </li>\r\n          <li class=\"nav-item\">\r\n            <a class=\"nav-link\" id=\"notes-tab\" [routerLink]=\"['/mailing/notes', mailing.id]\" role=\"tab\" aria-selected=\"false\">Notes</a>\r\n          </li>\r\n        </ul>\r\n      </div>\r\n\r\n\r\n\r\n      <div class=\"tab-content position-relative\">\r\n\r\n        <!-- filter -->\r\n        <!--<div class=\"input-group mb-3 d-none\">\r\n      <input type=\"text\" class=\"form-control\" (keyup)=\"applyFilter($event)\" placeholder=\"Search by name...\" aria-label=\"Search by name\">\r\n    </div>-->\r\n        <!-- end filter -->\r\n        <!-- mailing files -->\r\n        <div class=\"tab-pane show active fade p-3\" id=\"mailingfiles\" role=\"tabpanel\">\r\n          <h5 class=\"card-title\">Mailing Files</h5>\r\n\r\n          <table mat-table matSort [dataSource]=\"dataSource\" class=\"table small table-striped\">\r\n\r\n            <!-- actions -->\r\n            <ng-container matColumnDef=\"action\">\r\n              <th *matHeaderCellDef class=\"text-left\">Action</th>\r\n              <td *matCellDef=\"let mailingFile\" class=\"left\">\r\n                <!-- mailing more settings -->\r\n                <div class=\"float-left rounded-0 ml-2\" *ngIf=\"mailing.isApproved == false\">\r\n                  <button class=\"btn text-dark btn-sm py-0\" type=\"button\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\r\n                    <span class=\"ion ion-md-more\"></span>\r\n                  </button>\r\n                  <div class=\"dropdown-menu small\">\r\n                    <a class=\"dropdown-item btn btn-sm\" href=\"javascript:void(0)\" (click)=\"deleteMailingFile(mailingFile.id)\" title=\"Delete\"><span class=\"ion ion-md-trash\"></span> Delete</a>\r\n                  </div>\r\n                </div>\r\n              </td>\r\n            </ng-container>\r\n\r\n\r\n            <!-- filename Column -->\r\n            <ng-container matColumnDef=\"name\">\r\n              <th *matHeaderCellDef>File Name</th>\r\n              <td mat-cell *matCellDef=\"let mailingFile\">\r\n                <div *ngIf=\"mailing.isApproved || mailingFile.isProcessed == 0; then thenBlock else elseBlock\"></div>\r\n\r\n                <ng-template #thenBlock><span class=\"btn btn-link\">{{mailingFile.name}}</span></ng-template>\r\n                <ng-template #elseBlock>\r\n                  <a class=\"btn btn-link\" href=\"javascript:void(0)\" (click)=\"mailingRecords.getRecords(mailingFile.id)\">{{mailingFile.name}}</a>\r\n                </ng-template>\r\n\r\n                <span *ngIf=\"mailingFile.isProcessed == true && mailingFile.totalRecords > 0\" class=\"badge text-light badge-success ml-1\">Processed</span>\r\n                <span *ngIf=\"mailingFile.isProcessed == false\" class=\"badge text-dark badge-warning ml-1\">Processing</span>\r\n                <span *ngIf=\"mailingFile.isProcessed == true && mailingFile.totalRecords == 0\" class=\"badge text-light badge-danger ml-1\">Error</span>\r\n\r\n              </td>\r\n            </ng-container>\r\n\r\n            <!-- file create date Column -->\r\n            <ng-container matColumnDef=\"createDate\">\r\n              <th *matHeaderCellDef>Uploaded on</th>\r\n              <td mat-cell *matCellDef=\"let mailingFile\"> {{mailingFile.createDate | date: 'MM/dd/yyyy'}} </td>\r\n            </ng-container>\r\n\r\n            <!-- total records Column -->\r\n            <ng-container matColumnDef=\"totalRecords\">\r\n              <th *matHeaderCellDef>Total Records</th>\r\n              <td mat-cell *matCellDef=\"let mailingFile\"> {{mailingFile.totalRecords}}</td>\r\n            </ng-container>\r\n\r\n            <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n            <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\"></tr>\r\n\r\n          </table>\r\n\r\n          <mat-paginator [length]=\"length\"\r\n                         [pageSize]=\"pageSize\"\r\n                         [pageSizeOptions]=\"pageSizeOptions\"\r\n                         (page)=\"pageEvent = $event\">\r\n          </mat-paginator>\r\n\r\n          <div class=\"text-right\" *ngIf=\"mailing.isApproved == false\">\r\n            <button class=\"btn btn-primary\" type=\"button\"\r\n                    id=\"launch\"\r\n                    (click)=\"importDataFile()\">\r\n              Add Mailing File\r\n            </button>\r\n          </div>\r\n        </div>\r\n\r\n      </div>\r\n    </div>\r\n  </div>\r\n \r\n</div>\r\n\r\n<!-- Modal for campaign Type selection -->\r\n<div class=\"modal\" id=\"addCampaignTypeModal\" tabindex=\"-1\" role=\"dialog\" data-backdrop=\"static\" data-keyboard=\"false\">\r\n  <div class=\"modal-dialog\" role=\"document\">\r\n    <div class=\"modal-content\">\r\n\r\n      <form [formGroup]=\"campaignTypeForm\">\r\n\r\n        <div class=\"modal-header\">\r\n          <h5 class=\"modal-title\">Brand/campaign Assigment</h5>\r\n        </div>\r\n\r\n        <div class=\"modal-body\">\r\n          <!--<p>If your file does not contain a campaign type, please associate a campaign type to the file you wish to upload:</p>\r\n          -->\r\n          <p>Your file does not appear to be associated with any campaign type and/or brand. Please assign the following fields to proceed:</p>\r\n\r\n          <div class=\"form-group\" *ngIf=\"campaignTypeForm.controls.campaignType\">\r\n            <label>Campaign Type</label>\r\n            <select class=\"form-control\" formControlName=\"campaignType\" [ngClass]=\"{ 'is-invalid': campaignTypeFormSubmitted && campaignTypeForm.controls.campaignType.errors }\">\r\n              <option value=\"\">--Choose one--</option>\r\n              <option *ngFor=\"let campaignType of campaignTypes;\" [value]=\"campaignType.name\">\r\n                {{campaignType.name}}\r\n              </option>\r\n            </select>\r\n            <div *ngIf=\"campaignTypeFormSubmitted && campaignTypeForm.controls.campaignType.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"campaignTypeForm.controls.campaignType.errors.required\">Campaign Type is required</div>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"form-group\" *ngIf=\"campaignTypeForm.controls.brand\">\r\n            <label>Brand</label>\r\n            <select class=\"form-control\" formControlName=\"brand\" [ngClass]=\"{ 'is-invalid': campaignTypeFormSubmitted && campaignTypeForm.controls.brand.errors }\">\r\n              <option value=\"\">--Choose one--</option>\r\n              <option *ngFor=\"let brand of brands;\" [value]=\"brand.name\">\r\n                {{brand.name}}\r\n              </option>\r\n            </select>\r\n            <div *ngIf=\"campaignTypeFormSubmitted && campaignTypeForm.controls.brand.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"campaignTypeForm.controls.brand.errors.required\">Brand is required</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"modal-footer\">\r\n          <button type=\"submit\" class=\"btn btn-primary\" (click)=\"addCampaignType()\">\r\n            Save Changes\r\n          </button>\r\n        </div>\r\n\r\n      </form>\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n\r\n<!-- mailing records module that displays records based on mailing file -->\r\n<app-mailing-record-list #mailingRecords></app-mailing-record-list>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/mailing-notes/mailing-notes.component.html":
/*!*************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/mailing-notes/mailing-notes.component.html ***!
  \*************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"py-3\" *ngIf=\"mailing\">\r\n  <h1>{{mailing.name}}  <span *ngIf=\"mailing.isApproved\" class=\"text-success\">(Approved)</span></h1>\r\n\r\n\r\n  <!-- header actions -->\r\n  <div class=\"row mb-4\">\r\n    <div class=\"col justify-content-md-end\">\r\n      <a [routerLink]=\"['/mailings']\" class=\"mr-3 btn btn-secondary btn-sm\">All mailings</a>\r\n    </div>\r\n  </div>\r\n  <!-- end header actions -->\r\n\r\n  <div class=\"card tab-card\">\r\n    <div class=\"card-header tab-card-header\">\r\n      <ul class=\"nav nav-tabs card-header-tabs\" id=\"myTab\" role=\"tablist\">\r\n        <li class=\"nav-item\">\r\n          <a class=\"nav-link\" id=\"mailingdetails-tab\" [routerLink]=\"['/mailing', mailing.id]\" role=\"tab\" aria-selected=\"false\">Mailing Details</a>\r\n        </li>\r\n        <li class=\"nav-item\">\r\n          <a class=\"nav-link\" id=\"mailingfiles-tab\" [routerLink]=\"['/mailing/files', mailing.id]\" role=\"tab\" aria-selected=\"false\">Mailing Files</a>\r\n        </li>\r\n        <li class=\"nav-item\">\r\n          <a class=\"nav-link\" id=\"qcreport-tab\" [routerLink]=\"['/mailing/report', mailing.id]\" role=\"tab\" aria-selected=\"true\">QC Report</a>\r\n        </li>\r\n        <li class=\"nav-item\">\r\n          <a class=\"nav-link active\" id=\"notes-tab\" [routerLink]=\"['/mailing/notes', mailing.id]\" role=\"tab\" aria-selected=\"false\">Notes</a>\r\n        </li>\r\n      </ul>\r\n    </div>\r\n    <div class=\"tab-content position-relative\" >\r\n      <div class=\"tab-pane show active fade p-3\">\r\n        <!-- heading -->\r\n        <h5 class=\"card-title\">Notes</h5>\r\n\r\n        <!-- notes tab -->\r\n        <app-notes [contentId]=\"id\" [contentType]=\"contentType\"></app-notes>\r\n        <!-- end notes tab -->\r\n\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div> \r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/mailing-record-list/mailing-record-list.component.html":
/*!*************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/mailing-record-list/mailing-record-list.component.html ***!
  \*************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div id=\"myMailingModal\" class=\"sidenav box-shadow\">\r\n \r\n  <div class=\"modal-header\">\r\n    <h4 class=\"modal-title\">Mailing Records</h4>\r\n    <button (click)=\"closeModal()\" type=\"button\" class=\"closebtn\">\r\n      <span aria-hidden=\"true\">&times;</span>\r\n    </button> \r\n  </div>\r\n  <div class=\"modal-body\">\r\n\r\n    <!-- filter -->\r\n    <div class=\"input-group mb-3\">\r\n      <input type=\"text\" class=\"form-control\" (keyup)=\"applyFilter($event)\" placeholder=\"Search records...\" >\r\n    </div>\r\n    <!-- end filter -->\r\n\r\n    <div class=\"mat-elevation-z8\">\r\n\r\n      <table mat-table matSort [dataSource]=\"dataSource\" class=\"small table-striped\">\r\n\r\n        <!-- patient id Column -->\r\n        <ng-container matColumnDef=\"patientId\">\r\n          <th mat-header-cell *matHeaderCellDef mat-sort-header>Patient Id </th>\r\n          <td mat-cell *matCellDef=\"let mailingRecord\">{{mailingRecord.patientId}}</td>\r\n        </ng-container>\r\n\r\n\r\n        <!-- patient name Column -->\r\n        <ng-container matColumnDef=\"fullName\">\r\n          <th mat-header-cell *matHeaderCellDef>Patient name</th>\r\n          <td mat-cell *matCellDef=\"let mailingRecord\"> {{mailingRecord.firstName}} {{mailingRecord.lastName}} </td>\r\n        </ng-container>\r\n\r\n        <!-- patient dob Column -->\r\n        <ng-container matColumnDef=\"dateOfBirth\">\r\n          <th mat-header-cell *matHeaderCellDef>DOB</th>\r\n          <td mat-cell *matCellDef=\"let mailingRecord\"> {{mailingRecord.dateOfBirth | date: 'MM/dd/yyyy'}} </td>\r\n        </ng-container>\r\n\r\n        <!-- patient gender Column -->\r\n        <ng-container matColumnDef=\"gender\">\r\n          <th mat-header-cell *matHeaderCellDef>Gender</th>\r\n          <td mat-cell *matCellDef=\"let mailingRecord\"> {{mailingRecord.gender}} </td>\r\n        </ng-container>\r\n\r\n        <!-- last exam date Column -->\r\n        <ng-container matColumnDef=\"lastExamDate\">\r\n          <th mat-header-cell *matHeaderCellDef>Last exam date</th>\r\n          <td mat-cell *matCellDef=\"let mailingRecord\"> {{mailingRecord.lastExamDate | date: 'MM/dd/yyyy'}} </td>\r\n        </ng-container>\r\n\r\n        <!-- months Column -->\r\n        <ng-container matColumnDef=\"months\">\r\n          <th mat-header-cell *matHeaderCellDef>Months since last exam</th>\r\n          <td mat-cell *matCellDef=\"let mailingRecord\"> {{mailingRecord.months}} </td>\r\n        </ng-container>\r\n\r\n        <!-- actions -->\r\n        <ng-container matColumnDef=\"actions\">\r\n          <th mat-header-cell *matHeaderCellDef mat-sort-header class=\"text-right\">Actions</th>\r\n          <td mat-cell *matCellDef=\"let mailingRecord\" class=\"text-right\">\r\n            <a href=\"javascript:void(0)\" class=\"btn btn-sm btn-outline-primary mr-2\" (click)=\"editMailingRecord(mailingRecord)\" title=\"Edit\"><span class=\"ion ion-md-create\"></span></a>\r\n            <a href=\"javascript:void(0)\" class=\"btn btn-sm btn-outline-primary\" (click)=\"deleteMailingRecord(mailingRecord.id)\" title=\"Delete\"><span class=\"ion ion-md-trash\"></span></a>\r\n          </td>\r\n        </ng-container>\r\n\r\n        <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n        <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\"></tr>\r\n\r\n      </table>\r\n\r\n      <mat-paginator [length]=\"length\"\r\n                     [pageSize]=\"pageSize\"\r\n                     [pageSizeOptions]=\"pageSizeOptions\">\r\n      </mat-paginator>\r\n    </div>\r\n  </div> \r\n</div> \r\n <div class=\"overlay\"></div>\r\n \r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/mailings/mailings.component.html":
/*!***************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/mailings/mailings.component.html ***!
  \***************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"py-3\">\r\n    <h1 class=\"mb-4\">Mailings</h1>\r\n\r\n    <!-- header actions -->\r\n    <div class=\"row mb-3\">\r\n      <div class=\"col justify-content-md-end text-right\">\r\n        <button class=\"btn btn-primary\" data-toggle=\"modal\" data-target=\"#addMailingModal\">Add a Mailing</button>\r\n      </div>\r\n    </div>\r\n    <!-- end header actions -->\r\n\r\n    <div class=\"row mb-4\">\r\n      <div class=\"col-sm-12\">\r\n\r\n        <!--  data filters -->\r\n        <div class=\"row\">\r\n          <div class=\"col-sm-5\">\r\n            <div class=\"input-group mb-3\">\r\n              <div class=\"input-group-prepend\">\r\n                <label class=\"input-group-text\" for=\"dateFilter\">Time Frame</label>\r\n              </div>\r\n              <select id=\"dateFilter\" class=\"custom-select\" [(ngModel)]=\"selectedDateFilter\" (change)=\"applyDateFilter($event)\">\r\n                <option *ngFor=\"let item of dateRanges\" [value]=\"item.Value\">{{ item.Text }}</option>\r\n              </select>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-sm-7\">\r\n            <div class=\"input-group mb-3\">\r\n              <input type=\"text\" class=\"form-control\" (keyup)=\"applyFilter($event)\" placeholder=\"Search mailings by name...\" aria-label=\"Enter mailing name\" aria-describedby=\"button-addon2\">\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n          <div class=\"col\">\r\n            <div class=\"card\">\r\n              <div class=\"card-header\">Mailings</div>\r\n              <div class=\"card-body\">\r\n\r\n\r\n                  <table mat-table matSort [dataSource]=\"dataSource\" class=\"small table-striped mat-table\">\r\n\r\n                    <!-- Name Column -->\r\n                    <ng-container matColumnDef=\"name\">\r\n                      <th *matHeaderCellDef mat-sort-header> Name </th>\r\n                      <td mat-cell *matCellDef=\"let mailing\"><a class=\"btn btn-link\" [routerLink]=\"['/mailing', mailing.id]\">{{mailing.name}}</a></td>\r\n                    </ng-container>\r\n\r\n                    <!-- status Column -->\r\n                    <ng-container matColumnDef=\"status\">\r\n                      <th *matHeaderCellDef mat-sort-header> Status </th>\r\n                      <td mat-cell *matCellDef=\"let mailing\"><span class=\"badge {{mailing.isApproved ? 'badge-success' : 'badge-warning'}}\">{{mailing.isApproved ? 'Approved' : 'In progress'}}</span></td>\r\n                    </ng-container>\r\n\r\n                    <!-- brand id Column -->\r\n                    <ng-container matColumnDef=\"brand\">\r\n                      <th *matHeaderCellDef>Brand</th>\r\n                      <td mat-cell *matCellDef=\"let mailing\"> {{mailing.brand.name}} </td>\r\n                    </ng-container>\r\n\r\n                    <!-- mailing startDate Column -->\r\n                    <ng-container matColumnDef=\"startDate\">\r\n                      <th *matHeaderCellDef>Start Date</th>\r\n                      <td mat-cell *matCellDef=\"let mailing\"> {{mailing.startDate | date: 'MM/yyyy'}} </td>\r\n                    </ng-container>\r\n\r\n \r\n\r\n                    <!-- create date Column -->\r\n                    <ng-container matColumnDef=\"createDate\">\r\n                      <th *matHeaderCellDef mat-sort-header>Created on</th>\r\n                      <td mat-cell *matCellDef=\"let mailing\"> {{mailing.createDate | date: 'MM/dd/yyyy'}} </td>\r\n                    </ng-container>\r\n\r\n                    <!-- createby Column -->\r\n                    <ng-container matColumnDef=\"createdBy\">\r\n                      <th *matHeaderCellDef>Created By</th>\r\n                      <td mat-cell *matCellDef=\"let mailing\"> {{mailing.createdBy}} </td>\r\n                    </ng-container>\r\n\r\n                    <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n                    <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\"></tr>\r\n\r\n                  </table>\r\n\r\n                  <mat-paginator [length]=\"length\"\r\n                                 [pageSize]=\"pageSize\"\r\n                                 [pageSizeOptions]=\"pageSizeOptions\"\r\n                                 (page)=\"pageEvent = $event\">\r\n                  </mat-paginator>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n         \r\n      </div>\r\n    </div>\r\n\r\n  </div>\r\n\r\n<!-- add Mailing Modal -->\r\n<div class=\"modal fade\" id=\"addMailingModal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\r\n  <div class=\"modal-dialog\" role=\"document\">\r\n    <div class=\"modal-content\">\r\n\r\n      <form [formGroup]=\"mailingForm\" (ngSubmit)=\"onSubmitForm()\">\r\n\r\n        <div class=\"modal-header\">\r\n          <h5 class=\"modal-title\">Add a Mailing</h5>\r\n          <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-labbtn-primaryel=\"Close\">\r\n            <span aria-hidden=\"true\">&times;</span>\r\n          </button>\r\n        </div>\r\n        <div class=\"modal-body\">\r\n\r\n\r\n          <div class=\"form-group\">\r\n            <label>Mailing name <span class=\"text-danger\">*</span></label>\r\n            <input type=\"text\" class=\"form-control\" formControlName=\"name\" [ngClass]=\"{ 'is-invalid': submitted && mailingForm.controls.name.errors}\" />\r\n            <div *ngIf=\"submitted && mailingForm.controls.name.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"mailingForm.controls.name.errors.required\">Mailing Name is required</div>\r\n              <div *ngIf=\"mailingForm.controls.name.errors.alphaNumeric\">Mailing Name contains invalid characters</div>\r\n            </div>\r\n          </div>\r\n\r\n          <label>Mailing Start Date <span class=\"text-danger\">*</span></label>\r\n          <div class=\"input-group mb-3\">\r\n            <input type=\"date\" class=\"form-control\" formControlName=\"startDate\" [ngClass]=\"{ 'is-invalid': submitted && mailingForm.controls.startDate.errors }\" />\r\n            <div class=\"input-group-append\">\r\n              <span class=\"input-group-text\"><span class=\"ion ion-ios-calendar\"></span></span>\r\n            </div>\r\n            <div *ngIf=\"submitted && mailingForm.controls.startDate.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"mailingForm.controls.startDate.errors.required\">Start date is required</div>\r\n            </div>\r\n          </div>\r\n\r\n\r\n          <div class=\"form-group\">\r\n            <label>Brand <span class=\"text-danger\">*</span></label>\r\n            <select class=\"form-control\" formControlName=\"brandId\" [ngClass]=\"{ 'is-invalid': submitted && mailingForm.controls.brandId.errors }\">\r\n              <option value=\"\">--Choose one--</option>\r\n              <option *ngFor=\"let brand of brands;\" [value]=\"brand.id\">\r\n                {{brand.name}} {{brand.brandId==0 ? ' (Master)' : ''}}\r\n              </option>\r\n            </select>\r\n            <div *ngIf=\"submitted && mailingForm.controls.brandId.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"mailingForm.controls.brandId.errors.required\">Brand ID is required</div>\r\n            </div>\r\n          </div>\r\n           \r\n        </div>\r\n        <div class=\"modal-footer\">\r\n          <button type=\"button\" class=\"btn btn-outline-primary\" data-dismiss=\"modal\">Cancel</button>\r\n          <button type=\"submit\" class=\"btn btn-primary\">\r\n            Add\r\n          </button>\r\n          <!--\r\n          <button type=\"submit\" class=\"btn btn-primary\" [disabled]=\"mailingForm.invalid\">\r\n            Add \r\n          </button>\r\n            -->\r\n        </div>\r\n      </form>\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n<!-- end add Mailing Modal-->\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/matrix-query-builder/matrix-query-builder.component.html":
/*!***************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/matrix-query-builder/matrix-query-builder.component.html ***!
  \***************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<h5>Query Builder</h5>\r\n\r\n\r\n<div class=\"d-flex align-items-center q-transition\">\r\n  <div class=\"custom-control custom-radio custom-control-inline\">\r\n    <input id=\"conditionAnd\" name=\"condition\" type=\"radio\" value=\"and\" class=\"custom-control-input\" checked (change)=\"changeCondition($event)\">\r\n    <label for=\"conditionAnd\" class=\"custom-control-label\">AND</label>\r\n\r\n  </div>\r\n  <div class=\"custom-control custom-radio custom-control-inline\">\r\n    <input id=\"conditionNo\" name=\"condition\" type=\"radio\" value=\"or\" class=\"custom-control-input\" (change)=\"changeCondition($event)\">\r\n    <label for=\"conditionNo\" class=\"custom-control-label\">OR</label>\r\n  </div>\r\n</div>\r\n\r\n<!-- edit rule form -->\r\n<form [formGroup]=\"editRuleForm\" (ngSubmit)=\"updateRule()\" class=\"mt-2\" *ngIf=\"showEditRule\">\r\n  <div class=\"rule card\">\r\n    <div class=\"card-body\">\r\n      <h4>Edit Rule</h4>\r\n      <input type=\"hidden\" formControlName=\"id\" />\r\n      <div class=\"row\">\r\n        <div class=\"col-sm-3\">\r\n          <div class=\"form-group\">\r\n            <label>Field name</label>\r\n            <select (change)=\"toggleValueField(fieldNameSelectEdit.value, true);\" #fieldNameSelectEdit formControlName=\"fieldName\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': editRuleSubmitted && editRuleForm.controls.fieldName.errors }\">\r\n              <option *ngFor=\"let item of fieldNames\" [value]=\"item\">{{item}}</option>\r\n            </select>\r\n            <div *ngIf=\"editRuleSubmitted && editRuleForm.controls.fieldName.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"editRuleForm.controls.fieldName.errors.required\">Field name is required</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-sm-3\">\r\n          <div class=\"form-group\">\r\n            <label>Operator</label>\r\n            <select formControlName=\"operator\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': editRuleSubmitted && editRuleForm.controls.operator.errors }\">\r\n              <option *ngFor=\"let item of operators\" [ngValue]=\"item\">{{item.name}}</option>\r\n            </select>\r\n            <div *ngIf=\"editRuleSubmitted && editRuleForm.controls.operator.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"editRuleForm.controls.operator.errors.required\">Operator is required</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-sm-3\">\r\n\r\n          <div class=\"form-group\">\r\n            <label>Value</label>\r\n\r\n            <!-- gender -->\r\n            <div *ngIf=\"showGender\">\r\n              <select (change)=\"setControlValue(genderSelectEdit.value, true)\" [(ngModel)]=\"genderSelected\" [ngModelOptions]=\"{standalone: true}\" #genderSelectEdit class=\"form-control\" [ngClass]=\"{ 'is-invalid': editRuleSubmitted && editRuleForm.controls.value.errors }\">\r\n                <option *ngFor=\"let gender of genderList\" [value]=\"gender\">{{gender}}</option>\r\n              </select>\r\n            </div>\r\n\r\n            <!-- age range -->\r\n            <div *ngIf=\"showAgeRange\">\r\n              <ng-select [items]=\"ageRangeList\"\r\n                         bindLabel=\"range\"\r\n                         bindValue=\"range\"\r\n                         [multiple]=\"true\"\r\n                         placeholder=\"Select age ranges\"\r\n                         (change)=\"setControlValues('ageRange', $event, true)\"\r\n                         [(ngModel)]=\"ageRangeSelected\" [ngModelOptions]=\"{standalone: true}\">\r\n              </ng-select>\r\n            </div>\r\n\r\n            <!-- campaign type-->\r\n            <div *ngIf=\"showCampaignType\">\r\n              <ng-select [items]=\"campaignTypeList\"\r\n                         bindLabel=\"name\"\r\n                         bindValue=\"name\"\r\n                         [multiple]=\"true\"\r\n                         placeholder=\"Select campaign types\"\r\n                         (change)=\"setControlValues('campaignType', $event, true)\"\r\n                         [(ngModel)]=\"campaignTypeSelected\" [ngModelOptions]=\"{standalone: true}\">\r\n              </ng-select>\r\n            </div>\r\n\r\n            <div *ngIf=\"showValue\">\r\n              <input formControlName=\"value\" type=\"text\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': editRuleSubmitted && editRuleForm.controls.value.errors }\" />\r\n            </div>\r\n\r\n            <!-- value validation-->\r\n            <div *ngIf=\"editRuleSubmitted && editRuleForm.controls.value.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"editRuleForm.controls.value.errors.required\">Value is required</div>\r\n            </div>\r\n\r\n          </div>\r\n          </div>\r\n          <div class=\"col-sm-3\">\r\n            <button class=\"btn btn-primary mt-4\">Save changes</button>\r\n          </div>\r\n        </div>\r\n    </div>\r\n  </div>\r\n</form>\r\n<div class=\"text-danger px-2\" *ngIf=\"editRuleErrors\">{{ruleErrors}}</div>\r\n<!-- end edit rule form -->\r\n\r\n<!-- current rules -->\r\n<div class=\"border card p-3 my-2\" *ngIf=\"rules.length\">\r\n  <div>\r\n    <h5>Current rules</h5>\r\n    <ul class=\"list-group\">\r\n      <li class=\"row p-2 m-1 q-connector q-transition border\" *ngFor=\"let rule of rules;let i = index\">\r\n        <div class=\"col-auto pr-0\">\r\n          {{rule.fieldName}} <strong>{{rule.operator.name}}</strong>\r\n          \"<span *ngFor=\"let value of rule.values;let counter = index\">{{value}}<span *ngIf=\"counter < rule.values.length-1\">, </span>\r\n          </span>\"\r\n        </div>\r\n        <div class=\"col-auto pl-1 text-uppercase row text-success m-1\" *ngIf=\"rules.length > 1 && i < rules.length - 1\">\r\n            {{condition}}\r\n        </div>\r\n        <div class=\"order-12 ml-auto\">\r\n          <button type=\"button\" class=\"btn q-edit-button\" (click)=\"editRule(rule)\"><i class=\"ion ion-md-create\"></i></button>\r\n          <button type=\"button\" class=\"btn q-remove-button\" (click)=\"removeRule(rule)\"><i class=\"ion ion-md-trash\"></i></button>\r\n        </div>\r\n      \r\n      </li>\r\n\r\n    </ul>\r\n  </div>\r\n\r\n</div>\r\n\r\n<!-- add rule form -->\r\n<form [formGroup]=\"ruleForm\" (ngSubmit)=\"addRule()\" class=\"mt-2\" *ngIf=\"showAddRule\">\r\n  <div class=\"rule card\">\r\n    <div class=\"card-body\">\r\n      <div class=\"row\">\r\n        <div class=\"col-sm-3\">\r\n          <div class=\"form-group\">\r\n            <label>Field name</label>\r\n            <select (change)=\"toggleValueField(fieldNameSelect.value, false);\" #fieldNameSelect formControlName=\"fieldName\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && ruleForm.controls.fieldName.errors }\">\r\n              <option *ngFor=\"let item of fieldNames\" [value]=\"item\">{{item}}</option>\r\n            </select>\r\n            <div *ngIf=\"submitted && ruleForm.controls.fieldName.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"ruleForm.controls.fieldName.errors.required\">Field name is required</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-sm-3\">\r\n          <div class=\"form-group\">\r\n            <label>Operator</label>\r\n            <select formControlName=\"operator\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && ruleForm.controls.operator.errors }\">\r\n              <option *ngFor=\"let item of operators\" [ngValue]=\"item\">{{item.name}}</option>\r\n            </select>\r\n            <div *ngIf=\"submitted && ruleForm.controls.operator.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"ruleForm.controls.operator.errors.required\">Operator is required</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-sm-3\">\r\n             \r\n          <div class=\"form-group\">\r\n            <label>Value</label>\r\n\r\n            <!-- gender -->\r\n            <div *ngIf=\"showGender\">\r\n              <select (change)=\"setControlValue(genderSelect.value, false)\" #genderSelect class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && ruleForm.controls.value.errors }\">\r\n                <option [value]=\"\">Choose...</option>\r\n                <option *ngFor=\"let gender of genderList\" [value]=\"gender\">{{gender}}</option>\r\n              </select>\r\n            </div>\r\n\r\n            <!-- age range -->\r\n            <div *ngIf=\"showAgeRange\">\r\n              <ng-select [items]=\"ageRangeList\"\r\n                         bindLabel=\"range\"\r\n                         bindValue=\"range\"\r\n                         [multiple]=\"true\"\r\n                         placeholder=\"Select age ranges\"\r\n                         (change)=\"setControlValues('ageRange', $event, false)\">\r\n              </ng-select>\r\n            </div>\r\n\r\n            <!-- campaign type-->\r\n            <div *ngIf=\"showCampaignType\">\r\n              <ng-select [items]=\"campaignTypeList\"\r\n                         bindLabel=\"name\"\r\n                         bindValue=\"name\"\r\n                         [multiple]=\"true\"\r\n                         placeholder=\"Select campaign types\"\r\n                         (change)=\"setControlValues('campaignType', $event, false)\">\r\n              </ng-select>\r\n            </div>\r\n\r\n            <div *ngIf=\"showValue\">\r\n              <input formControlName=\"value\" type=\"text\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && ruleForm.controls.value.errors }\" />\r\n            </div>\r\n\r\n            <!-- value validation-->\r\n            <div *ngIf=\"submitted && ruleForm.controls.value.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"ruleForm.controls.value.errors.required\">Value is required</div>\r\n            </div>\r\n\r\n          </div>\r\n\r\n        </div>\r\n        <div class=\"col-sm-3\">\r\n          <button class=\"btn btn-primary mt-4\">Add</button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</form>\r\n<div class=\"text-danger px-2\" *ngIf=\"ruleErrors\">{{ruleErrors}}</div>\r\n<!-- end form -->\r\n\r\n<div class=\"text-right py-3\">\r\n  <button class=\"btn btn-primary mr-2\" (click)=\"openRuleBox()\">Add Rule</button>\r\n  <button class=\"btn btn-primary\" *ngIf=\"rules.length\" (click)=\"runQuery()\">Run Query</button>\r\n</div>\r\n<!-- end current rules-->\r\n \r\n\r\n<div class=\"border card p-3 my-2\" *ngIf=\"showUpdateCard\">\r\n\r\n  <h5>Bulk Update</h5>\r\n\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-4\">\r\n      <div class=\"form-group\">\r\n        <label>Field To Update</label>\r\n        <select class=\"form-control\" #updateFieldSelected>\r\n          <option>Choose...</option>\r\n          <option>\r\n            FrontImage\r\n          </option>\r\n          <option>\r\n            FrontCTA\r\n          </option>\r\n          <option>\r\n            FrontOffer\r\n          </option>\r\n          <option>\r\n            FrontLogo\r\n          </option>\r\n          <option>\r\n            BackLogo\r\n          </option>\r\n          <option>\r\n            BackCTA\r\n          </option>\r\n          <option>\r\n            BackBackground\r\n          </option>\r\n          <option>\r\n            BackTopLeftCopy\r\n          </option>\r\n          <option>\r\n            BackStoreBlock\r\n          </option>\r\n          <option>\r\n            BackOfferBlock\r\n          </option>\r\n          <option>\r\n            BackBottomLeftCopy\r\n          </option>\r\n          <option>Style</option>\r\n          <!--<option>Custom1</option>\r\n          <option>Custom2</option>\r\n          <option>Custom3</option>\r\n          <option>Custom4</option>\r\n          <option>Custom5</option>-->\r\n        </select>\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-4\">\r\n      <div class=\"form-group\">\r\n        <label>New Value</label>\r\n        <input type=\"text\" class=\"form-control\" #updateText />\r\n      </div>\r\n    </div>\r\n    <div class=\"col-sm-2 text-right mt-4\">\r\n      <button class=\"btn btn-primary\" (click)=\"bulkUpdate(updateFieldSelected.value, updateText.value)\">Save Changes</button>\r\n    </div>\r\n  </div>\r\n\r\n</div>\r\n\r\n<!-- query results -->\r\n<div class=\"border card p-3 my-2\" *ngIf=\"showUpdateCard\">\r\n  <h5>Query Results</h5>\r\n  <div class=\"table-responsive\">\r\n\r\n\r\n    <table mat-table matSort [dataSource]=\"dataSource1\" class=\"table table-sm small table-striped\">\r\n\r\n      <!-- campaign type column -->\r\n      <ng-container matColumnDef=\"campaignTypeName\">\r\n        <th *matHeaderCellDef mat-sort-header>Campaign Type</th>\r\n        <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.campaignTypeName}}</td>\r\n      </ng-container>\r\n\r\n\r\n      <!-- name column -->\r\n      <ng-container matColumnDef=\"brandName\">\r\n        <th *matHeaderCellDef mat-sort-header>Brand</th>\r\n        <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.brandName}}</td>\r\n      </ng-container>\r\n\r\n      <!-- name column -->\r\n      <ng-container matColumnDef=\"templateId\">\r\n        <th *matHeaderCellDef mat-sort-header>Template</th>\r\n        <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.templateId}}</td>\r\n      </ng-container>\r\n\r\n      <!-- months column -->\r\n      <ng-container matColumnDef=\"months\">\r\n        <th *matHeaderCellDef mat-sort-header>Months</th>\r\n        <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.months}}</td>\r\n      </ng-container>\r\n\r\n      <!-- age range column -->\r\n      <ng-container matColumnDef=\"ageRangeName\">\r\n        <th *matHeaderCellDef mat-sort-header>Age Range</th>\r\n        <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.ageRangeName}}</td>\r\n      </ng-container>\r\n\r\n      <!-- gender column -->\r\n      <ng-container matColumnDef=\"gender\">\r\n        <th *matHeaderCellDef mat-sort-header>Gender</th>\r\n        <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.gender}}</td>\r\n      </ng-container>\r\n\r\n      <!-- front image column -->\r\n      <ng-container matColumnDef=\"frontImage\">\r\n        <th *matHeaderCellDef mat-sort-header>Front Image</th>\r\n        <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.frontImage}}</td>\r\n      </ng-container>\r\n\r\n      <!-- front cta column -->\r\n      <ng-container matColumnDef=\"frontCTA\">\r\n        <th *matHeaderCellDef mat-sort-header>Front CTA</th>\r\n        <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.frontCTA}}</td>\r\n      </ng-container>\r\n\r\n      <!-- front offer column -->\r\n      <ng-container matColumnDef=\"frontOffer\">\r\n        <th *matHeaderCellDef mat-sort-header>Front Offer</th>\r\n        <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.frontOffer}}</td>\r\n      </ng-container>\r\n\r\n      <!-- front logo column -->\r\n      <ng-container matColumnDef=\"frontLogo\">\r\n        <th *matHeaderCellDef mat-sort-header>Front Logo</th>\r\n        <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.frontLogo}}</td>\r\n      </ng-container>\r\n\r\n      <!-- back logo column -->\r\n      <ng-container matColumnDef=\"backLogo\">\r\n        <th *matHeaderCellDef mat-sort-header>Back Logo</th>\r\n        <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.backLogo}}</td>\r\n      </ng-container>\r\n\r\n      <!-- backCTA column -->\r\n      <ng-container matColumnDef=\"backCTA\">\r\n        <th *matHeaderCellDef mat-sort-header>Back CTA</th>\r\n        <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.backCTA}}</td>\r\n      </ng-container>\r\n\r\n      <!-- backBackground column -->\r\n      <ng-container matColumnDef=\"backBackground\">\r\n        <th *matHeaderCellDef mat-sort-header>Back Background</th>\r\n        <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.backBackground}}</td>\r\n      </ng-container>\r\n\r\n      <!-- BackBottomLeftCopy column -->\r\n      <ng-container matColumnDef=\"backBottomLeftCopy\">\r\n        <th *matHeaderCellDef mat-sort-header>Back Bottom Left Copy</th>\r\n        <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.backBottomLeftCopy}}</td>\r\n      </ng-container>\r\n\r\n      <!-- backOfferBlock column -->\r\n      <ng-container matColumnDef=\"backOfferBlock\">\r\n        <th *matHeaderCellDef mat-sort-header>Back Offer Block</th>\r\n        <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.backOfferBlock}}</td>\r\n      </ng-container>\r\n\r\n      <!-- style column -->\r\n      <ng-container matColumnDef=\"style\">\r\n        <th *matHeaderCellDef mat-sort-header>Style</th>\r\n        <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.style}}</td>\r\n      </ng-container>\r\n\r\n      <!-- style custom 1 -->\r\n      <ng-container matColumnDef=\"custom1\">\r\n        <th *matHeaderCellDef mat-sort-header>Custom 1</th>\r\n        <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.custom1}}</td>\r\n      </ng-container>\r\n\r\n      <!-- style custom 2 -->\r\n      <ng-container matColumnDef=\"custom2\">\r\n        <th *matHeaderCellDef mat-sort-header>Custom 2</th>\r\n        <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.custom2}}</td>\r\n      </ng-container>\r\n\r\n      <!-- style custom 3 -->\r\n      <ng-container matColumnDef=\"custom3\">\r\n        <th *matHeaderCellDef mat-sort-header>Custom 3</th>\r\n        <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.custom3}}</td>\r\n      </ng-container>\r\n\r\n      <!-- style custom 4 -->\r\n      <ng-container matColumnDef=\"custom4\">\r\n        <th *matHeaderCellDef mat-sort-header>Custom 4</th>\r\n        <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.custom4}}</td>\r\n      </ng-container>\r\n\r\n      <!-- style custom 5 -->\r\n      <ng-container matColumnDef=\"custom5\">\r\n        <th *matHeaderCellDef mat-sort-header>Custom 5</th>\r\n        <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.custom5}}</td>\r\n      </ng-container>\r\n\r\n      <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n      <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\"></tr>\r\n\r\n    </table>\r\n\r\n      <mat-paginator [length]=\"length\"\r\n                     [pageSize]=\"pageSize\"\r\n                     [pageSizeOptions]=\"pageSizeOptions\"\r\n                     (page)=\"pageEvent = $event\">\r\n      </mat-paginator>\r\n    </div>\r\n\r\n      <div class=\"text-right py-3\">\r\n        <button class=\"btn btn-primary mr-2\" (click)=\"exportData()\">Export to CSV</button>\r\n      </div>\r\n  </div>\r\n\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/matrix/matrix.component.html":
/*!***********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/matrix/matrix.component.html ***!
  \***********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"card1 tab-card1\">\r\n  <div class=\"card-header tab-card-header\">\r\n    <ul class=\"nav nav-tabs card-header-tabs\" id=\"myTab\" role=\"tablist\">\r\n      <li class=\"nav-item\">\r\n        <a class=\"nav-link active\" data-toggle=\"tab\" href=\"#matrixDefault\" role=\"tab\"  aria-selected=\"true\">Matrix</a>\r\n      </li>\r\n      <li class=\"nav-item\">\r\n        <a class=\"nav-link\" data-toggle=\"tab\" href=\"#matrixQueryBuilder\" role=\"tab\" aria-selected=\"false\">Query Builder</a>\r\n      </li> \r\n    </ul>\r\n  </div>\r\n  <div class=\"tab-content\" id=\"myMatrixTabContent\">\r\n    <div class=\"tab-pane fade show active p-3\" id=\"matrixDefault\" role=\"tabpanel\">\r\n      <!-- matrix -->\r\n      <!-- heading -->\r\n      <h5 class=\"card-title\">Matrix (Master)</h5>\r\n\r\n      <!-- filter -->\r\n      <div class=\"input-group mb-3\">\r\n        <input type=\"text\" class=\"form-control\" (keyup)=\"applyFilter($event)\" placeholder=\"Search matrix by name...\">\r\n      </div>\r\n      <!-- end filter -->\r\n      <!-- creativeTemplates grid -->\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <div class=\"table-responsive\"> \r\n            <table mat-table matSort [dataSource]=\"dataSource\" class=\"table table-sm small table-striped\">\r\n\r\n\r\n              <!-- actions -->\r\n              <ng-container matColumnDef=\"actions\">\r\n                <th *matHeaderCellDef class=\"text-left\">Action</th>\r\n                <td *matCellDef=\"let creativeTemplate\" class=\"left\">\r\n                  <!-- mailing more settings -->\r\n                  <div class=\"float-left rounded-0 ml-2\">\r\n                    <button class=\"btn text-dark btn-sm py-0\" type=\"button\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\r\n                      <span class=\"ion ion-md-more\"></span>\r\n                    </button>\r\n                    <div class=\"dropdown-menu small\">\r\n                      <a href=\"javascript:void(0)\" class=\"dropdown-item btn btn-sm\" (click)=\"editCreativeTemplate(creativeTemplate)\" data-toggle=\"modal\" title=\"Edit\"><span class=\"ion ion-md-create\"></span> Edit</a>\r\n                      <a href=\"javascript:void(0)\" class=\"dropdown-item btn btn-sm\" (click)=\"deleteCreativeTemplate(creativeTemplate.id)\" title=\"Delete\"><span class=\"ion ion-md-trash\"></span> Delete</a>\r\n                      <a href=\"javascript:void(0)\" class=\"dropdown-item btn btn-sm\" (click)=\"copyCreativeTemplate(creativeTemplate)\" title=\"Copy\"><span class=\"ion ion-md-copy\"></span> Copy</a>\r\n                    </div>\r\n                  </div>\r\n\r\n                </td>\r\n              </ng-container>\r\n\r\n              <!-- id column -->\r\n              <ng-container matColumnDef=\"id\">\r\n                <th *matHeaderCellDef mat-sort-header>Id</th>\r\n                <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.id}}</td>\r\n              </ng-container>\r\n\r\n\r\n              <!-- campaign type column -->\r\n              <ng-container matColumnDef=\"campaignTypeName\">\r\n                <th *matHeaderCellDef mat-sort-header>Campaign Type</th>\r\n                <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.campaignTypeName}}</td>\r\n              </ng-container>\r\n\r\n\r\n              <!-- name column -->\r\n              <ng-container matColumnDef=\"brandName\">\r\n                <th *matHeaderCellDef mat-sort-header>Brand</th>\r\n                <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.brandName}}</td>\r\n              </ng-container>\r\n\r\n              <!-- name column -->\r\n              <ng-container matColumnDef=\"templateId\">\r\n                <th *matHeaderCellDef mat-sort-header>Template</th>\r\n                <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.templateId}}</td>\r\n              </ng-container>\r\n\r\n              <!-- months column -->\r\n              <ng-container matColumnDef=\"months\">\r\n                <th *matHeaderCellDef mat-sort-header>Months</th>\r\n                <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.months}}</td>\r\n              </ng-container>\r\n\r\n              <!-- age range column -->\r\n              <ng-container matColumnDef=\"ageRangeName\">\r\n                <th *matHeaderCellDef mat-sort-header>Age Range</th>\r\n                <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.ageRangeName}}</td>\r\n              </ng-container>\r\n\r\n              <!-- gender column -->\r\n              <ng-container matColumnDef=\"gender\">\r\n                <th *matHeaderCellDef mat-sort-header>Gender</th>\r\n                <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.gender}}</td>\r\n              </ng-container>\r\n\r\n\r\n              <!-- front image column -->\r\n              <ng-container matColumnDef=\"frontImage\">\r\n                <th *matHeaderCellDef mat-sort-header>Front Image</th>\r\n                <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.frontImage}}</td>\r\n              </ng-container>\r\n\r\n              <!-- front cta column -->\r\n              <ng-container matColumnDef=\"frontCTA\">\r\n                <th *matHeaderCellDef mat-sort-header>Front CTA</th>\r\n                <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.frontCTA}}</td>\r\n              </ng-container>\r\n\r\n              <!-- front offer column -->\r\n              <ng-container matColumnDef=\"frontOffer\">\r\n                <th *matHeaderCellDef mat-sort-header>Front Offer</th>\r\n                <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.frontOffer}}</td>\r\n              </ng-container>\r\n\r\n              <!-- front logo column -->\r\n              <ng-container matColumnDef=\"frontLogo\">\r\n                <th *matHeaderCellDef mat-sort-header>Front Logo</th>\r\n                <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.frontLogo}}</td>\r\n              </ng-container>\r\n\r\n              <!-- back logo column -->\r\n              <ng-container matColumnDef=\"backLogo\">\r\n                <th *matHeaderCellDef mat-sort-header>Back Logo</th>\r\n                <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.backLogo}}</td>\r\n              </ng-container>\r\n\r\n              <!-- backCTA column -->\r\n              <ng-container matColumnDef=\"backCTA\">\r\n                <th *matHeaderCellDef mat-sort-header>Back CTA</th>\r\n                <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.backCTA}}</td>\r\n              </ng-container>\r\n\r\n              <!-- backBackground column -->\r\n              <ng-container matColumnDef=\"backBackground\">\r\n                <th *matHeaderCellDef mat-sort-header>Back Background</th>\r\n                <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.backBackground}}</td>\r\n              </ng-container>\r\n\r\n              <!-- BackTopLeftCopy column -->\r\n              <ng-container matColumnDef=\"backTopLeftCopy\">\r\n                <th *matHeaderCellDef mat-sort-header>Back Top Left Copy</th>\r\n                <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.backTopLeftCopy}}</td>\r\n              </ng-container>\r\n\r\n              <!-- BackBottomLeftCopy column -->\r\n              <ng-container matColumnDef=\"backBottomLeftCopy\">\r\n                <th *matHeaderCellDef mat-sort-header>Back Bottom Left Copy</th>\r\n                <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.backBottomLeftCopy}}</td>\r\n              </ng-container>\r\n               \r\n\r\n              <!-- backOfferBlock column -->\r\n              <ng-container matColumnDef=\"backOfferBlock\">\r\n                <th *matHeaderCellDef mat-sort-header>Back Offer Block</th>\r\n                <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.backOfferBlock}}</td>\r\n              </ng-container>\r\n\r\n              <!-- style column -->\r\n              <ng-container matColumnDef=\"style\">\r\n                <th *matHeaderCellDef mat-sort-header>Style</th>\r\n                <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.style}}</td>\r\n              </ng-container>\r\n\r\n              <!-- style custom 1 -->\r\n              <!--<ng-container matColumnDef=\"custom1\">\r\n    <th *matHeaderCellDef mat-sort-header>Custom 1</th>\r\n    <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.custom1}}</td>\r\n  </ng-container>-->\r\n              <!-- style custom 2 -->\r\n              <!--<ng-container matColumnDef=\"custom2\">\r\n    <th *matHeaderCellDef mat-sort-header>Custom 2</th>\r\n    <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.custom2}}</td>\r\n  </ng-container>-->\r\n              <!-- style custom 3 -->\r\n              <!--<ng-container matColumnDef=\"custom3\">\r\n    <th *matHeaderCellDef mat-sort-header>Custom 3</th>\r\n    <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.custom3}}</td>\r\n  </ng-container>-->\r\n              <!-- style custom 4 -->\r\n              <!--<ng-container matColumnDef=\"custom4\">\r\n    <th *matHeaderCellDef mat-sort-header>Custom 4</th>\r\n    <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.custom4}}</td>\r\n  </ng-container>-->\r\n              <!-- style custom 5 -->\r\n              <!--<ng-container matColumnDef=\"custom5\">\r\n    <th *matHeaderCellDef mat-sort-header>Custom 5</th>\r\n    <td *matCellDef=\"let creativeTemplate\">{{creativeTemplate.custom5}}</td>\r\n  </ng-container>-->\r\n\r\n\r\n              <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n              <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\"></tr>\r\n\r\n            </table>\r\n          </div>\r\n            <mat-paginator [length]=\"length\"\r\n                           [pageSize]=\"pageSize\"\r\n                           [pageSizeOptions]=\"pageSizeOptions\"\r\n                           (page)=\"pageEvent = $event\">\r\n            </mat-paginator>\r\n         \r\n        </div>\r\n      </div>\r\n\r\n      <!-- footer actions -->\r\n      <div class=\"row mb-3\">\r\n        <div class=\"col justify-content-md-end text-right\">\r\n          <button class=\"btn btn-danger mr-2\" (click)=\"resetMatrix()\">Reset Matrix</button>\r\n          <button class=\"btn btn-primary mr-2\" (click)=\"importDataFile()\">Import Matrix</button>\r\n          <button class=\"btn btn-primary mr-2\" (click)=\"exportData()\">Export to CSV</button>\r\n          <button class=\"btn btn-primary\" (click)=\"openAddModal()\">Add an entry</button>\r\n        </div>\r\n      </div>\r\n      <!-- end header actions -->\r\n      <!-- end matrix -->\r\n    </div>\r\n    <div class=\"tab-pane fade p-3\" id=\"matrixQueryBuilder\" role=\"tabpanel\">\r\n      <!--matrix query builder -->\r\n      <app-matrix-query-builder [id]=\"id\"></app-matrix-query-builder>\r\n      <!-- matrix query builder -->\r\n    </div>\r\n  </div>\r\n</div>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/month-conversions/month-conversions.component.html":
/*!*********************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/month-conversions/month-conversions.component.html ***!
  \*********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- heading -->\r\n<h5 class=\"card-title\">Month Conversion</h5>\r\n\r\n<!-- filter -->\r\n<!--<div class=\"input-group mb-3\">\r\n  <input type=\"text\" class=\"form-control\" (keyup)=\"applyFilter($event)\" placeholder=\"Search stores by name...\" aria-label=\"Enter model name\">\r\n</div>-->\r\n<!-- end filter -->\r\n\r\n<!-- models grid -->\r\n<div class=\"row\">\r\n  <div class=\"col\"> \r\n     \r\n    <table mat-table matSort [dataSource]=\"dataSource\" class=\"small table-striped\">\r\n\r\n      <!-- actions -->\r\n      <ng-container matColumnDef=\"actions\">\r\n        <th *matHeaderCellDef class=\"text-left\">Action</th>\r\n        <td *matCellDef=\"let model\" class=\"left\">\r\n          <!-- mailing more settings -->\r\n          <div class=\"float-left rounded-0 ml-2\">\r\n            <button class=\"btn text-dark btn-sm py-0\" type=\"button\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\r\n              <span class=\"ion ion-md-more\"></span>\r\n            </button>\r\n            <div class=\"dropdown-menu small\">\r\n              <a href=\"javascript:void(0)\" class=\"dropdown-item btn btn-sm\" (click)=\"editItem(model)\" data-toggle=\"modal\" title=\"Edit\"><span class=\"ion ion-md-create\"></span> Edit</a>\r\n              <a href=\"javascript:void(0)\" class=\"dropdown-item btn btn-sm\" (click)=\"deleteItem(model.id)\" title=\"Delete\"><span class=\"ion ion-md-trash\"></span> Delete</a>\r\n            </div>\r\n          </div>\r\n\r\n        </td>\r\n      </ng-container>\r\n\r\n      <!-- campaign column -->\r\n      <ng-container matColumnDef=\"campaignType\">\r\n        <th *matHeaderCellDef mat-sort-header>Campaign Type</th>\r\n        <td mat-cell *matCellDef=\"let model\"> {{model.campaignTypeName}} </td>\r\n      </ng-container>\r\n\r\n\r\n      <!-- name column -->\r\n      <ng-container matColumnDef=\"range\">\r\n        <th *matHeaderCellDef mat-sort-header>Month Range</th>\r\n        <td mat-cell *matCellDef=\"let model\">{{model.fromMonth}} - {{model.toMonth}}</td>\r\n      </ng-container>\r\n\r\n      <!-- conversion column -->\r\n      <ng-container matColumnDef=\"convertMonth\">\r\n        <th *matHeaderCellDef mat-sort-header>Month Conversion</th>\r\n        <td mat-cell *matCellDef=\"let model\"> {{model.convertMonth}} </td>\r\n      </ng-container>\r\n\r\n\r\n\r\n      <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n      <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\"></tr>\r\n\r\n    </table>\r\n\r\n    <mat-paginator [length]=\"length\"\r\n                   [pageSize]=\"pageSize\"\r\n                   [pageSizeOptions]=\"pageSizeOptions\"\r\n                   (page)=\"pageEvent = $event\">\r\n    </mat-paginator>\r\n\r\n  </div>\r\n</div>\r\n\r\n<!-- footer actions -->\r\n<div class=\"row mb-3\">\r\n  <div class=\"col justify-content-md-end text-right\">\r\n    <button class=\"btn btn-primary\" (click)=\"openAddModal()\" >Add Month Conversion</button>\r\n  </div>\r\n</div>\r\n<!-- end footer actions --> \r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/notes/notes.component.html":
/*!*********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/notes/notes.component.html ***!
  \*********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- models grid -->\r\n<div class=\"row\">\r\n  <div class=\"col\"> \r\n     \r\n    <table mat-table matSort [dataSource]=\"dataSource\" class=\"small table-striped\">\r\n\r\n      <!-- actions -->\r\n      <ng-container matColumnDef=\"actions\">\r\n        <th *matHeaderCellDef class=\"text-left\">Action</th>\r\n        <td *matCellDef=\"let model\" class=\"left\">\r\n          <!-- mailing more settings -->\r\n          <div class=\"float-left rounded-0 ml-2\">\r\n            <button class=\"btn text-dark btn-sm py-0\" type=\"button\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\r\n              <span class=\"ion ion-md-more\"></span>\r\n            </button>\r\n            <div class=\"dropdown-menu small\">\r\n              <a href=\"javascript:void(0)\" class=\"dropdown-item btn btn-sm\" (click)=\"editItem(model)\" data-toggle=\"modal\" title=\"Edit\"><span class=\"ion ion-md-create\"></span> Edit</a>\r\n              <a *ngIf=\"userName == model.createdBy\" href=\"javascript:void(0)\" class=\"dropdown-item btn btn-sm\" (click)=\"deleteItem(model.id)\" title=\"Delete\"><span class=\"ion ion-md-trash\"></span> Delete</a>\r\n            </div>\r\n          </div>\r\n\r\n        </td>\r\n      </ng-container>\r\n\r\n\r\n      <!-- description column -->\r\n      <ng-container matColumnDef=\"description\">\r\n        <th *matHeaderCellDef mat-sort-header>Description</th>\r\n        <td mat-cell *matCellDef=\"let model\">{{model.description | truncateString:50}}</td>\r\n      </ng-container>\r\n\r\n\r\n      <!-- created by column -->\r\n      <ng-container matColumnDef=\"createdBy\">\r\n        <th *matHeaderCellDef mat-sort-header>Created By</th>\r\n        <td mat-cell *matCellDef=\"let model\">{{model.createdBy}}</td>\r\n      </ng-container>\r\n\r\n      <!-- created date column -->\r\n      <ng-container matColumnDef=\"createDate\">\r\n        <th *matHeaderCellDef mat-sort-header>Create Date</th>\r\n        <td mat-cell *matCellDef=\"let model\">{{model.createDate | date: 'MM/dd/yyyy'}}</td>\r\n      </ng-container>\r\n\r\n      <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n      <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\"></tr>\r\n\r\n    </table>\r\n\r\n    <mat-paginator [length]=\"length\"\r\n                   [pageSize]=\"pageSize\"\r\n                   [pageSizeOptions]=\"pageSizeOptions\"\r\n                   (page)=\"pageEvent = $event\">\r\n    </mat-paginator>\r\n\r\n  </div>\r\n</div>\r\n\r\n<!-- footer actions -->\r\n<div class=\"row mb-3\">\r\n  <div class=\"col justify-content-md-end text-right\">\r\n    <button class=\"btn btn-primary\" (click)=\"openAddModal()\" >Add Note</button>\r\n  </div>\r\n</div>\r\n<!-- end footer actions --> \r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/override-rules/override-rules.component.html":
/*!***************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/override-rules/override-rules.component.html ***!
  \***************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\r\n\r\n      <!-- heading -->\r\n      <h5 class=\"card-title\">Override Rules</h5>\r\n\r\n      <!-- filter -->\r\n      <div class=\"input-group mb-3\">\r\n        <input type=\"text\" class=\"form-control\" (keyup)=\"applyFilter($event)\" placeholder=\"Search rules...\">\r\n      </div>\r\n      <!-- end filter -->\r\n\r\n      <!-- overrideRules grid -->\r\n      <div class=\"row\">\r\n        <div class=\"col\">\r\n          <div class=\"table-responsive\"> \r\n            <table mat-table matSort [dataSource]=\"dataSource\" class=\"table table-sm small table-striped\">\r\n\r\n              <!-- actions -->\r\n              <ng-container matColumnDef=\"actions\">\r\n                <th *matHeaderCellDef mat-sort-header class=\"text-right\">Actions</th>\r\n                <td *matCellDef=\"let overrideRule\" class=\"text-right\">\r\n\r\n                  <div class=\"float-left rounded-0 ml-2\">\r\n                    <button class=\"btn text-dark btn-sm py-0\" type=\"button\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\">\r\n                      <span class=\"ion ion-md-more\"></span>\r\n                    </button>\r\n                    <div class=\"dropdown-menu small\">\r\n                      <a href=\"javascript:void(0)\" class=\"dropdown-item btn btn-sm\" (click)=\"editOverrideRule(overrideRule)\" data-toggle=\"modal\" title=\"Edit\"><span class=\"ion ion-md-create\"></span> Edit</a>\r\n                      <a href=\"javascript:void(0)\" class=\"dropdown-item btn btn-sm\" (click)=\"copyOverrideRule(overrideRule)\" title=\"Copy\"><span class=\"ion ion-md-copy\"></span> Copy</a>\r\n                      <a href=\"javascript:void(0)\" class=\"dropdown-item btn btn-sm\" (click)=\"deleteOverrideRule(overrideRule.id)\" title=\"Delete\"><span class=\"ion ion-md-trash\"></span> Delete</a>\r\n                    </div>\r\n                  </div>\r\n\r\n                </td>\r\n              </ng-container>\r\n\r\n              <!-- campaign type column -->\r\n              <ng-container matColumnDef=\"id\">\r\n                <th *matHeaderCellDef mat-sort-header>Id</th>\r\n                <td *matCellDef=\"let overrideRule\">{{overrideRule.id}}</td>\r\n              </ng-container>\r\n\r\n\r\n              <!-- campaign type column -->\r\n              <ng-container matColumnDef=\"campaignTypeName\">\r\n                <th *matHeaderCellDef mat-sort-header>Campaign Type</th>\r\n                <td *matCellDef=\"let overrideRule\">{{overrideRule.campaignTypeName}} <span class=\"badge text-light badge-info ml-1\" *ngIf=\"overrideRule.startDate >= now\">Active</span></td>\r\n              </ng-container>\r\n\r\n              <!-- storeName column -->\r\n              <ng-container matColumnDef=\"storeLocationName\">\r\n                <th *matHeaderCellDef mat-sort-header>Store Name</th>\r\n                <td *matCellDef=\"let overrideRule\">{{overrideRule.storeLocationName}}</td>\r\n              </ng-container>\r\n\r\n              <!-- name column -->\r\n              <ng-container matColumnDef=\"brandName\">\r\n                <th *matHeaderCellDef mat-sort-header>Brand</th>\r\n                <td *matCellDef=\"let overrideRule\">{{overrideRule.brandName}}</td>\r\n              </ng-container>\r\n\r\n              <!-- months column -->\r\n              <ng-container matColumnDef=\"months\">\r\n                <th *matHeaderCellDef mat-sort-header>Months</th>\r\n                <td *matCellDef=\"let overrideRule\">{{overrideRule.months}}</td>\r\n              </ng-container>\r\n\r\n              <!-- age range column -->\r\n              <ng-container matColumnDef=\"ageRangeName\">\r\n                <th *matHeaderCellDef mat-sort-header>Age Range</th>\r\n                <td *matCellDef=\"let overrideRule\">{{overrideRule.ageRangeName}}</td>\r\n              </ng-container>\r\n\r\n              <!-- gender column -->\r\n              <ng-container matColumnDef=\"gender\">\r\n                <th *matHeaderCellDef mat-sort-header>Gender</th>\r\n                <td *matCellDef=\"let overrideRule\">{{overrideRule.gender}}</td>\r\n              </ng-container>\r\n\r\n              <!-- priority column -->\r\n              <ng-container matColumnDef=\"priority\">\r\n                <th *matHeaderCellDef mat-sort-header>Priority</th>\r\n                <td *matCellDef=\"let overrideRule\">{{overrideRule.priority}}</td>\r\n              </ng-container>\r\n\r\n              <!-- startdate column -->\r\n              <ng-container matColumnDef=\"startDate\">\r\n                <th *matHeaderCellDef mat-sort-header>Start Date</th>\r\n                <td *matCellDef=\"let overrideRule\">{{overrideRule.startDate | date: 'MM/dd/yyyy'}}</td>\r\n              </ng-container>\r\n\r\n              <!-- enddate column -->\r\n              <ng-container matColumnDef=\"endDate\">\r\n                <th *matHeaderCellDef mat-sort-header>End Date</th>\r\n                <td *matCellDef=\"let overrideRule\">{{overrideRule.endDate | date: 'MM/dd/yyyy'}}</td>\r\n              </ng-container>\r\n\r\n              <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n              <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\"></tr>\r\n\r\n            </table>\r\n          </div>\r\n            <mat-paginator [length]=\"length\"\r\n                           [pageSize]=\"pageSize\"\r\n                           [pageSizeOptions]=\"pageSizeOptions\"\r\n                           (page)=\"pageEvent = $event\">\r\n            </mat-paginator>\r\n         \r\n        </div>\r\n      </div>\r\n\r\n      <!-- footer actions -->\r\n      <div class=\"row mb-3\">\r\n        <div class=\"col justify-content-md-end text-right\">\r\n          <button class=\"btn btn-primary mr-2\" (click)=\"exportData()\">Export to CSV</button>\r\n          <button class=\"btn btn-primary d-none1\" (click)=\"openAddModal()\">Add new rule</button>\r\n        </div>\r\n      </div>\r\n      <!-- end header actions -->\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/qc-report/qc-report.component.html":
/*!*****************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/qc-report/qc-report.component.html ***!
  \*****************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\r\n<div class=\"py-3\" *ngIf=\"mailing\">\r\n  <h1>{{mailing.name}}  <span *ngIf=\"mailing.isApproved\" class=\"text-success\">(Approved)</span></h1>\r\n\r\n\r\n  <!-- header actions -->\r\n  <div class=\"row mb-4\">\r\n    <div class=\"col justify-content-md-end\">\r\n      <a [routerLink]=\"['/mailings']\" class=\"mr-3 btn btn-secondary btn-sm\">All mailings</a>\r\n    </div>\r\n  </div>\r\n  <!-- end header actions -->\r\n\r\n  <div class=\"card tab-card\">\r\n    <div class=\"card-header tab-card-header\">\r\n      <ul class=\"nav nav-tabs card-header-tabs\" id=\"myTab\" role=\"tablist\">\r\n        <li class=\"nav-item\">\r\n          <a class=\"nav-link\" id=\"mailingdetails-tab\" [routerLink]=\"['/mailing', mailing.id]\" role=\"tab\" aria-selected=\"false\">Mailing Details</a>\r\n        </li>\r\n        <li class=\"nav-item\">\r\n          <a class=\"nav-link\" id=\"mailingfiles-tab\" [routerLink]=\"['/mailing/files', mailing.id]\" role=\"tab\" aria-selected=\"false\">Mailing Files</a>\r\n        </li>\r\n        <li class=\"nav-item\">\r\n          <a class=\"nav-link  active\" id=\"qcreport-tab\" [routerLink]=\"['/mailing/report', mailing.id]\" role=\"tab\" aria-selected=\"true\">QC Report</a>\r\n        </li>\r\n        <li class=\"nav-item\">\r\n          <a class=\"nav-link\" id=\"notes-tab\" [routerLink]=\"['/mailing/notes', mailing.id]\" role=\"tab\" aria-selected=\"false\">Notes</a>\r\n        </li>\r\n      </ul>\r\n    </div>\r\n    <div class=\"tab-content position-relative\" >\r\n      <div class=\"tab-pane show active fade p-3\" >\r\n        <h5 class=\"card-title\">QC Report</h5>\r\n\r\n        <!-- filter -->\r\n        <div class=\"input-group mb-3 d-none\">\r\n          <input type=\"text\" class=\"form-control\" (keyup)=\"applyFilter($event)\" placeholder=\"Search reports by name...\" aria-label=\"Search reports by name\">\r\n        </div>\r\n\r\n        <!-- end filter -->\r\n\r\n        <table mat-table matSort [dataSource]=\"dataSource\" class=\"table small table-striped\">\r\n\r\n          <!-- mailing file name column -->\r\n          <ng-container matColumnDef=\"mailingFile\">\r\n            <th *matHeaderCellDef mat-sort-header>Mailing File</th>\r\n            <td mat-cell *matCellDef=\"let report\"> <a class=\"btn btn-link\" href=\"javascript:void(0)\" (click)=\"mailingRecordsReport.getRecords(report.mailingFileId)\">{{report.mailingFileName}}</a></td>\r\n          </ng-container>\r\n\r\n          <!-- brand name column -->\r\n          <ng-container matColumnDef=\"brand\">\r\n            <th *matHeaderCellDef mat-sort-header>Brand</th>\r\n            <td mat-cell *matCellDef=\"let report\">{{report.brandName}}</td>\r\n          </ng-container>\r\n\r\n          <!-- patient id column -->\r\n          <ng-container matColumnDef=\"patientId\">\r\n            <th *matHeaderCellDef mat-sort-header>Patient Id</th>\r\n            <td mat-cell *matCellDef=\"let report\">{{report.patientId}}</td>\r\n          </ng-container>\r\n\r\n          <!-- patient id column -->\r\n          <ng-container matColumnDef=\"fullName\">\r\n            <th *matHeaderCellDef mat-sort-header>Last, First</th>\r\n            <td mat-cell *matCellDef=\"let report\"><a href=\"javascript:void(0)\" class=\"btn btn-link\" (click)=\"editMailingRecord(report.id)\">{{report.lastName}}, {{report.firstName}}</a></td>\r\n          </ng-container>\r\n\r\n          <!-- months column -->\r\n          <ng-container matColumnDef=\"monthsOriginal\">\r\n            <th *matHeaderCellDef mat-sort-header>Original Months</th>\r\n            <td mat-cell *matCellDef=\"let report\">{{report.monthsOriginal}}</td>\r\n          </ng-container>\r\n\r\n          <!-- months column -->\r\n          <ng-container matColumnDef=\"monthsConversion\">\r\n            <th *matHeaderCellDef mat-sort-header>Months Conversion</th>\r\n            <td mat-cell *matCellDef=\"let report\">{{report.months}}</td>\r\n          </ng-container>\r\n\r\n          <!-- campaigntype column -->\r\n          <ng-container matColumnDef=\"campaignType\">\r\n            <th *matHeaderCellDef mat-sort-header>Campaign Type</th>\r\n            <td mat-cell *matCellDef=\"let report\">{{report.campaignTypeName}}</td>\r\n          </ng-container>\r\n\r\n          <!-- birthday column -->\r\n          <ng-container matColumnDef=\"birthday\">\r\n            <th *matHeaderCellDef mat-sort-header>Birthday</th>\r\n            <td mat-cell *matCellDef=\"let report\">{{report.dateOfBirth}}</td>\r\n          </ng-container>\r\n\r\n          <!-- age column -->\r\n          <ng-container matColumnDef=\"age\">\r\n            <th *matHeaderCellDef mat-sort-header>Age</th>\r\n            <td mat-cell *matCellDef=\"let report\">{{report.age}}</td>\r\n          </ng-container>\r\n\r\n\r\n          <!-- notes column -->\r\n          <ng-container matColumnDef=\"notes\">\r\n            <th *matHeaderCellDef mat-sort-header>Notes</th>\r\n            <td mat-cell *matCellDef=\"let report\" class=\"text-danger\">{{report.notes}}</td>\r\n          </ng-container>\r\n\r\n          <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n          <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\"></tr>\r\n\r\n        </table>\r\n\r\n        <mat-paginator [length]=\"length\"\r\n                       [pageSize]=\"pageSize\"\r\n                       [pageSizeOptions]=\"pageSizeOptions\"\r\n                       (page)=\"pageEvent = $event\">\r\n        </mat-paginator>\r\n\r\n        <div class=\"text-right\">\r\n          <span *ngIf=\"showMsg\" class=\"text-success mr-3\">No issues were found. Keep up the good work!</span>\r\n\r\n          <button (click)=\"getRecords()\" [disabled]=\"loader1\" class=\"btn btn-primary\">Run Report</button>\r\n        </div>\r\n\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n  <!-- mailing records module that displays records based on mailing file -->\r\n  <app-mailing-record-list #mailingRecordsReport></app-mailing-record-list>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/reports/reports.component.html":
/*!*************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/reports/reports.component.html ***!
  \*************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"py-3\">\r\n    <h1 class=\"mb-4\">Reports</h1>\r\n\r\n    <button class=\"btn btn-primary mb-3\">Import Data Error Report</button><br />\r\n    <button class=\"btn btn-primary mb-3\">Mailing Type Report</button><br />\r\n    <button class=\"btn btn-primary mb-3\">Count by Member Report</button>\r\n</div>\r\n\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/subbrands/subbrands.component.html":
/*!*****************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/subbrands/subbrands.component.html ***!
  \*****************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<!-- heading -->\r\n<h5 class=\"card-title\">Brands</h5>\r\n\r\n<!-- filter -->\r\n<div class=\"input-group mb-3\">\r\n  <input type=\"text\" class=\"form-control\" (keyup)=\"applyFilter($event)\" placeholder=\"Search brands by name...\" aria-label=\"Search brands by name\">\r\n</div>\r\n<!-- end filter -->\r\n\r\n<!-- brands grid -->\r\n<div class=\"row\">\r\n  <div class=\"col\">\r\n\r\n    <table mat-table matSort [dataSource]=\"dataSource\" class=\"small table-striped\">\r\n\r\n      <!-- name column -->\r\n      <ng-container matColumnDef=\"name\">\r\n        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>\r\n        <td mat-cell *matCellDef=\"let brand\">{{brand.name}}</td>\r\n      </ng-container>\r\n\r\n      <!-- phone number column -->\r\n      <ng-container matColumnDef=\"phone\">\r\n        <th mat-header-cell *matHeaderCellDef>Phone</th>\r\n        <td mat-cell *matCellDef=\"let brand\"> {{brand.phone}} </td>\r\n      </ng-container>\r\n\r\n      <!-- email column -->\r\n      <ng-container matColumnDef=\"email\">\r\n        <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>\r\n        <td mat-cell *matCellDef=\"let brand\"> {{brand.email}} </td>\r\n      </ng-container>\r\n\r\n      <!-- url column -->\r\n      <ng-container matColumnDef=\"url\">\r\n        <th mat-header-cell *matHeaderCellDef mat-sort-header>Url</th>\r\n        <td mat-cell *matCellDef=\"let brand\"> {{brand.url}} </td>\r\n      </ng-container>\r\n\r\n      <!-- isActive column -->\r\n      <ng-container matColumnDef=\"isActive\">\r\n        <th mat-header-cell *matHeaderCellDef mat-sort-header>Is Active</th>\r\n        <td mat-cell *matCellDef=\"let brand\"> {{brand.isActive | yesNo}} </td>\r\n      </ng-container>\r\n\r\n      <!-- actions -->\r\n      <ng-container matColumnDef=\"actions\" class=\"text-right\">\r\n        <th mat-header-cell *matHeaderCellDef mat-sort-header class=\"text-right\">Actions</th>\r\n        <td mat-cell *matCellDef=\"let brand\" class=\"text-right\">\r\n          <a href=\"/brand/{{brand.id}}\" class=\"btn btn-sm btn-outline-primary mr-2\" title=\"Edit\"><span class=\"ion ion-md-create\"></span></a>\r\n          <!--<a href=\"javascript:void(0)\" class=\"btn btn-sm btn-outline-primary\" (click)=\"deletebrand(brand.id)\"><span class=\"ion ion-md-trash\"></span> Delete</a>-->\r\n        </td>\r\n      </ng-container>\r\n\r\n      <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\r\n      <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\"></tr>\r\n\r\n    </table>\r\n\r\n    <mat-paginator [length]=\"length\"\r\n                   [pageSize]=\"pageSize\"\r\n                   [pageSizeOptions]=\"pageSizeOptions\"\r\n                   (page)=\"pageEvent = $event\">\r\n    </mat-paginator>\r\n\r\n  </div>\r\n</div>\r\n\r\n<!-- footer actions -->\r\n<div class=\"row mb-3\">\r\n  <div class=\"col justify-content-md-end text-right\">\r\n    <button class=\"btn btn-primary\" type=\"button\" id=\"addBrandBtn\" data-toggle=\"modal\" data-target=\"#addBrandModal\">Add Brand</button>\r\n  </div>\r\n</div>\r\n<!-- end header actions -->\r\n\r\n<!-- add brand Modal -->\r\n<div class=\"modal fade\" id=\"addBrandModal\" tabindex=\"-1\" role=\"dialog\" aria-hidden=\"true\">\r\n  <div class=\"modal-dialog\" role=\"document\">\r\n    <div class=\"modal-content\">\r\n\r\n      <form [formGroup]=\"brandForm\" (ngSubmit)=\"addBrand()\">\r\n\r\n        <div class=\"modal-header\">\r\n          <h5 class=\"modal-title\">Add a Brand</h5>\r\n          <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-labbtn-primaryel=\"Close\">\r\n            <span aria-hidden=\"true\">&times;</span>\r\n          </button>\r\n        </div>\r\n        <div class=\"modal-body\">\r\n\r\n          <div class=\"form-group\">\r\n            <label>Brand name <span class=\"text-danger\">*</span></label>\r\n            <input type=\"text\" class=\"form-control\" formControlName=\"name\" [ngClass]=\"{ 'is-invalid': submitted && brandForm.controls.name.errors}\" />\r\n            <div *ngIf=\"submitted && brandForm.controls.name.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"brandForm.controls.name.errors.required\">Name is required</div>\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n        <div class=\"modal-footer\">\r\n          <button type=\"button\" class=\"btn btn-outline-primary\" data-dismiss=\"modal\">Cancel</button>\r\n          <button type=\"submit\" class=\"btn btn-primary\">\r\n           Submit\r\n          </button>\r\n        </div>\r\n      </form>\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n<!-- end add brand Modal-->\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/layout/nav-menu/nav-menu.component.html":
/*!*****************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/layout/nav-menu/nav-menu.component.html ***!
  \*****************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nav class=\"navbar navbar-expand-md fixed-top navbar-light bg-white bd-navbar border-bottom box-shadow mb-3\">\r\n  <a class=\"header-logo text-dark navbar-brand mr-0 mr-md-2\" [routerLink]=\"['/dashboard']\"><img src=\"../../../assets/images/logo.png\" alt=\"Logo\" /></a>\r\n  <button class=\"navbar-toggler\"\r\n          type=\"button\"\r\n          data-toggle=\"collapse\"\r\n          data-target=\".navbar-collapse\"\r\n          aria-label=\"Toggle navigation\"\r\n          [attr.aria-expanded]=\"isExpanded\"\r\n          (click)=\"toggle()\">\r\n    <span class=\"navbar-toggler-icon\"></span>\r\n  </button>\r\n\r\n  <div class=\"collapse navbar-collapse\" id=\"navbarsExampleDefault\" >\r\n    <ul class=\"navbar-nav mr-auto\" *ngIf=\"isAuthenticated | async\">\r\n       <li class=\"nav-item\"\r\n           [routerLinkActive]=\"['link-active']\"\r\n           [routerLinkActiveOptions]=\"{ exact: true }\">\r\n         <a class=\"nav-link text-dark\" [routerLink]=\"['/dashboard']\">Dashboard</a>\r\n       </li>\r\n       <li class=\"nav-item\" [routerLinkActive]=\"['link-active']\">\r\n         <a class=\"nav-link text-dark\" [routerLink]=\"['/brands']\">Brands</a>\r\n       </li>\r\n       <li class=\"nav-item\" [routerLinkActive]=\"['link-active']\">\r\n         <a class=\"nav-link text-dark\" [routerLink]=\"['/mailings']\">Mailings</a>\r\n       </li>\r\n       <li class=\"nav-item d-none\" [routerLinkActive]=\"['link-active']\">\r\n         <a class=\"nav-link text-dark\" [routerLink]=\"['/reports']\">Reports</a>\r\n       </li>\r\n       <li class=\"nav-item d-none\" [routerLinkActive]=\"['link-active']\">\r\n         <a class=\"nav-link text-dark\" [routerLink]=\"['/billing']\">Billing</a>\r\n       </li> \r\n    </ul>\r\n    <app-login-menu></app-login-menu> \r\n  </div>\r\n</nav> \r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/brand-picker-modal/brand-picker.component.html":
/*!*******************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/brand-picker-modal/brand-picker.component.html ***!
  \*******************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"modal-header\">\r\n  <h5 class=\"modal-title\">{{title}}</h5>\r\n  <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"dismiss()\">\r\n    <span aria-hidden=\"true\">&times;</span>\r\n  </button>\r\n</div>\r\n<div class=\"modal-body\">\r\n  <!-- filter -->\r\n  <div class=\"input-group mb-3\">\r\n    <input type=\"text\" class=\"form-control\" (keyup)=\"applyFilter($event)\" placeholder=\"Search brand by name...\">\r\n  </div>\r\n  <!-- end filter -->\r\n  <div class=\"pre-scrollable\">\r\n    <ul class=\"list-group list-group-flush\">\r\n      <li class=\"list-group-item\" *ngFor=\"let brand of filteredBrands\">\r\n        <a class=\"btn-link\" href=\"/brand/{{brand.id}}\">{{brand.name}} <span class=\"badge text-light badge-info ml-1\">{{brand.brandId == 0 ? 'Master' : ''}}</span></a>\r\n      </li>\r\n    </ul>\r\n  </div>\r\n</div> \r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/brand-seed-modal/brand-seed-form.component.html":
/*!********************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/brand-seed-modal/brand-seed-form.component.html ***!
  \********************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<form [formGroup]=\"modelForm\" (ngSubmit)=\"onSubmit()\">\r\n  <input type=\"hidden\" formControlName=\"id\" />\r\n  <input type=\"hidden\" formControlName=\"brandId\" />\r\n\r\n  <div class=\"modal-header\">\r\n    <h5 class=\"modal-title\">{{title}}</h5>\r\n    <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"dismiss()\">\r\n      <span aria-hidden=\"true\">&times;</span>\r\n    </button>\r\n  </div>\r\n\r\n  <div class=\"modal-body\">\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-sm-6\">\r\n        <div class=\"form-group\">\r\n          <label>Patient Id</label>\r\n          <input type=\"text\" class=\"form-control\" formControlName=\"patientId\" [ngClass]=\"{'is-invalid': submitted && modelForm.controls.patientId.errors}\" />\r\n        </div>\r\n      </div>\r\n      <div class=\"col-sm-6\">\r\n        <div class=\"form-group\">\r\n          <label>CLX Patient Id</label>\r\n          <input type=\"text\" class=\"form-control\" formControlName=\"clxPatientId\" [ngClass]=\"{'is-invalid': submitted && modelForm.controls.clxPatientId.errors}\" />\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-sm-6\">\r\n        <div class=\"form-group\">\r\n          <label>First Name <span class=\"text-danger\">*</span></label>\r\n          <input type=\"text\" class=\"form-control\" formControlName=\"firstName\" [ngClass]=\"{'is-invalid': submitted && modelForm.controls.firstName.errors}\" />\r\n          <div *ngIf=\"submitted && modelForm.controls.firstName.errors\" class=\"invalid-feedback\">\r\n            <div *ngIf=\"modelForm.controls.firstName.errors.required\">First Name is required</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-sm-6\">\r\n        <div class=\"form-group\">\r\n          <label>Last Name <span class=\"text-danger\">*</span></label>\r\n          <input type=\"text\" class=\"form-control\" formControlName=\"lastName\" [ngClass]=\"{'is-invalid': submitted && modelForm.controls.lastName.errors}\" />\r\n          <div *ngIf=\"submitted && modelForm.controls.lastName.errors\" class=\"invalid-feedback\">\r\n            <div *ngIf=\"modelForm.controls.lastName.errors.required\">Last Name is required</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n\r\n    <div class=\"form-group\">\r\n      <label>Address 1 <span class=\"text-danger\">*</span></label>\r\n      <input type=\"text\" class=\"form-control\" formControlName=\"address1\" [ngClass]=\"{ 'is-invalid': submitted && modelForm.controls.address1.errors }\" />\r\n      <div *ngIf=\"submitted && modelForm.controls.address1.errors\" class=\"invalid-feedback\">\r\n        <div *ngIf=\"modelForm.controls.address1.errors.required\">Address 1 is required</div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n      <label>Address 2</label>\r\n      <input type=\"text\" class=\"form-control\" formControlName=\"address2\" [ngClass]=\"{ 'is-invalid': submitted && modelForm.controls.address2.errors }\" />\r\n      <div *ngIf=\"submitted && modelForm.controls.address2.errors\" class=\"invalid-feedback\">\r\n        <div *ngIf=\"modelForm.controls.address2.errors.required\">Address 2 is required</div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-sm-5\">\r\n        <div class=\"form-group\">\r\n          <label>City <span class=\"text-danger\">*</span></label>\r\n          <input type=\"text\" class=\"form-control\" formControlName=\"city\" [ngClass]=\"{ 'is-invalid': submitted && modelForm.controls.city.errors }\" />\r\n          <div *ngIf=\"submitted && modelForm.controls.city.errors\" class=\"invalid-feedback\">\r\n            <div *ngIf=\"modelForm.controls.city.errors.required\">City is required</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-sm-4\">\r\n        <div class=\"form-group\">\r\n          <label>State <span class=\"text-danger\">*</span></label>\r\n          <select formControlName=\"state\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && modelForm.controls.state.errors }\">\r\n            <option [value]=\"null\">Choose...</option>\r\n            <option *ngFor=\"let state of stateList\" [value]=\"state.abbreviation\">{{state.abbreviation}}</option>\r\n          </select>\r\n          <div *ngIf=\"submitted && modelForm.controls.state.errors\" class=\"invalid-feedback\">\r\n            <div *ngIf=\"modelForm.controls.state.errors.required\">State is required</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-sm-3\">\r\n        <div class=\"form-group\">\r\n          <label>Zip Code <span class=\"text-danger\">*</span></label>\r\n          <input type=\"text\" class=\"form-control\" formControlName=\"zipCode\" placeholder=\"00000\" [ngClass]=\"{ 'is-invalid': submitted && modelForm.controls.zipCode.errors }\" />\r\n          <div *ngIf=\"submitted && modelForm.controls.zipCode.errors\" class=\"invalid-feedback\">\r\n            <div *ngIf=\"modelForm.controls.zipCode.errors.required\">Zip Code is required</div>\r\n            <div *ngIf=\"modelForm.controls.zipCode.errors.zipCode\">Zip Code must be five digits</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-sm-4\">\r\n        <div class=\"form-group\">\r\n          <label>Gender <span class=\"text-danger\">*</span></label>\r\n          <select formControlName=\"gender\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && modelForm.controls.gender.errors }\">\r\n            <option [value]=\"null\">Choose...</option>\r\n            <option *ngFor=\"let gender of genderList\" [value]=\"gender\">{{gender}}</option>\r\n          </select>\r\n          <div *ngIf=\"submitted && modelForm.controls.gender.errors\" class=\"invalid-feedback\">\r\n            <div *ngIf=\"modelForm.controls.gender.errors.required\">Gender is required</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-sm-4\">\r\n        <div class=\"form-group\">\r\n          <label>Date of Birth</label>\r\n          <input type=\"text\" class=\"form-control\" formControlName=\"dateOfBirth\" placeholder=\"mm/dd/yyyy\" [ngClass]=\"{'is-invalid': submitted && modelForm.controls.dateOfBirth.errors}\" />\r\n          <div *ngIf=\"submitted && modelForm.controls.dateOfBirth.errors\" class=\"invalid-feedback\">\r\n            <div *ngIf=\"modelForm.controls.dateOfBirth.errors.required\">Date of Birth is required</div>\r\n            <div *ngIf=\"modelForm.controls.dateOfBirth.errors.pattern\">Date of Birth is invalid</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-sm-4\">\r\n\r\n\r\n        <div class=\"row\"> \r\n            <div class=\"col-sm-12\">\r\n              <div class=\"form-group\">\r\n                <label>Months</label>\r\n                <input type=\"number\" class=\"form-control\" formControlName=\"months\" [ngClass]=\"{'is-invalid': submitted && modelForm.controls.months.errors}\" />\r\n                <div *ngIf=\"submitted && modelForm.controls.months.errors\" class=\"invalid-feedback\">\r\n                  <div *ngIf=\"modelForm.controls.months.errors.required\">Months is required</div>\r\n                  <div *ngIf=\"modelForm.controls.months.errors.min\">Months must be zero or greater</div>\r\n                  <div *ngIf=\"modelForm.controls.months.errors.numeric\">Months must be a number</div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n          <!--<div class=\"form-group\">\r\n            <label>Last Exam Date</label>\r\n            <input type=\"text\" class=\"form-control\" formControlName=\"lastExamDate\" placeholder=\"mm/dd/yyyy\" [ngClass]=\"{'is-invalid': submitted && modelForm.controls.lastExamDate.errors}\" />\r\n            <div *ngIf=\"submitted && modelForm.controls.lastExamDate.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"modelForm.controls.lastExamDate.errors.required\">Last Exam Date is required</div>\r\n              <div *ngIf=\"modelForm.controls.lastExamDate.errors.pattern\">Last Exam Date is invalid</div>\r\n            </div>\r\n          </div>-->\r\n\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-sm-6\">\r\n        <div class=\"form-group\">\r\n          <label>Phone</label>\r\n          <input type=\"text\" class=\"form-control\" formControlName=\"phone\" placeholder=\"000-000-0000\" [ngClass]=\"{'is-invalid': submitted && modelForm.controls.phone.errors}\" />\r\n          <div *ngIf=\"submitted && modelForm.controls.phone.errors\" class=\"invalid-feedback\">\r\n            <div *ngIf=\"modelForm.controls.phone.errors.required\">Phone is required</div>\r\n            <div *ngIf=\"modelForm.controls.phone.errors.phone\">Phone format is invalid</div>\r\n\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-sm-6\">\r\n\r\n        <div class=\"form-group\">\r\n          <label>Email</label>\r\n          <input type=\"text\" class=\"form-control\" formControlName=\"email\" [ngClass]=\"{'is-invalid': submitted && modelForm.controls.email.errors}\" />\r\n          <div *ngIf=\"submitted && modelForm.controls.email.errors\" class=\"invalid-feedback\">\r\n            <div *ngIf=\"modelForm.controls.email.errors.required\">Email is required</div>\r\n            <div *ngIf=\"modelForm.controls.email.errors.email\">Email format is invalid</div>\r\n\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n   \r\n    <div class=\"row\">\r\n      <div class=\"col-sm-6\">\r\n        <div class=\"form-group\">\r\n          <label>Campaign Type <span class=\"text-danger\">*</span></label>\r\n          <select formControlName=\"campaignTypeId\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && modelForm.controls.campaignTypeId.errors }\">\r\n            <option [value]=\"0\">Choose...</option>\r\n            <option *ngFor=\"let campaignType of campaignTypeList\" [value]=\"campaignType.id\">{{campaignType.name}}</option>\r\n          </select>\r\n          <div *ngIf=\"submitted && modelForm.controls.campaignTypeId.errors\" class=\"invalid-feedback\">\r\n            <div *ngIf=\"modelForm.controls.campaignTypeId.errors.required || modelForm.controls.campaignTypeId.errors.min\">Campaign Type is required</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-sm-6\">\r\n        <div class=\"form-group\">\r\n          <label>Store Location</label>\r\n          <select formControlName=\"storeLocationId\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && modelForm.controls.storeLocationId.errors }\">\r\n            <option [ngValue]=\"0\">Choose...</option>\r\n            <option *ngFor=\"let store of storeLocationList\" [ngValue]=\"store.id\">{{store.name}}</option>\r\n          </select>\r\n          <div *ngIf=\"submitted && modelForm.controls.storeLocationId.errors\" class=\"invalid-feedback\">\r\n            <div *ngIf=\"modelForm.controls.storeLocationId.errors.required\">Store Location is required</div>\r\n            <div *ngIf=\"modelForm.controls.storeLocationId.errors.min\">Store Location is required</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n       \r\n    <div class=\"form-group\">\r\n      <label>Custom 1</label>\r\n      <input type=\"text\" class=\"form-control\" formControlName=\"custom1\" [ngClass]=\"{'is-invalid': submitted && modelForm.controls.custom1.errors}\" />\r\n      <div *ngIf=\"submitted && modelForm.controls.custom1.errors\" class=\"invalid-feedback\">\r\n      </div>\r\n    </div>\r\n\r\n\r\n    <div class=\"form-group\">\r\n      <label>Custom 2</label>\r\n      <input type=\"text\" class=\"form-control\" formControlName=\"custom2\" [ngClass]=\"{'is-invalid': submitted && modelForm.controls.custom2.errors}\" />\r\n      <div *ngIf=\"submitted && modelForm.controls.custom2.errors\" class=\"invalid-feedback\">\r\n      </div>\r\n    </div>\r\n\r\n\r\n    <div class=\"form-group\">\r\n      <label>Custom 3</label>\r\n      <input type=\"text\" class=\"form-control\" formControlName=\"custom3\" [ngClass]=\"{'is-invalid': submitted && modelForm.controls.custom3.errors}\" />\r\n      <div *ngIf=\"submitted && modelForm.controls.custom3.errors\" class=\"invalid-feedback\">\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n      <label>Custom 4</label>\r\n      <input type=\"text\" class=\"form-control\" formControlName=\"custom4\" [ngClass]=\"{'is-invalid': submitted && modelForm.controls.custom4.errors}\" />\r\n      <div *ngIf=\"submitted && modelForm.controls.custom4.errors\" class=\"invalid-feedback\">\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n      <label>Custom 5</label>\r\n      <input type=\"text\" class=\"form-control\" formControlName=\"custom5\" [ngClass]=\"{'is-invalid': submitted && modelForm.controls.custom5.errors}\" />\r\n      <div *ngIf=\"submitted && modelForm.controls.custom5.errors\" class=\"invalid-feedback\">\r\n      </div>\r\n    </div>\r\n\r\n  </div>\r\n  <div class=\"modal-footer\">\r\n    <button type=\"button\" class=\"btn btn-outline-dark\" (click)=\"decline()\">Close</button>\r\n    <button type=\"submit\" class=\"btn btn-primary\">Submit</button>\r\n  </div>\r\n\r\n</form>\r\n\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/creative-template-add-modal/creative-template-add.component.html":
/*!*************************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/creative-template-add-modal/creative-template-add.component.html ***!
  \*************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<form [formGroup]=\"editForm\" (ngSubmit)=\"onSubmit()\">\r\n\r\n    <div class=\"modal-header\">\r\n      <h5 class=\"modal-title\">{{title}}</h5>\r\n      <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"dismiss()\">\r\n        <span aria-hidden=\"true\">&times;</span>\r\n      </button>\r\n    </div>\r\n    <div class=\"modal-body\">\r\n      <input type=\"hidden\" formControlName=\"brandId\" />\r\n\r\n      <div class=\"form-group\">\r\n        <label>Campaign Type <span class=\"text-danger\">*</span></label>\r\n        <select class=\"form-control\" formControlName=\"campaignTypeId\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.campaignTypeId.errors }\" (change)=\"onChangeCampaignType($event.target.value)\">\r\n          <option [ngValue]=\"null\">Choose...</option>\r\n          <option *ngFor=\"let campaignType of campaignTypeList\" [value]=\"campaignType.id\">\r\n            {{campaignType.name}}\r\n          </option>\r\n        </select>\r\n        <div *ngIf=\"submitted && editForm.controls.campaignTypeId.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.campaignTypeId.errors.required\">Campaign Type is required</div>\r\n          <div *ngIf=\"editForm.controls.campaignTypeId.errors.min\">Campaign Type is invalid</div>\r\n        </div>\r\n      </div>\r\n\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-sm-4\">\r\n          <div class=\"form-group\">\r\n            <label>Months</label>\r\n            <select formControlName=\"months\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.months.errors }\">\r\n              <option [value]=\"0\">Choose...</option>\r\n              <option *ngFor=\"let m of monthsList\" [value]=\"m.months\">{{m.months}}</option>\r\n            </select>\r\n            <div *ngIf=\"submitted && editForm.controls.months.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"editForm.controls.months.errors.required\">Months is required</div>\r\n              <div *ngIf=\"editForm.controls.months.errors.numeric\">Months must be a number</div>\r\n            </div> \r\n          </div> \r\n        </div>\r\n\r\n        <div class=\"col-sm-4\">\r\n          <div class=\"form-group\">\r\n            <label>Age Range <span class=\"text-danger\">*</span></label>\r\n            <select formControlName=\"ageRangeId\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.ageRangeId.errors }\">\r\n              <option [ngValue]=\"null\">Choose...</option>\r\n              <option *ngFor=\"let range of ageRangeList\" [value]=\"range.id\">{{range.range}}</option>\r\n            </select>\r\n            <div *ngIf=\"submitted && editForm.controls.ageRangeId.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"editForm.controls.ageRangeId.errors.required\">Age Range is required</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-sm-4\">\r\n          <div class=\"form-group\">\r\n            <label>Gender <span class=\"text-danger\">*</span></label>\r\n            <select formControlName=\"gender\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.gender.errors }\">\r\n              <option [value]=\"null\">Choose...</option>\r\n              <option *ngFor=\"let gender of genderList\" [value]=\"gender\">{{gender}}</option>\r\n            </select>\r\n            <div *ngIf=\"submitted && editForm.controls.gender.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"editForm.controls.gender.errors.required\">Gender is required</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n\r\n      <!--\r\n  <div class=\"form-group\">\r\n    <label>Store Location <span class=\"text-danger\">*</span></label>\r\n    <select formControlName=\"storeLocationId\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.storeLocationId.errors }\">\r\n      <option [value]=\"null\">Choose...</option>\r\n      <option *ngFor=\"let store of storeLocationList\" [value]=\"store.id\">{{store.name}}</option>\r\n    </select>\r\n    <div *ngIf=\"submitted && editForm.controls.storeLocationId.errors\" class=\"invalid-feedback\">\r\n      <div *ngIf=\"editForm.controls.storeLocationId.errors.required\">Store Location is required</div>\r\n    </div>\r\n  </div>\r\n  -->\r\n\r\n      <div class=\"form-group\">\r\n        <label>Front Image</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"frontImage\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.frontImage.errors }\" />\r\n        <div *ngIf=\"submitted && editForm.controls.frontImage.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.frontImage.errors.required\">Front Image is required</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-sm-6\">\r\n          <div class=\"form-group\">\r\n            <label>Front CTA</label>\r\n            <input type=\"text\" class=\"form-control\" formControlName=\"frontCTA\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.frontCTA.errors }\" />\r\n            <div *ngIf=\"submitted && editForm.controls.frontCTA.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"editForm.controls.locationId.errors.required\">Front CTA is required</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-sm-6\">\r\n          <div class=\"form-group\">\r\n            <label>Front Offer</label>\r\n            <input type=\"text\" class=\"form-control\" formControlName=\"frontOffer\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.frontOffer.errors }\" />\r\n            <div *ngIf=\"submitted && editForm.controls.frontOffer.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"editForm.controls.frontOffer.errors.required\">Front Offer is required</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label>Front Logo</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"frontLogo\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.frontLogo.errors }\" />\r\n        <div *ngIf=\"submitted && editForm.controls.frontLogo.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.frontLogo.errors.required\">Front Logo is required</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label>Back Logo</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"backLogo\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.backLogo.errors }\" />\r\n        <div *ngIf=\"submitted && editForm.controls.backLogo.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.backLogo.errors.required\">Back Logo is required</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label>Back CTA</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"backCTA\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.backCTA.errors }\" />\r\n        <div *ngIf=\"submitted && editForm.controls.backCTA.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.backCTA.errors.required\">Back CTA is required</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label>Back Background</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"backBackground\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.backBackground.errors }\" />\r\n        <div *ngIf=\"submitted && editForm.controls.backBackground.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.backBackground.errors.required\">Back Background is required</div>\r\n        </div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label>Back Top Left Copy</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"backTopLeftCopy\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.backTopLeftCopy.errors }\" />\r\n        <div *ngIf=\"submitted && editForm.controls.backTopLeftCopy.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.backTopLeftCopy.errors.required\">Back Top Left Copy is required</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label>Back Offer Block</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"backOfferBlock\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.backOfferBlock.errors}\" />\r\n        <div *ngIf=\"submitted && editForm.controls.backOfferBlock.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.backOfferBlock.errors.required\">Back Offer Block is required</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label>Back Store Block</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"backStoreBlock\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.backStoreBlock.errors}\" />\r\n        <div *ngIf=\"submitted && editForm.controls.backStoreBlock.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.backStoreBlock.errors.required\">Back Store Block is required</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label>Back Bottom Left Copy</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"backBottomLeftCopy\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.backBottomLeftCopy.errors}\" />\r\n        <div *ngIf=\"submitted && editForm.controls.backBottomLeftCopy.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.backBottomLeftCopy.errors.required\">Back Bottom Left Copy is required</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label>Style</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"style\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.style.errors}\" />\r\n        <div *ngIf=\"submitted && editForm.controls.style.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.style.errors.required\">Style is required</div>\r\n        </div>\r\n      </div>\r\n       \r\n      <!--<div class=\"form-group\">\r\n        <label>Custom 1</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"custom1\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.custom1.errors }\" />\r\n        <div *ngIf=\"submitted && editForm.controls.custom1.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.custom1.errors.required\">Custom 1 is required</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label>Custom 2</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"custom2\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.custom2.errors }\" />\r\n        <div *ngIf=\"submitted && editForm.controls.custom2.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.custom2.errors.required\">Custom 2 is required</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label>Custom 3</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"custom3\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.custom3.errors }\" />\r\n        <div *ngIf=\"submitted && editForm.controls.custom3.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.custom3.errors.required\">Custom 3 is required</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label>Custom 4</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"custom4\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.custom4.errors }\" />\r\n        <div *ngIf=\"submitted && editForm.controls.custom4.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.custom4.errors.required\">Custom 4 is required</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label>Custom 5</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"custom5\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.custom5.errors }\" />\r\n        <div *ngIf=\"submitted && editForm.controls.custom5.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.custom5.errors.required\">Custom 5 is required</div>\r\n        </div>\r\n      </div>-->\r\n\r\n    </div>\r\n    <div class=\"modal-footer\">\r\n      <button type=\"button\" class=\"btn btn-outline-dark\" (click)=\"decline()\">Close</button>\r\n      <button type=\"submit\" class=\"btn btn-primary\">Submit</button>\r\n    </div>\r\n\r\n</form>\r\n\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/creative-template-edit-modal/creative-template-edit.component.html":
/*!***************************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/creative-template-edit-modal/creative-template-edit.component.html ***!
  \***************************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<form [formGroup]=\"editForm\" (ngSubmit)=\"onSubmit()\">\r\n\r\n    <div class=\"modal-header\">\r\n      <h5 class=\"modal-title\">{{title}}</h5>\r\n      <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"dismiss()\">\r\n        <span aria-hidden=\"true\">&times;</span>\r\n      </button>\r\n    </div>\r\n    <div class=\"modal-body\">\r\n      <input type=\"hidden\" formControlName=\"brandId\" />\r\n\r\n      <div class=\"form-group\">\r\n        <label>Campaign Type <span class=\"text-danger\">*</span></label>\r\n        <select class=\"form-control\" formControlName=\"campaignTypeId\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.campaignTypeId.errors }\">\r\n          <option [ngValue]=\"0\">Choose...</option>\r\n          <option *ngFor=\"let campaignType of campaignTypeList\" [value]=\"campaignType.id\">\r\n            {{campaignType.name}}\r\n          </option>\r\n        </select>\r\n        <div *ngIf=\"submitted && editForm.controls.campaignTypeId.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.campaignTypeId.errors.required\">Campaign Type is required</div>\r\n          <div *ngIf=\"editForm.controls.campaignTypeId.errors.min\">Campaign Type is invalid</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-sm-4\">\r\n          <div class=\"form-group\">\r\n            <label>Months</label>\r\n            <select formControlName=\"months\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.months.errors }\">\r\n              <option [value]=\"0\">Choose...</option>\r\n              <option *ngFor=\"let m of monthsList\" [value]=\"m.months\">{{m.months}}</option>\r\n            </select>\r\n            <div *ngIf=\"submitted && editForm.controls.months.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"editForm.controls.months.errors.required\">Months is required</div>\r\n              <div *ngIf=\"editForm.controls.months.errors.numeric\">Months must be a number</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-sm-4\">\r\n          <div class=\"form-group\">\r\n            <label>Age Range <span class=\"text-danger\">*</span></label>\r\n            <select formControlName=\"ageRangeId\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.ageRangeId.errors }\">\r\n              <option [ngValue]=\"null\">Choose...</option>\r\n              <option *ngFor=\"let range of ageRangeList\" [value]=\"range.id\">{{range.range}}</option>\r\n            </select>\r\n            <div *ngIf=\"submitted && editForm.controls.ageRangeId.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"editForm.controls.ageRangeId.errors.required\">Age Range is required</div>\r\n              <div *ngIf=\"editForm.controls.ageRangeId.errors.min\">Age Range is invalid</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-sm-4\">\r\n          <div class=\"form-group\">\r\n            <label>Gender <span class=\"text-danger\">*</span></label>\r\n            <select formControlName=\"gender\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.gender.errors }\" required>\r\n              <option value=\"\">Choose...</option>\r\n              <option *ngFor=\"let gender of genderList\" [value]=\"gender\">{{gender}}</option>\r\n            </select>\r\n            <div *ngIf=\"submitted && editForm.controls.gender.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"editForm.controls.gender.errors.required\">Gender is required</div>\r\n              <div *ngIf=\"editForm.controls.gender.errors.min\">Gender is invalid</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <!--\r\n  <div class=\"form-group\">\r\n    <label>Store Location <span class=\"text-danger\">*</span></label>\r\n    <select formControlName=\"storeLocationId\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.storeLocationId.errors }\">\r\n      <option [value]=\"0\">Choose...</option>\r\n      <option *ngFor=\"let store of storeLocationList\" [ngValue]=\"store.id\">{{store.name}}</option>\r\n    </select>\r\n    <div *ngIf=\"submitted && editForm.controls.storeLocationId.errors\" class=\"invalid-feedback\">\r\n      <div *ngIf=\"editForm.controls.storeLocationId.errors.required\">Store Location is required</div>\r\n      <div *ngIf=\"editForm.controls.storeLocationId.errors.min\">Store Location is invalid</div>\r\n    </div>\r\n  </div>\r\n    -->\r\n\r\n      <div class=\"form-group\">\r\n        <label>Front Image</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"frontImage\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.frontImage.errors }\" />\r\n        <div *ngIf=\"submitted && editForm.controls.frontImage.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.frontImage.errors.required\">Front Image is required</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-sm-6\">\r\n          <div class=\"form-group\">\r\n            <label>Front CTA</label>\r\n            <input type=\"text\" class=\"form-control\" formControlName=\"frontCTA\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.frontCTA.errors }\" />\r\n            <div *ngIf=\"submitted && editForm.controls.frontCTA.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"editForm.controls.locationId.errors.required\">Front CTA is required</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-sm-6\">\r\n          <div class=\"form-group\">\r\n            <label>Front Offer</label>\r\n            <input type=\"text\" class=\"form-control\" formControlName=\"frontOffer\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.frontOffer.errors }\" />\r\n            <div *ngIf=\"submitted && editForm.controls.frontOffer.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"editForm.controls.frontOffer.errors.required\">Front Offer is required</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label>Front Logo</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"frontLogo\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.frontLogo.errors }\" />\r\n        <div *ngIf=\"submitted && editForm.controls.frontLogo.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.frontLogo.errors.required\">Front Logo is required</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label>Back Logo</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"backLogo\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.backLogo.errors }\" />\r\n        <div *ngIf=\"submitted && editForm.controls.backLogo.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.backLogo.errors.required\">Back Logo is required</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label>Back CTA</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"backCTA\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.backCTA.errors }\" />\r\n        <div *ngIf=\"submitted && editForm.controls.backCTA.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.backCTA.errors.required\">Back CTA is required</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label>Back Background</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"backBackground\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.backBackground.errors }\" />\r\n        <div *ngIf=\"submitted && editForm.controls.backBackground.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.backBackground.errors.required\">Back Background is required</div>\r\n        </div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label>Back Top Left Copy</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"backTopLeftCopy\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.backTopLeftCopy.errors }\" />\r\n        <div *ngIf=\"submitted && editForm.controls.backTopLeftCopy.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.backTopLeftCopy.errors.required\">Back Top Left Copy is required</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label>Back Offer Block</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"backOfferBlock\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.backOfferBlock.errors}\" />\r\n        <div *ngIf=\"submitted && editForm.controls.backOfferBlock.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.backOfferBlock.errors.required\">Back Offer Block is required</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label>Back Store Block</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"backStoreBlock\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.backStoreBlock.errors}\" />\r\n        <div *ngIf=\"submitted && editForm.controls.backStoreBlock.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.backStoreBlock.errors.required\">Back Store Block is required</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label>Back Bottom Left Copy</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"backBottomLeftCopy\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.backBottomLeftCopy.errors}\" />\r\n        <div *ngIf=\"submitted && editForm.controls.backBottomLeftCopy.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.backBottomLeftCopy.errors.required\">Back Bottom Left Copy is required</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label>Style</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"style\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.style.errors}\" />\r\n        <div *ngIf=\"submitted && editForm.controls.style.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.style.errors.required\">Style is required</div>\r\n        </div>\r\n      </div>\r\n\r\n      <!--<div class=\"form-group\">\r\n        <label>Custom 1</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"custom1\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.custom1.errors }\" />\r\n        <div *ngIf=\"submitted && editForm.controls.custom1.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.custom1.errors.required\">Custom 1 is required</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label>Custom 2</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"custom2\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.custom2.errors }\" />\r\n        <div *ngIf=\"submitted && editForm.controls.custom2.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.custom2.errors.required\">Custom 2 is required</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label>Custom 3</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"custom3\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.custom3.errors }\" />\r\n        <div *ngIf=\"submitted && editForm.controls.custom3.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.custom3.errors.required\">Custom 3 is required</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label>Custom 4</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"custom4\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.custom4.errors }\" />\r\n        <div *ngIf=\"submitted && editForm.controls.custom4.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.custom4.errors.required\">Custom 4 is required</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label>Custom 5</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"custom5\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.custom5.errors }\" />\r\n        <div *ngIf=\"submitted && editForm.controls.custom5.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.custom5.errors.required\">Custom 5 is required</div>\r\n        </div>\r\n      </div>-->\r\n\r\n\r\n    </div>\r\n    <div class=\"modal-footer\">\r\n      <button type=\"button\" class=\"btn btn-outline-dark\" (click)=\"decline()\">Close</button>\r\n      <button type=\"submit\" class=\"btn btn-primary\">Submit</button>\r\n    </div> \r\n</form>\r\n\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/location-add-modal/location-add.component.html":
/*!*******************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/location-add-modal/location-add.component.html ***!
  \*******************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<form [formGroup]=\"addForm\" (ngSubmit)=\"onSubmit()\">\r\n\r\n    <div class=\"modal-header\">\r\n      <h5 class=\"modal-title\">{{title}}</h5>\r\n      <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"activeModal.dismiss('Cross click')\">\r\n        <span aria-hidden=\"true\">&times;</span>\r\n      </button>\r\n    </div>\r\n    <div class=\"modal-body\">\r\n\r\n      <input type=\"hidden\" formControlName=\"brandId\" />\r\n\r\n      <div class=\"form-group\">\r\n        <label>Name <span class=\"text-danger\">*</span></label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"name\" [ngClass]=\"{ 'is-invalid': submitted && addForm.controls.name.errors }\" />\r\n        <div *ngIf=\"submitted && addForm.controls.name.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"addForm.controls.name.errors.required\">Name is required</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-sm-12\">\r\n          <div class=\"form-group\">\r\n            <label>Store ID</label>\r\n            <input type=\"text\" class=\"form-control\" formControlName=\"storeId\" [ngClass]=\"{ 'is-invalid': submitted && addForm.controls.storeId.errors }\" />\r\n            <div *ngIf=\"submitted && addForm.controls.storeId.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"addForm.controls.storeId.errors.required\">Store Id is required</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n\r\n      <div class=\"form-group\">\r\n        <label>Address 1 <span class=\"text-danger\">*</span></label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"address1\" [ngClass]=\"{ 'is-invalid': submitted && addForm.controls.address1.errors }\" />\r\n        <div *ngIf=\"submitted && addForm.controls.address1.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"addForm.controls.address1.errors.required\">Address 1 is required</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label>Address 2</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"address2\" [ngClass]=\"{ 'is-invalid': submitted && addForm.controls.address2.errors }\" />\r\n        <div *ngIf=\"submitted && addForm.controls.address2.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"addForm.controls.address2.errors.required\">Address 2 is required</div>\r\n        </div>\r\n      </div>\r\n\r\n\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-sm-5\">\r\n          <div class=\"form-group\">\r\n            <label>City <span class=\"text-danger\">*</span></label>\r\n            <input type=\"text\" class=\"form-control\" formControlName=\"city\" [ngClass]=\"{ 'is-invalid': submitted && addForm.controls.city.errors }\" />\r\n            <div *ngIf=\"submitted && addForm.controls.city.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"addForm.controls.city.errors.required\">City is required</div>\r\n              <div *ngIf=\"addForm.controls.city.errors.alphaNumericSpecialCharacters\">City contains invalid characters</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-sm-4\">\r\n          <div class=\"form-group\">\r\n            <label>State <span class=\"text-danger\">*</span></label>\r\n            <select formControlName=\"state\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && addForm.controls.state.errors }\">\r\n              <option [value]=\"\">Choose...</option>\r\n              <option *ngFor=\"let state of stateList\" [value]=\"state.abbreviation\">{{state.abbreviation}}</option>\r\n            </select>\r\n            <div *ngIf=\"submitted && addForm.controls.state.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"addForm.controls.state.errors.required\">State is required</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-sm-3\">\r\n          <div class=\"form-group\">\r\n            <label>Zip Code <span class=\"text-danger\">*</span></label>\r\n            <input type=\"text\" class=\"form-control\" formControlName=\"zipCode\" [ngClass]=\"{ 'is-invalid': submitted && addForm.controls.zipCode.errors }\" />\r\n            <div *ngIf=\"submitted && addForm.controls.zipCode.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"addForm.controls.zipCode.errors.required\">Zip Code is required</div>\r\n              <div *ngIf=\"addForm.controls.zipCode.errors.zipCode\">Zip Code must be five digits</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div> \r\n      <div class=\"form-group\">\r\n        <label>Email</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"email\" [ngClass]=\"{'is-invalid': submitted && addForm.controls.email.errors}\" />\r\n        <div *ngIf=\"submitted && addForm.controls.email.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"addForm.controls.email.errors.required\">Email is required</div>\r\n          <div *ngIf=\"addForm.controls.email.errors.email\">Email format is invalid</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label>Phone</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"phone\" [ngClass]=\"{'is-invalid': submitted && addForm.controls.phone.errors}\" />\r\n        <div *ngIf=\"submitted && addForm.controls.phone.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"addForm.controls.phone.errors.required\">Phone is required</div>\r\n          <div *ngIf=\"addForm.controls.phone.errors.phone\">Phone format is invalid</div>\r\n\r\n        </div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label>URL</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"url\" [ngClass]=\"{'is-invalid': submitted && addForm.controls.url.errors}\" />\r\n        <div *ngIf=\"submitted && addForm.controls.url.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"addForm.controls.url.errors.required\">Url is required</div>\r\n          <div *ngIf=\"addForm.controls.url.errors.url\">Url format is invalid</div>\r\n        </div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label>Hours</label>\r\n        <textarea type=\"text\" class=\"form-control\" formControlName=\"hours\" [ngClass]=\"{'is-invalid': submitted && addForm.controls.hours.errors}\"></textarea>\r\n      </div>\r\n\r\n    </div>\r\n    <div class=\"modal-footer\">\r\n      <button type=\"button\" class=\"btn btn-outline-dark\" (click)=\"activeModal.close('Close click')\">Close</button>\r\n      <button type=\"submit\" class=\"btn btn-primary\">Submit</button>\r\n    </div>\r\n\r\n</form>\r\n\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/location-edit-modal/location-edit.component.html":
/*!*********************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/location-edit-modal/location-edit.component.html ***!
  \*********************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<form [formGroup]=\"editForm\" (ngSubmit)=\"onSubmit()\">\r\n\r\n    <div class=\"modal-header\">\r\n      <h5 class=\"modal-title\">{{title}}</h5>\r\n      <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"dismiss()\">\r\n        <span aria-hidden=\"true\">&times;</span>\r\n      </button>\r\n    </div>\r\n    <div class=\"modal-body\">\r\n      <input type=\"hidden\" formControlName=\"brandId\" />\r\n\r\n      <div class=\"form-group\">\r\n        <label>Name <span class=\"text-danger\">*</span></label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"name\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.name.errors }\" />\r\n        <div *ngIf=\"submitted && editForm.controls.name.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.name.errors.required\">Name is required</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-sm-12\">\r\n          <div class=\"form-group\">\r\n            <label>Store ID</label>\r\n            <input type=\"text\" class=\"form-control\" formControlName=\"storeId\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.storeId.errors }\" />\r\n            <div *ngIf=\"submitted && editForm.controls.storeId.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"editForm.controls.storeId.errors.required\">Store Id is required</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label>Address 1 <span class=\"text-danger\">*</span></label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"address1\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.address1.errors }\" />\r\n        <div *ngIf=\"submitted && editForm.controls.address1.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.address1.errors.required\">Address 1 is required</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label>Address 2</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"address2\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.address2.errors }\" />\r\n        <div *ngIf=\"submitted && editForm.controls.address2.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.address2.errors.required\">Address 2 is required</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-sm-5\">\r\n          <div class=\"form-group\">\r\n            <label>City <span class=\"text-danger\">*</span></label>\r\n            <input type=\"text\" class=\"form-control\" formControlName=\"city\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.city.errors }\" />\r\n            <div *ngIf=\"submitted && editForm.controls.city.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"editForm.controls.city.errors.required\">City is required</div>\r\n              <div *ngIf=\"editForm.controls.city.errors.alphaNumericSpecialCharacters\">City contains invalid characters</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-sm-4\">\r\n          <div class=\"form-group\">\r\n            <label>State <span class=\"text-danger\">*</span></label>\r\n            <select formControlName=\"state\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.state.errors }\">\r\n              <option [value]=\"\">Choose...</option>\r\n              <option *ngFor=\"let state of stateList\" [value]=\"state.abbreviation\">{{state.abbreviation}}</option>\r\n            </select>\r\n            <div *ngIf=\"submitted && editForm.controls.state.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"editForm.controls.state.errors.required\">State is required</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-sm-3\">\r\n          <div class=\"form-group\">\r\n            <label>Zip Code <span class=\"text-danger\">*</span></label>\r\n            <input type=\"text\" class=\"form-control\" formControlName=\"zipCode\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.zipCode.errors }\" />\r\n            <div *ngIf=\"submitted && editForm.controls.zipCode.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"editForm.controls.zipCode.errors.required\">Zip Code is required</div>\r\n              <div *ngIf=\"editForm.controls.zipCode.errors.zipCode\">Zip Code must be five digits</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n\r\n      <div class=\"form-group\">\r\n        <label>Email</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"email\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.email.errors}\" />\r\n        <div *ngIf=\"submitted && editForm.controls.email.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.email.errors.required\">Email is required</div>\r\n          <div *ngIf=\"editForm.controls.email.errors.email\">Email format is invalid</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label>Phone</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"phone\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.phone.errors}\" />\r\n        <div *ngIf=\"submitted && editForm.controls.phone.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.phone.errors.required\">Phone is required</div>\r\n          <div *ngIf=\"editForm.controls.phone.errors.phone\">Phone format is invalid</div>\r\n\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label>URL</label>\r\n        <input type=\"text\" class=\"form-control\" formControlName=\"url\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.url.errors}\" />\r\n        <div *ngIf=\"submitted && editForm.controls.url.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.url.errors.required\">Url is required</div>\r\n          <div *ngIf=\"editForm.controls.url.errors.url\">Url format is invalid</div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"form-group\">\r\n        <label>Hours</label>\r\n        <textarea type=\"text\" class=\"form-control\" formControlName=\"hours\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.hours.errors}\"></textarea>\r\n      </div>\r\n\r\n    </div>\r\n\r\n    <div class=\"modal-footer\">\r\n      <button type=\"button\" class=\"btn btn-outline-dark\" (click)=\"decline()\">Close</button>\r\n      <button type=\"submit\" class=\"btn btn-primary\">Submit</button>\r\n    </div>\r\n\r\n</form>\r\n\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/location-override-modal/location-override-form.component.html":
/*!**********************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/location-override-modal/location-override-form.component.html ***!
  \**********************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<form [formGroup]=\"modelForm\" (ngSubmit)=\"onSubmit()\">\r\n\r\n  <div class=\"modal-header\">\r\n    <h5 class=\"modal-title\">{{title}}</h5>\r\n    <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"dismiss()\">\r\n      <span aria-hidden=\"true\">&times;</span>\r\n    </button>\r\n  </div>\r\n  <div class=\"modal-body\">\r\n    <input type=\"hidden\" formControlName=\"brandId\" />\r\n\r\n    <div class=\"form-group\">\r\n      <label>Source Store Location <span class=\"text-danger\">*</span></label>\r\n      <select formControlName=\"sourceStoreLocationId\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && modelForm.controls.sourceStoreLocationId.errors }\">\r\n        <option [value]=\"0\">Choose...</option>\r\n        <option *ngFor=\"let store of storeLocationList\" [ngValue]=\"store.id\">{{store.name}}</option>\r\n      </select>\r\n      <div *ngIf=\"submitted && modelForm.controls.sourceStoreLocationId.errors\" class=\"invalid-feedback\">\r\n        <div *ngIf=\"modelForm.controls.sourceStoreLocationId.errors.required\">Store Location is required</div>\r\n        <div *ngIf=\"modelForm.controls.sourceStoreLocationId.errors.min\">Store Location is required</div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n      <label>Destination Store Location <span class=\"text-danger\">*</span></label>\r\n      <select formControlName=\"destinationStoreLocationId\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && modelForm.controls.destinationStoreLocationId.errors }\">\r\n        <option [value]=\"0\">Choose...</option>\r\n        <option *ngFor=\"let store of storeLocationList\" [ngValue]=\"store.id\">{{store.name}}</option>\r\n      </select>\r\n      <div *ngIf=\"submitted && modelForm.controls.destinationStoreLocationId.errors\" class=\"invalid-feedback\">\r\n        <div *ngIf=\"modelForm.controls.destinationStoreLocationId.errors.required\">Destination Store Location is required</div>\r\n        <div *ngIf=\"modelForm.controls.destinationStoreLocationId.errors.min\">Destination Store Location is required</div>\r\n      </div>\r\n      <div *ngIf=\"submitted && modelForm.errors?.storeLocation\" class=\"invalid-feedback\" style=\"display:block;\">Store locations must be different</div>\r\n    </div>\r\n\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-sm-6\">\r\n        <label>Start Date <span class=\"text-danger\">*</span></label>\r\n        <div class=\"input-group mb-3\">\r\n          <input type=\"date\" class=\"form-control\" placeholder=\"mm/dd/yyyy\" formControlName=\"startDate\" [ngModel]=\"startDate | date:'yyyy-MM-dd'\" [ngClass]=\"{ 'is-invalid': submitted && modelForm.controls.startDate.errors }\" />\r\n          <div class=\"input-group-append\">\r\n            <span class=\"input-group-text\"><span class=\"ion ion-ios-calendar\"></span></span>\r\n          </div>\r\n          <div *ngIf=\"submitted && modelForm.controls.startDate.errors\" class=\"invalid-feedback\">\r\n            <div *ngIf=\"modelForm.controls.startDate.errors.required\">Start date is required</div>\r\n            <div *ngIf=\"modelForm.controls.startDate.errors.pattern\">Invalid date format</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"col-sm-6\">\r\n        <label>End Date <span class=\"text-danger\">*</span></label>\r\n        <div class=\"input-group mb-3\">\r\n          <input type=\"date\" class=\"form-control\" placeholder=\"mm/dd/yyyy\" formControlName=\"endDate\" [ngModel]=\"endDate | date:'yyyy-MM-dd'\" [ngClass]=\"{ 'is-invalid': submitted && modelForm.controls.endDate.errors }\" />\r\n          <div class=\"input-group-append\">\r\n            <span class=\"input-group-text\"><span class=\"ion ion-ios-calendar\"></span></span>\r\n          </div>\r\n          <div *ngIf=\"submitted && modelForm.controls.endDate.errors\" class=\"invalid-feedback\">\r\n            <div *ngIf=\"modelForm.controls.endDate.errors.required\">End date is required</div>\r\n            <div *ngIf=\"modelForm.controls.endDate.errors.pattern\">Invalid date format</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n  </div>\r\n\r\n  <div class=\"modal-footer\">\r\n    <button type=\"button\" class=\"btn btn-outline-dark\" (click)=\"decline()\">Close</button>\r\n    <button type=\"submit\" class=\"btn btn-primary\">Submit</button>\r\n  </div>\r\n\r\n</form>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/mailing-record-edit-modal/mailing-record-edit.component.html":
/*!*********************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/mailing-record-edit-modal/mailing-record-edit.component.html ***!
  \*********************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<form [formGroup]=\"editForm\" (ngSubmit)=\"onSubmit()\">\r\n  <input type=\"hidden\" formControlName=\"id\" /> \r\n\r\n  <div class=\"modal-header\">\r\n    <h5 class=\"modal-title\">{{title}}</h5>\r\n    <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"dismiss()\">\r\n      <span aria-hidden=\"true\">&times;</span>\r\n    </button>\r\n  </div>\r\n\r\n  <div class=\"modal-body\">\r\n\r\n    <div class=\"form-group\">\r\n      <label>Patient Id</label>\r\n      <input type=\"text\" class=\"form-control\" formControlName=\"patientId\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.patientId.errors}\" />\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n      <label>CLX Patient Id</label>\r\n      <input type=\"text\" class=\"form-control\" formControlName=\"clxPatientId\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.clxPatientId.errors}\" />\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n      <label>First Name <span class=\"text-danger\">*</span></label>\r\n      <input type=\"text\" class=\"form-control\" formControlName=\"firstName\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.firstName.errors}\" />\r\n      <div *ngIf=\"submitted && editForm.controls.firstName.errors\" class=\"invalid-feedback\">\r\n        <div *ngIf=\"editForm.controls.firstName.errors.required\">First Name is required</div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n      <label>Last Name <span class=\"text-danger\">*</span></label>\r\n      <input type=\"text\" class=\"form-control\" formControlName=\"lastName\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.lastName.errors}\" />\r\n      <div *ngIf=\"submitted && editForm.controls.lastName.errors\" class=\"invalid-feedback\">\r\n        <div *ngIf=\"editForm.controls.lastName.errors.required\">Last Name is required</div>\r\n      </div>\r\n    </div>\r\n\r\n\r\n    <div class=\"form-group\">\r\n      <label>Address 1 <span class=\"text-danger\">*</span></label>\r\n      <input type=\"text\" class=\"form-control\" formControlName=\"address1\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.address1.errors }\" />\r\n      <div *ngIf=\"submitted && editForm.controls.address1.errors\" class=\"invalid-feedback\">\r\n        <div *ngIf=\"editForm.controls.address1.errors.required\">Address 1 is required</div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n      <label>Address 2</label>\r\n      <input type=\"text\" class=\"form-control\" formControlName=\"address2\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.address2.errors }\" />\r\n      <div *ngIf=\"submitted && editForm.controls.address2.errors\" class=\"invalid-feedback\">\r\n        <div *ngIf=\"editForm.controls.address2.errors.required\">Address 2 is required</div>\r\n\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-sm-5\">\r\n        <div class=\"form-group\">\r\n          <label>City <span class=\"text-danger\">*</span></label>\r\n          <input type=\"text\" class=\"form-control\" formControlName=\"city\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.city.errors }\" />\r\n          <div *ngIf=\"submitted && editForm.controls.city.errors\" class=\"invalid-feedback\">\r\n            <div *ngIf=\"editForm.controls.city.errors.required\">City is required</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-sm-4\">\r\n        <div class=\"form-group\">\r\n          <label>State <span class=\"text-danger\">*</span></label>\r\n          <select formControlName=\"state\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.state.errors }\">\r\n            <option [value]=\"\">Choose...</option>\r\n            <option *ngFor=\"let state of stateList\" [value]=\"state.abbreviation\">{{state.abbreviation}}</option>\r\n          </select>\r\n          <div *ngIf=\"submitted && editForm.controls.state.errors\" class=\"invalid-feedback\">\r\n            <div *ngIf=\"editForm.controls.state.errors.required\">State is required</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-sm-3\">\r\n        <div class=\"form-group\">\r\n          <label>Zip Code <span class=\"text-danger\">*</span></label>\r\n          <input type=\"text\" class=\"form-control\" formControlName=\"zipCode\" placeholder=\"00000\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.zipCode.errors }\" />\r\n          <div *ngIf=\"submitted && editForm.controls.zipCode.errors\" class=\"invalid-feedback\">\r\n            <div *ngIf=\"editForm.controls.zipCode.errors.required\">Zip Code is required</div>\r\n            <div *ngIf=\"editForm.controls.zipCode.errors.zipCode\">Zip Code must be five digits</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-sm-6\">\r\n        <div class=\"form-group\">\r\n          <label>Gender <span class=\"text-danger\">*</span></label>\r\n          <select formControlName=\"gender\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.gender.errors }\">\r\n            <option [value]=\"\">Choose...</option>\r\n            <option *ngFor=\"let gender of genderList\" [value]=\"gender\">{{gender}}</option>\r\n          </select>\r\n          <div *ngIf=\"submitted && editForm.controls.gender.errors\" class=\"invalid-feedback\">\r\n            <div *ngIf=\"editForm.controls.gender.errors.required\">Gender is required</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-sm-6\">\r\n        <div class=\"form-group\">\r\n          <label>Date of Birth <span class=\"text-danger\">*</span></label>\r\n          <input type=\"text\" class=\"form-control\" formControlName=\"dateOfBirth\" placeholder=\"mm/dd/yyyy\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.dateOfBirth.errors}\" />\r\n          <div *ngIf=\"submitted && editForm.controls.dateOfBirth.errors\" class=\"invalid-feedback\">\r\n            <div *ngIf=\"editForm.controls.dateOfBirth.errors.required\">Date of Birth is required</div>\r\n            <div *ngIf=\"editForm.controls.dateOfBirth.errors.pattern\">Date of Birth is invalid</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n      <label>Last Exam Date <span class=\"text-danger\">*</span></label>\r\n      <input type=\"text\" class=\"form-control\" formControlName=\"lastExamDate\" placeholder=\"mm/dd/yyyy\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.lastExamDate.errors}\" />\r\n      <div *ngIf=\"submitted && editForm.controls.lastExamDate.errors\" class=\"invalid-feedback\">\r\n        <div *ngIf=\"editForm.controls.lastExamDate.errors.required\">Last Exam Date is required</div>\r\n        <div *ngIf=\"editForm.controls.lastExamDate.errors.pattern\">Last Exam Date is invalid</div>\r\n      </div>\r\n    </div>\r\n\r\n\r\n    <!--\r\n      <div class=\"form-group\">\r\n        <label>Last Exam Date</label>\r\n        <div class=\"input-group date\">\r\n          <input class=\"form-control\" [matDatepicker]=\"lastExamDatePicker\" placeholder=\"mm/dd/yyyy\" formControlName=\"lastExamDate\" (dateChange)=\"formatDate($event, 'lastExamDate')\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.lastExamDate.errors}\">\r\n          <mat-datepicker #lastExamDatePicker></mat-datepicker>\r\n          <div class=\"input-group-append input-group-addon\">\r\n            <button class=\"btn btn-outline-secondary calendar\" (focus)=\"lastExamDatePicker.open()\" type=\"button\"><span class=\"ion ion-md-calendar\"></span></button>\r\n          </div>\r\n          <div *ngIf=\"submitted && editForm.controls.lastExamDate.errors\" class=\"invalid-feedback\">\r\n            <div *ngIf=\"editForm.controls.lastExamDate.errors.required\">Last Exam Date is required</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n  -->\r\n    <div class=\"form-group\">\r\n      <label>Phone</label>\r\n      <input type=\"text\" class=\"form-control\" formControlName=\"phone\" placeholder=\"000-000-0000\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.phone.errors}\" />\r\n      <div *ngIf=\"submitted && editForm.controls.phone.errors\" class=\"invalid-feedback\">\r\n        <div *ngIf=\"editForm.controls.phone.errors.required\">Phone is required</div>\r\n        <div *ngIf=\"editForm.controls.phone.errors.phone\">Phone format is invalid</div>\r\n\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n      <label>Email</label>\r\n      <input type=\"text\" class=\"form-control\" formControlName=\"email\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.email.errors}\" />\r\n      <div *ngIf=\"submitted && editForm.controls.email.errors\" class=\"invalid-feedback\">\r\n        <div *ngIf=\"editForm.controls.email.errors.required\">Email is required</div>\r\n        <div *ngIf=\"editForm.controls.email.errors.email\">Email format is invalid</div>\r\n\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n      <label>Campaign Type <span class=\"text-danger\">*</span></label>\r\n      <select formControlName=\"campaignTypeId\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.campaignTypeId.errors }\">\r\n        <option [value]=\"0\">Choose...</option>\r\n        <option *ngFor=\"let campaignType of campaignTypeList\" [value]=\"campaignType.id\">{{campaignType.name}}</option>\r\n      </select>\r\n      <div *ngIf=\"submitted && editForm.controls.campaignTypeId.errors\" class=\"invalid-feedback\">\r\n        <div *ngIf=\"editForm.controls.campaignTypeId.errors.required\">Campaign Type is required</div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n      <label>Brand <span class=\"text-danger\">*</span></label>\r\n      <select formControlName=\"brandId\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.brandId.errors }\">\r\n        <option [value]=\"\">Choose...</option>\r\n        <option *ngFor=\"let brand of brandList\" [value]=\"brand.id\">{{brand.name}}</option>\r\n      </select>\r\n      <div *ngIf=\"submitted && editForm.controls.brandId.errors\" class=\"invalid-feedback\">\r\n        <div *ngIf=\"editForm.controls.brandId.errors.required\">Brand is required</div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n      <label>Store Location</label>\r\n      <select formControlName=\"storeLocationId\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.storeLocationId.errors }\">\r\n        <option [ngValue]=\"0\">Choose...</option>\r\n        <option *ngFor=\"let store of storeLocationList\" [ngValue]=\"store.id\">{{store.name}}</option>\r\n      </select>\r\n      <div *ngIf=\"submitted && editForm.controls.storeLocationId.errors\" class=\"invalid-feedback\">\r\n        <div *ngIf=\"editForm.controls.storeLocationId.errors.required\">Store Location is required</div>\r\n        <div *ngIf=\"editForm.controls.storeLocationId.errors.min\">Store Location is required</div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n      <label>Custom 1</label>\r\n      <input type=\"text\" class=\"form-control\" formControlName=\"custom1\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.custom1.errors}\" />\r\n      <div *ngIf=\"submitted && editForm.controls.custom1.errors\" class=\"invalid-feedback\">\r\n      </div>\r\n    </div>\r\n\r\n\r\n    <div class=\"form-group\">\r\n      <label>Custom 2</label>\r\n      <input type=\"text\" class=\"form-control\" formControlName=\"custom2\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.custom2.errors}\" />\r\n      <div *ngIf=\"submitted && editForm.controls.custom2.errors\" class=\"invalid-feedback\">\r\n      </div>\r\n    </div>\r\n\r\n\r\n    <div class=\"form-group\">\r\n      <label>Custom 3</label>\r\n      <input type=\"text\" class=\"form-control\" formControlName=\"custom3\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.custom3.errors}\" />\r\n      <div *ngIf=\"submitted && editForm.controls.custom3.errors\" class=\"invalid-feedback\">\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n      <label>Custom 4</label>\r\n      <input type=\"text\" class=\"form-control\" formControlName=\"custom4\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.custom4.errors}\" />\r\n      <div *ngIf=\"submitted && editForm.controls.custom4.errors\" class=\"invalid-feedback\">\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"form-group\">\r\n      <label>Custom 5</label>\r\n      <input type=\"text\" class=\"form-control\" formControlName=\"custom5\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.custom5.errors}\" />\r\n      <div *ngIf=\"submitted && editForm.controls.custom5.errors\" class=\"invalid-feedback\">\r\n      </div>\r\n    </div>\r\n\r\n  </div>\r\n  <div class=\"modal-footer\">\r\n    <button type=\"button\" class=\"btn btn-outline-dark\" (click)=\"decline()\">Close</button>\r\n    <button type=\"submit\" class=\"btn btn-primary\">Submit</button>\r\n  </div>\r\n\r\n</form>\r\n\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/month-conversion-modal/month-conversion-form.component.html":
/*!********************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/month-conversion-modal/month-conversion-form.component.html ***!
  \********************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<form [formGroup]=\"modelForm\" (ngSubmit)=\"onSubmit()\">\r\n\r\n    <div class=\"modal-header\">\r\n      <h5 class=\"modal-title\">{{title}}</h5>\r\n      <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"activeModal.dismiss('Cross click')\">\r\n        <span aria-hidden=\"true\">&times;</span>\r\n      </button>\r\n    </div>\r\n    <div class=\"modal-body\">\r\n\r\n      <input type=\"hidden\" formControlName=\"id\" />\r\n      <input type=\"hidden\" formControlName=\"brandId\" />\r\n\r\n      <div class=\"form-group\">\r\n        <label>Campaign Type <span class=\"text-danger\">*</span></label>\r\n        <select class=\"form-control\" formControlName=\"campaignTypeId\" [ngClass]=\"{ 'is-invalid': submitted && modelForm.controls.campaignTypeId.errors }\">\r\n          <option [ngValue]=\"0\">Choose...</option>\r\n          <option *ngFor=\"let campaignType of campaignTypeList\" [ngValue]=\"campaignType.id\">\r\n            {{campaignType.name}}\r\n          </option>\r\n        </select>\r\n        <div *ngIf=\"submitted && modelForm.controls.campaignTypeId.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"modelForm.controls.campaignTypeId.errors.required\">Campaign Type is required</div>\r\n          <div *ngIf=\"modelForm.controls.campaignTypeId.errors.min\">Campaign Type is required</div>\r\n        </div>\r\n      </div>\r\n\r\n      <label>Month Range <span class=\"text-danger\">*</span></label>\r\n      <div class=\"row\"> \r\n        <div class=\"col-sm-6\">\r\n\r\n          <div class=\"input-group mb-3\">\r\n            <div class=\"input-group-prepend\">\r\n              <span class=\"input-group-text\">From</span>\r\n            </div>\r\n            <input type=\"number\" class=\"form-control\" formControlName=\"fromMonth\" [ngClass]=\"{ 'is-invalid': submitted && modelForm.controls.fromMonth.errors }\">\r\n            <div *ngIf=\"submitted && modelForm.controls.fromMonth.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"modelForm.controls.fromMonth.errors.required\">From Month is required</div>\r\n              <div *ngIf=\"modelForm.controls.fromMonth.errors.min\">From Month must be greater than zero</div>\r\n            </div>\r\n          </div> \r\n\r\n        </div>\r\n\r\n        <div class=\"col-sm-6\">\r\n\r\n          <div class=\"input-group mb-3\">\r\n            <div class=\"input-group-prepend\">\r\n              <span class=\"input-group-text\">To</span>\r\n            </div>\r\n            <input type=\"number\" class=\"form-control\" formControlName=\"toMonth\" [ngClass]=\"{ 'is-invalid': submitted && modelForm.controls.toMonth.errors }\">\r\n            <div *ngIf=\"submitted && modelForm.controls.toMonth.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"modelForm.controls.toMonth.errors.required\">To Month is required</div>\r\n              <div *ngIf=\"modelForm.controls.toMonth.errors.min\">To Month must be greater than zero</div>\r\n\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n      </div>\r\n       \r\n\r\n      <div class=\"form-group\">\r\n        <label>Month Conversion <span class=\"text-danger\">*</span></label>\r\n        <input type=\"number\" class=\"form-control\" formControlName=\"convertMonth\" [ngClass]=\"{ 'is-invalid': submitted && modelForm.controls.convertMonth.errors }\" />\r\n        <div *ngIf=\"submitted && modelForm.controls.convertMonth.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"modelForm.controls.convertMonth.errors.required\">From Month is required</div>\r\n          <div *ngIf=\"modelForm.controls.convertMonth.errors.min\">From Month must be greater than zero</div>\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n    <div class=\"modal-footer\">\r\n      <button type=\"button\" class=\"btn btn-outline-dark\" (click)=\"activeModal.close('Close click')\">Close</button>\r\n      <button type=\"submit\" class=\"btn btn-primary\">Submit</button>\r\n    </div>\r\n\r\n</form>\r\n\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/note-modal/note-form.component.html":
/*!********************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/note-modal/note-form.component.html ***!
  \********************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<form [formGroup]=\"modelForm\" (ngSubmit)=\"onSubmit()\">\r\n\r\n    <div class=\"modal-header\">\r\n      <h5 class=\"modal-title\">{{title}}</h5>\r\n      <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"activeModal.dismiss('Cross click')\">\r\n        <span aria-hidden=\"true\">&times;</span>\r\n      </button>\r\n    </div>\r\n    <div class=\"modal-body\">\r\n\r\n      <input type=\"hidden\" formControlName=\"id\" />\r\n      <input type=\"hidden\" formControlName=\"contentId\" />\r\n      <input type=\"hidden\" formControlName=\"contentType\" />\r\n\r\n      <div class=\"form-group\">\r\n        <label>Notes <span class=\"text-danger\">*</span></label>\r\n        <textarea rows=\"6\" [attr.readonly]=\"editMode == false ? '' : null\" type=\"text\" class=\"form-control\" formControlName=\"description\" [ngClass]=\"{'is-invalid': submitted && modelForm.controls.description.errors }\">\r\n        </textarea>\r\n        <div *ngIf=\"submitted && modelForm.controls.description.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"modelForm.controls.description.errors.required\">Notes is required</div>\r\n          <div *ngIf=\"modelForm.controls.description.errors.maxlength\">500 characters maximum allowed.</div>\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n    <div class=\"modal-footer\">\r\n      <button type=\"button\" class=\"btn btn-outline-dark\" (click)=\"activeModal.close('Close click')\">Close</button>\r\n      <button *ngIf=\"editMode\" type=\"submit\" class=\"btn btn-primary\" [attr.disabled]=\"editMode == false ? '' : null\" [ngClass]=\"{'disabled': editMode == false}\" >Submit</button>\r\n    </div>\r\n\r\n</form>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/override-rule-add-modal/override-rule-add.component.html":
/*!*****************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/override-rule-add-modal/override-rule-add.component.html ***!
  \*****************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<form [formGroup]=\"editForm\" (ngSubmit)=\"onSubmit()\">\r\n\r\n    <div class=\"modal-header\">\r\n      <h5 class=\"modal-title\">{{title}}</h5>\r\n      <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"dismiss()\">\r\n        <span aria-hidden=\"true\">&times;</span>\r\n      </button>\r\n    </div>\r\n\r\n    <div class=\"modal-body\">\r\n      <input type=\"hidden\" formControlName=\"brandId\" />\r\n\r\n      <div class=\"card mb-3\">\r\n        <div class=\"card-body\">\r\n          <h5 class=\"card-title\">Filters</h5>\r\n\r\n          <div class=\"row\">\r\n            <div class=\"col-sm-6\">\r\n              <div class=\"form-group\">\r\n                <label>Campaign Type</label>\r\n                <select class=\"form-control\" formControlName=\"campaignTypeId\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.campaignTypeId.errors }\">\r\n                  <option [ngValue]=\"0\">Choose...</option>\r\n                  <option *ngFor=\"let campaignType of campaignTypeList\" [value]=\"campaignType.id\">\r\n                    {{campaignType.name}}\r\n                  </option>\r\n                </select>\r\n                <div *ngIf=\"submitted && editForm.controls.campaignTypeId.errors\" class=\"invalid-feedback\">\r\n                  <div *ngIf=\"editForm.controls.campaignTypeId.errors.required\">Campaign Type is required</div>\r\n                  <div *ngIf=\"editForm.controls.campaignTypeId.errors.min\">Campaign Type is invalid</div>\r\n                </div>\r\n              </div>\r\n\r\n            </div>\r\n\r\n            <div class=\"col-sm-6\">\r\n              <div class=\"form-group\">\r\n                <label>Age Range <span class=\"text-danger\">*</span></label>\r\n                <select formControlName=\"ageRangeId\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.ageRangeId.errors }\">\r\n                  <option [ngValue]=\"0\">Choose...</option>\r\n                  <option *ngFor=\"let range of ageRangeList\" [value]=\"range.id\">{{range.range}}</option>\r\n                </select>\r\n                <div *ngIf=\"submitted && editForm.controls.ageRangeId.errors\" class=\"invalid-feedback\">\r\n                  <div *ngIf=\"editForm.controls.ageRangeId.errors.required\">Age Range is required</div>\r\n                  <div *ngIf=\"editForm.controls.ageRangeId.errors.min\">Age Range is required</div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-sm-6\">\r\n              <div class=\"form-group\">\r\n                <label>Gender</label>\r\n                <select formControlName=\"gender\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.gender.errors }\">\r\n                  <option [value]=\"null\">Choose...</option>\r\n                  <option *ngFor=\"let gender of genderList\" [value]=\"gender\">{{gender}}</option>\r\n                </select>\r\n                <div *ngIf=\"submitted && editForm.controls.gender.errors\" class=\"invalid-feedback\">\r\n                  <div *ngIf=\"editForm.controls.gender.errors.required\">Gender is required</div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"col-sm-6\">\r\n              <div class=\"form-group\">\r\n                <label>Store Location</label>\r\n                <select formControlName=\"storeLocationId\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.storeLocationId.errors }\">\r\n                  <option [value]=\"0\">Choose...</option>\r\n                  <option *ngFor=\"let store of storeLocationList\" [ngValue]=\"store.id\">{{store.name}}</option>\r\n                </select>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"col-sm-6\">\r\n              <div class=\"form-group\">\r\n                <label>Months</label>\r\n                <input type=\"text\" class=\"form-control\" formControlName=\"months\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.months.errors}\" />\r\n                <div *ngIf=\"submitted && editForm.controls.months.errors\" class=\"invalid-feedback\">\r\n                  <div *ngIf=\"editForm.controls.months.errors.numeric\">Months must be a number</div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"col-sm-6\">\r\n              <div class=\"form-group\">\r\n                <label>Custom 1</label>\r\n                <input type=\"text\" class=\"form-control\" formControlName=\"custom1\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.custom1.errors}\" />\r\n              </div>\r\n            </div>\r\n            <div class=\"col-sm-6\">\r\n              <div class=\"form-group\">\r\n                <label>Custom 2</label>\r\n                <input type=\"text\" class=\"form-control\" formControlName=\"custom2\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.custom2.errors}\" />\r\n              </div>\r\n            </div>\r\n            <div class=\"col-sm-6\">\r\n              <div class=\"form-group\">\r\n                <label>Custom 3</label>\r\n                <input type=\"text\" class=\"form-control\" formControlName=\"custom3\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.custom3.errors}\" />\r\n              </div>\r\n            </div>\r\n            <div class=\"col-sm-6\">\r\n              <div class=\"form-group\">\r\n                <label>Custom 4</label>\r\n                <input type=\"text\" class=\"form-control\" formControlName=\"custom4\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.custom4.errors}\" />\r\n              </div>\r\n            </div>\r\n            <div class=\"col-sm-6\">\r\n              <div class=\"form-group\">\r\n                <label>Custom 5</label>\r\n                <input type=\"text\" class=\"form-control\" formControlName=\"custom5\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.custom5.errors}\" />\r\n              </div>\r\n            </div>\r\n\r\n\r\n\r\n\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"card mb-3\">\r\n        <div class=\"card-body\">\r\n          <h5 class=\"card-title\">Fields to update</h5>\r\n\r\n          <div formArrayName=\"fields\" *ngFor=\"let item of editForm.get('fields')['controls']; let i = index;\">\r\n            <div class=\"row\" [formGroupName]=\"i\">\r\n              <div class=\"col-sm-5\">\r\n                <div class=\"form-group\">\r\n                  <label>Field name</label>\r\n\r\n                  <select class=\"form-control\" formControlName=\"name\" [ngClass]=\"{ 'is-invalid': submitted && item.controls.name.errors }\">\r\n                    <option *ngFor=\"let f of fieldNames\" [ngValue]=\"f\">{{f}}</option>\r\n                  </select>\r\n                   \r\n                  <div *ngIf=\"submitted && item.controls.name.errors\" class=\"invalid-feedback\">\r\n                    <div *ngIf=\"item.controls.name.errors.required\"> Field name is required</div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-sm-5\">\r\n                <div class=\"form-group\">\r\n                  <label>New Value</label>\r\n                  <input formControlName=\"value\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && item.controls.value.errors }\">\r\n                  <div *ngIf=\"submitted && item.controls.value.errors\" class=\"invalid-feedback\">\r\n                    <div *ngIf=\"item.controls.value.errors.required\"> Value is required</div>\r\n                  </div>\r\n\r\n                </div>\r\n              </div>\r\n              <div class=\"col-sm-2 text-right py-2\" *ngIf=\"editForm.get('fields').controls.length > 1\">\r\n                <button class=\"btn btn-outline-secondary btn-sm\" type=\"button\" (click)=\"removeFieldName(i)\"><span class=\"ion ion-md-trash\"></span></button>\r\n              </div>\r\n\r\n            </div>\r\n            <hr />\r\n          </div>\r\n\r\n          <div class=\"form-group mt-2 text-right\">\r\n            <button type=\"button\" (click)=\"addFieldName()\" class=\"btn btn-secondary\">Add another field</button>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-sm-6\">\r\n          <label>Start Date <span class=\"text-danger\">*</span></label>\r\n          <div class=\"input-group mb-3\">\r\n            <input type=\"date\" class=\"form-control\" formControlName=\"startDate\" [ngModel]=\"startDate | date:'yyyy-MM-dd'\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.startDate.errors }\" />\r\n            <div class=\"input-group-append\">\r\n              <span class=\"input-group-text\"><span class=\"ion ion-ios-calendar\"></span></span>\r\n            </div>\r\n            <div *ngIf=\"submitted && editForm.controls.startDate.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"editForm.controls.startDate.errors.required\">Start date is required</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"col-sm-6\">\r\n          <label>End Date <span class=\"text-danger\">*</span></label>\r\n          <div class=\"input-group mb-3\">\r\n            <input type=\"date\" class=\"form-control\" formControlName=\"endDate\" [ngModel]=\"endDate | date:'yyyy-MM-dd'\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.endDate.errors }\" />\r\n            <div class=\"input-group-append\">\r\n              <span class=\"input-group-text\"><span class=\"ion ion-ios-calendar\"></span></span>\r\n            </div>\r\n            <div *ngIf=\"submitted && editForm.controls.endDate.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"editForm.controls.endDate.errors.required\">End date is required</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div> \r\n\r\n      <div class=\"form-group w-50\">\r\n        <label>\r\n          Priority <span class=\"text-danger\">*</span>\r\n          <span class=\"ml-1\" triggers=\"mouseenter:mouseleave\" popoverTitle=\"Priority\" placement=\"top\" ngbPopover=\"The priority field controls the order on which this rule is applied, where the lower numbers will be applied first.\">\r\n            <span class=\"ion ion-ios-help-circle text-info lead\"></span>\r\n          </span>\r\n        </label>\r\n        <input min=\"0\" type=\"number\" class=\"form-control\" formControlName=\"priority\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.priority.errors}\" />\r\n        <div *ngIf=\"submitted && editForm.controls.priority.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.priority.errors.required\">Priority is required</div>\r\n          <div *ngIf=\"editForm.controls.priority.errors.min\">Priority must be a number greater or equal to (0)</div>\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n\r\n    <div class=\"modal-footer\">\r\n      <button type=\"button\" class=\"btn btn-outline-dark\" (click)=\"decline()\">Close</button>\r\n      <button type=\"submit\" class=\"btn btn-primary\">Submit</button>\r\n    </div>\r\n\r\n</form>\r\n\r\n<script>\r\n  $(function () {\r\n    $('.example-popover').popover({\r\n      container: 'body'\r\n    })\r\n  });\r\n</script>\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/override-rule-edit-modal/override-rule-edit.component.html":
/*!*******************************************************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/override-rule-edit-modal/override-rule-edit.component.html ***!
  \*******************************************************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<form [formGroup]=\"editForm\" (ngSubmit)=\"onSubmit()\">\r\n\r\n    <div class=\"modal-header\">\r\n      <h5 class=\"modal-title\">{{title}}</h5>\r\n      <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"dismiss()\">\r\n        <span aria-hidden=\"true\">&times;</span>\r\n      </button>\r\n    </div>\r\n    <div class=\"modal-body\">\r\n      <input type=\"hidden\" formControlName=\"brandId\" />\r\n\r\n      <div class=\"card mb-3\">\r\n        <div class=\"card-body\">\r\n          <h5 class=\"card-title\">Filters</h5>\r\n\r\n\r\n          <div class=\"row\">\r\n            <div class=\"col-sm-6\">\r\n              <div class=\"form-group\">\r\n                <label>Campaign Type</label>\r\n                <select class=\"form-control\" formControlName=\"campaignTypeId\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.campaignTypeId.errors }\">\r\n                  <option [ngValue]=\"0\">Choose...</option>\r\n                  <option *ngFor=\"let campaignType of campaignTypeList\" [value]=\"campaignType.id\">\r\n                    {{campaignType.name}}\r\n                  </option>\r\n                </select>\r\n                <div *ngIf=\"submitted && editForm.controls.campaignTypeId.errors\" class=\"invalid-feedback\">\r\n                  <div *ngIf=\"editForm.controls.campaignTypeId.errors.required\">Campaign Type is required</div>\r\n                  <div *ngIf=\"editForm.controls.campaignTypeId.errors.min\">Campaign Type is invalid</div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"col-sm-6\">\r\n              <div class=\"form-group\">\r\n                <label>Age Range <span class=\"text-danger\">*</span></label>\r\n                <select formControlName=\"ageRangeId\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.ageRangeId.errors }\">\r\n                  <option [ngValue]=\"0\">Choose...</option>\r\n                  <option *ngFor=\"let range of ageRangeList\" [value]=\"range.id\">{{range.range}}</option>\r\n                </select>\r\n                <div *ngIf=\"submitted && editForm.controls.ageRangeId.errors\" class=\"invalid-feedback\">\r\n                  <div *ngIf=\"editForm.controls.ageRangeId.errors.required\">Age Range is required</div>\r\n                  <div *ngIf=\"editForm.controls.ageRangeId.errors.min\">Age Range is invalid</div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-sm-6\">\r\n              <div class=\"form-group\">\r\n                <label>Gender</label>\r\n                <select formControlName=\"gender\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.gender.errors }\">\r\n                  <option [ngValue]=\"null\" >Choose...</option>\r\n                  <option *ngFor=\"let gender of genderList\" [value]=\"gender\">{{gender}}</option>\r\n                </select>\r\n                <div *ngIf=\"submitted && editForm.controls.gender.errors\" class=\"invalid-feedback\">\r\n                  <div *ngIf=\"editForm.controls.gender.errors.required\">Gender is required</div>\r\n                  <div *ngIf=\"editForm.controls.gender.errors.min\">Gender is invalid</div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"col-sm-6\">\r\n              <div class=\"form-group\">\r\n                <label>Store Location</label>\r\n                <select formControlName=\"storeLocationId\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.storeLocationId.errors }\">\r\n                  <option [value]=\"0\">Choose...</option>\r\n                  <option *ngFor=\"let store of storeLocationList\" [ngValue]=\"store.id\">{{store.name}}</option>\r\n                </select>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"col-sm-6\">\r\n              <div class=\"form-group\">\r\n                <label>Months</label>\r\n                <input type=\"text\" class=\"form-control\" formControlName=\"months\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.months.errors}\" />\r\n                <div *ngIf=\"submitted && editForm.controls.months.errors\" class=\"invalid-feedback\">\r\n                  <div *ngIf=\"editForm.controls.months.errors.numeric\">Months must be a number</div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"col-sm-6\">\r\n              <div class=\"form-group\">\r\n                <label>Custom 1</label>\r\n                <input type=\"text\" class=\"form-control\" formControlName=\"custom1\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.custom1.errors}\" />\r\n              </div>\r\n            </div>\r\n            <div class=\"col-sm-6\">\r\n              <div class=\"form-group\">\r\n                <label>Custom 2</label>\r\n                <input type=\"text\" class=\"form-control\" formControlName=\"custom2\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.custom2.errors}\" />\r\n              </div>\r\n            </div>\r\n            <div class=\"col-sm-6\">\r\n              <div class=\"form-group\">\r\n                <label>Custom 3</label>\r\n                <input type=\"text\" class=\"form-control\" formControlName=\"custom3\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.custom3.errors}\" />\r\n              </div>\r\n            </div>\r\n            <div class=\"col-sm-6\">\r\n              <div class=\"form-group\">\r\n                <label>Custom 4</label>\r\n                <input type=\"text\" class=\"form-control\" formControlName=\"custom4\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.custom4.errors}\" />\r\n              </div>\r\n            </div>\r\n            <div class=\"col-sm-6\">\r\n              <div class=\"form-group\">\r\n                <label>Custom 5</label>\r\n                <input type=\"text\" class=\"form-control\" formControlName=\"custom5\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.custom5.errors}\" />\r\n              </div>\r\n            </div>\r\n\r\n          </div>\r\n\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"card mb-3\">\r\n        <div class=\"card-body\">\r\n          <h5 class=\"card-title\">Fields to update</h5>\r\n          <div formArrayName=\"fields\" *ngFor=\"let item of editForm.get('fields')['controls']; let i = index;\">\r\n            <div class=\"row\" [formGroupName]=\"i\">\r\n\r\n              <div class=\"col-sm-5\">\r\n                <div class=\"form-group\">\r\n                  <label>Field name</label>\r\n                  <select class=\"form-control\" formControlName=\"name\" [ngClass]=\"{ 'is-invalid': submitted && item.controls.name.errors }\">\r\n                    <option *ngFor=\"let f of fieldNames\" [ngValue]=\"f\">{{f}}</option>\r\n                  </select>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-sm-5\">\r\n                <div class=\"form-group\">\r\n                  <label>New Value</label>\r\n                  <input formControlName=\"value\" class=\"form-control\" [ngClass]=\"{ 'is-invalid': submitted && item.controls.value.errors }\">\r\n                  <div *ngIf=\"submitted && item.invalid\" class=\"invalid-feedback\">\r\n                    <div *ngIf=\"item.invalid\" class=\"invalid-feedback\"> Value is required</div>\r\n                  </div>\r\n\r\n                </div>\r\n              </div>\r\n              <div class=\"col-sm-2 text-right mt-4 py-2\" *ngIf=\"editForm.get('fields').controls.length > 1\">\r\n                <button class=\"btn btn-outline-secondary btn-sm\" type=\"button\" (click)=\"removeFieldName(i)\"><span class=\"ion ion-md-trash\"></span></button>\r\n              </div>\r\n\r\n            </div>\r\n            <hr />\r\n          </div>\r\n\r\n          <div class=\"form-group text-right\">\r\n            <button type=\"button\" (click)=\"addFieldName()\" class=\"btn btn-secondary\">Add another field</button>\r\n          </div>\r\n        </div>\r\n      </div>\r\n       \r\n      <div class=\"row\">\r\n        <div class=\"col-sm-6\">\r\n          <label>Start Date <span class=\"text-danger\">*</span></label>\r\n          <div class=\"input-group mb-3\">\r\n            <input type=\"date\" class=\"form-control\" placeholder=\"mm/dd/yyyy\" formControlName=\"startDate\" [ngModel]=\"startDate | date:'yyyy-MM-dd'\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.startDate.errors }\" />\r\n            <div class=\"input-group-append\">\r\n              <span class=\"input-group-text\"><span class=\"ion ion-ios-calendar\"></span></span>\r\n            </div>\r\n            <div *ngIf=\"submitted && editForm.controls.startDate.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"editForm.controls.startDate.errors.required\">Start date is required</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"col-sm-6\">\r\n          <label>End Date <span class=\"text-danger\">*</span></label>\r\n          <div class=\"input-group mb-3\">\r\n            <input type=\"date\" class=\"form-control\" placeholder=\"mm/dd/yyyy\" formControlName=\"endDate\"  [ngModel]=\"endDate | date:'yyyy-MM-dd'\" [ngClass]=\"{ 'is-invalid': submitted && editForm.controls.endDate.errors }\" />\r\n            <div class=\"input-group-append\">\r\n              <span class=\"input-group-text\"><span class=\"ion ion-ios-calendar\"></span></span>\r\n            </div>\r\n            <div *ngIf=\"submitted && editForm.controls.endDate.errors\" class=\"invalid-feedback\">\r\n              <div *ngIf=\"editForm.controls.endDate.errors.required\">End date is required</div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n\r\n      <div class=\"form-group w-50\">\r\n        <label>Priority <span class=\"text-danger\">*</span></label>\r\n        <input min=\"0\" type=\"number\" class=\"form-control\" formControlName=\"priority\" [ngClass]=\"{'is-invalid': submitted && editForm.controls.priority.errors}\" />\r\n        <div *ngIf=\"submitted && editForm.controls.priority.errors\" class=\"invalid-feedback\">\r\n          <div *ngIf=\"editForm.controls.priority.errors.required\">Priority is required</div>\r\n          <div *ngIf=\"editForm.controls.priority.errors.min\">Priority must be a number greater or equal to (0)</div>\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n    <div class=\"modal-footer\">\r\n      <button type=\"button\" class=\"btn btn-outline-dark\" (click)=\"decline()\">Close</button>\r\n      <button type=\"submit\" class=\"btn btn-primary\">Submit</button>\r\n    </div> \r\n</form>\r\n\r\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/spinner/spinner.component.html":
/*!********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/spinner/spinner.component.html ***!
  \********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"spinner-container\"> \r\n  <div class=\"spinner\"></div><div *ngIf=\"message\" class=\"spinner-message\">{{message}}</div>\r\n</div>\r\n");

/***/ }),

/***/ "./src/$$_lazy_route_resource lazy recursive":
/*!**********************************************************!*\
  !*** ./src/$$_lazy_route_resource lazy namespace object ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./src/api-authorization/api-authorization.constants.ts":
/*!**************************************************************!*\
  !*** ./src/api-authorization/api-authorization.constants.ts ***!
  \**************************************************************/
/*! exports provided: ApplicationName, ReturnUrlType, QueryParameterNames, LogoutActions, LoginActions, ApplicationPaths */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApplicationName", function() { return ApplicationName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReturnUrlType", function() { return ReturnUrlType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QueryParameterNames", function() { return QueryParameterNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LogoutActions", function() { return LogoutActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LoginActions", function() { return LoginActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApplicationPaths", function() { return ApplicationPaths; });
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
const ApplicationName = 'OptiPort.Web';
const ReturnUrlType = 'returnUrl';
const QueryParameterNames = {
    ReturnUrl: ReturnUrlType,
    Message: 'message'
};
const LogoutActions = {
    LogoutCallback: 'logout-callback',
    Logout: 'logout',
    LoggedOut: 'logged-out'
};
const LoginActions = {
    Login: 'login',
    LoginCallback: 'login-callback',
    LoginFailed: 'login-failed',
    Profile: 'profile',
    Register: 'register'
};
let applicationPaths = {
    DefaultLoginRedirectPath: '/',
    ApiAuthorizationClientConfigurationUrl: `/_configuration/${ApplicationName}`,
    Login: `authentication/${LoginActions.Login}`,
    LoginFailed: `authentication/${LoginActions.LoginFailed}`,
    LoginCallback: `authentication/${LoginActions.LoginCallback}`,
    Register: `authentication/${LoginActions.Register}`,
    Profile: `authentication/${LoginActions.Profile}`,
    LogOut: `authentication/${LogoutActions.Logout}`,
    LoggedOut: `authentication/${LogoutActions.LoggedOut}`,
    LogOutCallback: `authentication/${LogoutActions.LogoutCallback}`,
    LoginPathComponents: [],
    LoginFailedPathComponents: [],
    LoginCallbackPathComponents: [],
    RegisterPathComponents: [],
    ProfilePathComponents: [],
    LogOutPathComponents: [],
    LoggedOutPathComponents: [],
    LogOutCallbackPathComponents: [],
    IdentityRegisterPath: '/Identity/Account/Register',
    IdentityManagePath: '/Identity/Account/Manage'
};
applicationPaths = Object.assign({}, applicationPaths, { LoginPathComponents: applicationPaths.Login.split('/'), LoginFailedPathComponents: applicationPaths.LoginFailed.split('/'), RegisterPathComponents: applicationPaths.Register.split('/'), ProfilePathComponents: applicationPaths.Profile.split('/'), LogOutPathComponents: applicationPaths.LogOut.split('/'), LoggedOutPathComponents: applicationPaths.LoggedOut.split('/'), LogOutCallbackPathComponents: applicationPaths.LogOutCallback.split('/') });
const ApplicationPaths = applicationPaths;


/***/ }),

/***/ "./src/api-authorization/api-authorization.module.ts":
/*!***********************************************************!*\
  !*** ./src/api-authorization/api-authorization.module.ts ***!
  \***********************************************************/
/*! exports provided: ApiAuthorizationModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApiAuthorizationModule", function() { return ApiAuthorizationModule; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _login_menu_login_menu_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./login-menu/login-menu.component */ "./src/api-authorization/login-menu/login-menu.component.ts");
/* harmony import */ var _login_login_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./login/login.component */ "./src/api-authorization/login/login.component.ts");
/* harmony import */ var _logout_logout_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./logout/logout.component */ "./src/api-authorization/logout/logout.component.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _api_authorization_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./api-authorization.constants */ "./src/api-authorization/api-authorization.constants.ts");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};








let ApiAuthorizationModule = class ApiAuthorizationModule {
};
ApiAuthorizationModule = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["NgModule"])({
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_1__["CommonModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_7__["HttpClientModule"],
            _angular_router__WEBPACK_IMPORTED_MODULE_5__["RouterModule"].forChild([
                { path: _api_authorization_constants__WEBPACK_IMPORTED_MODULE_6__["ApplicationPaths"].Register, component: _login_login_component__WEBPACK_IMPORTED_MODULE_3__["LoginComponent"] },
                { path: _api_authorization_constants__WEBPACK_IMPORTED_MODULE_6__["ApplicationPaths"].Profile, component: _login_login_component__WEBPACK_IMPORTED_MODULE_3__["LoginComponent"] },
                { path: _api_authorization_constants__WEBPACK_IMPORTED_MODULE_6__["ApplicationPaths"].Login, component: _login_login_component__WEBPACK_IMPORTED_MODULE_3__["LoginComponent"] },
                { path: _api_authorization_constants__WEBPACK_IMPORTED_MODULE_6__["ApplicationPaths"].LoginFailed, component: _login_login_component__WEBPACK_IMPORTED_MODULE_3__["LoginComponent"] },
                { path: _api_authorization_constants__WEBPACK_IMPORTED_MODULE_6__["ApplicationPaths"].LoginCallback, component: _login_login_component__WEBPACK_IMPORTED_MODULE_3__["LoginComponent"] },
                { path: _api_authorization_constants__WEBPACK_IMPORTED_MODULE_6__["ApplicationPaths"].LogOut, component: _logout_logout_component__WEBPACK_IMPORTED_MODULE_4__["LogoutComponent"] },
                { path: _api_authorization_constants__WEBPACK_IMPORTED_MODULE_6__["ApplicationPaths"].LoggedOut, component: _logout_logout_component__WEBPACK_IMPORTED_MODULE_4__["LogoutComponent"] },
                { path: _api_authorization_constants__WEBPACK_IMPORTED_MODULE_6__["ApplicationPaths"].LogOutCallback, component: _logout_logout_component__WEBPACK_IMPORTED_MODULE_4__["LogoutComponent"] }
            ])
        ],
        declarations: [_login_menu_login_menu_component__WEBPACK_IMPORTED_MODULE_2__["LoginMenuComponent"], _login_login_component__WEBPACK_IMPORTED_MODULE_3__["LoginComponent"], _logout_logout_component__WEBPACK_IMPORTED_MODULE_4__["LogoutComponent"]],
        exports: [_login_menu_login_menu_component__WEBPACK_IMPORTED_MODULE_2__["LoginMenuComponent"], _login_login_component__WEBPACK_IMPORTED_MODULE_3__["LoginComponent"], _logout_logout_component__WEBPACK_IMPORTED_MODULE_4__["LogoutComponent"]]
    })
], ApiAuthorizationModule);



/***/ }),

/***/ "./src/api-authorization/authorize.guard.ts":
/*!**************************************************!*\
  !*** ./src/api-authorization/authorize.guard.ts ***!
  \**************************************************/
/*! exports provided: AuthorizeGuard */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthorizeGuard", function() { return AuthorizeGuard; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _authorize_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./authorize.service */ "./src/api-authorization/authorize.service.ts");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _api_authorization_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./api-authorization.constants */ "./src/api-authorization/api-authorization.constants.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};





let AuthorizeGuard = class AuthorizeGuard {
    constructor(authorize, router) {
        this.authorize = authorize;
        this.router = router;
    }
    canActivate(_next, state) {
        return this.authorize.isAuthenticated()
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(isAuthenticated => this.handleAuthorization(isAuthenticated, state)));
    }
    handleAuthorization(isAuthenticated, state) {
        if (!isAuthenticated) {
            this.router.navigate(_api_authorization_constants__WEBPACK_IMPORTED_MODULE_4__["ApplicationPaths"].LoginPathComponents, {
                queryParams: {
                    [_api_authorization_constants__WEBPACK_IMPORTED_MODULE_4__["QueryParameterNames"].ReturnUrl]: state.url
                }
            });
        }
    }
};
AuthorizeGuard.ctorParameters = () => [
    { type: _authorize_service__WEBPACK_IMPORTED_MODULE_2__["AuthorizeService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"] }
];
AuthorizeGuard = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"])({
        providedIn: 'root'
    }),
    __metadata("design:paramtypes", [_authorize_service__WEBPACK_IMPORTED_MODULE_2__["AuthorizeService"], _angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"]])
], AuthorizeGuard);



/***/ }),

/***/ "./src/api-authorization/authorize.interceptor.ts":
/*!********************************************************!*\
  !*** ./src/api-authorization/authorize.interceptor.ts ***!
  \********************************************************/
/*! exports provided: AuthorizeInterceptor */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthorizeInterceptor", function() { return AuthorizeInterceptor; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _authorize_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./authorize.service */ "./src/api-authorization/authorize.service.ts");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};



let AuthorizeInterceptor = class AuthorizeInterceptor {
    constructor(authorize) {
        this.authorize = authorize;
    }
    intercept(req, next) {
        return this.authorize.getAccessToken()
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["mergeMap"])(token => this.processRequestWithToken(token, req, next)));
    }
    // Checks if there is an access_token available in the authorize service
    // and adds it to the request in case it's targeted at the same origin as the
    // single page application.
    processRequestWithToken(token, req, next) {
        if (!!token && this.isSameOriginUrl(req)) {
            req = req.clone({
                setHeaders: {
                    Authorization: 'Bearer ' + token
                }
            });
        }
        return next.handle(req);
    }
    isSameOriginUrl(req) {
        // It's an absolute url with the same origin.
        if (req.url.startsWith(`${window.location.origin}/`)) {
            return true;
        }
        // It's a protocol relative url with the same origin.
        // For example: //www.example.com/api/Products
        if (req.url.startsWith(`//${window.location.host}/`)) {
            return true;
        }
        // It's a relative url like /api/Products
        if (/^\/[^\/].*/.test(req.url)) {
            return true;
        }
        // It's an absolute or protocol relative url that
        // doesn't have the same origin.
        return false;
    }
};
AuthorizeInterceptor.ctorParameters = () => [
    { type: _authorize_service__WEBPACK_IMPORTED_MODULE_1__["AuthorizeService"] }
];
AuthorizeInterceptor = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"])({
        providedIn: 'root'
    }),
    __metadata("design:paramtypes", [_authorize_service__WEBPACK_IMPORTED_MODULE_1__["AuthorizeService"]])
], AuthorizeInterceptor);



/***/ }),

/***/ "./src/api-authorization/authorize.service.ts":
/*!****************************************************!*\
  !*** ./src/api-authorization/authorize.service.ts ***!
  \****************************************************/
/*! exports provided: AuthenticationResultStatus, AuthorizeService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthenticationResultStatus", function() { return AuthenticationResultStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AuthorizeService", function() { return AuthorizeService; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var oidc_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! oidc-client */ "./node_modules/oidc-client/lib/oidc-client.min.js");
/* harmony import */ var oidc_client__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(oidc_client__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _api_authorization_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./api-authorization.constants */ "./src/api-authorization/api-authorization.constants.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};





var AuthenticationResultStatus;
(function (AuthenticationResultStatus) {
    AuthenticationResultStatus[AuthenticationResultStatus["Success"] = 0] = "Success";
    AuthenticationResultStatus[AuthenticationResultStatus["Redirect"] = 1] = "Redirect";
    AuthenticationResultStatus[AuthenticationResultStatus["Fail"] = 2] = "Fail";
})(AuthenticationResultStatus || (AuthenticationResultStatus = {}));
let AuthorizeService = class AuthorizeService {
    constructor() {
        // By default pop ups are disabled because they don't work properly on Edge.
        // If you want to enable pop up authentication simply set this flag to false.
        this.popUpDisabled = true;
        this.userSubject = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"](null);
    }
    isAuthenticated() {
        return this.getUser().pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(u => !!u));
    }
    getUser() {
        return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["concat"])(this.userSubject.pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["take"])(1), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["filter"])(u => !!u)), this.getUserFromStorage().pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["filter"])(u => !!u), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(u => this.userSubject.next(u))), this.userSubject.asObservable());
    }
    getAccessToken() {
        return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["from"])(this.ensureUserManagerInitialized())
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["mergeMap"])(() => Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["from"])(this.userManager.getUser())), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(user => user && user.access_token));
    }
    // We try to authenticate the user in three different ways:
    // 1) We try to see if we can authenticate the user silently. This happens
    //    when the user is already logged in on the IdP and is done using a hidden iframe
    //    on the client.
    // 2) We try to authenticate the user using a PopUp Window. This might fail if there is a
    //    Pop-Up blocker or the user has disabled PopUps.
    // 3) If the two methods above fail, we redirect the browser to the IdP to perform a traditional
    //    redirect flow.
    signIn(state) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.ensureUserManagerInitialized();
            let user = null;
            try {
                user = yield this.userManager.signinSilent(this.createArguments());
                this.userSubject.next(user.profile);
                return this.success(state);
            }
            catch (silentError) {
                // User might not be authenticated, fallback to popup authentication
                console.log('Silent authentication error: ', silentError);
                try {
                    if (this.popUpDisabled) {
                        throw new Error('Popup disabled. Change \'authorize.service.ts:AuthorizeService.popupDisabled\' to false to enable it.');
                    }
                    user = yield this.userManager.signinPopup(this.createArguments());
                    this.userSubject.next(user.profile);
                    return this.success(state);
                }
                catch (popupError) {
                    if (popupError.message === 'Popup window closed') {
                        // The user explicitly cancelled the login action by closing an opened popup.
                        return this.error('The user closed the window.');
                    }
                    else if (!this.popUpDisabled) {
                        console.log('Popup authentication error: ', popupError);
                    }
                    // PopUps might be blocked by the user, fallback to redirect
                    try {
                        yield this.userManager.signinRedirect(this.createArguments(state));
                        return this.redirect();
                    }
                    catch (redirectError) {
                        console.log('Redirect authentication error: ', redirectError);
                        return this.error(redirectError);
                    }
                }
            }
        });
    }
    completeSignIn(url) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.ensureUserManagerInitialized();
                const user = yield this.userManager.signinCallback(url);
                this.userSubject.next(user && user.profile);
                return this.success(user && user.state);
            }
            catch (error) {
                console.log('There was an error signing in: ', error);
                return this.error('There was an error signing in.');
            }
        });
    }
    signOut(state) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (this.popUpDisabled) {
                    throw new Error('Popup disabled. Change \'authorize.service.ts:AuthorizeService.popupDisabled\' to false to enable it.');
                }
                yield this.ensureUserManagerInitialized();
                yield this.userManager.signoutPopup(this.createArguments());
                this.userSubject.next(null);
                return this.success(state);
            }
            catch (popupSignOutError) {
                console.log('Popup signout error: ', popupSignOutError);
                try {
                    yield this.userManager.signoutRedirect(this.createArguments(state));
                    return this.redirect();
                }
                catch (redirectSignOutError) {
                    console.log('Redirect signout error: ', popupSignOutError);
                    return this.error(redirectSignOutError);
                }
            }
        });
    }
    completeSignOut(url) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.ensureUserManagerInitialized();
            try {
                const state = yield this.userManager.signoutCallback(url);
                this.userSubject.next(null);
                return this.success(state && state.data);
            }
            catch (error) {
                console.log(`There was an error trying to log out '${error}'.`);
                return this.error(error);
            }
        });
    }
    createArguments(state) {
        return { useReplaceToNavigate: true, data: state };
    }
    error(message) {
        return { status: AuthenticationResultStatus.Fail, message };
    }
    success(state) {
        return { status: AuthenticationResultStatus.Success, state };
    }
    redirect() {
        return { status: AuthenticationResultStatus.Redirect };
    }
    ensureUserManagerInitialized() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.userManager !== undefined) {
                return;
            }
            const response = yield fetch(_api_authorization_constants__WEBPACK_IMPORTED_MODULE_4__["ApplicationPaths"].ApiAuthorizationClientConfigurationUrl);
            if (!response.ok) {
                throw new Error(`Could not load settings for '${_api_authorization_constants__WEBPACK_IMPORTED_MODULE_4__["ApplicationName"]}'`);
            }
            const settings = yield response.json();
            settings.automaticSilentRenew = true;
            settings.includeIdTokenInSilentRenew = true;
            this.userManager = new oidc_client__WEBPACK_IMPORTED_MODULE_1__["UserManager"](settings);
            this.userManager.events.addUserSignedOut(() => __awaiter(this, void 0, void 0, function* () {
                yield this.userManager.removeUser();
                this.userSubject.next(null);
            }));
        });
    }
    getUserFromStorage() {
        return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["from"])(this.ensureUserManagerInitialized())
            .pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["mergeMap"])(() => this.userManager.getUser()), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["map"])(u => u && u.profile));
    }
};
AuthorizeService = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"])({
        providedIn: 'root'
    })
], AuthorizeService);



/***/ }),

/***/ "./src/api-authorization/login-menu/login-menu.component.css":
/*!*******************************************************************!*\
  !*** ./src/api-authorization/login-menu/login-menu.component.css ***!
  \*******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBpLWF1dGhvcml6YXRpb24vbG9naW4tbWVudS9sb2dpbi1tZW51LmNvbXBvbmVudC5jc3MifQ== */");

/***/ }),

/***/ "./src/api-authorization/login-menu/login-menu.component.ts":
/*!******************************************************************!*\
  !*** ./src/api-authorization/login-menu/login-menu.component.ts ***!
  \******************************************************************/
/*! exports provided: LoginMenuComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LoginMenuComponent", function() { return LoginMenuComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _authorize_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../authorize.service */ "./src/api-authorization/authorize.service.ts");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _app_shared_components_modals_brand_picker_modal_brand_picker_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../app/shared/components/modals/brand-picker-modal/brand-picker.component */ "./src/app/shared/components/modals/brand-picker-modal/brand-picker.component.ts");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};





let LoginMenuComponent = class LoginMenuComponent {
    constructor(authorizeService, modalService) {
        this.authorizeService = authorizeService;
        this.modalService = modalService;
    }
    ngOnInit() {
        this.isAuthenticated = this.authorizeService.isAuthenticated();
        this.userName = this.authorizeService.getUser().pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_2__["map"])(u => u && u.name));
    }
    openBrandPicker() {
        const modalRef = this.modalService.open(_app_shared_components_modals_brand_picker_modal_brand_picker_component__WEBPACK_IMPORTED_MODULE_3__["BrandPickerComponent"]);
        modalRef.componentInstance.title = 'Choose a Brand';
    }
};
LoginMenuComponent.ctorParameters = () => [
    { type: _authorize_service__WEBPACK_IMPORTED_MODULE_1__["AuthorizeService"] },
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_4__["NgbModal"] }
];
LoginMenuComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-login-menu',
        template: __importDefault(__webpack_require__(/*! raw-loader!./login-menu.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/api-authorization/login-menu/login-menu.component.html")).default,
        styles: [__importDefault(__webpack_require__(/*! ./login-menu.component.css */ "./src/api-authorization/login-menu/login-menu.component.css")).default]
    }),
    __metadata("design:paramtypes", [_authorize_service__WEBPACK_IMPORTED_MODULE_1__["AuthorizeService"], _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_4__["NgbModal"]])
], LoginMenuComponent);



/***/ }),

/***/ "./src/api-authorization/login/login.component.css":
/*!*********************************************************!*\
  !*** ./src/api-authorization/login/login.component.css ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBpLWF1dGhvcml6YXRpb24vbG9naW4vbG9naW4uY29tcG9uZW50LmNzcyJ9 */");

/***/ }),

/***/ "./src/api-authorization/login/login.component.ts":
/*!********************************************************!*\
  !*** ./src/api-authorization/login/login.component.ts ***!
  \********************************************************/
/*! exports provided: LoginComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LoginComponent", function() { return LoginComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _authorize_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../authorize.service */ "./src/api-authorization/authorize.service.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _api_authorization_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../api-authorization.constants */ "./src/api-authorization/api-authorization.constants.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};





// The main responsibility of this component is to handle the user's login process.
// This is the starting point for the login process. Any component that needs to authenticate
// a user can simply perform a redirect to this component with a returnUrl query parameter and
// let the component perform the login and return back to the return url.
let LoginComponent = class LoginComponent {
    constructor(authorizeService, activatedRoute, router) {
        this.authorizeService = authorizeService;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.message = new rxjs__WEBPACK_IMPORTED_MODULE_3__["BehaviorSubject"](null);
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            const action = this.activatedRoute.snapshot.url[1];
            switch (action.path) {
                case _api_authorization_constants__WEBPACK_IMPORTED_MODULE_4__["LoginActions"].Login:
                    yield this.login(this.getReturnUrl());
                    break;
                case _api_authorization_constants__WEBPACK_IMPORTED_MODULE_4__["LoginActions"].LoginCallback:
                    yield this.processLoginCallback();
                    break;
                case _api_authorization_constants__WEBPACK_IMPORTED_MODULE_4__["LoginActions"].LoginFailed:
                    const message = this.activatedRoute.snapshot.queryParamMap.get(_api_authorization_constants__WEBPACK_IMPORTED_MODULE_4__["QueryParameterNames"].Message);
                    this.message.next(message);
                    break;
                case _api_authorization_constants__WEBPACK_IMPORTED_MODULE_4__["LoginActions"].Profile:
                    this.redirectToProfile();
                    break;
                case _api_authorization_constants__WEBPACK_IMPORTED_MODULE_4__["LoginActions"].Register:
                    this.redirectToRegister();
                    break;
                default:
                    throw new Error("Invalid action '${action}'");
            }
        });
    }
    login(returnUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            const state = { returnUrl };
            const result = yield this.authorizeService.signIn(state);
            this.message.next(undefined);
            switch (result.status) {
                case _authorize_service__WEBPACK_IMPORTED_MODULE_1__["AuthenticationResultStatus"].Redirect:
                    break;
                case _authorize_service__WEBPACK_IMPORTED_MODULE_1__["AuthenticationResultStatus"].Success:
                    yield this.navigateToReturnUrl(returnUrl);
                    break;
                case _authorize_service__WEBPACK_IMPORTED_MODULE_1__["AuthenticationResultStatus"].Fail:
                    yield this.router.navigate(_api_authorization_constants__WEBPACK_IMPORTED_MODULE_4__["ApplicationPaths"].LoginFailedPathComponents, {
                        queryParams: { [_api_authorization_constants__WEBPACK_IMPORTED_MODULE_4__["QueryParameterNames"].Message]: result.message }
                    });
                    break;
                default:
                    throw new Error(`Invalid status result ${result.status}.`);
            }
        });
    }
    processLoginCallback() {
        return __awaiter(this, void 0, void 0, function* () {
            const url = window.location.href;
            const result = yield this.authorizeService.completeSignIn(url);
            switch (result.status) {
                case _authorize_service__WEBPACK_IMPORTED_MODULE_1__["AuthenticationResultStatus"].Redirect:
                    // There should not be any redirects as completeSignIn never redirects.
                    throw new Error('Should not redirect.');
                case _authorize_service__WEBPACK_IMPORTED_MODULE_1__["AuthenticationResultStatus"].Success:
                    yield this.navigateToReturnUrl(this.getReturnUrl(result.state));
                    break;
                case _authorize_service__WEBPACK_IMPORTED_MODULE_1__["AuthenticationResultStatus"].Fail:
                    this.message.next(result.message);
                    break;
            }
        });
    }
    redirectToRegister() {
        this.redirectToApiAuthorizationPath("${ApplicationPaths.IdentityRegisterPath}?returnUrl=${encodeURI('/' + ApplicationPaths.Login)}");
    }
    redirectToProfile() {
        this.redirectToApiAuthorizationPath(_api_authorization_constants__WEBPACK_IMPORTED_MODULE_4__["ApplicationPaths"].IdentityManagePath);
    }
    navigateToReturnUrl(returnUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            // It's important that we do a replace here so that we remove the callback uri with the
            // fragment containing the tokens from the browser history.
            yield this.router.navigateByUrl(returnUrl, {
                replaceUrl: true
            });
        });
    }
    getReturnUrl(state) {
        const fromQuery = this.activatedRoute.snapshot.queryParams.returnUrl;
        // If the url is comming from the query string, check that is either
        // a relative url or an absolute url
        if (fromQuery &&
            !(fromQuery.startsWith(`${window.location.origin}/`) ||
                /\/[^\/].*/.test(fromQuery))) {
            // This is an extra check to prevent open redirects.
            throw new Error('Invalid return url. The return url needs to have the same origin as the current page.');
        }
        return (state && state.returnUrl) ||
            fromQuery ||
            _api_authorization_constants__WEBPACK_IMPORTED_MODULE_4__["ApplicationPaths"].DefaultLoginRedirectPath;
    }
    redirectToApiAuthorizationPath(apiAuthorizationPath) {
        // It's important that we do a replace here so that when the user hits the back arrow on the
        // browser they get sent back to where it was on the app instead of to an endpoint on this
        // component.
        const redirectUrl = `${window.location.origin}${apiAuthorizationPath}`;
        window.location.replace(redirectUrl);
    }
};
LoginComponent.ctorParameters = () => [
    { type: _authorize_service__WEBPACK_IMPORTED_MODULE_1__["AuthorizeService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] }
];
LoginComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-login',
        template: __importDefault(__webpack_require__(/*! raw-loader!./login.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/api-authorization/login/login.component.html")).default,
        styles: [__importDefault(__webpack_require__(/*! ./login.component.css */ "./src/api-authorization/login/login.component.css")).default]
    }),
    __metadata("design:paramtypes", [_authorize_service__WEBPACK_IMPORTED_MODULE_1__["AuthorizeService"],
        _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"],
        _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"]])
], LoginComponent);



/***/ }),

/***/ "./src/api-authorization/logout/logout.component.css":
/*!***********************************************************!*\
  !*** ./src/api-authorization/logout/logout.component.css ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBpLWF1dGhvcml6YXRpb24vbG9nb3V0L2xvZ291dC5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/api-authorization/logout/logout.component.ts":
/*!**********************************************************!*\
  !*** ./src/api-authorization/logout/logout.component.ts ***!
  \**********************************************************/
/*! exports provided: LogoutComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LogoutComponent", function() { return LogoutComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _authorize_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../authorize.service */ "./src/api-authorization/authorize.service.ts");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _api_authorization_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../api-authorization.constants */ "./src/api-authorization/api-authorization.constants.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};






// The main responsibility of this component is to handle the user's logout process.
// This is the starting point for the logout process, which is usually initiated when a
// user clicks on the logout button on the LoginMenu component.
let LogoutComponent = class LogoutComponent {
    constructor(authorizeService, activatedRoute, router) {
        this.authorizeService = authorizeService;
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.message = new rxjs__WEBPACK_IMPORTED_MODULE_2__["BehaviorSubject"](null);
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            const action = this.activatedRoute.snapshot.url[1];
            switch (action.path) {
                case _api_authorization_constants__WEBPACK_IMPORTED_MODULE_5__["LogoutActions"].Logout:
                    if (!!window.history.state.local) {
                        yield this.logout(this.getReturnUrl());
                    }
                    else {
                        // This prevents regular links to <app>/authentication/logout from triggering a logout
                        this.message.next('The logout was not initiated from within the page.');
                    }
                    break;
                case _api_authorization_constants__WEBPACK_IMPORTED_MODULE_5__["LogoutActions"].LogoutCallback:
                    yield this.processLogoutCallback();
                    break;
                case _api_authorization_constants__WEBPACK_IMPORTED_MODULE_5__["LogoutActions"].LoggedOut:
                    this.message.next('You successfully logged out!');
                    break;
                default:
                    throw new Error(`Invalid action '${action}'`);
            }
        });
    }
    logout(returnUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            const state = { returnUrl };
            const isauthenticated = yield this.authorizeService.isAuthenticated().pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_4__["take"])(1)).toPromise();
            if (isauthenticated) {
                const result = yield this.authorizeService.signOut(state);
                switch (result.status) {
                    case _authorize_service__WEBPACK_IMPORTED_MODULE_1__["AuthenticationResultStatus"].Redirect:
                        break;
                    case _authorize_service__WEBPACK_IMPORTED_MODULE_1__["AuthenticationResultStatus"].Success:
                        yield this.navigateToReturnUrl(returnUrl);
                        break;
                    case _authorize_service__WEBPACK_IMPORTED_MODULE_1__["AuthenticationResultStatus"].Fail:
                        this.message.next(result.message);
                        break;
                    default:
                        throw new Error('Invalid authentication result status.');
                }
            }
            else {
                this.message.next('You successfully logged out!');
                this.router.navigate(['/dashboard']);
            }
        });
    }
    processLogoutCallback() {
        return __awaiter(this, void 0, void 0, function* () {
            const url = window.location.href;
            const result = yield this.authorizeService.completeSignOut(url);
            switch (result.status) {
                case _authorize_service__WEBPACK_IMPORTED_MODULE_1__["AuthenticationResultStatus"].Redirect:
                    // There should not be any redirects as the only time completeAuthentication finishes
                    // is when we are doing a redirect sign in flow.
                    throw new Error('Should not redirect.');
                case _authorize_service__WEBPACK_IMPORTED_MODULE_1__["AuthenticationResultStatus"].Success:
                    yield this.navigateToReturnUrl(this.getReturnUrl(result.state));
                    break;
                case _authorize_service__WEBPACK_IMPORTED_MODULE_1__["AuthenticationResultStatus"].Fail:
                    this.message.next(result.message);
                    break;
                default:
                    throw new Error('Invalid authentication result status.');
            }
        });
    }
    navigateToReturnUrl(returnUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.router.navigateByUrl(returnUrl, {
                replaceUrl: true
            });
        });
    }
    getReturnUrl(state) {
        const fromQuery = this.activatedRoute.snapshot.queryParams.returnUrl;
        // If the url is comming from the query string, check that is either
        // a relative url or an absolute url
        if (fromQuery &&
            !(fromQuery.startsWith(`${window.location.origin}/`) ||
                /\/[^\/].*/.test(fromQuery))) {
            // This is an extra check to prevent open redirects.
            throw new Error('Invalid return url. The return url needs to have the same origin as the current page.');
        }
        return (state && state.returnUrl) ||
            fromQuery ||
            _api_authorization_constants__WEBPACK_IMPORTED_MODULE_5__["ApplicationPaths"].LoggedOut;
    }
};
LogoutComponent.ctorParameters = () => [
    { type: _authorize_service__WEBPACK_IMPORTED_MODULE_1__["AuthorizeService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["ActivatedRoute"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["Router"] }
];
LogoutComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-logout',
        template: __importDefault(__webpack_require__(/*! raw-loader!./logout.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/api-authorization/logout/logout.component.html")).default,
        styles: [__importDefault(__webpack_require__(/*! ./logout.component.css */ "./src/api-authorization/logout/logout.component.css")).default]
    }),
    __metadata("design:paramtypes", [_authorize_service__WEBPACK_IMPORTED_MODULE_1__["AuthorizeService"],
        _angular_router__WEBPACK_IMPORTED_MODULE_3__["ActivatedRoute"],
        _angular_router__WEBPACK_IMPORTED_MODULE_3__["Router"]])
], LogoutComponent);



/***/ }),

/***/ "./src/app/app.component.scss":
/*!************************************!*\
  !*** ./src/app/app.component.scss ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2FwcC5jb21wb25lbnQuc2NzcyJ9 */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};

let AppComponent = class AppComponent {
    constructor() {
        this.title = 'app';
        this.year = (new Date()).getFullYear();
    }
};
AppComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-root',
        template: __importDefault(__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [__importDefault(__webpack_require__(/*! ./app.component.scss */ "./src/app/app.component.scss")).default]
    }),
    __metadata("design:paramtypes", [])
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/cdk/portal */ "./node_modules/@angular/cdk/esm2015/portal.js");
/* harmony import */ var _angular_material_sort__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material/sort */ "./node_modules/@angular/material/esm2015/sort.js");
/* harmony import */ var _angular_material_paginator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/material/paginator */ "./node_modules/@angular/material/esm2015/paginator.js");
/* harmony import */ var _angular_material_table__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/material/table */ "./node_modules/@angular/material/esm2015/table.js");
/* harmony import */ var _angular_material_input__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/material/input */ "./node_modules/@angular/material/esm2015/input.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _ng_select_ng_select__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @ng-select/ng-select */ "./node_modules/@ng-select/ng-select/fesm2015/ng-select-ng-select.js");
/* harmony import */ var _shared_components_layout_nav_menu_nav_menu_component__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./shared/components/layout/nav-menu/nav-menu.component */ "./src/app/shared/components/layout/nav-menu/nav-menu.component.ts");
/* harmony import */ var _components_home_home_component__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./components/home/home.component */ "./src/app/components/home/home.component.ts");
/* harmony import */ var _components_brands_brands_component__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./components/brands/brands.component */ "./src/app/components/brands/brands.component.ts");
/* harmony import */ var _components_brand_details_brand_details_component__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./components/brand-details/brand-details.component */ "./src/app/components/brand-details/brand-details.component.ts");
/* harmony import */ var _components_dashboard_dashboard_component__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./components/dashboard/dashboard.component */ "./src/app/components/dashboard/dashboard.component.ts");
/* harmony import */ var _components_reports_reports_component__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./components/reports/reports.component */ "./src/app/components/reports/reports.component.ts");
/* harmony import */ var _components_mailings_mailings_component__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./components/mailings/mailings.component */ "./src/app/components/mailings/mailings.component.ts");
/* harmony import */ var _components_mailing_details_mailing_details_component__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./components/mailing-details/mailing-details.component */ "./src/app/components/mailing-details/mailing-details.component.ts");
/* harmony import */ var _components_billing_billing_component__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./components/billing/billing.component */ "./src/app/components/billing/billing.component.ts");
/* harmony import */ var _components_mailing_record_list_mailing_record_list_component__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./components/mailing-record-list/mailing-record-list.component */ "./src/app/components/mailing-record-list/mailing-record-list.component.ts");
/* harmony import */ var _components_locations_locations_component__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./components/locations/locations.component */ "./src/app/components/locations/locations.component.ts");
/* harmony import */ var _components_subbrands_subbrands_component__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./components/subbrands/subbrands.component */ "./src/app/components/subbrands/subbrands.component.ts");
/* harmony import */ var _components_matrix_matrix_component__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./components/matrix/matrix.component */ "./src/app/components/matrix/matrix.component.ts");
/* harmony import */ var _components_matrix_query_builder_matrix_query_builder_component__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./components/matrix-query-builder/matrix-query-builder.component */ "./src/app/components/matrix-query-builder/matrix-query-builder.component.ts");
/* harmony import */ var _components_override_rules_override_rules_component__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./components/override-rules/override-rules.component */ "./src/app/components/override-rules/override-rules.component.ts");
/* harmony import */ var _components_qc_report_qc_report_component__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./components/qc-report/qc-report.component */ "./src/app/components/qc-report/qc-report.component.ts");
/* harmony import */ var _components_month_conversions_month_conversions_component__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./components/month-conversions/month-conversions.component */ "./src/app/components/month-conversions/month-conversions.component.ts");
/* harmony import */ var _shared_components_spinner_spinner_component__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./shared/components/spinner/spinner.component */ "./src/app/shared/components/spinner/spinner.component.ts");
/* harmony import */ var _shared_components_modals_modal_modal_component__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./shared/components/modals/modal/modal.component */ "./src/app/shared/components/modals/modal/modal.component.ts");
/* harmony import */ var _shared_components_modals_location_add_modal_location_add_component__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./shared/components/modals/location-add-modal/location-add.component */ "./src/app/shared/components/modals/location-add-modal/location-add.component.ts");
/* harmony import */ var _shared_components_modals_location_edit_modal_location_edit_component__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./shared/components/modals/location-edit-modal/location-edit.component */ "./src/app/shared/components/modals/location-edit-modal/location-edit.component.ts");
/* harmony import */ var _shared_components_modals_confirmation_modal_confirmation_modal_component__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./shared/components/modals/confirmation-modal/confirmation-modal.component */ "./src/app/shared/components/modals/confirmation-modal/confirmation-modal.component.ts");
/* harmony import */ var _shared_components_modals_brand_picker_modal_brand_picker_component__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./shared/components/modals/brand-picker-modal/brand-picker.component */ "./src/app/shared/components/modals/brand-picker-modal/brand-picker.component.ts");
/* harmony import */ var _shared_components_modals_creative_template_edit_modal_creative_template_edit_component__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./shared/components/modals/creative-template-edit-modal/creative-template-edit.component */ "./src/app/shared/components/modals/creative-template-edit-modal/creative-template-edit.component.ts");
/* harmony import */ var _shared_components_modals_creative_template_add_modal_creative_template_add_component__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./shared/components/modals/creative-template-add-modal/creative-template-add.component */ "./src/app/shared/components/modals/creative-template-add-modal/creative-template-add.component.ts");
/* harmony import */ var _shared_components_modals_override_rule_edit_modal_override_rule_edit_component__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ./shared/components/modals/override-rule-edit-modal/override-rule-edit.component */ "./src/app/shared/components/modals/override-rule-edit-modal/override-rule-edit.component.ts");
/* harmony import */ var _shared_components_modals_override_rule_add_modal_override_rule_add_component__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ./shared/components/modals/override-rule-add-modal/override-rule-add.component */ "./src/app/shared/components/modals/override-rule-add-modal/override-rule-add.component.ts");
/* harmony import */ var _shared_pipes_yesno_pipe__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ./shared/pipes/yesno.pipe */ "./src/app/shared/pipes/yesno.pipe.ts");
/* harmony import */ var _shared_pipes_filter_pipe__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ./shared/pipes/filter.pipe */ "./src/app/shared/pipes/filter.pipe.ts");
/* harmony import */ var _shared_pipes_excludeDuplicates_pipe__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ./shared/pipes/excludeDuplicates.pipe */ "./src/app/shared/pipes/excludeDuplicates.pipe.ts");
/* harmony import */ var _shared_pipes_filterMonthsByCampaign_pipe__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ./shared/pipes/filterMonthsByCampaign.pipe */ "./src/app/shared/pipes/filterMonthsByCampaign.pipe.ts");
/* harmony import */ var _shared_pipes_truncateString_pipe__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ./shared/pipes/truncateString.pipe */ "./src/app/shared/pipes/truncateString.pipe.ts");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var src_api_authorization_api_authorization_module__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! src/api-authorization/api-authorization.module */ "./src/api-authorization/api-authorization.module.ts");
/* harmony import */ var src_api_authorization_authorize_guard__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! src/api-authorization/authorize.guard */ "./src/api-authorization/authorize.guard.ts");
/* harmony import */ var src_api_authorization_authorize_interceptor__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! src/api-authorization/authorize.interceptor */ "./src/api-authorization/authorize.interceptor.ts");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _shared_components_modals_mailing_record_edit_modal_mailing_record_edit_component__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! ./shared/components/modals/mailing-record-edit-modal/mailing-record-edit.component */ "./src/app/shared/components/modals/mailing-record-edit-modal/mailing-record-edit.component.ts");
/* harmony import */ var _shared_components_loader_loader_component__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! ./shared/components/loader/loader.component */ "./src/app/shared/components/loader/loader.component.ts");
/* harmony import */ var _shared_components_modals_month_conversion_modal_month_conversion_form_component__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! ./shared/components/modals/month-conversion-modal/month-conversion-form.component */ "./src/app/shared/components/modals/month-conversion-modal/month-conversion-form.component.ts");
/* harmony import */ var _components_mailing_files_mailing_files_component__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! ./components/mailing-files/mailing-files.component */ "./src/app/components/mailing-files/mailing-files.component.ts");
/* harmony import */ var _components_brand_seeds_brand_seeds_component__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! ./components/brand-seeds/brand-seeds.component */ "./src/app/components/brand-seeds/brand-seeds.component.ts");
/* harmony import */ var _shared_components_modals_brand_seed_modal_brand_seed_form_component__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! ./shared/components/modals/brand-seed-modal/brand-seed-form.component */ "./src/app/shared/components/modals/brand-seed-modal/brand-seed-form.component.ts");
/* harmony import */ var _components_location_overrides_location_overrides_component__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! ./components/location-overrides/location-overrides.component */ "./src/app/components/location-overrides/location-overrides.component.ts");
/* harmony import */ var _shared_components_modals_location_override_modal_location_override_form_component__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! ./shared/components/modals/location-override-modal/location-override-form.component */ "./src/app/shared/components/modals/location-override-modal/location-override-form.component.ts");
/* harmony import */ var _components_notes_notes_component__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(/*! ./components/notes/notes.component */ "./src/app/components/notes/notes.component.ts");
/* harmony import */ var _shared_components_modals_note_modal_note_form_component__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(/*! ./shared/components/modals/note-modal/note-form.component */ "./src/app/shared/components/modals/note-modal/note-form.component.ts");
/* harmony import */ var _components_mailing_notes_mailing_notes_component__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(/*! ./components/mailing-notes/mailing-notes.component */ "./src/app/components/mailing-notes/mailing-notes.component.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};






// app components
// material







// page parts components

//import { LoginComponent } from './login/login.component';
// page components
















// shared components










// custom data types





// date pipe

// main app


// authorization modules



//ng bootstrap


//import { SpinnerDirective } from './shared/components/spinner/spinner.directive';










let AppModule = class AppModule {
};
AppModule = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_46__["AppComponent"],
            _shared_components_layout_nav_menu_nav_menu_component__WEBPACK_IMPORTED_MODULE_13__["NavMenuComponent"],
            _components_home_home_component__WEBPACK_IMPORTED_MODULE_14__["HomeComponent"],
            _components_brands_brands_component__WEBPACK_IMPORTED_MODULE_15__["BrandsComponent"],
            _components_brand_seeds_brand_seeds_component__WEBPACK_IMPORTED_MODULE_56__["BrandSeedsComponent"],
            _components_brand_details_brand_details_component__WEBPACK_IMPORTED_MODULE_16__["BrandDetailsComponent"],
            _components_dashboard_dashboard_component__WEBPACK_IMPORTED_MODULE_17__["DashboardComponent"],
            _components_reports_reports_component__WEBPACK_IMPORTED_MODULE_18__["ReportsComponent"],
            _components_mailings_mailings_component__WEBPACK_IMPORTED_MODULE_19__["MailingsComponent"],
            _components_mailing_details_mailing_details_component__WEBPACK_IMPORTED_MODULE_20__["MailingDetailsComponent"],
            _components_mailing_record_list_mailing_record_list_component__WEBPACK_IMPORTED_MODULE_22__["MailingRecordListComponent"],
            _components_billing_billing_component__WEBPACK_IMPORTED_MODULE_21__["BillingComponent"],
            _shared_pipes_yesno_pipe__WEBPACK_IMPORTED_MODULE_40__["YesNoPipe"],
            _shared_pipes_filter_pipe__WEBPACK_IMPORTED_MODULE_41__["FilterPipe"],
            _shared_pipes_excludeDuplicates_pipe__WEBPACK_IMPORTED_MODULE_42__["ExcludeDuplicatesPipe"],
            _shared_pipes_filterMonthsByCampaign_pipe__WEBPACK_IMPORTED_MODULE_43__["FilterMonthsByCampaignPipe"],
            _shared_pipes_truncateString_pipe__WEBPACK_IMPORTED_MODULE_44__["TruncateStringPipe"],
            _shared_components_spinner_spinner_component__WEBPACK_IMPORTED_MODULE_30__["SpinnerComponent"],
            _components_locations_locations_component__WEBPACK_IMPORTED_MODULE_23__["LocationsComponent"],
            _components_location_overrides_location_overrides_component__WEBPACK_IMPORTED_MODULE_58__["LocationOverridesComponent"],
            _shared_components_modals_modal_modal_component__WEBPACK_IMPORTED_MODULE_31__["ModalComponent"],
            _shared_components_modals_location_add_modal_location_add_component__WEBPACK_IMPORTED_MODULE_32__["LocationAddFormComponent"],
            _shared_components_modals_location_edit_modal_location_edit_component__WEBPACK_IMPORTED_MODULE_33__["LocationEditFormComponent"],
            _shared_components_modals_location_override_modal_location_override_form_component__WEBPACK_IMPORTED_MODULE_59__["LocationOverrideFormComponent"],
            _shared_components_modals_confirmation_modal_confirmation_modal_component__WEBPACK_IMPORTED_MODULE_34__["ConfirmationModalComponent"],
            _components_subbrands_subbrands_component__WEBPACK_IMPORTED_MODULE_24__["SubBrandsComponent"],
            _shared_components_modals_brand_picker_modal_brand_picker_component__WEBPACK_IMPORTED_MODULE_35__["BrandPickerComponent"],
            _components_matrix_matrix_component__WEBPACK_IMPORTED_MODULE_25__["MatrixComponent"],
            _components_matrix_query_builder_matrix_query_builder_component__WEBPACK_IMPORTED_MODULE_26__["MatrixQueryBuilderComponent"],
            _components_override_rules_override_rules_component__WEBPACK_IMPORTED_MODULE_27__["OverrideRulesComponent"],
            _shared_components_modals_creative_template_edit_modal_creative_template_edit_component__WEBPACK_IMPORTED_MODULE_36__["CreativeTemplateEditFormComponent"],
            _shared_components_modals_creative_template_add_modal_creative_template_add_component__WEBPACK_IMPORTED_MODULE_37__["CreativeTemplateAddFormComponent"],
            _shared_components_modals_override_rule_edit_modal_override_rule_edit_component__WEBPACK_IMPORTED_MODULE_38__["OverrideRuleEditFormComponent"],
            _shared_components_modals_override_rule_add_modal_override_rule_add_component__WEBPACK_IMPORTED_MODULE_39__["OverrideRuleAddFormComponent"],
            _shared_components_modals_mailing_record_edit_modal_mailing_record_edit_component__WEBPACK_IMPORTED_MODULE_52__["MailingRecordEditFormComponent"],
            _components_qc_report_qc_report_component__WEBPACK_IMPORTED_MODULE_28__["QCReportComponent"],
            _shared_components_loader_loader_component__WEBPACK_IMPORTED_MODULE_53__["LoaderComponent"],
            _components_month_conversions_month_conversions_component__WEBPACK_IMPORTED_MODULE_29__["MonthConversionsComponent"],
            _shared_components_modals_month_conversion_modal_month_conversion_form_component__WEBPACK_IMPORTED_MODULE_54__["MonthConversionFormComponent"],
            _components_mailing_files_mailing_files_component__WEBPACK_IMPORTED_MODULE_55__["MailingFilesComponent"],
            _shared_components_modals_brand_seed_modal_brand_seed_form_component__WEBPACK_IMPORTED_MODULE_57__["BrandSeedFormComponent"],
            _components_mailing_notes_mailing_notes_component__WEBPACK_IMPORTED_MODULE_62__["MailingNotesComponent"],
            _components_notes_notes_component__WEBPACK_IMPORTED_MODULE_60__["NotesComponent"],
            _shared_components_modals_note_modal_note_form_component__WEBPACK_IMPORTED_MODULE_61__["NoteFormComponent"]
            //SpinnerDirective,
        ],
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_0__["BrowserModule"].withServerTransition({ appId: 'ng-cli-universal' }),
            _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClientModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormsModule"],
            src_api_authorization_api_authorization_module__WEBPACK_IMPORTED_MODULE_48__["ApiAuthorizationModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_2__["ReactiveFormsModule"],
            _ng_select_ng_select__WEBPACK_IMPORTED_MODULE_12__["NgSelectModule"],
            _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_5__["PortalModule"],
            _angular_router__WEBPACK_IMPORTED_MODULE_4__["RouterModule"].forRoot([
                { path: '', component: _components_home_home_component__WEBPACK_IMPORTED_MODULE_14__["HomeComponent"], pathMatch: 'full' },
                //{ path: 'login', component: LoginComponent, pathMatch: 'full' },
                { path: 'dashboard', component: _components_dashboard_dashboard_component__WEBPACK_IMPORTED_MODULE_17__["DashboardComponent"], canActivate: [src_api_authorization_authorize_guard__WEBPACK_IMPORTED_MODULE_49__["AuthorizeGuard"]] },
                { path: 'brands', component: _components_brands_brands_component__WEBPACK_IMPORTED_MODULE_15__["BrandsComponent"], canActivate: [src_api_authorization_authorize_guard__WEBPACK_IMPORTED_MODULE_49__["AuthorizeGuard"]] },
                { path: 'brand/:id', component: _components_brand_details_brand_details_component__WEBPACK_IMPORTED_MODULE_16__["BrandDetailsComponent"], canActivate: [src_api_authorization_authorize_guard__WEBPACK_IMPORTED_MODULE_49__["AuthorizeGuard"]] },
                { path: 'reports', component: _components_reports_reports_component__WEBPACK_IMPORTED_MODULE_18__["ReportsComponent"], canActivate: [src_api_authorization_authorize_guard__WEBPACK_IMPORTED_MODULE_49__["AuthorizeGuard"]] },
                { path: 'mailings', component: _components_mailings_mailings_component__WEBPACK_IMPORTED_MODULE_19__["MailingsComponent"], canActivate: [src_api_authorization_authorize_guard__WEBPACK_IMPORTED_MODULE_49__["AuthorizeGuard"]] },
                { path: 'mailing/:id', component: _components_mailing_details_mailing_details_component__WEBPACK_IMPORTED_MODULE_20__["MailingDetailsComponent"], canActivate: [src_api_authorization_authorize_guard__WEBPACK_IMPORTED_MODULE_49__["AuthorizeGuard"]] },
                { path: 'mailing/report/:id', component: _components_qc_report_qc_report_component__WEBPACK_IMPORTED_MODULE_28__["QCReportComponent"], canActivate: [src_api_authorization_authorize_guard__WEBPACK_IMPORTED_MODULE_49__["AuthorizeGuard"]] },
                { path: 'mailing/files/:id', component: _components_mailing_files_mailing_files_component__WEBPACK_IMPORTED_MODULE_55__["MailingFilesComponent"], canActivate: [src_api_authorization_authorize_guard__WEBPACK_IMPORTED_MODULE_49__["AuthorizeGuard"]] },
                { path: 'mailing/notes/:id', component: _components_mailing_notes_mailing_notes_component__WEBPACK_IMPORTED_MODULE_62__["MailingNotesComponent"], canActivate: [src_api_authorization_authorize_guard__WEBPACK_IMPORTED_MODULE_49__["AuthorizeGuard"]] },
                { path: 'billing', component: _components_billing_billing_component__WEBPACK_IMPORTED_MODULE_21__["BillingComponent"], canActivate: [src_api_authorization_authorize_guard__WEBPACK_IMPORTED_MODULE_49__["AuthorizeGuard"]] }
            ]),
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_47__["BrowserAnimationsModule"],
            _angular_material_sort__WEBPACK_IMPORTED_MODULE_6__["MatSortModule"],
            _angular_material_paginator__WEBPACK_IMPORTED_MODULE_7__["MatPaginatorModule"],
            _angular_material_table__WEBPACK_IMPORTED_MODULE_8__["MatTableModule"],
            _angular_material_input__WEBPACK_IMPORTED_MODULE_9__["MatInputModule"],
            _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_10__["MatSnackBarModule"],
            _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_51__["NgbModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_11__["MatDatepickerModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_11__["MatNativeDateModule"] // <----- import for date formating(optional)
        ],
        exports: [
            _angular_material__WEBPACK_IMPORTED_MODULE_11__["MatDatepickerModule"],
            _angular_material_input__WEBPACK_IMPORTED_MODULE_9__["MatInputModule"],
            _angular_material__WEBPACK_IMPORTED_MODULE_11__["MatNativeDateModule"],
            _angular_material_paginator__WEBPACK_IMPORTED_MODULE_7__["MatPaginatorModule"]
        ],
        providers: [
            { provide: _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HTTP_INTERCEPTORS"], useClass: src_api_authorization_authorize_interceptor__WEBPACK_IMPORTED_MODULE_50__["AuthorizeInterceptor"], multi: true }, _angular_material__WEBPACK_IMPORTED_MODULE_11__["MatDatepickerModule"], _angular_common__WEBPACK_IMPORTED_MODULE_45__["DatePipe"]
        ],
        entryComponents: [
            _shared_components_modals_modal_modal_component__WEBPACK_IMPORTED_MODULE_31__["ModalComponent"],
            _shared_components_modals_location_add_modal_location_add_component__WEBPACK_IMPORTED_MODULE_32__["LocationAddFormComponent"],
            _shared_components_modals_location_edit_modal_location_edit_component__WEBPACK_IMPORTED_MODULE_33__["LocationEditFormComponent"],
            _shared_components_modals_location_override_modal_location_override_form_component__WEBPACK_IMPORTED_MODULE_59__["LocationOverrideFormComponent"],
            _shared_components_modals_confirmation_modal_confirmation_modal_component__WEBPACK_IMPORTED_MODULE_34__["ConfirmationModalComponent"],
            _shared_components_modals_brand_picker_modal_brand_picker_component__WEBPACK_IMPORTED_MODULE_35__["BrandPickerComponent"],
            _shared_components_modals_brand_seed_modal_brand_seed_form_component__WEBPACK_IMPORTED_MODULE_57__["BrandSeedFormComponent"],
            _shared_components_spinner_spinner_component__WEBPACK_IMPORTED_MODULE_30__["SpinnerComponent"],
            _shared_components_modals_creative_template_edit_modal_creative_template_edit_component__WEBPACK_IMPORTED_MODULE_36__["CreativeTemplateEditFormComponent"],
            _shared_components_modals_creative_template_add_modal_creative_template_add_component__WEBPACK_IMPORTED_MODULE_37__["CreativeTemplateAddFormComponent"],
            _shared_components_modals_override_rule_edit_modal_override_rule_edit_component__WEBPACK_IMPORTED_MODULE_38__["OverrideRuleEditFormComponent"],
            _shared_components_modals_override_rule_add_modal_override_rule_add_component__WEBPACK_IMPORTED_MODULE_39__["OverrideRuleAddFormComponent"],
            _shared_components_modals_mailing_record_edit_modal_mailing_record_edit_component__WEBPACK_IMPORTED_MODULE_52__["MailingRecordEditFormComponent"],
            _shared_components_modals_month_conversion_modal_month_conversion_form_component__WEBPACK_IMPORTED_MODULE_54__["MonthConversionFormComponent"],
            _shared_components_modals_note_modal_note_form_component__WEBPACK_IMPORTED_MODULE_61__["NoteFormComponent"]
        ],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_46__["AppComponent"]]
    })
], AppModule);



/***/ }),

/***/ "./src/app/components/billing/billing.component.ts":
/*!*********************************************************!*\
  !*** ./src/app/components/billing/billing.component.ts ***!
  \*********************************************************/
/*! exports provided: BillingComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BillingComponent", function() { return BillingComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};

let BillingComponent = class BillingComponent {
};
BillingComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-billing',
        template: __importDefault(__webpack_require__(/*! raw-loader!./billing.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/billing/billing.component.html")).default
    })
], BillingComponent);



/***/ }),

/***/ "./src/app/components/brand-details/brand-details.component.ts":
/*!*********************************************************************!*\
  !*** ./src/app/components/brand-details/brand-details.component.ts ***!
  \*********************************************************************/
/*! exports provided: BrandDetailsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BrandDetailsComponent", function() { return BrandDetailsComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _shared_services_brand_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../shared/services/brand.service */ "./src/app/shared/services/brand.service.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _shared_models_state__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../shared/models/state */ "./src/app/shared/models/state.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _shared_components_spinner_spinner_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../shared/components/spinner/spinner.service */ "./src/app/shared/components/spinner/spinner.service.ts");
/* harmony import */ var _shared_services_template_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../shared/services/template.service */ "./src/app/shared/services/template.service.ts");
/* harmony import */ var _shared_services_validation_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../shared/services/validation.service */ "./src/app/shared/services/validation.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};










let BrandDetailsComponent = class BrandDetailsComponent {
    constructor(brandService, templateService, route, formBuilder, notification, spinnerService) {
        this.brandService = brandService;
        this.templateService = templateService;
        this.route = route;
        this.formBuilder = formBuilder;
        this.notification = notification;
        this.spinnerService = spinnerService;
        this.editBrandFormSubmitted = false;
        this.DELIMITER = '-';
    }
    ngOnInit() {
        // show spinner on page load
        this.spinnerService.show();
        this.sub = this.route.params.subscribe(params => {
            this.id = +params['id']; // (+) converts string 'id' to a number  
            this.msg = '';
            // get brand profile
            this.brandService.getById(this.id).subscribe(result => {
                this.templateService.getAll().subscribe(templateResult => {
                    if (templateResult.length) {
                        this.templates = templateResult;
                    }
                }, error => console.error(error));
                this.brandService.getAllMaster().subscribe(masterResult => {
                    if (masterResult.length) {
                        // used for profile parent brand field select
                        this.parentBrands = masterResult;
                    }
                    // this.brands = result;
                }, error => console.error(error));
                // bind list of states
                this.stateList = _shared_models_state__WEBPACK_IMPORTED_MODULE_3__["STATES"];
                this.brand = result;
                // initialize edit brand form
                this.editBrandForm = this.formBuilder.group({
                    name: [this.brand.name, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
                    firstName: [this.brand.firstName || ''],
                    lastName: [this.brand.lastName || ''],
                    address1: [this.brand.address1 || ''],
                    address2: [this.brand.address2 || ''],
                    city: [this.brand.city || '', _shared_services_validation_service__WEBPACK_IMPORTED_MODULE_9__["ValidationService"].alphaNumericSpecialCharactersValidator],
                    state: [this.brand.state || ''],
                    zipCode: [this.brand.zipCode || '', _shared_services_validation_service__WEBPACK_IMPORTED_MODULE_9__["ValidationService"].zipCodeValidator],
                    email: [this.brand.email || '', _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].email],
                    phone: [this.brand.phone || '', _shared_services_validation_service__WEBPACK_IMPORTED_MODULE_9__["ValidationService"].phoneValidator],
                    url: [this.brand.url || '', _shared_services_validation_service__WEBPACK_IMPORTED_MODULE_9__["ValidationService"].urlValidator],
                    startDate: [this.brand.startDate || '', _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
                    management: [this.brand.management || ''],
                    brandId: [this.brand.brandId || 0, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
                    templateId: [this.brand.templateId || 0, _angular_forms__WEBPACK_IMPORTED_MODULE_4__["Validators"].required],
                    isActive: [this.brand.isActive || false]
                });
                // hide spinner
                setTimeout(() => {
                    this.spinnerService.hide();
                }, 1500);
            }, error => console.error(error));
        });
    }
    // format date
    formatDate(e, fieldName) {
        if (e.target.value === null) {
            this.editBrandForm.get(fieldName).setValue('', {
                onlyself: true
            });
        }
        else {
            var convertDate = new Date(e.target.value);
            this.editBrandForm.get(fieldName).setValue(convertDate, {
                onlyself: true
            });
        }
    }
    // update existing brand details
    updateBrand() {
        this.editBrandFormSubmitted = true;
        // stop here if form is invalid
        if (this.editBrandForm.invalid) {
            return;
        }
        //var startDate = formatDate(this.editBrandForm.value["startDate"], 'MM-dd-yyyy', 'en-US'); 
        this.brand.name = this.editBrandForm.value["name"];
        this.brand.firstName = this.editBrandForm.value["firstName"];
        this.brand.lastName = this.editBrandForm.value["lastName"];
        this.brand.brandId = +this.editBrandForm.value["brandId"];
        this.brand.templateId = +this.editBrandForm.value["templateId"];
        this.brand.address1 = this.editBrandForm.value["address1"];
        this.brand.address2 = this.editBrandForm.value["address2"];
        this.brand.city = this.editBrandForm.value["city"];
        this.brand.state = this.editBrandForm.value["state"];
        this.brand.zipCode = this.editBrandForm.value["zipCode"];
        this.brand.management = this.editBrandForm.value["management"];
        this.brand.phone = this.editBrandForm.value["phone"];
        this.brand.email = this.editBrandForm.value["email"];
        this.brand.url = this.editBrandForm.value["url"];
        this.brand.startDate = Object(_angular_common__WEBPACK_IMPORTED_MODULE_6__["formatDate"])(this.editBrandForm.value["startDate"], 'yyyy-MM-dd', 'en-US'); //this.formatNgDate(this.editBrandForm.value["startDate"]);
        this.brand.isActive = this.editBrandForm.value["isActive"];
        this.brandService.update(this.id, this.brand)
            .subscribe(() => 
        // Simple message with an action.
        this.showNotification('Your changes have been saved!', 'Okay!'));
    }
    // destroy 
    ngOnDestroy() {
        this.sub.unsubscribe();
    }
    // display notifications
    showNotification(msg, action) {
        this.notification.open(msg, action, { duration: 5000, panelClass: ['snackbar-success'] });
    }
};
BrandDetailsComponent.ctorParameters = () => [
    { type: _shared_services_brand_service__WEBPACK_IMPORTED_MODULE_1__["BrandService"] },
    { type: _shared_services_template_service__WEBPACK_IMPORTED_MODULE_8__["TemplateService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormBuilder"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__["MatSnackBar"] },
    { type: _shared_components_spinner_spinner_service__WEBPACK_IMPORTED_MODULE_7__["SpinnerService"] }
];
BrandDetailsComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-brand-details',
        template: __importDefault(__webpack_require__(/*! raw-loader!./brand-details.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/brand-details/brand-details.component.html")).default
    }),
    __metadata("design:paramtypes", [_shared_services_brand_service__WEBPACK_IMPORTED_MODULE_1__["BrandService"],
        _shared_services_template_service__WEBPACK_IMPORTED_MODULE_8__["TemplateService"],
        _angular_router__WEBPACK_IMPORTED_MODULE_2__["ActivatedRoute"],
        _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormBuilder"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__["MatSnackBar"],
        _shared_components_spinner_spinner_service__WEBPACK_IMPORTED_MODULE_7__["SpinnerService"]])
], BrandDetailsComponent);



/***/ }),

/***/ "./src/app/components/brand-seeds/brand-seeds.component.ts":
/*!*****************************************************************!*\
  !*** ./src/app/components/brand-seeds/brand-seeds.component.ts ***!
  \*****************************************************************/
/*! exports provided: BrandSeedsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BrandSeedsComponent", function() { return BrandSeedsComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_material_sort__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/sort */ "./node_modules/@angular/material/esm2015/sort.js");
/* harmony import */ var _angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/paginator */ "./node_modules/@angular/material/esm2015/paginator.js");
/* harmony import */ var _angular_material_table__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/table */ "./node_modules/@angular/material/esm2015/table.js");
/* harmony import */ var _shared_services_brandSeed_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../shared/services/brandSeed.service */ "./src/app/shared/services/brandSeed.service.ts");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../shared/components/modals/confirmation-modal/confirmation-modal.service */ "./src/app/shared/components/modals/confirmation-modal/confirmation-modal.service.ts");
/* harmony import */ var _shared_components_modals_brand_seed_modal_brand_seed_form_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../shared/components/modals/brand-seed-modal/brand-seed-form.component */ "./src/app/shared/components/modals/brand-seed-modal/brand-seed-form.component.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
// angular


// material 



// services 





let BrandSeedsComponent = class BrandSeedsComponent {
    constructor(brandSeedService, route, modalService, notification, confirmationModalService) {
        this.brandSeedService = brandSeedService;
        this.route = route;
        this.modalService = modalService;
        this.notification = notification;
        this.confirmationModalService = confirmationModalService;
        // MatPaginator Inputs
        this.length = 20;
        this.pageSize = 10;
        this.pageSizeOptions = [10, 25, 100];
        this.dataSource = new _angular_material_table__WEBPACK_IMPORTED_MODULE_4__["MatTableDataSource"]();
        this.displayedColumns = ['actions', 'id', 'patientId', 'fullName', 'dateOfBirth', 'gender', 'months'];
    }
    // use getter setter to define the property
    get id() {
        return this._id;
    }
    set id(val) {
        this._id = val;
    }
    ngOnInit() {
        this.getItems(this.id);
    }
    // gets records per brand id
    getItems(id) {
        if (id > 0) {
            this.brandSeedService.getAll(id).subscribe(result => {
                this.dataSource.data = result;
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
            }, error => console.error(error));
        }
    }
    // delete item
    deleteItem(id) {
        this.confirmationModalService.confirm('Confirm', 'Are you sure you want to delete this item?')
            .then((confirmed) => {
            if (confirmed) {
                this.brandSeedService.delete(id).subscribe(() => {
                    this.showNotification('The seed has been deleted successfully!', 'Okay!');
                    this.getItems(this.id);
                });
            }
        })
            .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
    }
    // copy entry
    copyItem(item) {
        let modalOptions = {
            backdrop: 'static',
            keyboard: false,
        };
        const modalRef = this.modalService.open(_shared_components_modals_brand_seed_modal_brand_seed_form_component__WEBPACK_IMPORTED_MODULE_9__["BrandSeedFormComponent"], modalOptions);
        modalRef.componentInstance.title = 'Copy Seed';
        modalRef.componentInstance.inputModel = item;
        modalRef.componentInstance.inputModel.id = 0; // reset unique id in order to make copy
        // modal result
        modalRef.result.then((result) => {
            this.getItems(this.id);
        }).catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
    }
    // open add form 
    openAddModal() {
        let modalOptions = {
            backdrop: 'static',
            keyboard: false,
        };
        const modalRef = this.modalService.open(_shared_components_modals_brand_seed_modal_brand_seed_form_component__WEBPACK_IMPORTED_MODULE_9__["BrandSeedFormComponent"], modalOptions);
        modalRef.componentInstance.title = 'Add Seed';
        let model = {
            id: 0,
            patientId: '',
            clxPatientId: '',
            firstName: '',
            lastName: '',
            address1: '',
            address2: '',
            city: '',
            state: null,
            zipCode: '',
            gender: null,
            dateOfBirth: '',
            age: 0,
            lastExamDate: '',
            months: 0,
            brandId: this.id,
            campaignTypeId: 0,
            campaignTypeName: '',
            storeLocationId: 0,
            storeNumber: '',
            phone: '',
            email: '',
            custom1: '',
            custom2: '',
            custom3: '',
            custom4: '',
            custom5: ''
        };
        modalRef.componentInstance.inputModel = model;
        // modal result
        modalRef.result.then((result) => {
            if (result) {
                this.getItems(this.id);
            }
        }).catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
    }
    //// edit item
    editItem(model) {
        let modalOptions = {
            backdrop: 'static',
            keyboard: false,
        };
        const modalRef = this.modalService.open(_shared_components_modals_brand_seed_modal_brand_seed_form_component__WEBPACK_IMPORTED_MODULE_9__["BrandSeedFormComponent"], modalOptions);
        modalRef.componentInstance.title = 'Edit Record';
        modalRef.componentInstance.inputModel = model;
        // modal result
        modalRef.result.then((result) => {
            if (result) {
                this.getItems(this.id);
            }
        }).catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
    }
    // filter locations
    applyFilter(event) {
        const filterValue = event.target.value;
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }
    // show notification popup
    showNotification(msg, action) {
        this.notification.open(msg, action, { duration: 40000, panelClass: ['snackbar-success'] });
    }
};
BrandSeedsComponent.ctorParameters = () => [
    { type: _shared_services_brandSeed_service__WEBPACK_IMPORTED_MODULE_5__["BrandSeedService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_1__["ActivatedRoute"] },
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_6__["NgbModal"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_7__["MatSnackBar"] },
    { type: _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_8__["ConfirmationModalService"] }
];
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])(_angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__["MatPaginator"], { static: false }),
    __metadata("design:type", _angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__["MatPaginator"])
], BrandSeedsComponent.prototype, "paginator", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])(_angular_material_sort__WEBPACK_IMPORTED_MODULE_2__["MatSort"], { static: false }),
    __metadata("design:type", _angular_material_sort__WEBPACK_IMPORTED_MODULE_2__["MatSort"])
], BrandSeedsComponent.prototype, "sort", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], BrandSeedsComponent.prototype, "id", null);
BrandSeedsComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-brand-seeds',
        template: __importDefault(__webpack_require__(/*! raw-loader!./brand-seeds.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/brand-seeds/brand-seeds.component.html")).default
    }),
    __metadata("design:paramtypes", [_shared_services_brandSeed_service__WEBPACK_IMPORTED_MODULE_5__["BrandSeedService"],
        _angular_router__WEBPACK_IMPORTED_MODULE_1__["ActivatedRoute"],
        _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_6__["NgbModal"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_7__["MatSnackBar"],
        _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_8__["ConfirmationModalService"]])
], BrandSeedsComponent);



/***/ }),

/***/ "./src/app/components/brands/brands.component.css":
/*!********************************************************!*\
  !*** ./src/app/components/brands/brands.component.css ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvYnJhbmRzL2JyYW5kcy5jb21wb25lbnQuY3NzIn0= */");

/***/ }),

/***/ "./src/app/components/brands/brands.component.ts":
/*!*******************************************************!*\
  !*** ./src/app/components/brands/brands.component.ts ***!
  \*******************************************************/
/*! exports provided: BrandsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BrandsComponent", function() { return BrandsComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _shared_services_brand_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../shared/services/brand.service */ "./src/app/shared/services/brand.service.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_material_sort__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/sort */ "./node_modules/@angular/material/esm2015/sort.js");
/* harmony import */ var _angular_material_paginator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/paginator */ "./node_modules/@angular/material/esm2015/paginator.js");
/* harmony import */ var _angular_material_table__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/table */ "./node_modules/@angular/material/esm2015/table.js");
/* harmony import */ var _shared_components_spinner_spinner_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../shared/components/spinner/spinner.service */ "./src/app/shared/components/spinner/spinner.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};




//import { MatPaginatorModule } from '@angular/material/paginator'; 



let BrandsComponent = class BrandsComponent {
    constructor(brandService, router, spinnerService) {
        this.brandService = brandService;
        this.router = router;
        this.spinnerService = spinnerService;
        // MatPaginator Inputs
        this.length = 20;
        this.pageSize = 10;
        this.pageSizeOptions = [5, 10, 25, 100];
        this.dataSource = new _angular_material_table__WEBPACK_IMPORTED_MODULE_5__["MatTableDataSource"]();
        this.displayedColumns = ['name', 'templateId', 'brandId', 'brandsCount', 'locationsNo', 'startDate'];
    }
    ngOnInit() {
        // show spinner on page load
        this.spinnerService.show();
        // hide spinner
        setTimeout(() => {
            this.getBrands(false);
            this.spinnerService.hide();
        }, 1500);
    }
    getBrands(showInactive) {
        // get all master brands 
        if (showInactive) {
            this.brandService.getInactiveBrands().subscribe(result => {
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
                this.dataSource.data = result;
            }, error => console.error(error));
        }
        else {
            this.brandService.getActiveBrands().subscribe(result => {
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
                this.dataSource.data = result;
            }, error => console.error(error));
        }
    }
    add(name) {
        name = name.trim();
        if (!name) {
            return;
        }
        this.brandService.add({ name: name })
            .subscribe(brand => {
            this.hideAddBrandModal();
            this.router.navigate(['/brand/' + brand.id]);
        });
    }
    // hide modal
    hideAddBrandModal() {
        $("#addBrandModal").modal('hide');
    }
    applyFilter(event) {
        const filterValue = event.target.value;
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }
    showInactive(event) {
        const filterValue = event.target.checked;
        this.getBrands(filterValue);
    }
};
BrandsComponent.ctorParameters = () => [
    { type: _shared_services_brand_service__WEBPACK_IMPORTED_MODULE_1__["BrandService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] },
    { type: _shared_components_spinner_spinner_service__WEBPACK_IMPORTED_MODULE_6__["SpinnerService"] }
];
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])(_angular_material_paginator__WEBPACK_IMPORTED_MODULE_4__["MatPaginator"], { static: true }),
    __metadata("design:type", _angular_material_paginator__WEBPACK_IMPORTED_MODULE_4__["MatPaginator"])
], BrandsComponent.prototype, "paginator", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])(_angular_material_sort__WEBPACK_IMPORTED_MODULE_3__["MatSort"], { static: true }),
    __metadata("design:type", _angular_material_sort__WEBPACK_IMPORTED_MODULE_3__["MatSort"])
], BrandsComponent.prototype, "sort", void 0);
BrandsComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-brands',
        template: __importDefault(__webpack_require__(/*! raw-loader!./brands.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/brands/brands.component.html")).default,
        styles: [__importDefault(__webpack_require__(/*! ./brands.component.css */ "./src/app/components/brands/brands.component.css")).default]
    }),
    __metadata("design:paramtypes", [_shared_services_brand_service__WEBPACK_IMPORTED_MODULE_1__["BrandService"], _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"], _shared_components_spinner_spinner_service__WEBPACK_IMPORTED_MODULE_6__["SpinnerService"]])
], BrandsComponent);



/***/ }),

/***/ "./src/app/components/dashboard/dashboard.component.ts":
/*!*************************************************************!*\
  !*** ./src/app/components/dashboard/dashboard.component.ts ***!
  \*************************************************************/
/*! exports provided: DashboardComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DashboardComponent", function() { return DashboardComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _shared_services_brand_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../shared/services/brand.service */ "./src/app/shared/services/brand.service.ts");
/* harmony import */ var _shared_services_mailing_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../shared/services/mailing.service */ "./src/app/shared/services/mailing.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};



let DashboardComponent = class DashboardComponent {
    constructor(brandService, mailingService) {
        this.brandService = brandService;
        this.mailingService = mailingService;
    }
    // on component load
    ngOnInit() {
        this.brandService.getMostRecent().subscribe((result) => {
            if (result.length) {
                this.brands = result;
            }
        });
        this.mailingService.getMostRecent().subscribe((result) => {
            if (result.length) {
                this.mailings = result;
            }
        });
    }
};
DashboardComponent.ctorParameters = () => [
    { type: _shared_services_brand_service__WEBPACK_IMPORTED_MODULE_1__["BrandService"] },
    { type: _shared_services_mailing_service__WEBPACK_IMPORTED_MODULE_2__["MailingService"] }
];
DashboardComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-dashboard',
        template: __importDefault(__webpack_require__(/*! raw-loader!./dashboard.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/dashboard/dashboard.component.html")).default,
    }),
    __metadata("design:paramtypes", [_shared_services_brand_service__WEBPACK_IMPORTED_MODULE_1__["BrandService"], _shared_services_mailing_service__WEBPACK_IMPORTED_MODULE_2__["MailingService"]])
], DashboardComponent);



/***/ }),

/***/ "./src/app/components/home/home.component.ts":
/*!***************************************************!*\
  !*** ./src/app/components/home/home.component.ts ***!
  \***************************************************/
/*! exports provided: HomeComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HomeComponent", function() { return HomeComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _src_api_authorization_authorize_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../src/api-authorization/authorize.service */ "./src/api-authorization/authorize.service.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};




let HomeComponent = class HomeComponent {
    constructor(authorizeService, router) {
        this.authorizeService = authorizeService;
        this.router = router;
        this.message = new rxjs__WEBPACK_IMPORTED_MODULE_3__["BehaviorSubject"](null);
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.authorizeService.isAuthenticated();
            if (result) {
                this.router.navigate(['/dashboard']);
            }
        });
    }
};
HomeComponent.ctorParameters = () => [
    { type: _src_api_authorization_authorize_service__WEBPACK_IMPORTED_MODULE_1__["AuthorizeService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] }
];
HomeComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-home',
        template: __importDefault(__webpack_require__(/*! raw-loader!./home.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/home/home.component.html")).default,
    }),
    __metadata("design:paramtypes", [_src_api_authorization_authorize_service__WEBPACK_IMPORTED_MODULE_1__["AuthorizeService"], _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"]])
], HomeComponent);



/***/ }),

/***/ "./src/app/components/location-overrides/location-overrides.component.ts":
/*!*******************************************************************************!*\
  !*** ./src/app/components/location-overrides/location-overrides.component.ts ***!
  \*******************************************************************************/
/*! exports provided: LocationOverridesComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LocationOverridesComponent", function() { return LocationOverridesComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_material_sort__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/sort */ "./node_modules/@angular/material/esm2015/sort.js");
/* harmony import */ var _angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/paginator */ "./node_modules/@angular/material/esm2015/paginator.js");
/* harmony import */ var _angular_material_table__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/table */ "./node_modules/@angular/material/esm2015/table.js");
/* harmony import */ var _shared_services_storelocation_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../shared/services/storelocation.service */ "./src/app/shared/services/storelocation.service.ts");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../shared/components/modals/confirmation-modal/confirmation-modal.service */ "./src/app/shared/components/modals/confirmation-modal/confirmation-modal.service.ts");
/* harmony import */ var _shared_services_storelocationOverride_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../shared/services/storelocationOverride.service */ "./src/app/shared/services/storelocationOverride.service.ts");
/* harmony import */ var _shared_components_modals_location_override_modal_location_override_form_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../shared/components/modals/location-override-modal/location-override-form.component */ "./src/app/shared/components/modals/location-override-modal/location-override-form.component.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};











let LocationOverridesComponent = class LocationOverridesComponent {
    constructor(storeLocationService, storeLocationOverrideService, router, route, modalService, notification, confirmationModalService) {
        this.storeLocationService = storeLocationService;
        this.storeLocationOverrideService = storeLocationOverrideService;
        this.router = router;
        this.route = route;
        this.modalService = modalService;
        this.notification = notification;
        this.confirmationModalService = confirmationModalService;
        // MatPaginator Inputs
        this.length = 20;
        this.pageSize = 10;
        this.pageSizeOptions = [10, 25, 100];
        this.dataSource = new _angular_material_table__WEBPACK_IMPORTED_MODULE_4__["MatTableDataSource"]();
        this.displayedColumns = ['actions', 'sourceName', 'destinationName', 'startDate', 'endDate'];
    }
    // use getter setter to define the property
    get id() {
        return this._id;
    }
    set id(val) {
        this._id = val;
    }
    // call get locations on load 
    ngOnInit() {
        this.getRecords(this.id);
    }
    // get locations
    getRecords(id) {
        if (id > 0) {
            this.storeLocationOverrideService.getAll(id).subscribe(result => {
                this.dataSource.data = result;
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
            }, error => console.error(error));
        }
    }
    // open add form for location
    openAddModal() {
        let model = {
            id: 0,
            sourceStoreLocationId: 0,
            destinationStoreLocationId: 0,
            brandId: this.id,
            startDate: '',
            endDate: '',
            sourceName: '',
            destinationName: ''
        };
        let modalOptions = {
            backdrop: 'static',
            keyboard: false,
        };
        const modalRef = this.modalService.open(_shared_components_modals_location_override_modal_location_override_form_component__WEBPACK_IMPORTED_MODULE_10__["LocationOverrideFormComponent"], modalOptions);
        modalRef.componentInstance.title = 'Add Location Override';
        modalRef.componentInstance.inputModel = model;
        // modal result
        modalRef.result.then((result) => {
            if (result) {
                this.getRecords(this.id);
            }
        }).catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
    }
    // delete location
    deleteItem(id) {
        this.confirmationModalService.confirm('Confirm', 'Are you sure you want to delete this item?')
            .then((confirmed) => {
            if (confirmed) {
                this.storeLocationOverrideService.delete(id).subscribe(() => {
                    this.showNotification('The store location has been deleted successfully!', 'Okay!');
                    this.getRecords(this.id);
                });
            }
        })
            .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
    }
    // edit location
    editItem(model) {
        let modalOptions = {
            backdrop: 'static',
            keyboard: false,
        };
        const modalRef = this.modalService.open(_shared_components_modals_location_override_modal_location_override_form_component__WEBPACK_IMPORTED_MODULE_10__["LocationOverrideFormComponent"], modalOptions);
        modalRef.componentInstance.title = 'Edit Store Location Override';
        modalRef.componentInstance.inputModel = model;
        // modal result
        modalRef.result.then((result) => {
            if (result) {
                this.getRecords(this.id);
            }
        }).catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
    }
    // filter locations
    applyFilter(event) {
        const filterValue = event.target.value;
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }
    // show notification popup
    showNotification(msg, action) {
        this.notification.open(msg, action, { duration: 40000, panelClass: ['snackbar-success'] });
    }
};
LocationOverridesComponent.ctorParameters = () => [
    { type: _shared_services_storelocation_service__WEBPACK_IMPORTED_MODULE_5__["StoreLocationService"] },
    { type: _shared_services_storelocationOverride_service__WEBPACK_IMPORTED_MODULE_9__["StoreLocationOverrideService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_1__["ActivatedRoute"] },
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_6__["NgbModal"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_7__["MatSnackBar"] },
    { type: _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_8__["ConfirmationModalService"] }
];
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])(_angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__["MatPaginator"], { static: true }),
    __metadata("design:type", _angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__["MatPaginator"])
], LocationOverridesComponent.prototype, "paginator", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])(_angular_material_sort__WEBPACK_IMPORTED_MODULE_2__["MatSort"], { static: true }),
    __metadata("design:type", _angular_material_sort__WEBPACK_IMPORTED_MODULE_2__["MatSort"])
], LocationOverridesComponent.prototype, "sort", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], LocationOverridesComponent.prototype, "id", null);
LocationOverridesComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-location-overrides',
        template: __importDefault(__webpack_require__(/*! raw-loader!./location-overrides.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/location-overrides/location-overrides.component.html")).default
    }),
    __metadata("design:paramtypes", [_shared_services_storelocation_service__WEBPACK_IMPORTED_MODULE_5__["StoreLocationService"],
        _shared_services_storelocationOverride_service__WEBPACK_IMPORTED_MODULE_9__["StoreLocationOverrideService"],
        _angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"],
        _angular_router__WEBPACK_IMPORTED_MODULE_1__["ActivatedRoute"],
        _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_6__["NgbModal"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_7__["MatSnackBar"],
        _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_8__["ConfirmationModalService"]])
], LocationOverridesComponent);



/***/ }),

/***/ "./src/app/components/locations/locations.component.ts":
/*!*************************************************************!*\
  !*** ./src/app/components/locations/locations.component.ts ***!
  \*************************************************************/
/*! exports provided: LocationsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LocationsComponent", function() { return LocationsComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_material_sort__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/sort */ "./node_modules/@angular/material/esm2015/sort.js");
/* harmony import */ var _angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/paginator */ "./node_modules/@angular/material/esm2015/paginator.js");
/* harmony import */ var _angular_material_table__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/table */ "./node_modules/@angular/material/esm2015/table.js");
/* harmony import */ var _shared_services_storelocation_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../shared/services/storelocation.service */ "./src/app/shared/services/storelocation.service.ts");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _shared_components_modals_location_add_modal_location_add_component__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../shared/components/modals/location-add-modal/location-add.component */ "./src/app/shared/components/modals/location-add-modal/location-add.component.ts");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../shared/components/modals/confirmation-modal/confirmation-modal.service */ "./src/app/shared/components/modals/confirmation-modal/confirmation-modal.service.ts");
/* harmony import */ var _shared_components_modals_location_edit_modal_location_edit_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../shared/components/modals/location-edit-modal/location-edit.component */ "./src/app/shared/components/modals/location-edit-modal/location-edit.component.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};











let LocationsComponent = class LocationsComponent {
    constructor(storeLocationService, router, route, modalService, notification, confirmationModalService) {
        this.storeLocationService = storeLocationService;
        this.router = router;
        this.route = route;
        this.modalService = modalService;
        this.notification = notification;
        this.confirmationModalService = confirmationModalService;
        // MatPaginator Inputs
        this.length = 20;
        this.pageSize = 10;
        this.pageSizeOptions = [10, 25, 100];
        this.dataSource = new _angular_material_table__WEBPACK_IMPORTED_MODULE_4__["MatTableDataSource"]();
        this.displayedColumns = ['actions', 'name', 'storeId', 'address', 'phone', 'email', 'url'];
    }
    // use getter setter to define the property
    get id() {
        return this._id;
    }
    set id(val) {
        this._id = val;
    }
    // call get locations on load 
    ngOnInit() {
        this.getRecords(this.id);
    }
    // get locations
    getRecords(id) {
        if (id > 0) {
            this.storeLocationService.getAll(id).subscribe(result => {
                this.dataSource.data = result;
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
            }, error => console.error(error));
        }
    }
    // open add form for location
    openAddModal() {
        let modalOptions = {
            backdrop: 'static',
            keyboard: false,
        };
        const modalRef = this.modalService.open(_shared_components_modals_location_add_modal_location_add_component__WEBPACK_IMPORTED_MODULE_7__["LocationAddFormComponent"], modalOptions);
        modalRef.componentInstance.title = 'Add a Store Location';
        modalRef.componentInstance.brandId = this.id;
        // modal result
        modalRef.result.then((result) => {
            if (result) {
                this.getRecords(this.id);
            }
        }).catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
    }
    // delete location
    deleteLocation(id) {
        this.confirmationModalService.confirm('Confirm', 'Are you sure you want to delete this item?')
            .then((confirmed) => {
            if (confirmed) {
                this.storeLocationService.delete(id).subscribe(() => {
                    this.showNotification('The store location has been deleted successfully!', 'Okay!');
                    this.getRecords(this.id);
                });
            }
        })
            .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
    }
    // edit location
    editLocation(location) {
        let modalOptions = {
            backdrop: 'static',
            keyboard: false,
        };
        const modalRef = this.modalService.open(_shared_components_modals_location_edit_modal_location_edit_component__WEBPACK_IMPORTED_MODULE_10__["LocationEditFormComponent"], modalOptions);
        modalRef.componentInstance.title = 'Edit Store Location';
        modalRef.componentInstance.location = location;
        // modal result
        modalRef.result.then((result) => {
            if (result) {
                this.getRecords(this.id);
            }
        }).catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
    }
    // filter locations
    applyFilter(event) {
        const filterValue = event.target.value;
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }
    // show notification popup
    showNotification(msg, action) {
        this.notification.open(msg, action, { duration: 40000, panelClass: ['snackbar-success'] });
    }
};
LocationsComponent.ctorParameters = () => [
    { type: _shared_services_storelocation_service__WEBPACK_IMPORTED_MODULE_5__["StoreLocationService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_1__["ActivatedRoute"] },
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_6__["NgbModal"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_8__["MatSnackBar"] },
    { type: _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_9__["ConfirmationModalService"] }
];
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])(_angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__["MatPaginator"], { static: true }),
    __metadata("design:type", _angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__["MatPaginator"])
], LocationsComponent.prototype, "paginator", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])(_angular_material_sort__WEBPACK_IMPORTED_MODULE_2__["MatSort"], { static: true }),
    __metadata("design:type", _angular_material_sort__WEBPACK_IMPORTED_MODULE_2__["MatSort"])
], LocationsComponent.prototype, "sort", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], LocationsComponent.prototype, "id", null);
LocationsComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-locations',
        template: __importDefault(__webpack_require__(/*! raw-loader!./locations.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/locations/locations.component.html")).default
    }),
    __metadata("design:paramtypes", [_shared_services_storelocation_service__WEBPACK_IMPORTED_MODULE_5__["StoreLocationService"],
        _angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"],
        _angular_router__WEBPACK_IMPORTED_MODULE_1__["ActivatedRoute"],
        _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_6__["NgbModal"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_8__["MatSnackBar"],
        _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_9__["ConfirmationModalService"]])
], LocationsComponent);



/***/ }),

/***/ "./src/app/components/mailing-details/mailing-details.component.ts":
/*!*************************************************************************!*\
  !*** ./src/app/components/mailing-details/mailing-details.component.ts ***!
  \*************************************************************************/
/*! exports provided: MailingDetailsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MailingDetailsComponent", function() { return MailingDetailsComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _angular_material_sort__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/sort */ "./node_modules/@angular/material/esm2015/sort.js");
/* harmony import */ var _angular_material_paginator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/paginator */ "./node_modules/@angular/material/esm2015/paginator.js");
/* harmony import */ var _angular_material_table__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/table */ "./node_modules/@angular/material/esm2015/table.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _shared_services_mailing_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../shared/services/mailing.service */ "./src/app/shared/services/mailing.service.ts");
/* harmony import */ var _shared_services_mailingFile_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../shared/services/mailingFile.service */ "./src/app/shared/services/mailingFile.service.ts");
/* harmony import */ var _shared_components_spinner_spinner_service__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../shared/components/spinner/spinner.service */ "./src/app/shared/components/spinner/spinner.service.ts");
/* harmony import */ var _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../shared/components/modals/confirmation-modal/confirmation-modal.service */ "./src/app/shared/components/modals/confirmation-modal/confirmation-modal.service.ts");
/* harmony import */ var _shared_services_validation_service__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../shared/services/validation.service */ "./src/app/shared/services/validation.service.ts");
/* harmony import */ var _shared_services_file_service__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../shared/services/file.service */ "./src/app/shared/services/file.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
// angular



// material 








// helper components



let MailingDetailsComponent = class MailingDetailsComponent {
    constructor(mailingService, mailingFileService, route, notification, formBuilder, 
    //private authorizeService: AuthorizeService,
    router, spinnerService, confirmationModalService, fileService, datepipe) {
        this.mailingService = mailingService;
        this.mailingFileService = mailingFileService;
        this.route = route;
        this.notification = notification;
        this.formBuilder = formBuilder;
        this.router = router;
        this.spinnerService = spinnerService;
        this.confirmationModalService = confirmationModalService;
        this.fileService = fileService;
        this.datepipe = datepipe;
        this.results = "[]"; //Result data from importer
        this.mailingFileId = 0;
        this.mailingRecords = [];
        this.mailingFormSubmitted = false;
        this.isMailingReady = false;
        // MatPaginator Inputs
        this.length = 20;
        this.pageSize = 10;
        this.pageSizeOptions = [5, 10, 25, 100];
        this.dataSource = new _angular_material_table__WEBPACK_IMPORTED_MODULE_5__["MatTableDataSource"]();
        this.displayedColumns = ['action', 'name', 'totalRecords', 'createDate'];
        this.pipe = new _angular_common__WEBPACK_IMPORTED_MODULE_2__["DatePipe"]('en-US');
    }
    // init
    ngOnInit() {
        // show spinner on page load
        this.spinnerService.show();
        //// get current user
        //this.authorizeService.getUser().subscribe(result => {
        //  this.userName = result.name;
        //  this.userId = result.sub;
        //});
        // get url parameter id 
        this.sub = this.route.params.subscribe(params => {
            this.id = +params['id']; // (+) converts string 'id' to a number  
            this.msg = '';
            this.getMailing(this.id);
            // get mailing files
            this.getMailingFiles(this.id);
        });
    }
    // gets mailing records based on mailing id
    getMailingFiles(id) {
        // get mailingrecords
        this.mailingFileService.getAll(id).subscribe(result => {
            //if (result.length) { 
            this.dataSource.data = result;
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            //} 
            this.isMailingReady = result.every(element => element.isProcessed === true);
        }, error => console.error(error));
    }
    // get mailing details
    getMailing(id) {
        // get mailing
        this.mailingService.getById(id).subscribe(result => {
            this.mailing = result;
            // build form
            if (this.mailing) {
                this.mailingForm = this.formBuilder.group({
                    name: [this.mailing.name, [_angular_forms__WEBPACK_IMPORTED_MODULE_7__["Validators"].required, _shared_services_validation_service__WEBPACK_IMPORTED_MODULE_12__["ValidationService"].alphaNumericValidator]],
                    brandId: [this.mailing.brandId, _angular_forms__WEBPACK_IMPORTED_MODULE_7__["Validators"].required],
                    startDate: [this.mailing.startDate, _angular_forms__WEBPACK_IMPORTED_MODULE_7__["Validators"].required]
                });
            }
            // hide spinner
            setTimeout(() => {
                this.spinnerService.hide();
            }, 1500);
        }, error => this.router.navigate(['/mailings/']) //console.error(error)
        );
    }
    // format gender
    convertGender(gender) {
        let g = 'F';
        switch (gender) {
            case 'F':
            case 'Female':
            case 'Unknown':
            case 'U':
                g = 'F';
                break;
            case 'M':
            case 'Male':
                g = 'M';
                break;
        }
        return g;
    }
    // update mailing
    updateMailing() {
        this.mailingFormSubmitted = true;
        // stop here if form is invalid
        if (this.mailingForm.invalid) {
            return;
        }
        this.mailingService.update(this.mailing.id, { name: this.mailingForm.value["name"] })
            .subscribe(() => this.showNotification('Your changes were saved!', 'Okay!'), this.mailing.name = this.mailingForm.value["name"]);
    }
    // delete mailing
    deleteMailing() {
        this.confirmationModalService.confirm('Confirm', 'Are you sure you want to delete this item?')
            .then((confirmed) => {
            if (confirmed) {
                this.mailingService.delete(this.mailing.id)
                    .subscribe(() => {
                    this.showNotification('This mailing has been deleted successfully!', 'Okay!');
                    this.router.navigate(['/mailings/']);
                });
            }
        })
            .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
    }
    // filter for campaign mailing records
    applyFilter(event) {
        const filterValue = event.target.value;
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }
    // show notification popup
    showNotification(msg, action) {
        this.notification.open(msg, action, { duration: 40000, panelClass: ['snackbar-success'] });
    }
    // export file for production
    exportForProduction(id) {
        // show spinner on page load
        this.spinnerService.show("Generating File");
        this.mailingService.getProcessRecall(id).subscribe(result => {
            //this.exports = result;
            this.spinnerService.hide();
            let headerList = [
                "id",
                "member",
                "patientID",
                //"clxPatientID",
                "firstName",
                "lastName",
                "address1",
                "address2",
                "city",
                "st",
                "zipCode",
                "sex",
                "dateOfBirth",
                "age",
                "lastExam",
                "months",
                "storeDescription",
                "storeNumber",
                "storeAddress1",
                "storeAddress2",
                "storeCity",
                "storeST",
                "storeZipCode",
                "storePhone",
                "storeEmail",
                "storeHours",
                "storeUrl",
                "campaignType",
                "template",
                "frontImage",
                "frontCTA",
                "frontOffer",
                "frontLogo",
                "backLogo",
                "backCTA",
                "backBackground",
                "backTopLeftCopy",
                "backOfferBlock",
                "backBottomLeftCopy",
                "backStoreBlock",
                "style",
                "custom1",
                "custom2",
                "custom3",
                "custom4",
                "custom5"
            ];
            let fileName = this.mailing.name.replace(' ', '_') + '_' + this.datepipe.transform(this.mailing.startDate, 'MM-dd-yyyy');
            this.fileService.downloadFile(result, headerList, fileName);
        }, error => console.error(error));
    }
    // approve mailing
    approveMailing(id) {
        this.confirmationModalService.confirm('Confirm', 'Are you sure you want to approve this mailing?')
            .then((confirmed) => {
            if (confirmed) {
                this.spinnerService.show();
                this.mailingService.update(id, { name: this.mailingForm.value["name"], isApproved: true })
                    .subscribe(() => {
                    this.showNotification('This mailing file has been approved successfully!', 'Okay!');
                    this.getMailing(this.id);
                    this.spinnerService.hide();
                });
            }
        })
            .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
    }
};
MailingDetailsComponent.ctorParameters = () => [
    { type: _shared_services_mailing_service__WEBPACK_IMPORTED_MODULE_8__["MailingService"] },
    { type: _shared_services_mailingFile_service__WEBPACK_IMPORTED_MODULE_9__["MailingFileService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_1__["ActivatedRoute"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_6__["MatSnackBar"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormBuilder"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"] },
    { type: _shared_components_spinner_spinner_service__WEBPACK_IMPORTED_MODULE_10__["SpinnerService"] },
    { type: _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_11__["ConfirmationModalService"] },
    { type: _shared_services_file_service__WEBPACK_IMPORTED_MODULE_13__["FileService"] },
    { type: _angular_common__WEBPACK_IMPORTED_MODULE_2__["DatePipe"] }
];
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])(_angular_material_paginator__WEBPACK_IMPORTED_MODULE_4__["MatPaginator"], { static: true }),
    __metadata("design:type", _angular_material_paginator__WEBPACK_IMPORTED_MODULE_4__["MatPaginator"])
], MailingDetailsComponent.prototype, "paginator", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])(_angular_material_sort__WEBPACK_IMPORTED_MODULE_3__["MatSort"], { static: true }),
    __metadata("design:type", _angular_material_sort__WEBPACK_IMPORTED_MODULE_3__["MatSort"])
], MailingDetailsComponent.prototype, "sort", void 0);
MailingDetailsComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-mailing-details',
        template: __importDefault(__webpack_require__(/*! raw-loader!./mailing-details.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/mailing-details/mailing-details.component.html")).default
    }),
    __metadata("design:paramtypes", [_shared_services_mailing_service__WEBPACK_IMPORTED_MODULE_8__["MailingService"],
        _shared_services_mailingFile_service__WEBPACK_IMPORTED_MODULE_9__["MailingFileService"],
        _angular_router__WEBPACK_IMPORTED_MODULE_1__["ActivatedRoute"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_6__["MatSnackBar"],
        _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormBuilder"],
        _angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"],
        _shared_components_spinner_spinner_service__WEBPACK_IMPORTED_MODULE_10__["SpinnerService"],
        _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_11__["ConfirmationModalService"],
        _shared_services_file_service__WEBPACK_IMPORTED_MODULE_13__["FileService"],
        _angular_common__WEBPACK_IMPORTED_MODULE_2__["DatePipe"]])
], MailingDetailsComponent);



/***/ }),

/***/ "./src/app/components/mailing-files/mailing-files.component.ts":
/*!*********************************************************************!*\
  !*** ./src/app/components/mailing-files/mailing-files.component.ts ***!
  \*********************************************************************/
/*! exports provided: MailingFilesComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MailingFilesComponent", function() { return MailingFilesComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_material_sort__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/sort */ "./node_modules/@angular/material/esm2015/sort.js");
/* harmony import */ var _angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/paginator */ "./node_modules/@angular/material/esm2015/paginator.js");
/* harmony import */ var _angular_material_table__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/table */ "./node_modules/@angular/material/esm2015/table.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _shared_components_spinner_spinner_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../shared/components/spinner/spinner.service */ "./src/app/shared/components/spinner/spinner.service.ts");
/* harmony import */ var _shared_services_mailingRecord_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../shared/services/mailingRecord.service */ "./src/app/shared/services/mailingRecord.service.ts");
/* harmony import */ var _shared_services_mailing_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../shared/services/mailing.service */ "./src/app/shared/services/mailing.service.ts");
/* harmony import */ var flatfile_csv_importer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! flatfile-csv-importer */ "./node_modules/flatfile-csv-importer/build/browser/index.js");
/* harmony import */ var _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../shared/components/modals/confirmation-modal/confirmation-modal.service */ "./src/app/shared/components/modals/confirmation-modal/confirmation-modal.service.ts");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _shared_services_campaignType_service__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../shared/services/campaignType.service */ "./src/app/shared/services/campaignType.service.ts");
/* harmony import */ var _shared_services_brand_service__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../shared/services/brand.service */ "./src/app/shared/services/brand.service.ts");
/* harmony import */ var _shared_services_mailingFile_service__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../shared/services/mailingFile.service */ "./src/app/shared/services/mailingFile.service.ts");
/* harmony import */ var _api_authorization_authorize_service__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../../api-authorization/authorize.service */ "./src/api-authorization/authorize.service.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../../environments/environment */ "./src/environments/environment.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};









// flatfile

// helper components









let MailingFilesComponent = class MailingFilesComponent {
    constructor(campaignTypeService, brandService, mailingFileService, router, route, notification, authorizeService, spinnerService, mailingRecordService, mailingService, confirmationModalService, datepipe) {
        this.campaignTypeService = campaignTypeService;
        this.brandService = brandService;
        this.mailingFileService = mailingFileService;
        this.router = router;
        this.route = route;
        this.notification = notification;
        this.authorizeService = authorizeService;
        this.spinnerService = spinnerService;
        this.mailingRecordService = mailingRecordService;
        this.mailingService = mailingService;
        this.confirmationModalService = confirmationModalService;
        this.datepipe = datepipe;
        this.length = 20;
        this.pageSize = 10;
        this.pageSizeOptions = [10, 25, 100];
        this.dataSource = new _angular_material_table__WEBPACK_IMPORTED_MODULE_4__["MatTableDataSource"]();
        this.displayedColumns = ['action', 'name', 'totalRecords', 'createDate'];
        this.loader1 = false;
        this.showMsg = false;
        this.results = "[]"; //Result data from importer
        this.mailingFileId = 0;
        this.mailingRecords = [];
        this.campaignTypeSelected = '';
        this.brandSelected = '';
        this.isMailingReady = false;
        this.campaignTypeFormSubmitted = false;
        this.pipe = new _angular_common__WEBPACK_IMPORTED_MODULE_13__["DatePipe"]('en-US');
    }
    // init
    ngOnInit() {
        // show spinner on page load
        this.spinnerService.show();
        this.campaignTypeForm = new _angular_forms__WEBPACK_IMPORTED_MODULE_12__["FormGroup"]({
            campaignType: new _angular_forms__WEBPACK_IMPORTED_MODULE_12__["FormControl"](false),
            brand: new _angular_forms__WEBPACK_IMPORTED_MODULE_12__["FormControl"](false)
        });
        // get url parameter id 
        this.sub = this.route.params.subscribe(params => {
            this.id = +params['id']; // (+) converts string 'id' to a number
            // get mailing info
            this.getMailing(this.id);
            // get mailing files
            this.getMailingFiles(this.id);
            // get current user
            this.authorizeService.getUser().subscribe(result => {
                this.userName = result.name;
                this.userId = result.sub;
            });
            // bind brands
            this.brandService.getActiveBrands().subscribe(result => {
                if (result.length) {
                    this.brands = result; // map brand options for dropdown
                    // get campaign types
                    this.campaignTypeService.getAll().subscribe(result => {
                        this.campaignTypes = result;
                        // call importer initializer
                        this.initializeImporter();
                    });
                }
            }, error => console.error(error));
            // hide spinner
            setTimeout(() => {
                this.spinnerService.hide();
            }, 1500);
        });
    }
    // get mailing details
    getMailing(id) {
        // get mailing
        this.mailingService.getById(id).subscribe(result => {
            this.mailing = result;
            // hide spinner
            setTimeout(() => {
                this.spinnerService.hide();
            }, 1500);
        }, error => console.error(error)
        //  this.router.navigate(['/mailings/'])
        );
    }
    //launch flatfile importer tool
    showCampaignTypeModal(missingCampaign, missingBrand) {
        // init mailingTypeForm
        if (missingCampaign) {
            this.campaignTypeForm.setControl('campaignType', new _angular_forms__WEBPACK_IMPORTED_MODULE_12__["FormControl"]('', _angular_forms__WEBPACK_IMPORTED_MODULE_12__["Validators"].required));
        }
        else {
            this.campaignTypeForm.removeControl('campaignType');
        }
        if (missingBrand) {
            this.campaignTypeForm.setControl('brand', new _angular_forms__WEBPACK_IMPORTED_MODULE_12__["FormControl"]('', _angular_forms__WEBPACK_IMPORTED_MODULE_12__["Validators"].required));
        }
        else {
            this.campaignTypeForm.removeControl('brand');
        }
        this.campaignTypeForm.updateValueAndValidity();
        $('#addCampaignTypeModal').modal({ 'show': true, 'keyboard': false, 'backdrop': 'static' });
    }
    // import files
    importDataFile() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let results = yield this.importer.requestDataFromUser();
                this.campaignTypeSelected = ''; // reset campaign type for additional file import
                //this.spinnerService.show("Loading");
                // reset list
                this.mailingRecords = [];
                // add new mailing file and convert each record to match upload model
                this.mailingFileService.add({ name: results.fileName, mailingId: +this.mailing.id })
                    .subscribe(mailingFile => {
                    // map data to object  
                    this.mailingRecords = results.validData.map((x) => ({
                        mailingFileId: mailingFile.id,
                        mailingId: this.mailing.id,
                        patientId: x.hasOwnProperty('patientId') ? x.patientId.trim() : '',
                        clxPatientId: x.hasOwnProperty('clxPatientId') ? x.clxPatientId.trim() : '',
                        firstName: x.hasOwnProperty('firstName') ? x.firstName.trim() : '',
                        lastName: x.hasOwnProperty('lastName') ? x.lastName.trim() : '',
                        address1: x.hasOwnProperty('address1') ? x.address1.trim() : '',
                        address2: x.hasOwnProperty('address2') ? x.address2.trim() : '',
                        city: x.hasOwnProperty('city') ? x.city.trim() : '',
                        state: x.hasOwnProperty('state') ? x.state.trim() : '',
                        zipCode: x.hasOwnProperty('zipCode') ? x.zipCode.trim() : '',
                        gender: x.hasOwnProperty('gender') ? x.gender.trim() : 'F',
                        brandName: x.hasOwnProperty('brandName') ? x.brandName.trim() : '',
                        dateOfBirth: this.convertDate(x.dateOfBirth),
                        lastExamDate: this.convertDate(x.lastExamDate),
                        storeLocationName: x.hasOwnProperty('storeDescription') ? x.storeDescription.trim() : '',
                        campaignTypeName: x.hasOwnProperty('campaignType') ? x.campaignType.trim() : '',
                        phone: x.hasOwnProperty('phone') ? x.phone.trim() : '',
                        email: x.hasOwnProperty('email') ? x.email.trim() : '',
                        custom1: x.hasOwnProperty('custom1') ? x.custom1.trim() : '',
                        custom2: x.hasOwnProperty('custom2') ? x.custom2.trim() : '',
                        custom3: x.hasOwnProperty('custom3') ? x.custom3.trim() : '',
                        custom4: x.hasOwnProperty('custom4') ? x.custom4.trim() : '',
                        custom5: x.hasOwnProperty('custom5') ? x.custom5.trim() : '',
                    }));
                    let isMissingCampaignType = this.mailingRecords.some(x => x.campaignTypeName === '' || x.campaignTypeName === undefined);
                    let isMissingBrand = this.mailingRecords.some(x => x.brandName === undefined || x.brandName === '');
                    // assign id of new mailingfile
                    this.mailingFileId = mailingFile.id;
                    if (isMissingCampaignType || isMissingBrand) {
                        this.showCampaignTypeModal(isMissingCampaignType, isMissingBrand);
                    }
                    else {
                        this.addMailingRecords();
                    }
                });
            }
            catch (e) {
                console.info(e || "window close");
            }
        });
    }
    // add mailing records
    addMailingRecords() {
        this.importer.displayLoader();
        //if campaign type was set by user then assign to records
        if (this.campaignTypeSelected !== '' && this.campaignTypeSelected !== undefined) {
            this.mailingRecords.forEach(x => x.campaignTypeName = this.campaignTypeSelected);
        }
        //if brand was set by user then assign to records
        if (this.brandSelected !== '' && this.brandSelected !== undefined) {
            this.mailingRecords.forEach(x => x.brandName = this.brandSelected);
        }
        // add mailing records
        this.mailingRecordService.addBulk(this.mailingFileId, this.mailingRecords).subscribe(() => {
            //this.spinnerService.hide();
            // reset fields
            this.brandSelected = '';
            this.campaignTypeSelected = '';
            this.campaignTypeFormSubmitted = false;
            this.mailingFileId = 0;
            this.mailingRecords = [];
            this.importer.displaySuccess("Your data was successfully imported!");
            this.getMailingFiles(this.id);
            const timeIntervalSeconds = 5; // seconds
            this.isMailingReady = false;
            // get now list of mailing files every 5 seconds to refresh status 
            const timer = Object(rxjs__WEBPACK_IMPORTED_MODULE_11__["interval"])(timeIntervalSeconds * 1000).subscribe(x => {
                this.getMailingFiles(this.id);
                if (this.isMailingReady === true) {
                    timer.unsubscribe();
                }
            });
        }, error => console.error(error));
    }
    // add campaign type and brand to mailing records
    addCampaignType() {
        this.campaignTypeFormSubmitted = true;
        if (this.campaignTypeForm.invalid) {
            return;
        }
        this.campaignTypeSelected = this.campaignTypeForm.value["campaignType"];
        this.brandSelected = this.campaignTypeForm.value["brand"];
        $('#addCampaignTypeModal').modal('hide');
        this.addMailingRecords();
    }
    // gets mailing records based on mailing id
    getMailingFiles(id) {
        // get mailingrecords
        this.mailingFileService.getAll(id).subscribe(result => {
            //if (result.length) { 
            this.dataSource.data = result;
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            //} 
            this.isMailingReady = result.every(element => element.isProcessed === true);
        }, error => console.error(error));
    }
    // delete mailing file
    deleteMailingFile(id) {
        this.confirmationModalService.confirm('Confirm', 'Are you sure you want to delete this item?')
            .then((confirmed) => {
            if (confirmed) {
                this.mailingFileService.delete(id)
                    .subscribe(() => {
                    this.showNotification('This mailing file has been deleted successfully!', 'Okay!');
                    this.getMailingFiles(this.mailing.id);
                    //this.router.navigate(['/mailings/']);
                });
            }
        })
            .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
    }
    // build fields configuration for flat file
    getFlatfileFields() {
        let config = [
            {
                label: 'Brand',
                key: 'brandName',
                alternates: ["member", 'brand name', 'company name', 'brand'],
            },
            {
                label: 'Patient ID',
                key: 'patientId',
                alternates: ['Pt #']
            },
            {
                label: 'CLX Patient ID',
                key: 'clxPatientId',
                alternates: ['clxPersonId'],
            }, {
                label: 'First Name',
                key: 'firstName',
                alternates: ['First'],
                validators: [
                    {
                        validate: "required",
                        error: "this field is required"
                    }
                ]
            }, {
                label: 'Last Name',
                key: 'lastName',
                alternates: ['Last'],
                validators: [
                    {
                        validate: "required",
                        error: "this field is required"
                    }
                ]
            }, {
                label: 'Address',
                key: 'address1',
                alternates: ['address', 'address_line1', 'Pt Address'],
                validators: [
                    {
                        validate: "required",
                        error: "this field is required"
                    }
                ]
            }, {
                label: 'Address 2',
                key: 'address2',
                alternates: ['address_line2'],
            }, {
                label: 'City',
                key: 'city',
                alternates: ['address_city', 'Pt City'],
            }, {
                label: 'State',
                key: 'state',
                alternates: ['address_state', 'ST', 'Pt State'],
            }, {
                label: 'Zip Code',
                key: 'zipCode',
                alternates: ['address_zip', 'Zip', 'Pt Zip'],
            }, {
                label: 'Gender',
                key: 'gender',
                alternates: ['Sex', 'Ins1 Sex']
                // isRequired: false
            }, {
                label: 'Date of Birth',
                key: 'dateOfBirth',
                alternates: ['DOB', 'Pt DOB']
                //validators: [
                //  {
                //    //regex: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/, 
                //    validate: "required",
                //    error: "this field is required"
                //  }
                //]
            }, {
                label: 'Last Exam Date',
                key: 'lastExamDate',
                alternates: ['LastExam', 'Last Eye Exam', 'last_exam_date', 'Last Visit']
                //validators: [
                //  {
                //    validate: "required",
                //    error: "this field is required"
                //  }
                //]
            }, {
                label: 'Campaign Type',
                key: 'campaignType',
                alternates: ['campaign'],
            },
            {
                label: 'Store Description',
                key: 'storeDescription',
                alternates: ['office_short_name', 'storeDescription', 'practiceName', 'Practice Name', 'StoreName', 'Location Plaza', 'Exam Office']
            },
            {
                label: 'Phone',
                key: 'phone',
                alternates: ['phone number', 'Pt Phone #']
            }, {
                label: 'Email',
                key: 'email',
                alternates: ['email address']
            }, {
                label: 'Custom 1',
                key: 'custom1'
            }, {
                label: 'Custom 2',
                key: 'custom2'
            }, {
                label: 'Custom 3',
                key: 'custom3'
            }, {
                label: 'Custom 4',
                key: 'custom4'
            }, {
                label: 'Custom 5',
                key: 'custom5'
            },
            // additional fields not being stored
            {
                label: 'Nickname',
                key: 'nickname'
            }, {
                label: 'Recall Type',
                key: 'recallType'
            }, {
                label: 'Recall Date',
                key: 'recallDate'
            }, {
                label: 'Full Name',
                key: 'fullName'
            }, {
                label: 'Full Address',
                key: 'fullAddress'
            }
        ];
        return config;
    }
    convertDate(s) {
        let strDate = null;
        if (s !== '' && s !== undefined && s !== '01/01/0001' && s !== '01/01/1900') {
            s = s.trim();
            let i = s.lastIndexOf('/');
            // format not found return default date
            if (i !== -1) {
                let year = s.substr(i + 1);
                let date = new Date(s);
                let currentYear = new Date().getFullYear();
                if (date.getFullYear() > currentYear && year.length === 2) {
                    date.setFullYear(date.getFullYear() - 100);
                }
                strDate = Object(_angular_common__WEBPACK_IMPORTED_MODULE_13__["formatDate"])(date, 'MM/dd/yyyy', 'en-US');
            }
        }
        return strDate;
    }
    // init flatfile importer
    initializeImporter() {
        flatfile_csv_importer__WEBPACK_IMPORTED_MODULE_9__["default"].setVersion(2);
        //this.brandSelectOptions = this.brands.map(b => ({ value: b.name, label: b.name }));
        //this.campaignSelectOptions = this.campaignTypes.map(b => ({ value: b.name, label: b.name }));
        this.importer = new flatfile_csv_importer__WEBPACK_IMPORTED_MODULE_9__["default"](_environments_environment__WEBPACK_IMPORTED_MODULE_18__["environment"].flatFileLicenseKey, {
            fields: this.getFlatfileFields(),
            //title: 'Import mailing records',
            type: 'MailingRecord',
            allowCustom: false,
            //maxRecords: 10000, 
            allowInvalidSubmit: true,
            managed: true,
            disableManualInput: true,
            devMode: (!_environments_environment__WEBPACK_IMPORTED_MODULE_18__["environment"].production),
            styleOverrides: {
                borderRadius: '4px',
                primaryButtonColor: '#289cbf',
                primaryButtonBorderColor: '#1f7a95',
                primaryButtonFontSize: '1.6rem',
                primaryButtonFontColor: '#fff',
                secondaryButtonColor: '#8b99a4',
                secondaryButtonBorderColor: '#8b99a4',
                secondaryButtonFontSize: '1.6rem',
                secondaryButtonFontColor: '#fff',
                linkColor: '#289cbf',
                linkAltColor: '#4a90e2',
                primaryTextColor: '#1D2830',
                secondaryTextColor: '#667d8d',
                errorColor: '#ff4c42',
                successColor: '#60b700',
                warningColor: '#f6A623',
                borderColor: '#e8e8e8',
                fontFamily: 'Gilroy, "Helvetica Neue", Arial, sans-serif'
            }
        });
        // set file user info
        this.importer.setCustomer({
            userId: this.userId,
            name: this.userName
        });
        //// multi-field validation
        //this.importer.registerRecordHook(record => {
        //  //let out = {
        //  //  "dateOfBirth": { value: record.brandName, info: [{ message: '', level: '' }] },
        //  //  "lastExamDate": { value: record.campaignType, info: [{ message: '', level: '' }] }
        //  //};
        //  // format birthdate
        //  if (record.dateOfBirth) {
        //    out.dateOfBirth = {
        //      value: this.convertDate(record.dateOfBirth),
        //      info: [
        //        {
        //          message: "Invalid date",
        //          level: "info"
        //        }
        //      ]
        //    } 
        //  }
        //  return out;
        //let out = {
        //  //"brandName": { value: record.brandName, info: [{ message: '', level: '' }] },
        //  //"campaignType": { value: record.campaignType, info: [{ message: '', level: '' }] },
        //  "gender": { value: record.gender, info: [{ message: '', level: '' }] } 
        //};
        //// format gender
        //out.gender = {
        //  info: [
        //    {
        //      message: "converted gender",
        //      level: "warning"
        //    }
        //  ],
        //  value: this.convertGender(record.gender)
        //}
        //validate brand
        //if (!this.brands.some((item) => item.name === record.brandName)) {
        //  out.brandName = {
        //    info: [
        //      {
        //        message: "Invalid brand name",
        //        level: "error"
        //      } 
        //    ],
        //    value: record.brandName
        //  } 
        // }
        // validate campaign
        //if (!this.campaignTypes.some((item) => item.name.toLowerCase() === record.campaignType.toLowerCase())) {
        //  out.campaignType = {
        //    info: [
        //      {
        //        message: "Invalid campaign type",
        //        level: "error"
        //      }
        //    ],
        //    value: record.campaignType
        //  } 
        //}
        //// format zip
        //if (record.zipCode && record.zipCode.length > 5) {
        //  out.zipCode = {
        //    value: record.zipCode,
        //    info: [
        //      {
        //        message: "Invalid zip code format",
        //        level: "error"
        //      }
        //    ]
        //  }
        //} 
        //  })
    }
    // filter 
    applyFilter(event) {
        const filterValue = event.target.value;
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }
    // show notification popup
    showNotification(msg, action) {
        this.notification.open(msg, action, { duration: 40000, panelClass: ['snackbar-success'] });
    }
};
MailingFilesComponent.ctorParameters = () => [
    { type: _shared_services_campaignType_service__WEBPACK_IMPORTED_MODULE_14__["CampaignTypeService"] },
    { type: _shared_services_brand_service__WEBPACK_IMPORTED_MODULE_15__["BrandService"] },
    { type: _shared_services_mailingFile_service__WEBPACK_IMPORTED_MODULE_16__["MailingFileService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_1__["ActivatedRoute"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__["MatSnackBar"] },
    { type: _api_authorization_authorize_service__WEBPACK_IMPORTED_MODULE_17__["AuthorizeService"] },
    { type: _shared_components_spinner_spinner_service__WEBPACK_IMPORTED_MODULE_6__["SpinnerService"] },
    { type: _shared_services_mailingRecord_service__WEBPACK_IMPORTED_MODULE_7__["MailingRecordService"] },
    { type: _shared_services_mailing_service__WEBPACK_IMPORTED_MODULE_8__["MailingService"] },
    { type: _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_10__["ConfirmationModalService"] },
    { type: _angular_common__WEBPACK_IMPORTED_MODULE_13__["DatePipe"] }
];
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])(_angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__["MatPaginator"], { static: true }),
    __metadata("design:type", _angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__["MatPaginator"])
], MailingFilesComponent.prototype, "paginator", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])(_angular_material_sort__WEBPACK_IMPORTED_MODULE_2__["MatSort"], { static: true }),
    __metadata("design:type", _angular_material_sort__WEBPACK_IMPORTED_MODULE_2__["MatSort"])
], MailingFilesComponent.prototype, "sort", void 0);
MailingFilesComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-mailing-files',
        template: __importDefault(__webpack_require__(/*! raw-loader!./mailing-files.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/mailing-files/mailing-files.component.html")).default
    }),
    __metadata("design:paramtypes", [_shared_services_campaignType_service__WEBPACK_IMPORTED_MODULE_14__["CampaignTypeService"],
        _shared_services_brand_service__WEBPACK_IMPORTED_MODULE_15__["BrandService"],
        _shared_services_mailingFile_service__WEBPACK_IMPORTED_MODULE_16__["MailingFileService"],
        _angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"],
        _angular_router__WEBPACK_IMPORTED_MODULE_1__["ActivatedRoute"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__["MatSnackBar"],
        _api_authorization_authorize_service__WEBPACK_IMPORTED_MODULE_17__["AuthorizeService"],
        _shared_components_spinner_spinner_service__WEBPACK_IMPORTED_MODULE_6__["SpinnerService"],
        _shared_services_mailingRecord_service__WEBPACK_IMPORTED_MODULE_7__["MailingRecordService"],
        _shared_services_mailing_service__WEBPACK_IMPORTED_MODULE_8__["MailingService"],
        _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_10__["ConfirmationModalService"],
        _angular_common__WEBPACK_IMPORTED_MODULE_13__["DatePipe"]])
], MailingFilesComponent);



/***/ }),

/***/ "./src/app/components/mailing-notes/mailing-notes.component.ts":
/*!*********************************************************************!*\
  !*** ./src/app/components/mailing-notes/mailing-notes.component.ts ***!
  \*********************************************************************/
/*! exports provided: MailingNotesComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MailingNotesComponent", function() { return MailingNotesComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _shared_components_spinner_spinner_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../shared/components/spinner/spinner.service */ "./src/app/shared/components/spinner/spinner.service.ts");
/* harmony import */ var _shared_services_mailing_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../shared/services/mailing.service */ "./src/app/shared/services/mailing.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};






let MailingNotesComponent = class MailingNotesComponent {
    constructor(mailingService, router, route, modalService, notification, spinnerService) {
        this.mailingService = mailingService;
        this.router = router;
        this.route = route;
        this.modalService = modalService;
        this.notification = notification;
        this.spinnerService = spinnerService;
        this.contentType = 1;
    }
    // init
    ngOnInit() {
        // show spinner on page load
        this.spinnerService.show();
        // get url parameter id 
        this.sub = this.route.params.subscribe(params => {
            this.id = +params['id']; // (+) converts string 'id' to a number
            this.getMailing(this.id);
            // hide spinner
            setTimeout(() => {
                this.spinnerService.hide();
            }, 1500);
        });
    }
    // get mailing details
    getMailing(id) {
        // get mailing
        this.mailingService.getById(this.id).subscribe(result => {
            this.mailing = result;
            // hide spinner
            setTimeout(() => {
                this.spinnerService.hide();
            }, 1500);
        }, error => 
        // console.error(error)
        this.router.navigate(['/mailings/']));
    }
};
MailingNotesComponent.ctorParameters = () => [
    { type: _shared_services_mailing_service__WEBPACK_IMPORTED_MODULE_5__["MailingService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_1__["ActivatedRoute"] },
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__["NgbModal"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_3__["MatSnackBar"] },
    { type: _shared_components_spinner_spinner_service__WEBPACK_IMPORTED_MODULE_4__["SpinnerService"] }
];
MailingNotesComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-mailing-notes',
        template: __importDefault(__webpack_require__(/*! raw-loader!./mailing-notes.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/mailing-notes/mailing-notes.component.html")).default
    }),
    __metadata("design:paramtypes", [_shared_services_mailing_service__WEBPACK_IMPORTED_MODULE_5__["MailingService"],
        _angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"],
        _angular_router__WEBPACK_IMPORTED_MODULE_1__["ActivatedRoute"],
        _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__["NgbModal"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_3__["MatSnackBar"],
        _shared_components_spinner_spinner_service__WEBPACK_IMPORTED_MODULE_4__["SpinnerService"]])
], MailingNotesComponent);



/***/ }),

/***/ "./src/app/components/mailing-record-list/mailing-record-list.component.ts":
/*!*********************************************************************************!*\
  !*** ./src/app/components/mailing-record-list/mailing-record-list.component.ts ***!
  \*********************************************************************************/
/*! exports provided: MailingRecordListComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MailingRecordListComponent", function() { return MailingRecordListComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_material_sort__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/sort */ "./node_modules/@angular/material/esm2015/sort.js");
/* harmony import */ var _angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/paginator */ "./node_modules/@angular/material/esm2015/paginator.js");
/* harmony import */ var _angular_material_table__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/table */ "./node_modules/@angular/material/esm2015/table.js");
/* harmony import */ var _shared_services_mailingRecord_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../shared/services/mailingRecord.service */ "./src/app/shared/services/mailingRecord.service.ts");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../shared/components/modals/confirmation-modal/confirmation-modal.service */ "./src/app/shared/components/modals/confirmation-modal/confirmation-modal.service.ts");
/* harmony import */ var _shared_components_modals_mailing_record_edit_modal_mailing_record_edit_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../shared/components/modals/mailing-record-edit-modal/mailing-record-edit.component */ "./src/app/shared/components/modals/mailing-record-edit-modal/mailing-record-edit.component.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
// angular


// material 



// services 





let MailingRecordListComponent = class MailingRecordListComponent {
    constructor(mailingRecordService, route, modalService, notification, confirmationModalService) {
        this.mailingRecordService = mailingRecordService;
        this.route = route;
        this.modalService = modalService;
        this.notification = notification;
        this.confirmationModalService = confirmationModalService;
        // MatPaginator Inputs
        this.length = 20;
        this.pageSize = 10;
        this.pageSizeOptions = [10, 25, 100];
        this.dataSource = new _angular_material_table__WEBPACK_IMPORTED_MODULE_4__["MatTableDataSource"]();
        this.displayedColumns = ['patientId', 'fullName', 'dateOfBirth', 'gender', 'lastExamDate', 'months', 'actions'];
        this.mailingFileId = 0;
    }
    ngOnInit() {
    }
    // gets mailing records based on mailing file id
    getRecords(id) {
        this.mailingFileId = id;
        if (id > 0) {
            this.mailingRecordService.getAll(id).subscribe(result => {
                if (result.length) {
                    this.dataSource.data = result;
                    this.dataSource.paginator = this.paginator;
                    this.dataSource.sort = this.sort;
                    this.openModal();
                    $('.overlay').addClass('active');
                    $('#myMailingModal').addClass('active');
                }
            }, error => console.error(error));
        }
    }
    openModal() {
        $('.overlay').addClass('active');
        $('#myMailingModal').addClass('active');
    }
    closeModal() {
        $('#myMailingModal').removeClass('active');
        $('.overlay').removeClass('active');
    }
    // delete location
    deleteMailingRecord(id) {
        this.confirmationModalService.confirm('Confirm', 'Are you sure you want to delete this item?')
            .then((confirmed) => {
            if (confirmed) {
                this.mailingRecordService.delete(id).subscribe(() => {
                    this.showNotification('The mailing record has been deleted successfully!', 'Okay!');
                    this.getRecords(this.mailingFileId);
                });
            }
        })
            .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
    }
    // edit location
    editMailingRecord(model) {
        let modalOptions = {
            backdrop: 'static',
            keyboard: false,
        };
        const modalRef = this.modalService.open(_shared_components_modals_mailing_record_edit_modal_mailing_record_edit_component__WEBPACK_IMPORTED_MODULE_9__["MailingRecordEditFormComponent"], modalOptions);
        modalRef.componentInstance.title = 'Edit Record';
        modalRef.componentInstance.mailingRecord = model;
        // modal result
        modalRef.result.then((result) => {
            if (result) {
                this.getRecords(this.mailingFileId);
            }
        }).catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
    }
    // filter locations
    applyFilter(event) {
        const filterValue = event.target.value;
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }
    // show notification popup
    showNotification(msg, action) {
        this.notification.open(msg, action, { duration: 40000, panelClass: ['snackbar-success'] });
    }
};
MailingRecordListComponent.ctorParameters = () => [
    { type: _shared_services_mailingRecord_service__WEBPACK_IMPORTED_MODULE_5__["MailingRecordService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_1__["ActivatedRoute"] },
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_6__["NgbModal"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_7__["MatSnackBar"] },
    { type: _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_8__["ConfirmationModalService"] }
];
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])(_angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__["MatPaginator"], { static: false }),
    __metadata("design:type", _angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__["MatPaginator"])
], MailingRecordListComponent.prototype, "paginator", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])(_angular_material_sort__WEBPACK_IMPORTED_MODULE_2__["MatSort"], { static: false }),
    __metadata("design:type", _angular_material_sort__WEBPACK_IMPORTED_MODULE_2__["MatSort"])
], MailingRecordListComponent.prototype, "sort", void 0);
MailingRecordListComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-mailing-record-list',
        template: __importDefault(__webpack_require__(/*! raw-loader!./mailing-record-list.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/mailing-record-list/mailing-record-list.component.html")).default
    }),
    __metadata("design:paramtypes", [_shared_services_mailingRecord_service__WEBPACK_IMPORTED_MODULE_5__["MailingRecordService"],
        _angular_router__WEBPACK_IMPORTED_MODULE_1__["ActivatedRoute"],
        _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_6__["NgbModal"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_7__["MatSnackBar"],
        _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_8__["ConfirmationModalService"]])
], MailingRecordListComponent);



/***/ }),

/***/ "./src/app/components/mailings/mailings.component.ts":
/*!***********************************************************!*\
  !*** ./src/app/components/mailings/mailings.component.ts ***!
  \***********************************************************/
/*! exports provided: MailingsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MailingsComponent", function() { return MailingsComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _shared_services_mailing_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../shared/services/mailing.service */ "./src/app/shared/services/mailing.service.ts");
/* harmony import */ var _shared_services_brand_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../shared/services/brand.service */ "./src/app/shared/services/brand.service.ts");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_material_sort__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/sort */ "./node_modules/@angular/material/esm2015/sort.js");
/* harmony import */ var _angular_material_paginator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/paginator */ "./node_modules/@angular/material/esm2015/paginator.js");
/* harmony import */ var _angular_material_table__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material/table */ "./node_modules/@angular/material/esm2015/table.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _shared_components_spinner_spinner_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../shared/components/spinner/spinner.service */ "./src/app/shared/components/spinner/spinner.service.ts");
/* harmony import */ var _shared_services_validation_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../shared/services/validation.service */ "./src/app/shared/services/validation.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};










let MailingsComponent = class MailingsComponent {
    constructor(mailingService, brandService, router, formBuilder, spinnerService) {
        this.mailingService = mailingService;
        this.brandService = brandService;
        this.router = router;
        this.formBuilder = formBuilder;
        this.spinnerService = spinnerService;
        // MatPaginator Inputs
        this.length = 20;
        this.pageSize = 10;
        this.pageSizeOptions = [5, 10, 25, 100];
        this.dataSource = new _angular_material_table__WEBPACK_IMPORTED_MODULE_6__["MatTableDataSource"]();
        this.displayedColumns = ['name', 'status', 'brand', 'startDate', 'createdBy', 'createDate'];
        this.dateRanges = [
            //{ Value: 1, Text: "Last month" },
            //{ Value: 3,  Text: "Last 3 months" },
            { Value: 6, Text: "Last 6 months" },
            { Value: 12, Text: "Last 12 months" },
            { Value: 24, Text: "Last 24 months" }
        ];
        this.submitted = false;
    }
    // init
    ngOnInit() {
        // show spinner on page load
        this.spinnerService.show();
        this.selectedDateFilter = 6;
        this.getMailings(this.selectedDateFilter);
        this.getBrands();
        this.mailingForm = this.formBuilder.group({
            name: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_7__["Validators"].required, _shared_services_validation_service__WEBPACK_IMPORTED_MODULE_9__["ValidationService"].alphaNumericValidator]],
            brandId: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_7__["Validators"].required],
            startDate: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_7__["Validators"].required]
        });
    }
    // add mailing
    add(name, brandId, startDate) {
        name = name.trim();
        brandId = +brandId;
        if (!name || !brandId) {
            return;
        }
        this.mailingService.add({ name: name, brandId: brandId, startDate })
            .subscribe(mailing => {
            this.dataSource.data.push(mailing);
            this.hideAddMailingModal();
            this.router.navigate(['/mailing/' + mailing.id]);
        });
    }
    // hide modal
    hideAddMailingModal() {
        $("#addMailingModal").modal('hide');
    }
    // convenience getter for easy access to form fields
    onSubmitForm() {
        this.submitted = true;
        // stop here if form is invalid
        if (this.mailingForm.invalid) {
            return;
        }
        // display form values on success
        //var jsonObj = JSON.stringify(this.mailingForm.value, null, 4);
        this.add(this.mailingForm.value["name"], +this.mailingForm.value["brandId"], this.mailingForm.value["startDate"]);
        this.resetForm();
    }
    resetForm() {
        this.submitted = false;
        this.mailingForm.reset();
    }
    // get data
    getMailings(filter) {
        this.spinnerService.show();
        let filterValue = new Date();
        filterValue.setMonth(filterValue.getMonth() - filter);
        // get all mailings
        this.mailingService.getAll(filterValue.toDateString()).subscribe(result => {
            if (result.length) {
                this.dataSource.data = result;
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
            }
            // hide spinner
            setTimeout(() => {
                this.spinnerService.hide();
            }, 1500);
        }, error => console.error(error));
    }
    // get brands
    getBrands() {
        // get all master brands
        this.brandService.getActiveBrands().subscribe(brandsResult => {
            if (brandsResult.length) {
                this.brands = brandsResult;
            }
        }, error => console.error(error));
    }
    // filter results by keyword
    applyFilter(event) {
        const filterValue = event.target.value;
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }
    // filter results by date
    applyDateFilter(event) {
        const filterValue = event.target.value;
        this.getMailings(+filterValue);
    }
};
MailingsComponent.ctorParameters = () => [
    { type: _shared_services_mailing_service__WEBPACK_IMPORTED_MODULE_1__["MailingService"] },
    { type: _shared_services_brand_service__WEBPACK_IMPORTED_MODULE_2__["BrandService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_3__["Router"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormBuilder"] },
    { type: _shared_components_spinner_spinner_service__WEBPACK_IMPORTED_MODULE_8__["SpinnerService"] }
];
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])(_angular_material_paginator__WEBPACK_IMPORTED_MODULE_5__["MatPaginator"], { static: true }),
    __metadata("design:type", _angular_material_paginator__WEBPACK_IMPORTED_MODULE_5__["MatPaginator"])
], MailingsComponent.prototype, "paginator", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])(_angular_material_sort__WEBPACK_IMPORTED_MODULE_4__["MatSort"], { static: true }),
    __metadata("design:type", _angular_material_sort__WEBPACK_IMPORTED_MODULE_4__["MatSort"])
], MailingsComponent.prototype, "sort", void 0);
MailingsComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-mailings',
        template: __importDefault(__webpack_require__(/*! raw-loader!./mailings.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/mailings/mailings.component.html")).default
    }),
    __metadata("design:paramtypes", [_shared_services_mailing_service__WEBPACK_IMPORTED_MODULE_1__["MailingService"], _shared_services_brand_service__WEBPACK_IMPORTED_MODULE_2__["BrandService"], _angular_router__WEBPACK_IMPORTED_MODULE_3__["Router"], _angular_forms__WEBPACK_IMPORTED_MODULE_7__["FormBuilder"], _shared_components_spinner_spinner_service__WEBPACK_IMPORTED_MODULE_8__["SpinnerService"]])
], MailingsComponent);



/***/ }),

/***/ "./src/app/components/matrix-query-builder/matrix-query-builder.component.ts":
/*!***********************************************************************************!*\
  !*** ./src/app/components/matrix-query-builder/matrix-query-builder.component.ts ***!
  \***********************************************************************************/
/*! exports provided: MatrixQueryBuilderComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatrixQueryBuilderComponent", function() { return MatrixQueryBuilderComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _shared_models_operators__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../shared/models/operators */ "./src/app/shared/models/operators.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _shared_models_rule__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../shared/models/rule */ "./src/app/shared/models/rule.ts");
/* harmony import */ var _shared_models_queryBuilder__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../shared/models/queryBuilder */ "./src/app/shared/models/queryBuilder.ts");
/* harmony import */ var _angular_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material */ "./node_modules/@angular/material/esm2015/material.js");
/* harmony import */ var _shared_services_creativeTemplate_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../shared/services/creativeTemplate.service */ "./src/app/shared/services/creativeTemplate.service.ts");
/* harmony import */ var _shared_services_ageRange_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../shared/services/ageRange.service */ "./src/app/shared/services/ageRange.service.ts");
/* harmony import */ var _shared_services_campaignType_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../shared/services/campaignType.service */ "./src/app/shared/services/campaignType.service.ts");
/* harmony import */ var _shared_models_queryBuilderUpdate__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../shared/models/queryBuilderUpdate */ "./src/app/shared/models/queryBuilderUpdate.ts");
/* harmony import */ var _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../shared/components/modals/confirmation-modal/confirmation-modal.service */ "./src/app/shared/components/modals/confirmation-modal/confirmation-modal.service.ts");
/* harmony import */ var _shared_services_file_service__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../shared/services/file.service */ "./src/app/shared/services/file.service.ts");
/* harmony import */ var _shared_components_spinner_spinner_service__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../shared/components/spinner/spinner.service */ "./src/app/shared/components/spinner/spinner.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};













let MatrixQueryBuilderComponent = class MatrixQueryBuilderComponent {
    constructor(formBuilder, creativeTemplateService, ageRangeService, campaignTypeService, notification, confirmationModalService, fileService, spinnerService) {
        this.formBuilder = formBuilder;
        this.creativeTemplateService = creativeTemplateService;
        this.ageRangeService = ageRangeService;
        this.campaignTypeService = campaignTypeService;
        this.notification = notification;
        this.confirmationModalService = confirmationModalService;
        this.fileService = fileService;
        this.spinnerService = spinnerService;
        this.fieldNames = ['ageRange', 'gender', 'months', 'campaignType'];
        this.operators = _shared_models_operators__WEBPACK_IMPORTED_MODULE_1__["OPERATORS"];
        this.showAddRule = false;
        this.showEditRule = false;
        this.rules = [];
        this.condition = "and";
        this.ruleErrors = "";
        this.editRuleErrors = "";
        this.showUpdateCard = false;
        this.showValue = true;
        this.showGender = false;
        this.showMonths = false;
        this.showAgeRange = false;
        this.showCampaignType = false;
        this.genderSelected = "";
        this.submitted = false;
        this.currentRule = new _shared_models_rule__WEBPACK_IMPORTED_MODULE_3__["Rule"]();
        this.editRuleSubmitted = false;
        this.genderList = ['F', 'M'];
        this.selectedValues = [];
        // data source fields
        this.length = 20;
        this.pageSize = 10;
        this.pageSizeOptions = [10, 25, 100];
        this.dataSource1 = new _angular_material__WEBPACK_IMPORTED_MODULE_5__["MatTableDataSource"]();
        this.displayedColumns = ['brandName', 'templateId', 'campaignTypeName', 'months', 'ageRangeName', 'gender', 'frontImage', 'frontCTA', 'frontOffer', 'frontLogo', 'backLogo', 'backCTA', 'backBackground', 'backBottomLeftCopy', 'backOfferBlock', 'style'];
    }
    // use getter setter to define the property
    get id() {
        return this._id;
    }
    set id(val) {
        this._id = val;
    }
    // init
    ngOnInit() {
        this.buildForm();
        // bind campaign types
        this.campaignTypeService.getAll().subscribe(campaignResult => {
            this.campaignTypeList = campaignResult;
        });
        // bind age ranges dropdown
        this.ageRangeService.getAll().subscribe(result => {
            this.ageRangeList = result;
        });
    }
    //// open new rule box
    openRuleBox() {
        this.showAddRule = true;
        this.showValue = true;
    }
    getRecords(query) {
        if (query.brandId > 0) {
            this.creativeTemplateService.getQuery(query).subscribe(result => {
                this.dataSource1.data = result;
                this.dataSource1.paginator = this.paginator;
                this.dataSource1.sort = this.sort;
            }, error => console.error(error));
        }
    }
    // submit new rule
    addRule() {
        this.submitted = true;
        // stop here if form is invalid
        if (this.ruleForm.invalid) {
            return;
        }
        this.ruleErrors = "";
        this.showValue = true;
        // add rule
        const model = new _shared_models_rule__WEBPACK_IMPORTED_MODULE_3__["Rule"](); //this.ruleForm.value as Rule;
        model.id = (new Date()).getTime();
        model.fieldName = this.ruleForm.value['fieldName'];
        model.operator = this.ruleForm.value['operator'];
        model.values = this.ruleForm.value['value'].toString().split(',');
        //const index: number = this.rules.indexOf(model);
        //if (index !== -1) {  
        //if (this.rules.findIndex((item) => (item.fieldName === model.fieldName && item.operator.name === model.operator.name && item.value === model.values)) < 0) {
        this.rules.push(model);
        this.ruleForm.reset();
        this.submitted = false;
        this.showAddRule = false;
        // reset value field status
        this.showValue = false;
        this.showGender = false;
        this.showMonths = false;
        this.showAgeRange = false;
        this.showCampaignType = false;
        this.selectedValues = null;
        //} 
        //else {
        //  this.ruleErrors = "This rule already exist, please try a different combination";
        //  return;
        //}
    }
    // build form
    buildForm() {
        this.submitted = false;
        this.ruleErrors = "";
        // build form model
        this.ruleForm = this.formBuilder.group({
            fieldName: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required],
            operator: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required],
            value: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required]
        });
        // build edit form model
        this.editRuleForm = this.formBuilder.group({
            id: this.currentRule.id,
            fieldName: [this.currentRule.fieldName, _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required],
            operator: [this.currentRule.operator, _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required],
            value: [this.currentRule.values.toString(), _angular_forms__WEBPACK_IMPORTED_MODULE_2__["Validators"].required]
        });
    }
    // change condition
    changeCondition(evt) {
        this.condition = evt.target.value;
    }
    // delete rule
    removeRule(rule) {
        const index = this.rules.indexOf(rule);
        if (index !== -1) {
            this.rules.splice(index, 1);
        }
        this.currentRule = new _shared_models_rule__WEBPACK_IMPORTED_MODULE_3__["Rule"];
        this.showEditRule = false;
        this.editRuleForm.reset();
    }
    // edit rule form
    editRule(rule) {
        this.currentRule = rule;
        this.editRuleSubmitted = false;
        this.editRuleErrors = "";
        // bind form group fields
        this.editRuleForm.controls['id'].setValue(this.currentRule.id);
        this.editRuleForm.controls['fieldName'].setValue(this.currentRule.fieldName);
        this.editRuleForm.controls['operator'].setValue(this.currentRule.operator);
        this.editRuleForm.controls['value'].setValue(this.currentRule.values.toString());
        if (this.currentRule.fieldName === "ageRange") {
            this.ageRangeSelected = this.currentRule.values;
            this.showAgeRange = true;
            this.showCampaignType = false;
            this.showValue = false;
            this.showGender = false;
        }
        else if (this.currentRule.fieldName === "campaignType") {
            this.campaignTypeSelected = this.currentRule.values;
            this.showAgeRange = false;
            this.showCampaignType = true;
            this.showValue = false;
            this.showGender = false;
        }
        else if (this.currentRule.fieldName === "gender") {
            this.genderSelected = this.currentRule.values.toString();
            this.showAgeRange = false;
            this.showCampaignType = false;
            this.showValue = false;
            this.showGender = true;
        }
        else {
            this.showAgeRange = false;
            this.showCampaignType = false;
            this.showValue = true;
            this.showGender = false;
        }
        this.showAddRule = false;
        this.showEditRule = true;
    }
    // update rule on submit
    updateRule() {
        this.editRuleSubmitted = true;
        this.editRuleErrors = "";
        // stop here if form is invalid
        if (this.editRuleForm.invalid) {
            return;
        }
        // update rule
        const model = new _shared_models_rule__WEBPACK_IMPORTED_MODULE_3__["Rule"](); //this.editRuleForm.value as Rule; const model = new Rule() //this.ruleForm.value as Rule;
        model.id = (new Date()).getTime();
        model.fieldName = this.editRuleForm.value['fieldName'];
        model.operator = this.editRuleForm.value['operator'];
        model.values = this.editRuleForm.value['value'].toString().split(',');
        const index = this.rules.indexOf(this.currentRule);
        if (index >= 0) {
            this.rules[index] = model;
            this.editRuleForm.reset();
            this.showEditRule = false;
        }
    }
    // run query
    runQuery() {
        let queryBuilder = new _shared_models_queryBuilder__WEBPACK_IMPORTED_MODULE_4__["QueryBuilder"];
        queryBuilder.condition = this.condition;
        queryBuilder.rules = this.rules;
        queryBuilder.brandId = this.id;
        this.getRecords(queryBuilder);
        this.showUpdateCard = true;
    }
    exportData() {
        let headerList = [
            "campaignTypeName",
            "brandName",
            "templateId",
            "months",
            "ageRangeName",
            "gender",
            "frontImage",
            "frontCTA",
            "frontOffer",
            "frontLogo",
            "backLogo",
            "backCTA",
            "backBackground",
            "backTopLeftCopy",
            "backOfferBlock",
            "backStoreBlock",
            "backBottomLeftCopy",
            "style"
            //"custom1",
            //"custom2",
            //"custom3",
            //"custom4",
            //"custom5"
        ];
        this.fileService.downloadFile(this.dataSource1.data, headerList, "datafile");
    }
    toggleValueField(fieldName, editMode) {
        this.ageRangeSelected = null;
        this.campaignTypeSelected = null;
        this.genderSelected = "";
        if (editMode === true) {
            this.editRuleForm.controls['value'].setValue('');
        }
        else {
            this.ruleForm.controls['value'].setValue('');
        }
        switch (fieldName) {
            case "ageRange":
                this.showValue = false;
                this.showGender = false;
                this.showMonths = false;
                this.showAgeRange = true;
                this.showCampaignType = false;
                break;
            case "gender":
                this.showValue = false;
                this.showGender = true;
                this.showMonths = false;
                this.showAgeRange = false;
                this.showCampaignType = false;
                break;
            case "months":
                this.showValue = true;
                this.showGender = false;
                this.showAgeRange = false;
                this.showCampaignType = false;
                break;
            case "campaignType":
                this.showValue = false;
                this.showGender = false;
                this.showMonths = false;
                this.showAgeRange = false;
                this.showCampaignType = true;
                break;
            default:
                this.showValue = true;
                this.showGender = false;
                this.showMonths = false;
                this.showAgeRange = false;
                this.showCampaignType = false;
                break;
        }
    }
    setControlValue(value, editMode) {
        if (editMode === true) {
            this.editRuleForm.controls['value'].setValue(value);
        }
        else {
            this.ruleForm.controls['value'].setValue(value);
        }
    }
    setControlValues(fieldName, $event, editMode) {
        let ids = $event;
        if (fieldName === "campaignType") {
            this.selectedValues = ids.map(a => a.name);
        }
        else {
            this.selectedValues = ids.map(a => a.range);
        }
        if (editMode === true) {
            this.editRuleForm.controls['value'].setValue(this.selectedValues.toString());
        }
        else {
            this.ruleForm.controls['value'].setValue(this.selectedValues.toString());
        }
    }
    bulkUpdate(fieldName, newValue) {
        if (fieldName !== "" && newValue !== "" && this.dataSource1.data.length > 0) {
            // confirm action
            this.confirmationModalService.confirm('Confirm', 'Are you sure you want to update all records?')
                .then((confirmed) => {
                if (confirmed) {
                    this.spinnerService.show();
                    let updateModel = new _shared_models_queryBuilderUpdate__WEBPACK_IMPORTED_MODULE_9__["QueryBuilderUpdate"]();
                    updateModel.ids = this.dataSource1.data.map(x => x.id);
                    updateModel.fieldName = fieldName;
                    updateModel.newValue = newValue;
                    this.creativeTemplateService.updateBulk(updateModel).subscribe(() => {
                        this.showNotification('Your changes were saved!', 'Okay!');
                        this.runQuery(); // refresh data for export event
                        this.spinnerService.hide();
                    });
                }
            })
                .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
        }
    }
    // show notification popup
    showNotification(msg, action) {
        this.notification.open(msg, action, { duration: 40000, panelClass: ['snackbar-success'] });
    }
};
MatrixQueryBuilderComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormBuilder"] },
    { type: _shared_services_creativeTemplate_service__WEBPACK_IMPORTED_MODULE_6__["CreativeTemplateService"] },
    { type: _shared_services_ageRange_service__WEBPACK_IMPORTED_MODULE_7__["AgeRangeService"] },
    { type: _shared_services_campaignType_service__WEBPACK_IMPORTED_MODULE_8__["CampaignTypeService"] },
    { type: _angular_material__WEBPACK_IMPORTED_MODULE_5__["MatSnackBar"] },
    { type: _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_10__["ConfirmationModalService"] },
    { type: _shared_services_file_service__WEBPACK_IMPORTED_MODULE_11__["FileService"] },
    { type: _shared_components_spinner_spinner_service__WEBPACK_IMPORTED_MODULE_12__["SpinnerService"] }
];
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])(_angular_material__WEBPACK_IMPORTED_MODULE_5__["MatPaginator"], { static: true }),
    __metadata("design:type", _angular_material__WEBPACK_IMPORTED_MODULE_5__["MatPaginator"])
], MatrixQueryBuilderComponent.prototype, "paginator", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])(_angular_material__WEBPACK_IMPORTED_MODULE_5__["MatSort"], { static: true }),
    __metadata("design:type", _angular_material__WEBPACK_IMPORTED_MODULE_5__["MatSort"])
], MatrixQueryBuilderComponent.prototype, "sort", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], MatrixQueryBuilderComponent.prototype, "id", null);
MatrixQueryBuilderComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-matrix-query-builder',
        template: __importDefault(__webpack_require__(/*! raw-loader!./matrix-query-builder.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/matrix-query-builder/matrix-query-builder.component.html")).default
    }),
    __metadata("design:paramtypes", [_angular_forms__WEBPACK_IMPORTED_MODULE_2__["FormBuilder"],
        _shared_services_creativeTemplate_service__WEBPACK_IMPORTED_MODULE_6__["CreativeTemplateService"],
        _shared_services_ageRange_service__WEBPACK_IMPORTED_MODULE_7__["AgeRangeService"],
        _shared_services_campaignType_service__WEBPACK_IMPORTED_MODULE_8__["CampaignTypeService"],
        _angular_material__WEBPACK_IMPORTED_MODULE_5__["MatSnackBar"],
        _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_10__["ConfirmationModalService"],
        _shared_services_file_service__WEBPACK_IMPORTED_MODULE_11__["FileService"],
        _shared_components_spinner_spinner_service__WEBPACK_IMPORTED_MODULE_12__["SpinnerService"]])
], MatrixQueryBuilderComponent);



/***/ }),

/***/ "./src/app/components/matrix/matrix.component.ts":
/*!*******************************************************!*\
  !*** ./src/app/components/matrix/matrix.component.ts ***!
  \*******************************************************/
/*! exports provided: MatrixComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatrixComponent", function() { return MatrixComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_material_sort__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/sort */ "./node_modules/@angular/material/esm2015/sort.js");
/* harmony import */ var _angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/paginator */ "./node_modules/@angular/material/esm2015/paginator.js");
/* harmony import */ var _angular_material_table__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/table */ "./node_modules/@angular/material/esm2015/table.js");
/* harmony import */ var _shared_services_creativeTemplate_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../shared/services/creativeTemplate.service */ "./src/app/shared/services/creativeTemplate.service.ts");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../shared/components/modals/confirmation-modal/confirmation-modal.service */ "./src/app/shared/components/modals/confirmation-modal/confirmation-modal.service.ts");
/* harmony import */ var _shared_components_modals_creative_template_edit_modal_creative_template_edit_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../shared/components/modals/creative-template-edit-modal/creative-template-edit.component */ "./src/app/shared/components/modals/creative-template-edit-modal/creative-template-edit.component.ts");
/* harmony import */ var _shared_components_modals_creative_template_add_modal_creative_template_add_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../shared/components/modals/creative-template-add-modal/creative-template-add.component */ "./src/app/shared/components/modals/creative-template-add-modal/creative-template-add.component.ts");
/* harmony import */ var _shared_services_file_service__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../shared/services/file.service */ "./src/app/shared/services/file.service.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../../environments/environment */ "./src/environments/environment.ts");
/* harmony import */ var flatfile_csv_importer__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! flatfile-csv-importer */ "./node_modules/flatfile-csv-importer/build/browser/index.js");
/* harmony import */ var src_api_authorization_authorize_service__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! src/api-authorization/authorize.service */ "./src/api-authorization/authorize.service.ts");
/* harmony import */ var _shared_services_ageRange_service__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../shared/services/ageRange.service */ "./src/app/shared/services/ageRange.service.ts");
/* harmony import */ var _shared_services_campaignType_service__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../shared/services/campaignType.service */ "./src/app/shared/services/campaignType.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};

















let MatrixComponent = class MatrixComponent {
    constructor(creativeTemplateService, router, route, modalService, notification, confirmationModalService, fileService, ageRangeService, campaignTypeService, authorizeService) {
        this.creativeTemplateService = creativeTemplateService;
        this.router = router;
        this.route = route;
        this.modalService = modalService;
        this.notification = notification;
        this.confirmationModalService = confirmationModalService;
        this.fileService = fileService;
        this.ageRangeService = ageRangeService;
        this.campaignTypeService = campaignTypeService;
        this.authorizeService = authorizeService;
        // MatPaginator Inputs
        this.length = 20;
        this.pageSize = 10;
        this.pageSizeOptions = [10, 25, 100];
        this.dataSource = new _angular_material_table__WEBPACK_IMPORTED_MODULE_4__["MatTableDataSource"]();
        this.displayedColumns = ['actions', 'id', 'brandName', 'campaignTypeName', 'months', 'ageRangeName', 'gender', 'frontImage', 'frontCTA', 'frontOffer', 'frontLogo', 'backLogo', 'backCTA', 'backBackground', 'backTopLeftCopy', 'backBottomLeftCopy', 'backOfferBlock'];
    }
    // use getter setter to define the property
    get id() {
        return this._id;
    }
    set id(val) {
        this._id = val;
    }
    // call get locations on load 
    ngOnInit() {
        // get current user
        this.authorizeService.getUser().subscribe(result => {
            this.userName = result.name;
            this.userId = result.sub;
        });
        //
        // bind campaign dropdown
        this.campaignTypeService.getAll().subscribe(cResult => {
            this.ageRangeService.getAll().subscribe(aResult => {
                this.ageRangeList = aResult;
            });
            this.campaignTypeList = cResult;
            // call importer initializer
            this.initializeImporter();
        });
        // get matrix records
        this.getRecords(this.id);
    }
    // get matrix records
    getRecords(id) {
        if (id > 0) {
            this.creativeTemplateService.getAll(id).subscribe(result => {
                this.dataSource.data = result;
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
            }, error => console.error(error));
        }
    }
    // open add form for location
    openAddModal() {
        let modalOptions = {
            backdrop: 'static',
            keyboard: false,
        };
        const modalRef = this.modalService.open(_shared_components_modals_creative_template_add_modal_creative_template_add_component__WEBPACK_IMPORTED_MODULE_10__["CreativeTemplateAddFormComponent"], modalOptions);
        modalRef.componentInstance.title = 'Add an entry';
        modalRef.componentInstance.brandId = this.id;
        // modal result
        modalRef.result.then((result) => {
            this.getRecords(this.id);
        }).catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
    }
    // delete creative template entry
    deleteCreativeTemplate(id) {
        this.confirmationModalService.confirm('Confirm', 'Are you sure you want to delete this item?')
            .then((confirmed) => {
            if (confirmed) {
                this.creativeTemplateService.delete(id).subscribe(() => {
                    this.showNotification('The item has been deleted successfully!', 'Okay!');
                    this.getRecords(this.id);
                });
            }
        })
            .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
    }
    // copy entry
    copyCreativeTemplate(item) {
        let modalOptions = {
            backdrop: 'static',
            keyboard: false,
        };
        const modalRef = this.modalService.open(_shared_components_modals_creative_template_add_modal_creative_template_add_component__WEBPACK_IMPORTED_MODULE_10__["CreativeTemplateAddFormComponent"], modalOptions);
        modalRef.componentInstance.title = 'Add an entry';
        modalRef.componentInstance.brandId = this.id;
        modalRef.componentInstance.model = item;
        // modal result
        modalRef.result.then((result) => {
            this.getRecords(this.id);
        }).catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
    }
    // edit location
    editCreativeTemplate(item) {
        this.creativeTemplateService.getById(item.id).subscribe(ct => {
            let template = ct;
            let modalOptions = {
                backdrop: 'static',
                keyboard: false,
            };
            const modalRef = this.modalService.open(_shared_components_modals_creative_template_edit_modal_creative_template_edit_component__WEBPACK_IMPORTED_MODULE_9__["CreativeTemplateEditFormComponent"], modalOptions);
            modalRef.componentInstance.title = 'Edit Entry';
            modalRef.componentInstance.creativeTemplate = ct;
            // modal result
            modalRef.result.then((result) => {
                if (result) {
                    this.getRecords(this.id);
                }
            }).catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
        });
    }
    exportData() {
        let headerList = [
            "campaignTypeName",
            "brandName",
            "templateId",
            "months",
            "ageRangeName",
            "gender",
            "frontImage",
            "frontCTA",
            "frontOffer",
            "frontLogo",
            "backLogo",
            "backCTA",
            "backBackground",
            "backTopLeftCopy",
            "backOfferBlock",
            "backStoreBlock",
            "backBottomLeftCopy",
            "style"
        ];
        this.fileService.downloadFile(this.dataSource.data, headerList, "datafile");
    }
    // filter locations
    applyFilter(event) {
        const filterValue = event.target.value;
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }
    //reload page
    reloadPage() {
        window.location.reload();
        //this.router.navigate([this.route.url])
    }
    // init flatfile importer
    initializeImporter() {
        //License key available from your app dashboard at flatfile.io
        flatfile_csv_importer__WEBPACK_IMPORTED_MODULE_13__["default"].setVersion(2);
        //this.brandSelectOptions = this.brands.map(b => ({ value: b.name, label: b.name }));
        //this.campaignSelectOptions = this.campaignTypes.map(b => ({ value: b.name, label: b.name }));
        this.importer = new flatfile_csv_importer__WEBPACK_IMPORTED_MODULE_13__["default"](_environments_environment__WEBPACK_IMPORTED_MODULE_12__["environment"].flatFileLicenseKey, {
            fields: this.getFlatfileFields(),
            title: 'Import creative assets (matrix)',
            type: 'CreativeTemplate',
            allowCustom: false,
            //maxRecords: 10000, 
            allowInvalidSubmit: true,
            managed: true,
            disableManualInput: true,
            devMode: (!_environments_environment__WEBPACK_IMPORTED_MODULE_12__["environment"].production),
            styleOverrides: {
                borderRadius: '4px',
                primaryButtonColor: '#289cbf',
                primaryButtonBorderColor: '#1f7a95',
                primaryButtonFontSize: '1.6rem',
                primaryButtonFontColor: '#fff',
                secondaryButtonColor: '#8b99a4',
                secondaryButtonBorderColor: '#8b99a4',
                secondaryButtonFontSize: '1.6rem',
                secondaryButtonFontColor: '#fff',
                linkColor: '#289cbf',
                linkAltColor: '#4a90e2',
                primaryTextColor: '#1D2830',
                secondaryTextColor: '#667d8d',
                errorColor: '#ff4c42',
                successColor: '#60b700',
                warningColor: '#f6A623',
                borderColor: '#e8e8e8',
                fontFamily: 'Gilroy, "Helvetica Neue", Arial, sans-serif'
            }
        });
        // set file user info
        this.importer.setCustomer({
            userId: this.userId,
            name: this.userName
        });
    }
    // build fields configuration for flat file
    getFlatfileFields() {
        let config = [
            //{
            //  label: 'Brand',
            //  key: 'brand',
            //  alternates: ["member", 'brand name', 'company name'],
            //  validators: [
            //      {
            //        validate: "required",
            //        error: "this field is required"
            //      }
            //  ]
            //},
            {
                label: 'Months',
                key: 'months',
                alternates: ['month conversion'],
                validators: [
                    {
                        validate: "required",
                        error: "this field is required"
                    }
                ]
            },
            {
                label: 'Gender',
                key: 'gender',
                alternates: ['sex'],
                validators: [
                    {
                        validate: "required",
                        error: "this field is required"
                    }
                ]
            },
            {
                label: 'Age Range',
                key: 'ageRange',
                validators: [
                    {
                        validate: "required",
                        error: "this field is required"
                    }
                ]
            },
            {
                label: 'Campaign Type',
                key: 'campaignType',
                alternates: ['campaign'],
                validators: [
                    {
                        validate: "required",
                        error: "this field is required"
                    }
                ]
            },
            {
                label: 'Front Image',
                key: 'frontImage'
            },
            {
                label: 'Front CTA',
                key: 'frontCTA'
            },
            {
                label: 'Front Offer',
                key: 'frontOffer',
            },
            {
                label: 'Front Logo',
                key: 'frontLogo'
            },
            {
                label: 'Back Logo',
                key: 'backLogo'
            },
            {
                label: 'Back CTA',
                key: 'backCTA'
            },
            {
                label: 'Back Background',
                key: 'backBackground'
            },
            {
                label: 'Back Top Left Copy',
                key: 'backTopLeftCopy'
            },
            {
                label: 'Back Top Left Copy',
                key: 'backTopLeftCopy'
            },
            {
                label: 'Back Offer Block',
                key: 'backOfferBlock'
            },
            {
                label: 'Back Store Block',
                key: 'backStoreBlock'
            },
            {
                label: 'Back Bottom Left Copy',
                key: 'backBottomLeftCopy'
            },
            {
                label: 'Style',
                key: 'style'
            }
        ];
        return config;
    }
    // import matrix
    importDataFile() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let results = yield this.importer.requestDataFromUser();
                // map data to object  
                this.creativeTemplateImportList = results.validData.map((x) => ({
                    id: 0,
                    brandId: +this.id,
                    brandName: '',
                    campaignTypeId: 0,
                    // campaignTypeId: this.campaignTypeList.filter(item => item.name.toLowerCase == x.campaignType.trim().toLowerCase())..id, //x.hasOwnProperty('campaignTypeId') ? +x.campaignTypeId.trim() : 0,
                    campaignTypeName: x.hasOwnProperty('campaignType') ? x.campaignType.trim() : '',
                    months: x.hasOwnProperty('months') ? +x.months.trim() : 0,
                    //ageRangeId: this.ageRangeList.filter(item => item.range.toLowerCase == x.ageRange.trim().toLowerCase())[0].id,
                    ageRangeId: 0,
                    ageRangeName: x.hasOwnProperty('ageRange') ? x.ageRange.trim() : 'None',
                    gender: x.hasOwnProperty('gender') ? x.gender.trim() : 'F',
                    frontImage: x.hasOwnProperty('frontImage') ? x.frontImage.trim() : '',
                    frontCTA: x.hasOwnProperty('frontCTA') ? x.frontCTA.trim() : '',
                    frontOffer: x.hasOwnProperty('frontOffer') ? x.frontOffer.trim() : '',
                    frontLogo: x.hasOwnProperty('frontLogo') ? x.frontLogo.trim() : '',
                    backLogo: x.hasOwnProperty('backLogo') ? x.backLogo.trim() : '',
                    backCTA: x.hasOwnProperty('backCTA') ? x.backCTA.trim() : '',
                    backBackground: x.hasOwnProperty('backBackground') ? x.backBackground.trim() : '',
                    backTopLeftCopy: x.hasOwnProperty('backTopLeftCopy') ? x.backTopLeftCopy.trim() : '',
                    backOfferBlock: x.hasOwnProperty('backOfferBlock') ? x.backOfferBlock.trim() : '',
                    backStoreBlock: x.hasOwnProperty('backStoreBlock') ? x.backStoreBlock.trim() : '',
                    backBottomLeftCopy: x.hasOwnProperty('backBottomLeftCopy') ? x.backBottomLeftCopy.trim() : '',
                    style: x.hasOwnProperty('style') ? x.style.trim() : ''
                }));
                this.creativeTemplateImportList.forEach(item => {
                    let filteredCampaignType = this.campaignTypeList.filter(y => y.name.toLowerCase() === item.campaignTypeName.trim().toLowerCase())[0];
                    if (filteredCampaignType) {
                        item.campaignTypeId = filteredCampaignType.id;
                    }
                    let filteredAgeRange = this.ageRangeList.filter(y => y.range.toLowerCase() === item.ageRangeName.trim().toLowerCase())[0];
                    if (filteredAgeRange) {
                        item.ageRangeId = filteredAgeRange.id;
                    }
                    else {
                        let filteredAgeRangeFallBack = this.ageRangeList.filter(y => y.range.toLowerCase() === 'none')[0];
                        item.ageRangeId = filteredAgeRangeFallBack.id;
                    }
                });
                this.importer.displayLoader();
                this.creativeTemplateService.addBulk(+this.id, this.creativeTemplateImportList).subscribe(creativeTemplate => {
                    this.getRecords(this.id);
                    this.importer.displaySuccess("Your data was successfully imported!");
                });
                //this.showNotification(`The matrix file was imported successfully.`, 'Okay!');
            }
            catch (e) {
                console.info(e || "window close");
            }
        });
    }
    resetMatrix() {
        this.confirmationModalService.confirm('Confirm', 'Are you sure you want to delete all records from this brand?')
            .then((confirmed) => {
            if (confirmed) {
                this.creativeTemplateService.deleteAll(this.id).subscribe(() => {
                    this.showNotification('The records have been deleted successfully!', 'Okay!');
                    this.getRecords(this.id);
                });
            }
        })
            .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
    }
    // show notification popup
    showNotification(msg, action) {
        this.notification.open(msg, action, { duration: 40000, panelClass: ['snackbar-success'] });
    }
};
MatrixComponent.ctorParameters = () => [
    { type: _shared_services_creativeTemplate_service__WEBPACK_IMPORTED_MODULE_5__["CreativeTemplateService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_1__["ActivatedRoute"] },
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_6__["NgbModal"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_7__["MatSnackBar"] },
    { type: _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_8__["ConfirmationModalService"] },
    { type: _shared_services_file_service__WEBPACK_IMPORTED_MODULE_11__["FileService"] },
    { type: _shared_services_ageRange_service__WEBPACK_IMPORTED_MODULE_15__["AgeRangeService"] },
    { type: _shared_services_campaignType_service__WEBPACK_IMPORTED_MODULE_16__["CampaignTypeService"] },
    { type: src_api_authorization_authorize_service__WEBPACK_IMPORTED_MODULE_14__["AuthorizeService"] }
];
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])(_angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__["MatPaginator"], { static: true }),
    __metadata("design:type", _angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__["MatPaginator"])
], MatrixComponent.prototype, "paginator", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])(_angular_material_sort__WEBPACK_IMPORTED_MODULE_2__["MatSort"], { static: true }),
    __metadata("design:type", _angular_material_sort__WEBPACK_IMPORTED_MODULE_2__["MatSort"])
], MatrixComponent.prototype, "sort", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], MatrixComponent.prototype, "id", null);
MatrixComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-matrix',
        template: __importDefault(__webpack_require__(/*! raw-loader!./matrix.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/matrix/matrix.component.html")).default
    }),
    __metadata("design:paramtypes", [_shared_services_creativeTemplate_service__WEBPACK_IMPORTED_MODULE_5__["CreativeTemplateService"],
        _angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"],
        _angular_router__WEBPACK_IMPORTED_MODULE_1__["ActivatedRoute"],
        _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_6__["NgbModal"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_7__["MatSnackBar"],
        _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_8__["ConfirmationModalService"],
        _shared_services_file_service__WEBPACK_IMPORTED_MODULE_11__["FileService"],
        _shared_services_ageRange_service__WEBPACK_IMPORTED_MODULE_15__["AgeRangeService"],
        _shared_services_campaignType_service__WEBPACK_IMPORTED_MODULE_16__["CampaignTypeService"],
        src_api_authorization_authorize_service__WEBPACK_IMPORTED_MODULE_14__["AuthorizeService"]])
], MatrixComponent);



/***/ }),

/***/ "./src/app/components/month-conversions/month-conversions.component.ts":
/*!*****************************************************************************!*\
  !*** ./src/app/components/month-conversions/month-conversions.component.ts ***!
  \*****************************************************************************/
/*! exports provided: MonthConversionsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MonthConversionsComponent", function() { return MonthConversionsComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_material_sort__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/sort */ "./node_modules/@angular/material/esm2015/sort.js");
/* harmony import */ var _angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/paginator */ "./node_modules/@angular/material/esm2015/paginator.js");
/* harmony import */ var _angular_material_table__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/table */ "./node_modules/@angular/material/esm2015/table.js");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../shared/components/modals/confirmation-modal/confirmation-modal.service */ "./src/app/shared/components/modals/confirmation-modal/confirmation-modal.service.ts");
/* harmony import */ var _shared_components_modals_month_conversion_modal_month_conversion_form_component__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../shared/components/modals/month-conversion-modal/month-conversion-form.component */ "./src/app/shared/components/modals/month-conversion-modal/month-conversion-form.component.ts");
/* harmony import */ var _shared_services_brandMonthConversion_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../shared/services/brandMonthConversion.service */ "./src/app/shared/services/brandMonthConversion.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};










let MonthConversionsComponent = class MonthConversionsComponent {
    constructor(brandMonthConversionService, router, route, modalService, notification, confirmationModalService) {
        this.brandMonthConversionService = brandMonthConversionService;
        this.router = router;
        this.route = route;
        this.modalService = modalService;
        this.notification = notification;
        this.confirmationModalService = confirmationModalService;
        // MatPaginator Inputs
        this.length = 20;
        this.pageSize = 10;
        this.pageSizeOptions = [10, 25, 100];
        this.dataSource = new _angular_material_table__WEBPACK_IMPORTED_MODULE_4__["MatTableDataSource"]();
        this.displayedColumns = ['actions', 'campaignType', 'range', 'convertMonth'];
    }
    // use getter setter to define the property
    get id() {
        return this._id;
    }
    set id(val) {
        this._id = val;
    }
    // on load
    ngOnInit() {
        this.getRecords(this.id);
    }
    // get records
    getRecords(id) {
        if (id > 0) {
            this.brandMonthConversionService.getAll(id).subscribe(result => {
                this.dataSource.data = result;
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
            }, error => console.error(error));
        }
    }
    // open add form 
    openAddModal() {
        let modalOptions = {
            backdrop: 'static',
            keyboard: false,
        };
        const modalRef = this.modalService.open(_shared_components_modals_month_conversion_modal_month_conversion_form_component__WEBPACK_IMPORTED_MODULE_8__["MonthConversionFormComponent"], modalOptions);
        modalRef.componentInstance.title = 'Add a Month Conversion';
        let model = {
            id: 0, brandId: this.id, campaignTypeId: 0, campaignTypeName: '', fromMonth: 0, toMonth: 0, convertMonth: 0
        };
        modalRef.componentInstance.inputModel = model;
        // modal result
        modalRef.result.then((result) => {
            if (result) {
                this.getRecords(this.id);
            }
        }).catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
    }
    // delete item
    deleteItem(id) {
        this.confirmationModalService.confirm('Confirm', 'Are you sure you want to delete this item?')
            .then((confirmed) => {
            if (confirmed) {
                this.brandMonthConversionService.delete(id).subscribe(() => {
                    this.showNotification('The month conversion has been deleted successfully!', 'Okay!');
                    this.getRecords(this.id);
                });
            }
        })
            .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
    }
    //// edit item
    editItem(model) {
        let modalOptions = {
            backdrop: 'static',
            keyboard: false,
        };
        const modalRef = this.modalService.open(_shared_components_modals_month_conversion_modal_month_conversion_form_component__WEBPACK_IMPORTED_MODULE_8__["MonthConversionFormComponent"], modalOptions);
        modalRef.componentInstance.title = 'Edit Month Conversion';
        modalRef.componentInstance.inputModel = model;
        // modal result
        modalRef.result.then((result) => {
            if (result) {
                this.getRecords(this.id);
            }
        }).catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
    }
    // filter locations
    applyFilter(event) {
        const filterValue = event.target.value;
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }
    // show notification popup
    showNotification(msg, action) {
        this.notification.open(msg, action, { duration: 40000, panelClass: ['snackbar-success'] });
    }
};
MonthConversionsComponent.ctorParameters = () => [
    { type: _shared_services_brandMonthConversion_service__WEBPACK_IMPORTED_MODULE_9__["BrandMonthConversionService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_1__["ActivatedRoute"] },
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_5__["NgbModal"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_6__["MatSnackBar"] },
    { type: _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_7__["ConfirmationModalService"] }
];
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])(_angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__["MatPaginator"], { static: true }),
    __metadata("design:type", _angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__["MatPaginator"])
], MonthConversionsComponent.prototype, "paginator", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])(_angular_material_sort__WEBPACK_IMPORTED_MODULE_2__["MatSort"], { static: true }),
    __metadata("design:type", _angular_material_sort__WEBPACK_IMPORTED_MODULE_2__["MatSort"])
], MonthConversionsComponent.prototype, "sort", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], MonthConversionsComponent.prototype, "id", null);
MonthConversionsComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-month-conversions',
        template: __importDefault(__webpack_require__(/*! raw-loader!./month-conversions.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/month-conversions/month-conversions.component.html")).default
    }),
    __metadata("design:paramtypes", [_shared_services_brandMonthConversion_service__WEBPACK_IMPORTED_MODULE_9__["BrandMonthConversionService"],
        _angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"],
        _angular_router__WEBPACK_IMPORTED_MODULE_1__["ActivatedRoute"],
        _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_5__["NgbModal"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_6__["MatSnackBar"],
        _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_7__["ConfirmationModalService"]])
], MonthConversionsComponent);



/***/ }),

/***/ "./src/app/components/notes/notes.component.ts":
/*!*****************************************************!*\
  !*** ./src/app/components/notes/notes.component.ts ***!
  \*****************************************************/
/*! exports provided: NotesComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NotesComponent", function() { return NotesComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_material_sort__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/sort */ "./node_modules/@angular/material/esm2015/sort.js");
/* harmony import */ var _angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/paginator */ "./node_modules/@angular/material/esm2015/paginator.js");
/* harmony import */ var _angular_material_table__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/table */ "./node_modules/@angular/material/esm2015/table.js");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../shared/components/modals/confirmation-modal/confirmation-modal.service */ "./src/app/shared/components/modals/confirmation-modal/confirmation-modal.service.ts");
/* harmony import */ var _shared_services_note_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../shared/services/note.service */ "./src/app/shared/services/note.service.ts");
/* harmony import */ var _shared_components_modals_note_modal_note_form_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../shared/components/modals/note-modal/note-form.component */ "./src/app/shared/components/modals/note-modal/note-form.component.ts");
/* harmony import */ var _api_authorization_authorize_service__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../api-authorization/authorize.service */ "./src/api-authorization/authorize.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};











let NotesComponent = class NotesComponent {
    constructor(noteService, router, route, modalService, notification, confirmationModalService, authorizeService) {
        this.noteService = noteService;
        this.router = router;
        this.route = route;
        this.modalService = modalService;
        this.notification = notification;
        this.confirmationModalService = confirmationModalService;
        this.authorizeService = authorizeService;
        // MatPaginator Inputs
        this.length = 20;
        this.pageSize = 10;
        this.pageSizeOptions = [10, 25, 100];
        this.dataSource = new _angular_material_table__WEBPACK_IMPORTED_MODULE_4__["MatTableDataSource"]();
        this.displayedColumns = ['actions', 'description', 'createdBy', 'createDate'];
        this._total = 0; // total number of pages
    }
    // use getter setter to define the property
    get contentId() {
        return this._contentId;
    }
    set contentId(val) {
        this._contentId = val;
    }
    set total(val) {
        this._total = val;
    }
    get total() {
        return this._total;
    }
    // use getter setter to define the property
    get contentType() {
        return this._contentType;
    }
    set contentType(val) {
        this._contentType = val;
    }
    // on load
    ngOnInit() {
        // get current user
        this.authorizeService.getUser().subscribe(result => {
            this.userName = result.name;
        });
        this.getRecords(this.contentId, this.contentType, this.total);
    }
    // get records
    getRecords(contentId, contentType, total) {
        this.noteService.getAll(contentId, contentType, total).subscribe(result => {
            this.dataSource.data = result;
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
        }, error => console.error(error));
    }
    // open add form 
    openAddModal() {
        let modalOptions = {
            backdrop: 'static',
            keyboard: false,
        };
        const modalRef = this.modalService.open(_shared_components_modals_note_modal_note_form_component__WEBPACK_IMPORTED_MODULE_9__["NoteFormComponent"], modalOptions);
        modalRef.componentInstance.title = 'Add Note';
        let model = {
            id: 0, contentId: this.contentId, contentType: this.contentType, description: '', createDate: '', createdBy: ''
        };
        modalRef.componentInstance.inputModel = model;
        // modal result
        modalRef.result.then((result) => {
            if (result) {
                this.getRecords(this.contentId, this.contentType, this.total);
            }
        }).catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
    }
    // delete item
    deleteItem(id) {
        this.confirmationModalService.confirm('Confirm', 'Are you sure you want to delete this item?')
            .then((confirmed) => {
            if (confirmed) {
                this.noteService.delete(id).subscribe(() => {
                    this.showNotification('The note has been deleted successfully!', 'Okay!');
                    this.getRecords(this.contentId, this.contentType, 0);
                });
            }
        })
            .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
    }
    //// edit item
    editItem(model) {
        let modalOptions = {
            backdrop: 'static',
            keyboard: false,
        };
        const modalRef = this.modalService.open(_shared_components_modals_note_modal_note_form_component__WEBPACK_IMPORTED_MODULE_9__["NoteFormComponent"], modalOptions);
        modalRef.componentInstance.title = 'Edit Note';
        modalRef.componentInstance.inputModel = model;
        // modal result
        modalRef.result.then((result) => {
            if (result) {
                this.getRecords(this.contentId, this.contentType, this.total);
            }
        }).catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
    }
    //// filter locations
    //applyFilter(event: Event) {
    //  const filterValue = (event.target as HTMLInputElement).value;
    //  this.dataSource.filter = filterValue.trim().toLowerCase();
    //}
    // show notification popup
    showNotification(msg, action) {
        this.notification.open(msg, action, { duration: 40000, panelClass: ['snackbar-success'] });
    }
};
NotesComponent.ctorParameters = () => [
    { type: _shared_services_note_service__WEBPACK_IMPORTED_MODULE_8__["NoteService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_1__["ActivatedRoute"] },
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_5__["NgbModal"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_6__["MatSnackBar"] },
    { type: _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_7__["ConfirmationModalService"] },
    { type: _api_authorization_authorize_service__WEBPACK_IMPORTED_MODULE_10__["AuthorizeService"] }
];
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])(_angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__["MatPaginator"], { static: true }),
    __metadata("design:type", _angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__["MatPaginator"])
], NotesComponent.prototype, "paginator", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])(_angular_material_sort__WEBPACK_IMPORTED_MODULE_2__["MatSort"], { static: true }),
    __metadata("design:type", _angular_material_sort__WEBPACK_IMPORTED_MODULE_2__["MatSort"])
], NotesComponent.prototype, "sort", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], NotesComponent.prototype, "contentId", null);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], NotesComponent.prototype, "total", null);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], NotesComponent.prototype, "contentType", null);
NotesComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-notes',
        template: __importDefault(__webpack_require__(/*! raw-loader!./notes.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/notes/notes.component.html")).default
    }),
    __metadata("design:paramtypes", [_shared_services_note_service__WEBPACK_IMPORTED_MODULE_8__["NoteService"],
        _angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"],
        _angular_router__WEBPACK_IMPORTED_MODULE_1__["ActivatedRoute"],
        _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_5__["NgbModal"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_6__["MatSnackBar"],
        _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_7__["ConfirmationModalService"],
        _api_authorization_authorize_service__WEBPACK_IMPORTED_MODULE_10__["AuthorizeService"]])
], NotesComponent);



/***/ }),

/***/ "./src/app/components/override-rules/override-rules.component.ts":
/*!***********************************************************************!*\
  !*** ./src/app/components/override-rules/override-rules.component.ts ***!
  \***********************************************************************/
/*! exports provided: OverrideRulesComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OverrideRulesComponent", function() { return OverrideRulesComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_material_sort__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/sort */ "./node_modules/@angular/material/esm2015/sort.js");
/* harmony import */ var _angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/paginator */ "./node_modules/@angular/material/esm2015/paginator.js");
/* harmony import */ var _angular_material_table__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/table */ "./node_modules/@angular/material/esm2015/table.js");
/* harmony import */ var _shared_services_overrideRule_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../shared/services/overrideRule.service */ "./src/app/shared/services/overrideRule.service.ts");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../shared/components/modals/confirmation-modal/confirmation-modal.service */ "./src/app/shared/components/modals/confirmation-modal/confirmation-modal.service.ts");
/* harmony import */ var _shared_components_modals_override_rule_edit_modal_override_rule_edit_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../shared/components/modals/override-rule-edit-modal/override-rule-edit.component */ "./src/app/shared/components/modals/override-rule-edit-modal/override-rule-edit.component.ts");
/* harmony import */ var _shared_components_modals_override_rule_add_modal_override_rule_add_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../shared/components/modals/override-rule-add-modal/override-rule-add.component */ "./src/app/shared/components/modals/override-rule-add-modal/override-rule-add.component.ts");
/* harmony import */ var _shared_services_file_service__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../shared/services/file.service */ "./src/app/shared/services/file.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};












let OverrideRulesComponent = class OverrideRulesComponent {
    constructor(overrideRuleService, router, route, modalService, notification, confirmationModalService, fileService) {
        this.overrideRuleService = overrideRuleService;
        this.router = router;
        this.route = route;
        this.modalService = modalService;
        this.notification = notification;
        this.confirmationModalService = confirmationModalService;
        this.fileService = fileService;
        // MatPaginator Inputs
        this.length = 20;
        this.pageSize = 10;
        this.pageSizeOptions = [10, 25, 100];
        this.dataSource = new _angular_material_table__WEBPACK_IMPORTED_MODULE_4__["MatTableDataSource"]();
        this.displayedColumns = ['actions', 'id', 'brandName', 'campaignTypeName', 'storeLocationName', 'months', 'ageRangeName', 'gender', 'priority', 'startDate', 'endDate'];
    }
    // use getter setter to define the property
    get id() {
        return this._id;
    }
    set id(val) {
        this._id = val;
    }
    // call get locations on load 
    ngOnInit() {
        this.getRecords(this.id);
        this.now = new Date();
    }
    // get matrix records
    getRecords(id) {
        if (id > 0) {
            this.overrideRuleService.getAll(id).subscribe(result => {
                this.dataSource.data = result;
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
            }, error => console.error(error));
        }
    }
    // open add form for location
    openAddModal() {
        let modalOptions = {
            backdrop: 'static',
            keyboard: false,
        };
        const modalRef = this.modalService.open(_shared_components_modals_override_rule_add_modal_override_rule_add_component__WEBPACK_IMPORTED_MODULE_10__["OverrideRuleAddFormComponent"], modalOptions);
        modalRef.componentInstance.title = 'Add new rule';
        modalRef.componentInstance.brandId = this.id;
        // modal result
        modalRef.result.then((result) => {
            this.getRecords(this.id);
        }).catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
    }
    // copy entry
    copyOverrideRule(item) {
        let modalOptions = {
            backdrop: 'static',
            keyboard: false,
        };
        const modalRef = this.modalService.open(_shared_components_modals_override_rule_add_modal_override_rule_add_component__WEBPACK_IMPORTED_MODULE_10__["OverrideRuleAddFormComponent"], modalOptions);
        modalRef.componentInstance.title = 'Copy rule';
        modalRef.componentInstance.brandId = this.id;
        modalRef.componentInstance.model = item;
        // modal result
        modalRef.result.then((result) => {
            this.getRecords(this.id);
        }).catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
    }
    // delete creative template entry
    deleteOverrideRule(id) {
        this.confirmationModalService.confirm('Confirm', 'Are you sure you want to delete this item?')
            .then((confirmed) => {
            if (confirmed) {
                this.overrideRuleService.delete(id).subscribe((result) => {
                    this.showNotification('The item has been deleted successfully!', 'Okay!');
                    this.getRecords(this.id);
                });
            }
        })
            .catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
    }
    // edit location
    editOverrideRule(item) {
        this.overrideRuleService.getById(item.id).subscribe(ct => {
            let template = ct;
            let modalOptions = {
                backdrop: 'static',
                keyboard: false,
            };
            const modalRef = this.modalService.open(_shared_components_modals_override_rule_edit_modal_override_rule_edit_component__WEBPACK_IMPORTED_MODULE_9__["OverrideRuleEditFormComponent"], modalOptions);
            modalRef.componentInstance.title = 'Edit Rule';
            modalRef.componentInstance.overrideRule = ct;
            // modal result
            modalRef.result.then((result) => {
                if (result) {
                    this.getRecords(this.id);
                }
            }).catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
        });
    }
    exportData() {
        let headerList = [
            "campaignTypeName",
            "brandName",
            "months",
            "ageRangeName",
            "gender",
            "priority",
            "startDate",
            "endDate"
        ];
        this.fileService.downloadFile(this.dataSource.data, headerList, "datafile");
    }
    // filter locations
    applyFilter(event) {
        const filterValue = event.target.value;
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }
    // show notification popup
    showNotification(msg, action) {
        this.notification.open(msg, action, { duration: 40000, panelClass: ['snackbar-success'] });
    }
};
OverrideRulesComponent.ctorParameters = () => [
    { type: _shared_services_overrideRule_service__WEBPACK_IMPORTED_MODULE_5__["OverrideRuleService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_1__["ActivatedRoute"] },
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_6__["NgbModal"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_7__["MatSnackBar"] },
    { type: _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_8__["ConfirmationModalService"] },
    { type: _shared_services_file_service__WEBPACK_IMPORTED_MODULE_11__["FileService"] }
];
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])(_angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__["MatPaginator"], { static: true }),
    __metadata("design:type", _angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__["MatPaginator"])
], OverrideRulesComponent.prototype, "paginator", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])(_angular_material_sort__WEBPACK_IMPORTED_MODULE_2__["MatSort"], { static: true }),
    __metadata("design:type", _angular_material_sort__WEBPACK_IMPORTED_MODULE_2__["MatSort"])
], OverrideRulesComponent.prototype, "sort", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], OverrideRulesComponent.prototype, "id", null);
OverrideRulesComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-overriderules',
        template: __importDefault(__webpack_require__(/*! raw-loader!./override-rules.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/override-rules/override-rules.component.html")).default
    }),
    __metadata("design:paramtypes", [_shared_services_overrideRule_service__WEBPACK_IMPORTED_MODULE_5__["OverrideRuleService"],
        _angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"],
        _angular_router__WEBPACK_IMPORTED_MODULE_1__["ActivatedRoute"],
        _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_6__["NgbModal"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_7__["MatSnackBar"],
        _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_8__["ConfirmationModalService"],
        _shared_services_file_service__WEBPACK_IMPORTED_MODULE_11__["FileService"]])
], OverrideRulesComponent);



/***/ }),

/***/ "./src/app/components/qc-report/qc-report.component.ts":
/*!*************************************************************!*\
  !*** ./src/app/components/qc-report/qc-report.component.ts ***!
  \*************************************************************/
/*! exports provided: QCReportComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QCReportComponent", function() { return QCReportComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_material_sort__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/sort */ "./node_modules/@angular/material/esm2015/sort.js");
/* harmony import */ var _angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/paginator */ "./node_modules/@angular/material/esm2015/paginator.js");
/* harmony import */ var _angular_material_table__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/table */ "./node_modules/@angular/material/esm2015/table.js");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _shared_services_report_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../shared/services/report.service */ "./src/app/shared/services/report.service.ts");
/* harmony import */ var _shared_components_spinner_spinner_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../shared/components/spinner/spinner.service */ "./src/app/shared/components/spinner/spinner.service.ts");
/* harmony import */ var _shared_components_modals_mailing_record_edit_modal_mailing_record_edit_component__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../shared/components/modals/mailing-record-edit-modal/mailing-record-edit.component */ "./src/app/shared/components/modals/mailing-record-edit-modal/mailing-record-edit.component.ts");
/* harmony import */ var _shared_services_mailingRecord_service__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../shared/services/mailingRecord.service */ "./src/app/shared/services/mailingRecord.service.ts");
/* harmony import */ var _shared_services_mailing_service__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../shared/services/mailing.service */ "./src/app/shared/services/mailing.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};












let QCReportComponent = class QCReportComponent {
    constructor(reportService, router, route, modalService, notification, spinnerService, mailingRecordService, mailingService) {
        this.reportService = reportService;
        this.router = router;
        this.route = route;
        this.modalService = modalService;
        this.notification = notification;
        this.spinnerService = spinnerService;
        this.mailingRecordService = mailingRecordService;
        this.mailingService = mailingService;
        this.length = 20;
        this.pageSize = 10;
        this.pageSizeOptions = [10, 25, 100];
        this.dataSource = new _angular_material_table__WEBPACK_IMPORTED_MODULE_4__["MatTableDataSource"]();
        this.displayedColumns = ['mailingFile', 'brand', 'fullName', 'patientId', 'monthsOriginal', 'monthsConversion', 'campaignType', 'birthday', 'age', 'notes'];
        this.loader1 = false;
        this.showMsg = false;
    }
    // init
    ngOnInit() {
        // show spinner on page load
        this.spinnerService.show();
        // get url parameter id 
        this.sub = this.route.params.subscribe(params => {
            this.id = +params['id']; // (+) converts string 'id' to a number
            this.getMailing(this.id);
            // hide spinner
            setTimeout(() => {
                this.spinnerService.hide();
            }, 1500);
        });
    }
    // get mailing details
    getMailing(id) {
        // get mailing
        this.mailingService.getById(this.id).subscribe(result => {
            this.mailing = result;
            // hide spinner
            setTimeout(() => {
                this.spinnerService.hide();
            }, 1500);
        }, error => 
        // console.error(error)
        this.router.navigate(['/mailings/']));
    }
    // get records
    getRecords() {
        this.showMsg = false;
        this.spinnerService.show("In progress...");
        if (this.id > 0) {
            this.reportService.getMailingErrorReport(this.id).subscribe(result => {
                this.dataSource.data = result;
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
                if (result.length == 0) {
                    this.showMsg = true;
                }
                this.spinnerService.hide();
                //this.loader1 = false; 
            }, error => console.error(error));
        }
    }
    // filter 
    applyFilter(event) {
        const filterValue = event.target.value;
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }
    // show notification popup
    showNotification(msg, action) {
        this.notification.open(msg, action, { duration: 40000, panelClass: ['snackbar-success'] });
    }
    // edit mailing record 
    editMailingRecord(id) {
        let modalOptions = {
            backdrop: 'static',
            keyboard: false,
        };
        this.mailingRecordService.getById(id).subscribe(record => {
            const modalRef = this.modalService.open(_shared_components_modals_mailing_record_edit_modal_mailing_record_edit_component__WEBPACK_IMPORTED_MODULE_9__["MailingRecordEditFormComponent"], modalOptions);
            modalRef.componentInstance.title = 'Edit Record';
            modalRef.componentInstance.mailingRecord = record;
            // modal result
            modalRef.result.then((result) => {
                if (result) {
                    this.showNotification('This mailing record has been saved successfully!', 'Okay!');
                    //this.getRecords(this.mailingFileId);
                }
            }).catch(() => console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)'));
        });
    }
};
QCReportComponent.ctorParameters = () => [
    { type: _shared_services_report_service__WEBPACK_IMPORTED_MODULE_7__["ReportService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_1__["ActivatedRoute"] },
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_5__["NgbModal"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_6__["MatSnackBar"] },
    { type: _shared_components_spinner_spinner_service__WEBPACK_IMPORTED_MODULE_8__["SpinnerService"] },
    { type: _shared_services_mailingRecord_service__WEBPACK_IMPORTED_MODULE_10__["MailingRecordService"] },
    { type: _shared_services_mailing_service__WEBPACK_IMPORTED_MODULE_11__["MailingService"] }
];
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])(_angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__["MatPaginator"], { static: true }),
    __metadata("design:type", _angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__["MatPaginator"])
], QCReportComponent.prototype, "paginator", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])(_angular_material_sort__WEBPACK_IMPORTED_MODULE_2__["MatSort"], { static: true }),
    __metadata("design:type", _angular_material_sort__WEBPACK_IMPORTED_MODULE_2__["MatSort"])
], QCReportComponent.prototype, "sort", void 0);
QCReportComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-qc-report',
        template: __importDefault(__webpack_require__(/*! raw-loader!./qc-report.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/qc-report/qc-report.component.html")).default
    }),
    __metadata("design:paramtypes", [_shared_services_report_service__WEBPACK_IMPORTED_MODULE_7__["ReportService"],
        _angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"],
        _angular_router__WEBPACK_IMPORTED_MODULE_1__["ActivatedRoute"],
        _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_5__["NgbModal"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_6__["MatSnackBar"],
        _shared_components_spinner_spinner_service__WEBPACK_IMPORTED_MODULE_8__["SpinnerService"],
        _shared_services_mailingRecord_service__WEBPACK_IMPORTED_MODULE_10__["MailingRecordService"],
        _shared_services_mailing_service__WEBPACK_IMPORTED_MODULE_11__["MailingService"]])
], QCReportComponent);



/***/ }),

/***/ "./src/app/components/reports/reports.component.ts":
/*!*********************************************************!*\
  !*** ./src/app/components/reports/reports.component.ts ***!
  \*********************************************************/
/*! exports provided: ReportsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReportsComponent", function() { return ReportsComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};

let ReportsComponent = class ReportsComponent {
    constructor() {
        this.title = 'Reports';
    }
};
ReportsComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-reports',
        template: __importDefault(__webpack_require__(/*! raw-loader!./reports.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/reports/reports.component.html")).default
    })
], ReportsComponent);



/***/ }),

/***/ "./src/app/components/subbrands/subbrands.component.ts":
/*!*************************************************************!*\
  !*** ./src/app/components/subbrands/subbrands.component.ts ***!
  \*************************************************************/
/*! exports provided: SubBrandsComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SubBrandsComponent", function() { return SubBrandsComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _angular_material_sort__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/material/sort */ "./node_modules/@angular/material/esm2015/sort.js");
/* harmony import */ var _angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/paginator */ "./node_modules/@angular/material/esm2015/paginator.js");
/* harmony import */ var _angular_material_table__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/material/table */ "./node_modules/@angular/material/esm2015/table.js");
/* harmony import */ var _shared_services_brand_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../shared/services/brand.service */ "./src/app/shared/services/brand.service.ts");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../shared/components/modals/confirmation-modal/confirmation-modal.service */ "./src/app/shared/components/modals/confirmation-modal/confirmation-modal.service.ts");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};










let SubBrandsComponent = class SubBrandsComponent {
    constructor(brandService, router, route, modalService, notification, confirmationModalService, formBuilder) {
        this.brandService = brandService;
        this.router = router;
        this.route = route;
        this.modalService = modalService;
        this.notification = notification;
        this.confirmationModalService = confirmationModalService;
        this.formBuilder = formBuilder;
        // MatPaginator Inputs
        this.length = 20;
        this.pageSize = 10;
        this.pageSizeOptions = [10, 25, 100];
        this.dataSource = new _angular_material_table__WEBPACK_IMPORTED_MODULE_4__["MatTableDataSource"]();
        this.displayedColumns = ['name', 'phone', 'email', 'url', 'isActive', 'actions'];
        this.submitted = false;
    }
    // use getter setter to define the property
    get id() {
        return this._id;
    }
    set id(val) {
        this._id = val;
    }
    // call get locations on load 
    ngOnInit() {
        this.getRecords(this.id);
        // initialize brand form
        this.brandForm = this.formBuilder.group({
            name: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_9__["Validators"].required],
            brandId: [this.id, _angular_forms__WEBPACK_IMPORTED_MODULE_9__["Validators"].required]
        });
    }
    // get locations
    getRecords(id) {
        if (id > 0) {
            this.brandService.getChildren(id).subscribe(result => {
                if (result.length) {
                    this.dataSource.data = result;
                    this.dataSource.paginator = this.paginator;
                    this.dataSource.sort = this.sort;
                }
            }, error => console.error(error));
        }
    }
    // add new brand form submission
    addBrand() {
        this.submitted = true;
        // stop here if form is invalid
        if (this.brandForm.invalid) {
            return;
        }
        this.brandService.add({ name: this.brandForm.value["name"], brandId: +this.brandForm.value["brandId"] })
            .subscribe(item => {
            this.getRecords(this.id);
            this.showNotification('Your brand was successuly added!', 'Okay!');
            this.resetAddBrandForm();
            this.hideAddBrandModal();
        });
    }
    hideAddBrandModal() {
        $('#addBrandModal').modal('hide');
    }
    // reset addBrandForm
    resetAddBrandForm() {
        this.submitted = false;
        this.brandForm.controls['name'].setValue('');
    }
    //// open add form for location
    //openAddModal() {
    //  const modalRef = this.modalService.open(LocationAddFormComponent);
    //  modalRef.componentInstance.title = 'Add a brand Location';
    //  modalRef.componentInstance.brandId = this.id;
    //  // modal result
    //  modalRef.result.then((result) => {
    //    if (result) {
    //      this.getRecords(this.id);
    //    }
    //  }).catch(() =>
    //    console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
    //  );
    //}
    //// delete location
    //deleteLocation(id: number) {
    //  this.confirmationModalService.confirm('Confirm', 'Are you sure you want to delete this item?')
    //    .then((confirmed) => {
    //      if (confirmed) {
    //        this.storeLocationService.delete(id).subscribe(() => {
    //          this.showNotification('The store location has been deleted successfully!', 'Okay!');
    //          this.getRecords(this.id);
    //        });
    //      }
    //    }
    //    )
    //    .catch(() =>
    //      console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
    //    );
    //}
    //// edit location
    //editLocation(location: StoreLocation) {
    //  const modalRef = this.modalService.open(LocationEditFormComponent);
    //  modalRef.componentInstance.title = 'Edit Store Location';
    //  modalRef.componentInstance.location = location;
    //  // modal result
    //  modalRef.result.then((result) => {
    //    if (result) {
    //      this.getRecords(this.id);
    //    }
    //  }).catch(() =>
    //    console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
    //  );
    //}
    // filter locations
    applyFilter(event) {
        const filterValue = event.target.value;
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }
    // show notification popup
    showNotification(msg, action) {
        this.notification.open(msg, action, { duration: 40000, panelClass: ['snackbar-success'] });
    }
};
SubBrandsComponent.ctorParameters = () => [
    { type: _shared_services_brand_service__WEBPACK_IMPORTED_MODULE_5__["BrandService"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"] },
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_1__["ActivatedRoute"] },
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_6__["NgbModal"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_7__["MatSnackBar"] },
    { type: _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_8__["ConfirmationModalService"] },
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_9__["FormBuilder"] }
];
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])(_angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__["MatPaginator"], { static: true }),
    __metadata("design:type", _angular_material_paginator__WEBPACK_IMPORTED_MODULE_3__["MatPaginator"])
], SubBrandsComponent.prototype, "paginator", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["ViewChild"])(_angular_material_sort__WEBPACK_IMPORTED_MODULE_2__["MatSort"], { static: true }),
    __metadata("design:type", _angular_material_sort__WEBPACK_IMPORTED_MODULE_2__["MatSort"])
], SubBrandsComponent.prototype, "sort", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], SubBrandsComponent.prototype, "id", null);
SubBrandsComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-subbrands',
        template: __importDefault(__webpack_require__(/*! raw-loader!./subbrands.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/subbrands/subbrands.component.html")).default
    }),
    __metadata("design:paramtypes", [_shared_services_brand_service__WEBPACK_IMPORTED_MODULE_5__["BrandService"],
        _angular_router__WEBPACK_IMPORTED_MODULE_1__["Router"],
        _angular_router__WEBPACK_IMPORTED_MODULE_1__["ActivatedRoute"],
        _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_6__["NgbModal"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_7__["MatSnackBar"],
        _shared_components_modals_confirmation_modal_confirmation_modal_service__WEBPACK_IMPORTED_MODULE_8__["ConfirmationModalService"],
        _angular_forms__WEBPACK_IMPORTED_MODULE_9__["FormBuilder"]])
], SubBrandsComponent);



/***/ }),

/***/ "./src/app/shared/components/layout/nav-menu/nav-menu.component.css":
/*!**************************************************************************!*\
  !*** ./src/app/shared/components/layout/nav-menu/nav-menu.component.css ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("a.navbar-brand {\r\n  white-space: normal;\r\n  text-align: center;\r\n  word-break: break-all;\r\n}\r\n  \r\n.box-shadow {\r\n  box-shadow: 0 .25rem .75rem rgba(0, 0, 0, .05);\r\n}\r\n\r\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvc2hhcmVkL2NvbXBvbmVudHMvbGF5b3V0L25hdi1tZW51L25hdi1tZW51LmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRSxtQkFBbUI7RUFDbkIsa0JBQWtCO0VBQ2xCLHFCQUFxQjtBQUN2Qjs7QUFFQTtFQUNFLDhDQUE4QztBQUNoRCIsImZpbGUiOiJzcmMvYXBwL3NoYXJlZC9jb21wb25lbnRzL2xheW91dC9uYXYtbWVudS9uYXYtbWVudS5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiYS5uYXZiYXItYnJhbmQge1xyXG4gIHdoaXRlLXNwYWNlOiBub3JtYWw7XHJcbiAgdGV4dC1hbGlnbjogY2VudGVyO1xyXG4gIHdvcmQtYnJlYWs6IGJyZWFrLWFsbDtcclxufVxyXG4gIFxyXG4uYm94LXNoYWRvdyB7XHJcbiAgYm94LXNoYWRvdzogMCAuMjVyZW0gLjc1cmVtIHJnYmEoMCwgMCwgMCwgLjA1KTtcclxufVxyXG4iXX0= */");

/***/ }),

/***/ "./src/app/shared/components/layout/nav-menu/nav-menu.component.ts":
/*!*************************************************************************!*\
  !*** ./src/app/shared/components/layout/nav-menu/nav-menu.component.ts ***!
  \*************************************************************************/
/*! exports provided: NavMenuComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NavMenuComponent", function() { return NavMenuComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_api_authorization_authorize_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! src/api-authorization/authorize.service */ "./src/api-authorization/authorize.service.ts");
/* harmony import */ var _shared_services_brand_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../shared/services/brand.service */ "./src/app/shared/services/brand.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};



let NavMenuComponent = class NavMenuComponent {
    constructor(authorizeService, brandService) {
        this.authorizeService = authorizeService;
        this.brandService = brandService;
        this.isExpanded = false;
    }
    ngOnInit() {
        this.isAuthenticated = this.authorizeService.isAuthenticated();
    }
    collapse() {
        this.isExpanded = false;
    }
    toggle() {
        this.isExpanded = !this.isExpanded;
    }
};
NavMenuComponent.ctorParameters = () => [
    { type: src_api_authorization_authorize_service__WEBPACK_IMPORTED_MODULE_1__["AuthorizeService"] },
    { type: _shared_services_brand_service__WEBPACK_IMPORTED_MODULE_2__["BrandService"] }
];
NavMenuComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-nav-menu',
        template: __importDefault(__webpack_require__(/*! raw-loader!./nav-menu.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/layout/nav-menu/nav-menu.component.html")).default,
        styles: [__importDefault(__webpack_require__(/*! ./nav-menu.component.css */ "./src/app/shared/components/layout/nav-menu/nav-menu.component.css")).default]
    }),
    __metadata("design:paramtypes", [src_api_authorization_authorize_service__WEBPACK_IMPORTED_MODULE_1__["AuthorizeService"], _shared_services_brand_service__WEBPACK_IMPORTED_MODULE_2__["BrandService"]])
], NavMenuComponent);



/***/ }),

/***/ "./src/app/shared/components/loader/loader.component.scss":
/*!****************************************************************!*\
  !*** ./src/app/shared/components/loader/loader.component.scss ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".loader-container {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  overflow: hidden;\n  z-index: 999999;\n  background-color: white; }\n\n.loader {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  height: 30px;\n  width: 30px;\n  margin: 0px auto;\n  -webkit-animation: rotation .6s infinite linear;\n  animation: rotation .6s infinite linear;\n  border-left: 4px solid rgba(3, 102, 214, 0.15);\n  border-right: 4px solid rgba(3, 102, 214, 0.15);\n  border-bottom: 4px solid rgba(3, 102, 214, 0.15);\n  border-top: 4px solid rgba(3, 102, 214, 0.8);\n  border-radius: 100%;\n  margin-left: -15px;\n  margin-top: -15px; }\n\n.loader-message {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  height: 30px;\n  width: 100px;\n  margin: 0px auto;\n  border-radius: 100%;\n  margin-left: -50px;\n  margin-top: 20px;\n  text-align: center; }\n\n@-webkit-keyframes rotation {\n  from {\n    -webkit-transform: rotate(0deg); }\n  to {\n    -webkit-transform: rotate(359deg); } }\n\n@keyframes rotation {\n  from {\n    transform: rotate(0deg); }\n  to {\n    transform: rotate(359deg); } }\n\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hcHAvc2hhcmVkL2NvbXBvbmVudHMvbG9hZGVyL0k6XFxXb3JrIFNwYWNlXFxQcm9qZWN0c1xcRElfVEZTXFxKMTktNDg4MiBPcHRpIFBvcnQgRE0gQXV0b21hdGlvblxcT1BETVxcT3B0aVBvcnQuV2ViXFxDbGllbnRBcHAvc3JjXFxhcHBcXHNoYXJlZFxcY29tcG9uZW50c1xcbG9hZGVyXFxsb2FkZXIuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUE7RUFDSSxXQUFVO0VBQ1YsWUFBVztFQUVYLGtCQUFpQjtFQUNqQixnQkFBZTtFQUNmLGVBQWM7RUFDZCx1QkFBcUMsRUFBQTs7QUFFekM7RUFDRSxrQkFBa0I7RUFDbEIsU0FBUztFQUNULFFBQVE7RUFDUixZQUFZO0VBQ1osV0FBVztFQUNYLGdCQUFnQjtFQUNoQiwrQ0FBK0M7RUFHL0MsdUNBQXVDO0VBQ3ZDLDhDQXJCcUI7RUFzQnJCLCtDQXRCcUI7RUF1QnJCLGdEQXZCcUI7RUF3QnJCLDRDQXhCcUI7RUF5QnJCLG1CQUFtQjtFQUNuQixrQkFBaUI7RUFDakIsaUJBQWdCLEVBQUE7O0FBR2xCO0VBQ0Usa0JBQWtCO0VBQ2xCLFNBQVM7RUFDVCxRQUFRO0VBQ1IsWUFBWTtFQUNaLFlBQVk7RUFDWixnQkFBZ0I7RUFDaEIsbUJBQW1CO0VBQ25CLGtCQUFrQjtFQUNsQixnQkFBZ0I7RUFDaEIsa0JBQWlCLEVBQUE7O0FBR25CO0VBQ0U7SUFDRSwrQkFBK0IsRUFBQTtFQUdqQztJQUNFLGlDQUFpQyxFQUFBLEVBQUE7O0FBd0JyQztFQUNFO0lBQ0UsdUJBQXVCLEVBQUE7RUFHekI7SUFDRSx5QkFBeUIsRUFBQSxFQUFBIiwiZmlsZSI6InNyYy9hcHAvc2hhcmVkL2NvbXBvbmVudHMvbG9hZGVyL2xvYWRlci5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIlxyXG4kdGhlbWUtcHJpbWFyeTogIzAzNjZkNjtcclxuLmxvYWRlci1jb250YWluZXJ7XHJcbiAgICB3aWR0aDoxMDAlO1xyXG4gICAgaGVpZ2h0OjEwMCU7XHJcbiAgICAvL3Bvc2l0aW9uOmZpeGVkO1xyXG4gICAgcG9zaXRpb246YWJzb2x1dGU7XHJcbiAgICBvdmVyZmxvdzpoaWRkZW47XHJcbiAgICB6LWluZGV4Ojk5OTk5OTtcclxuICAgIGJhY2tncm91bmQtY29sb3I6cmdiYSgyNTUsMjU1LDI1NSwgMSk7IFxyXG59XHJcbi5sb2FkZXIge1xyXG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcclxuICBsZWZ0OiA1MCU7XHJcbiAgdG9wOiA1MCU7XHJcbiAgaGVpZ2h0OiAzMHB4O1xyXG4gIHdpZHRoOiAzMHB4O1xyXG4gIG1hcmdpbjogMHB4IGF1dG87XHJcbiAgLXdlYmtpdC1hbmltYXRpb246IHJvdGF0aW9uIC42cyBpbmZpbml0ZSBsaW5lYXI7XHJcbiAgLW1vei1hbmltYXRpb246IHJvdGF0aW9uIC42cyBpbmZpbml0ZSBsaW5lYXI7XHJcbiAgLW8tYW5pbWF0aW9uOiByb3RhdGlvbiAuNnMgaW5maW5pdGUgbGluZWFyO1xyXG4gIGFuaW1hdGlvbjogcm90YXRpb24gLjZzIGluZmluaXRlIGxpbmVhcjtcclxuICBib3JkZXItbGVmdDogNHB4IHNvbGlkIHJnYmEoJHRoZW1lLXByaW1hcnksLjE1KTtcclxuICBib3JkZXItcmlnaHQ6IDRweCBzb2xpZCByZ2JhKCR0aGVtZS1wcmltYXJ5LC4xNSk7XHJcbiAgYm9yZGVyLWJvdHRvbTogNHB4IHNvbGlkIHJnYmEoJHRoZW1lLXByaW1hcnksLjE1KTtcclxuICBib3JkZXItdG9wOiA0cHggc29saWQgcmdiYSgkdGhlbWUtcHJpbWFyeSwuOCk7XHJcbiAgYm9yZGVyLXJhZGl1czogMTAwJTtcclxuICBtYXJnaW4tbGVmdDotMTVweDtcclxuICBtYXJnaW4tdG9wOi0xNXB4O1xyXG59XHJcblxyXG4ubG9hZGVyLW1lc3NhZ2V7XHJcbiAgcG9zaXRpb246IGFic29sdXRlO1xyXG4gIGxlZnQ6IDUwJTtcclxuICB0b3A6IDUwJTtcclxuICBoZWlnaHQ6IDMwcHg7XHJcbiAgd2lkdGg6IDEwMHB4O1xyXG4gIG1hcmdpbjogMHB4IGF1dG87ICBcclxuICBib3JkZXItcmFkaXVzOiAxMDAlO1xyXG4gIG1hcmdpbi1sZWZ0OiAtNTBweDtcclxuICBtYXJnaW4tdG9wOiAyMHB4O1xyXG4gIHRleHQtYWxpZ246Y2VudGVyO1xyXG59XHJcblxyXG5ALXdlYmtpdC1rZXlmcmFtZXMgcm90YXRpb24ge1xyXG4gIGZyb20ge1xyXG4gICAgLXdlYmtpdC10cmFuc2Zvcm06IHJvdGF0ZSgwZGVnKTtcclxuICB9XHJcblxyXG4gIHRvIHtcclxuICAgIC13ZWJraXQtdHJhbnNmb3JtOiByb3RhdGUoMzU5ZGVnKTtcclxuICB9XHJcbn1cclxuXHJcbkAtbW96LWtleWZyYW1lcyByb3RhdGlvbiB7XHJcbiAgZnJvbSB7XHJcbiAgICAtbW96LXRyYW5zZm9ybTogcm90YXRlKDBkZWcpO1xyXG4gIH1cclxuXHJcbiAgdG8ge1xyXG4gICAgLW1vei10cmFuc2Zvcm06IHJvdGF0ZSgzNTlkZWcpO1xyXG4gIH1cclxufVxyXG5cclxuQC1vLWtleWZyYW1lcyByb3RhdGlvbiB7XHJcbiAgZnJvbSB7XHJcbiAgICAtby10cmFuc2Zvcm06IHJvdGF0ZSgwZGVnKTtcclxuICB9XHJcblxyXG4gIHRvIHtcclxuICAgIC1vLXRyYW5zZm9ybTogcm90YXRlKDM1OWRlZyk7XHJcbiAgfVxyXG59XHJcblxyXG5Aa2V5ZnJhbWVzIHJvdGF0aW9uIHtcclxuICBmcm9tIHtcclxuICAgIHRyYW5zZm9ybTogcm90YXRlKDBkZWcpO1xyXG4gIH1cclxuXHJcbiAgdG8ge1xyXG4gICAgdHJhbnNmb3JtOiByb3RhdGUoMzU5ZGVnKTtcclxuICB9XHJcbn1cclxuIl19 */");

/***/ }),

/***/ "./src/app/shared/components/loader/loader.component.ts":
/*!**************************************************************!*\
  !*** ./src/app/shared/components/loader/loader.component.ts ***!
  \**************************************************************/
/*! exports provided: LoaderComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LoaderComponent", function() { return LoaderComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};

let LoaderComponent = class LoaderComponent {
    constructor() {
        this.show = false;
    }
};
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Object)
], LoaderComponent.prototype, "message", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Object)
], LoaderComponent.prototype, "show", void 0);
LoaderComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-loader',
        template: `<div *ngIf="show" class="loader-container"> 
              <div class="loader"></div><div *ngIf="message" class="loader-message">{{message}}</div>
            </div>
            `,
        styles: [__importDefault(__webpack_require__(/*! ./loader.component.scss */ "./src/app/shared/components/loader/loader.component.scss")).default]
    })
], LoaderComponent);



/***/ }),

/***/ "./src/app/shared/components/modals/brand-picker-modal/brand-picker.component.ts":
/*!***************************************************************************************!*\
  !*** ./src/app/shared/components/modals/brand-picker-modal/brand-picker.component.ts ***!
  \***************************************************************************************/
/*! exports provided: BrandPickerComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BrandPickerComponent", function() { return BrandPickerComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _shared_services_brand_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../../shared/services/brand.service */ "./src/app/shared/services/brand.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};



let BrandPickerComponent = class BrandPickerComponent {
    constructor(activeModal, brandService) {
        this.activeModal = activeModal;
        this.brandService = brandService;
    }
    // on component load
    ngOnInit() {
        this.brandService.getAll().subscribe((result) => {
            if (result.length) {
                this.brands = result.filter(x => x.isActive == true);
                this.filteredBrands = this.brands;
            }
        });
    }
    decline() {
        this.activeModal.close(false);
    }
    dismiss() {
        this.activeModal.dismiss();
    }
    // filter locations
    applyFilter(event) {
        const filterValue = event.target.value;
        this.filteredBrands = this.brands.filter(brand => brand.name.trim().toLowerCase().includes(filterValue.trim().toLowerCase()));
    }
};
BrandPickerComponent.ctorParameters = () => [
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_1__["NgbActiveModal"] },
    { type: _shared_services_brand_service__WEBPACK_IMPORTED_MODULE_2__["BrandService"] }
];
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Object)
], BrandPickerComponent.prototype, "title", void 0);
BrandPickerComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-brand-picker',
        template: __importDefault(__webpack_require__(/*! raw-loader!./brand-picker.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/brand-picker-modal/brand-picker.component.html")).default
    }),
    __metadata("design:paramtypes", [_ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_1__["NgbActiveModal"], _shared_services_brand_service__WEBPACK_IMPORTED_MODULE_2__["BrandService"]])
], BrandPickerComponent);



/***/ }),

/***/ "./src/app/shared/components/modals/brand-seed-modal/brand-seed-form.component.ts":
/*!****************************************************************************************!*\
  !*** ./src/app/shared/components/modals/brand-seed-modal/brand-seed-form.component.ts ***!
  \****************************************************************************************/
/*! exports provided: BrandSeedFormComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BrandSeedFormComponent", function() { return BrandSeedFormComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _services_storelocation_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../services/storelocation.service */ "./src/app/shared/services/storelocation.service.ts");
/* harmony import */ var _shared_models_state__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../shared/models/state */ "./src/app/shared/models/state.ts");
/* harmony import */ var _services_campaignType_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../services/campaignType.service */ "./src/app/shared/services/campaignType.service.ts");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _services_validation_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../services/validation.service */ "./src/app/shared/services/validation.service.ts");
/* harmony import */ var _models_BrandSeed__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../models/BrandSeed */ "./src/app/shared/models/BrandSeed.ts");
/* harmony import */ var _services_brandSeed_service__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../services/brandSeed.service */ "./src/app/shared/services/brandSeed.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};











let BrandSeedFormComponent = class BrandSeedFormComponent {
    constructor(formBuilder, activeModal, brandSeedService, storeLocationService, campaignTypeService, notification) {
        this.formBuilder = formBuilder;
        this.activeModal = activeModal;
        this.brandSeedService = brandSeedService;
        this.storeLocationService = storeLocationService;
        this.campaignTypeService = campaignTypeService;
        this.notification = notification;
        this.eventEmitter = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
        this.submitted = false;
        this.genderList = ['F', 'M'];
        this.stateList = _shared_models_state__WEBPACK_IMPORTED_MODULE_5__["STATES"]; // bind list of states
    }
    // on component load
    ngOnInit() {
        // bind store locations dropdown
        this.storeLocationService.getAll(this.inputModel.brandId).subscribe(locationResult => {
            this.storeLocationList = locationResult;
        });
        // bind campaign types
        this.campaignTypeService.getAll().subscribe(campaignResult => {
            this.campaignTypeList = campaignResult;
        });
        const dateReg = /^\d{2}([./-])\d{2}\1\d{4}$/;
        this.modelForm = this.formBuilder.group({
            id: [this.inputModel.id],
            patientId: [this.inputModel.patientId],
            clxPatientId: [this.inputModel.clxPatientId],
            firstName: [this.inputModel.firstName, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            lastName: [this.inputModel.lastName, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            address1: [this.inputModel.address1, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            address2: [this.inputModel.address2],
            city: [this.inputModel.city, [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required, _services_validation_service__WEBPACK_IMPORTED_MODULE_8__["ValidationService"].alphaNumericSpecialCharactersValidator]],
            state: [this.inputModel.state, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            zipCode: [this.inputModel.zipCode, [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required, _services_validation_service__WEBPACK_IMPORTED_MODULE_8__["ValidationService"].zipCodeValidator]],
            gender: [this.inputModel.gender, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            dateOfBirth: [(this.inputModel.dateOfBirth !== null && this.inputModel.dateOfBirth !== undefined && this.inputModel.dateOfBirth !== '' ? Object(_angular_common__WEBPACK_IMPORTED_MODULE_7__["formatDate"])(this.inputModel.dateOfBirth, 'MM/dd/yyyy', 'en-US') : null), _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].pattern(dateReg)],
            //lastExamDate: [(this.inputModel.lastExamDate !== null && this.inputModel.lastExamDate !== undefined && this.inputModel.lastExamDate !== '' ? formatDate(this.inputModel.lastExamDate, 'MM/dd/yyyy', 'en-US') : null), [Validators.pattern(dateReg)]],
            months: [this.inputModel.months, [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].min(0), _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required, _services_validation_service__WEBPACK_IMPORTED_MODULE_8__["ValidationService"].numericValidator]],
            phone: [this.inputModel.phone, _services_validation_service__WEBPACK_IMPORTED_MODULE_8__["ValidationService"].phoneValidator],
            email: [this.inputModel.email, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].email],
            brandId: [this.inputModel.brandId, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            campaignTypeId: [this.inputModel.campaignTypeId, [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].min(1)]],
            storeLocationId: this.inputModel.storeLocationId,
            custom1: [this.inputModel.custom1],
            custom2: [this.inputModel.custom2],
            custom3: [this.inputModel.custom3],
            custom4: [this.inputModel.custom4],
            custom5: [this.inputModel.custom5],
        });
    }
    // format date  
    formatDate(e, fieldName) {
        if (e.target.value === null) {
            this.modelForm.get(fieldName).setValue('', {
                onlyself: true
            });
        }
        else {
            var convertDate = new Date(e.target.value);
            this.modelForm.get(fieldName).setValue(convertDate, {
                onlyself: true
            });
        }
    }
    transformDate(dateStr) {
        const dateSendingToServer = new _angular_common__WEBPACK_IMPORTED_MODULE_7__["DatePipe"]('en-US').transform(dateStr, 'dd/MM/yyyy');
        return dateSendingToServer;
    }
    // handle form submit  
    onSubmit() {
        this.submitted = true;
        // stop here if form is invalid
        if (this.modelForm.invalid) {
            return;
        }
        let formValues = this.modelForm.value;
        formValues.id = +this.modelForm.value['id'];
        formValues.brandId = +this.modelForm.value['brandId'];
        formValues.campaignTypeId = +this.modelForm.value['campaignTypeId'];
        formValues.storeLocationId = +this.modelForm.value['storeLocationId'];
        formValues.dateOfBirth = this.modelForm.value['dateOfBirth'];
        formValues.lastExamDate = this.modelForm.value['lastExamDate'];
        formValues.months = +this.modelForm.value['months'];
        //add
        if (formValues.id == 0) {
            this.brandSeedService.add(formValues).subscribe(brandSeed => {
                this.eventEmitter.emit(this.modelForm.value);
                this.activeModal.close(brandSeed);
                this.showNotification(`The new seed was successuly added!`, 'Okay!');
            });
            // update
        }
        else {
            this.brandSeedService.update(formValues.id, formValues).subscribe(brandSeed => {
                this.eventEmitter.emit(this.modelForm.value);
                this.activeModal.close(brandSeed);
                this.showNotification(`The entry was successuly updated!`, 'Okay!');
            });
        }
    }
    decline() {
        this.activeModal.close(false);
    }
    dismiss() {
        this.activeModal.dismiss();
    }
    // display notifications
    showNotification(msg, action) {
        this.notification.open(msg, action, { duration: 5000, panelClass: ['snackbar-success'] });
    }
};
BrandSeedFormComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormBuilder"] },
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__["NgbActiveModal"] },
    { type: _services_brandSeed_service__WEBPACK_IMPORTED_MODULE_10__["BrandSeedService"] },
    { type: _services_storelocation_service__WEBPACK_IMPORTED_MODULE_4__["StoreLocationService"] },
    { type: _services_campaignType_service__WEBPACK_IMPORTED_MODULE_6__["CampaignTypeService"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_3__["MatSnackBar"] }
];
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Object)
], BrandSeedFormComponent.prototype, "title", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", _models_BrandSeed__WEBPACK_IMPORTED_MODULE_9__["BrandSeed"])
], BrandSeedFormComponent.prototype, "inputModel", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"])(),
    __metadata("design:type", _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"])
], BrandSeedFormComponent.prototype, "eventEmitter", void 0);
BrandSeedFormComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-brand-seed-form',
        template: __importDefault(__webpack_require__(/*! raw-loader!./brand-seed-form.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/brand-seed-modal/brand-seed-form.component.html")).default
    }),
    __metadata("design:paramtypes", [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormBuilder"],
        _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__["NgbActiveModal"],
        _services_brandSeed_service__WEBPACK_IMPORTED_MODULE_10__["BrandSeedService"],
        _services_storelocation_service__WEBPACK_IMPORTED_MODULE_4__["StoreLocationService"],
        _services_campaignType_service__WEBPACK_IMPORTED_MODULE_6__["CampaignTypeService"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_3__["MatSnackBar"]])
], BrandSeedFormComponent);



/***/ }),

/***/ "./src/app/shared/components/modals/confirmation-modal/confirmation-modal.component.ts":
/*!*********************************************************************************************!*\
  !*** ./src/app/shared/components/modals/confirmation-modal/confirmation-modal.component.ts ***!
  \*********************************************************************************************/
/*! exports provided: ConfirmationModalComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConfirmationModalComponent", function() { return ConfirmationModalComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};


let ConfirmationModalComponent = class ConfirmationModalComponent {
    constructor(activeModal) {
        this.activeModal = activeModal;
    }
    accept() {
        this.activeModal.close(true);
    }
    decline() {
        this.activeModal.close(false);
    }
    dismiss() {
        this.activeModal.dismiss();
    }
};
ConfirmationModalComponent.ctorParameters = () => [
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_1__["NgbActiveModal"] }
];
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Object)
], ConfirmationModalComponent.prototype, "title", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Object)
], ConfirmationModalComponent.prototype, "message", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", String)
], ConfirmationModalComponent.prototype, "btnOkText", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", String)
], ConfirmationModalComponent.prototype, "btnCancelText", void 0);
ConfirmationModalComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-confirmation-modal',
        template: `
    <div class="modal-header">
      <h4 class="modal-title">{{title}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body text-center">
      <div class="py-3">
      {{message}}
      <div class="mt-3">
        <button type="button" class="btn mr-2 btn-primary" (click)="accept()">{{ btnOkText }}</button>
        <button type="button" class="btn btn-outline-dark" (click)="decline()">{{ btnCancelText }}</button>
      </div>
      </div>
    </div>
    
  `
    }),
    __metadata("design:paramtypes", [_ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_1__["NgbActiveModal"]])
], ConfirmationModalComponent);



/***/ }),

/***/ "./src/app/shared/components/modals/confirmation-modal/confirmation-modal.service.ts":
/*!*******************************************************************************************!*\
  !*** ./src/app/shared/components/modals/confirmation-modal/confirmation-modal.service.ts ***!
  \*******************************************************************************************/
/*! exports provided: ConfirmationModalService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConfirmationModalService", function() { return ConfirmationModalService; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _confirmation_modal_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./confirmation-modal.component */ "./src/app/shared/components/modals/confirmation-modal/confirmation-modal.component.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};



let ConfirmationModalService = class ConfirmationModalService {
    constructor(modalService) {
        this.modalService = modalService;
    }
    confirm(title, message, btnOkText = 'Yes', btnCancelText = 'No', dialogSize = 'md') {
        const modalRef = this.modalService.open(_confirmation_modal_component__WEBPACK_IMPORTED_MODULE_2__["ConfirmationModalComponent"], { size: dialogSize });
        modalRef.componentInstance.title = title;
        modalRef.componentInstance.message = message;
        modalRef.componentInstance.btnOkText = btnOkText;
        modalRef.componentInstance.btnCancelText = btnCancelText;
        return modalRef.result;
    }
};
ConfirmationModalService.ctorParameters = () => [
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_1__["NgbModal"] }
];
ConfirmationModalService = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"])({ providedIn: 'root' }),
    __metadata("design:paramtypes", [_ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_1__["NgbModal"]])
], ConfirmationModalService);



/***/ }),

/***/ "./src/app/shared/components/modals/creative-template-add-modal/creative-template-add.component.ts":
/*!*********************************************************************************************************!*\
  !*** ./src/app/shared/components/modals/creative-template-add-modal/creative-template-add.component.ts ***!
  \*********************************************************************************************************/
/*! exports provided: CreativeTemplateAddFormComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CreativeTemplateAddFormComponent", function() { return CreativeTemplateAddFormComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _shared_models_creativeTemplate__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../shared/models/creativeTemplate */ "./src/app/shared/models/creativeTemplate.ts");
/* harmony import */ var _shared_services_creativeTemplate_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../shared/services/creativeTemplate.service */ "./src/app/shared/services/creativeTemplate.service.ts");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _services_ageRange_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../services/ageRange.service */ "./src/app/shared/services/ageRange.service.ts");
/* harmony import */ var _services_storelocation_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../services/storelocation.service */ "./src/app/shared/services/storelocation.service.ts");
/* harmony import */ var _services_campaignType_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../services/campaignType.service */ "./src/app/shared/services/campaignType.service.ts");
/* harmony import */ var _services_brandMonthConversion_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../services/brandMonthConversion.service */ "./src/app/shared/services/brandMonthConversion.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};










let CreativeTemplateAddFormComponent = class CreativeTemplateAddFormComponent {
    constructor(formBuilder, activeModal, creativeTemplateService, ageRangeService, storeLocationService, notification, campaignTypeService, brandMonthConversionService) {
        this.formBuilder = formBuilder;
        this.activeModal = activeModal;
        this.creativeTemplateService = creativeTemplateService;
        this.ageRangeService = ageRangeService;
        this.storeLocationService = storeLocationService;
        this.notification = notification;
        this.campaignTypeService = campaignTypeService;
        this.brandMonthConversionService = brandMonthConversionService;
        this.submitted = false;
        this.genderList = ['F', 'M'];
    }
    // on component load
    ngOnInit() {
        // bind age ranges dropdown
        this.ageRangeService.getAll().subscribe(result => {
            this.ageRangeList = result;
        });
        // bind campaign dropdown
        this.campaignTypeService.getAll().subscribe(result => {
            this.campaignTypeList = result;
        });
        // bind store locations dropdown
        this.storeLocationService.getAll(this.brandId).subscribe(result => {
            this.storeLocationList = result;
        });
        // get all months
        this.brandMonthConversionService.getAll(this.brandId).subscribe(result => {
            this.monthsConversionList = result.filter((x, i, arr) => {
                return arr.indexOf(arr.find(t => t.campaignTypeId === x.campaignTypeId && t.convertMonth === x.convertMonth)) === i;
            }).map(b => ({ campaignTypeId: b.campaignTypeId, months: b.convertMonth }));
            if (this.model !== undefined) {
                this.onChangeCampaignType(this.model.campaignTypeId);
            }
        });
        // build form
        if (this.model === undefined) {
            // build form model
            this.editForm = this.formBuilder.group({
                frontImage: [''],
                frontCTA: [''],
                frontOffer: [''],
                frontLogo: [''],
                backLogo: [''],
                backCTA: [''],
                backBackground: [''],
                backTopLeftCopy: [''],
                backOfferBlock: [''],
                backStoreBlock: [''],
                backBottomLeftCopy: [''],
                //custom1: [''],
                //custom2: [''],
                //custom3: [''],
                //custom4: [''],
                //custom5: [''],
                gender: [null, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
                months: [0],
                style: [''],
                brandId: [this.brandId],
                campaignTypeId: [null, [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].min(1)]],
                ageRangeId: [null, [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].min(1)]]
            });
        }
        else {
            // build form model
            this.editForm = this.formBuilder.group({
                frontImage: [this.model.frontImage],
                frontCTA: [this.model.frontCTA],
                frontOffer: [this.model.frontOffer],
                frontLogo: [this.model.frontLogo],
                backLogo: [this.model.backLogo],
                backCTA: [this.model.backCTA],
                backBackground: [this.model.backBackground],
                backTopLeftCopy: [this.model.backTopLeftCopy],
                backOfferBlock: [this.model.backOfferBlock],
                backStoreBlock: [this.model.backStoreBlock],
                backBottomLeftCopy: [this.model.backBottomLeftCopy],
                //custom1: [this.model.custom1],
                //custom2: [this.model.custom2],
                //custom3: [this.model.custom3],
                //custom4: [this.model.custom4],
                //custom5: [this.model.custom5],
                gender: [this.model.gender || null, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
                months: [this.model.months],
                style: [this.model.style],
                brandId: [this.brandId],
                campaignTypeId: [this.model.campaignTypeId, [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].min(1)]],
                ageRangeId: [this.model.ageRangeId, [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].min(1)]]
            });
        }
    }
    // handle form submit 
    onSubmit() {
        this.submitted = true;
        // stop here if form is invalid
        if (this.editForm.invalid) {
            return;
        }
        const model = this.editForm.value;
        model.brandId = +this.editForm.value['brandId'];
        model.campaignTypeId = +this.editForm.value['campaignTypeId'];
        model.ageRangeId = +this.editForm.value['ageRangeId'];
        model.months = +this.editForm.value['months'];
        this.creativeTemplateService.add(model).subscribe(creativeTemplate => {
            //this.eventEmitter.emit(this.editForm.value);
            this.activeModal.close(true);
            this.showNotification(`The entry was successuly updated!`, 'Okay!');
        });
    }
    // change campaign type
    onChangeCampaignType(campaignTypeId) {
        this.monthsList = this.monthsConversionList.filter(x => {
            return x.campaignTypeId === +campaignTypeId;
        });
    }
    decline() {
        this.activeModal.close(false);
    }
    dismiss() {
        this.activeModal.dismiss();
    }
    // display notifications
    showNotification(msg, action) {
        this.notification.open(msg, action, { duration: 5000, panelClass: ['snackbar-success'] });
    }
};
CreativeTemplateAddFormComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormBuilder"] },
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__["NgbActiveModal"] },
    { type: _shared_services_creativeTemplate_service__WEBPACK_IMPORTED_MODULE_4__["CreativeTemplateService"] },
    { type: _services_ageRange_service__WEBPACK_IMPORTED_MODULE_6__["AgeRangeService"] },
    { type: _services_storelocation_service__WEBPACK_IMPORTED_MODULE_7__["StoreLocationService"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__["MatSnackBar"] },
    { type: _services_campaignType_service__WEBPACK_IMPORTED_MODULE_8__["CampaignTypeService"] },
    { type: _services_brandMonthConversion_service__WEBPACK_IMPORTED_MODULE_9__["BrandMonthConversionService"] }
];
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Object)
], CreativeTemplateAddFormComponent.prototype, "title", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Number)
], CreativeTemplateAddFormComponent.prototype, "brandId", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", _shared_models_creativeTemplate__WEBPACK_IMPORTED_MODULE_3__["CreativeTemplate"])
], CreativeTemplateAddFormComponent.prototype, "model", void 0);
CreativeTemplateAddFormComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-creative-template-add-form',
        template: __importDefault(__webpack_require__(/*! raw-loader!./creative-template-add.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/creative-template-add-modal/creative-template-add.component.html")).default
    }),
    __metadata("design:paramtypes", [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormBuilder"],
        _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__["NgbActiveModal"],
        _shared_services_creativeTemplate_service__WEBPACK_IMPORTED_MODULE_4__["CreativeTemplateService"],
        _services_ageRange_service__WEBPACK_IMPORTED_MODULE_6__["AgeRangeService"],
        _services_storelocation_service__WEBPACK_IMPORTED_MODULE_7__["StoreLocationService"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__["MatSnackBar"],
        _services_campaignType_service__WEBPACK_IMPORTED_MODULE_8__["CampaignTypeService"],
        _services_brandMonthConversion_service__WEBPACK_IMPORTED_MODULE_9__["BrandMonthConversionService"]])
], CreativeTemplateAddFormComponent);



/***/ }),

/***/ "./src/app/shared/components/modals/creative-template-edit-modal/creative-template-edit.component.ts":
/*!***********************************************************************************************************!*\
  !*** ./src/app/shared/components/modals/creative-template-edit-modal/creative-template-edit.component.ts ***!
  \***********************************************************************************************************/
/*! exports provided: CreativeTemplateEditFormComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CreativeTemplateEditFormComponent", function() { return CreativeTemplateEditFormComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _shared_models_creativeTemplate__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../shared/models/creativeTemplate */ "./src/app/shared/models/creativeTemplate.ts");
/* harmony import */ var _shared_services_creativeTemplate_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../shared/services/creativeTemplate.service */ "./src/app/shared/services/creativeTemplate.service.ts");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _services_ageRange_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../services/ageRange.service */ "./src/app/shared/services/ageRange.service.ts");
/* harmony import */ var _services_storelocation_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../services/storelocation.service */ "./src/app/shared/services/storelocation.service.ts");
/* harmony import */ var _services_campaignType_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../services/campaignType.service */ "./src/app/shared/services/campaignType.service.ts");
/* harmony import */ var _services_validation_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../services/validation.service */ "./src/app/shared/services/validation.service.ts");
/* harmony import */ var _services_brandMonthConversion_service__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../../services/brandMonthConversion.service */ "./src/app/shared/services/brandMonthConversion.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};











let CreativeTemplateEditFormComponent = class CreativeTemplateEditFormComponent {
    constructor(formBuilder, activeModal, creativeTemplateService, ageRangeService, storeLocationService, notification, campaignTypeService, brandMonthConversionService) {
        this.formBuilder = formBuilder;
        this.activeModal = activeModal;
        this.creativeTemplateService = creativeTemplateService;
        this.ageRangeService = ageRangeService;
        this.storeLocationService = storeLocationService;
        this.notification = notification;
        this.campaignTypeService = campaignTypeService;
        this.brandMonthConversionService = brandMonthConversionService;
        this.submitted = false;
        this.genderList = ['F', 'M'];
    }
    // on component load
    ngOnInit() {
        // bind campaign types
        this.campaignTypeService.getAll().subscribe(campaignResult => {
            this.campaignTypeList = campaignResult;
        });
        // bind age ranges dropdown
        this.ageRangeService.getAll().subscribe(result => {
            this.ageRangeList = result;
        });
        // bind store locations dropdown
        this.storeLocationService.getAll(this.creativeTemplate.brandId).subscribe(result => {
            this.storeLocationList = result;
        });
        // get all months
        this.brandMonthConversionService.getAll(this.creativeTemplate.brandId).subscribe(result => {
            this.monthsConversionList = result.filter((x, i, arr) => {
                return arr.indexOf(arr.find(t => t.campaignTypeId === x.campaignTypeId && t.convertMonth === x.convertMonth)) === i;
            }).map(b => ({ campaignTypeId: b.campaignTypeId, months: b.convertMonth }));
            // bind dropdown list for months based on current campaign type id
            this.onChangeCampaignType(this.creativeTemplate.campaignTypeId);
        });
        this.editForm = this.formBuilder.group({
            frontImage: [this.creativeTemplate.frontImage || ''],
            frontCTA: [this.creativeTemplate.frontCTA || ''],
            frontOffer: [this.creativeTemplate.frontOffer || ''],
            frontLogo: [this.creativeTemplate.frontLogo || ''],
            backLogo: [this.creativeTemplate.backLogo || ''],
            backCTA: [this.creativeTemplate.backCTA || ''],
            backBackground: [this.creativeTemplate.backBackground || ''],
            backTopLeftCopy: [this.creativeTemplate.backTopLeftCopy || ''],
            backOfferBlock: [this.creativeTemplate.backOfferBlock || ''],
            backStoreBlock: [this.creativeTemplate.backStoreBlock || ''],
            backBottomLeftCopy: [this.creativeTemplate.backBottomLeftCopy || ''],
            //custom1: [this.creativeTemplate.custom1 || ''],
            //custom2: [this.creativeTemplate.custom2 || ''],
            //custom3: [this.creativeTemplate.custom3 || ''],
            //custom4: [this.creativeTemplate.custom4 || ''],
            //custom5: [this.creativeTemplate.custom5 || ''], 
            gender: [this.creativeTemplate.gender || '', _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            months: [this.creativeTemplate.months, [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required, _services_validation_service__WEBPACK_IMPORTED_MODULE_9__["ValidationService"].numericValidator]],
            style: [this.creativeTemplate.style || ''],
            brandId: [this.creativeTemplate.brandId || 0],
            campaignTypeId: [this.creativeTemplate.campaignTypeId || 0, [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].min(1)]],
            ageRangeId: [this.creativeTemplate.ageRangeId, [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].min(1)]],
        });
    }
    // change campaign type
    onChangeCampaignType(campaignTypeId) {
        this.monthsList = this.monthsConversionList.filter(x => {
            return x.campaignTypeId === +campaignTypeId;
        });
    }
    // handle form submit 
    onSubmit() {
        this.submitted = true;
        // stop here if form is invalid
        if (this.editForm.invalid) {
            return;
        }
        const model = this.editForm.value;
        model.brandId = +this.editForm.value['brandId'];
        model.campaignTypeId = +this.editForm.value['campaignTypeId'];
        model.ageRangeId = +this.editForm.value['ageRangeId'];
        model.months = +this.editForm.value['months'];
        // model.storeLocationId = +this.editForm.value['storeLocationId'];
        this.creativeTemplateService.update(+this.creativeTemplate.id, model).subscribe(creativeTemplate => {
            //this.eventEmitter.emit(this.editForm.value);
            this.activeModal.close(true);
            this.showNotification(`The entry was successuly updated!`, 'Okay!');
        });
    }
    decline() {
        this.activeModal.close(false);
    }
    dismiss() {
        this.activeModal.dismiss();
    }
    // display notifications
    showNotification(msg, action) {
        this.notification.open(msg, action, { duration: 5000, panelClass: ['snackbar-success'] });
    }
};
CreativeTemplateEditFormComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormBuilder"] },
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__["NgbActiveModal"] },
    { type: _shared_services_creativeTemplate_service__WEBPACK_IMPORTED_MODULE_4__["CreativeTemplateService"] },
    { type: _services_ageRange_service__WEBPACK_IMPORTED_MODULE_6__["AgeRangeService"] },
    { type: _services_storelocation_service__WEBPACK_IMPORTED_MODULE_7__["StoreLocationService"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__["MatSnackBar"] },
    { type: _services_campaignType_service__WEBPACK_IMPORTED_MODULE_8__["CampaignTypeService"] },
    { type: _services_brandMonthConversion_service__WEBPACK_IMPORTED_MODULE_10__["BrandMonthConversionService"] }
];
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Object)
], CreativeTemplateEditFormComponent.prototype, "title", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", _shared_models_creativeTemplate__WEBPACK_IMPORTED_MODULE_3__["CreativeTemplate"])
], CreativeTemplateEditFormComponent.prototype, "creativeTemplate", void 0);
CreativeTemplateEditFormComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-creative-template-edit-form',
        template: __importDefault(__webpack_require__(/*! raw-loader!./creative-template-edit.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/creative-template-edit-modal/creative-template-edit.component.html")).default
    }),
    __metadata("design:paramtypes", [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormBuilder"],
        _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__["NgbActiveModal"],
        _shared_services_creativeTemplate_service__WEBPACK_IMPORTED_MODULE_4__["CreativeTemplateService"],
        _services_ageRange_service__WEBPACK_IMPORTED_MODULE_6__["AgeRangeService"],
        _services_storelocation_service__WEBPACK_IMPORTED_MODULE_7__["StoreLocationService"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__["MatSnackBar"],
        _services_campaignType_service__WEBPACK_IMPORTED_MODULE_8__["CampaignTypeService"],
        _services_brandMonthConversion_service__WEBPACK_IMPORTED_MODULE_10__["BrandMonthConversionService"]])
], CreativeTemplateEditFormComponent);



/***/ }),

/***/ "./src/app/shared/components/modals/location-add-modal/location-add.component.ts":
/*!***************************************************************************************!*\
  !*** ./src/app/shared/components/modals/location-add-modal/location-add.component.ts ***!
  \***************************************************************************************/
/*! exports provided: LocationAddFormComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LocationAddFormComponent", function() { return LocationAddFormComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _shared_models_state__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../shared/models/state */ "./src/app/shared/models/state.ts");
/* harmony import */ var _shared_services_storelocation_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../shared/services/storelocation.service */ "./src/app/shared/services/storelocation.service.ts");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _services_validation_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../services/validation.service */ "./src/app/shared/services/validation.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};







let LocationAddFormComponent = class LocationAddFormComponent {
    constructor(formBuilder, activeModal, storeLocationService, notification) {
        this.formBuilder = formBuilder;
        this.activeModal = activeModal;
        this.storeLocationService = storeLocationService;
        this.notification = notification;
        this.eventEmitter = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
        this.submitted = false;
        this.stateList = _shared_models_state__WEBPACK_IMPORTED_MODULE_3__["STATES"]; // bind list of states
    }
    // on component load
    ngOnInit() {
        this.addForm = this.formBuilder.group({
            brandId: [this.brandId, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            storeId: [''],
            name: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            address1: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            address2: [''],
            city: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required, _services_validation_service__WEBPACK_IMPORTED_MODULE_6__["ValidationService"].alphaNumericSpecialCharactersValidator]],
            state: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            zipCode: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required, _services_validation_service__WEBPACK_IMPORTED_MODULE_6__["ValidationService"].zipCodeValidator]],
            email: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].email],
            phone: ['', _services_validation_service__WEBPACK_IMPORTED_MODULE_6__["ValidationService"].phoneValidator],
            hours: [''],
            url: ['', _services_validation_service__WEBPACK_IMPORTED_MODULE_6__["ValidationService"].urlValidator]
        });
    }
    // handle form submit 
    onSubmit() {
        this.submitted = true;
        // stop here if form is invalid
        if (this.addForm.invalid) {
            return;
        }
        this.storeLocationService.add(this.addForm.value).subscribe(storeLocation => {
            this.eventEmitter.emit(this.addForm.value);
            this.activeModal.close(storeLocation);
            this.showNotification(`The new store location ${storeLocation.name} was successuly added!`, 'Okay!');
        });
    }
    // display notifications
    showNotification(msg, action) {
        this.notification.open(msg, action, { duration: 5000, panelClass: ['snackbar-success'] });
    }
};
LocationAddFormComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormBuilder"] },
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__["NgbActiveModal"] },
    { type: _shared_services_storelocation_service__WEBPACK_IMPORTED_MODULE_4__["StoreLocationService"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__["MatSnackBar"] }
];
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Object)
], LocationAddFormComponent.prototype, "title", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Number)
], LocationAddFormComponent.prototype, "brandId", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"])(),
    __metadata("design:type", _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"])
], LocationAddFormComponent.prototype, "eventEmitter", void 0);
LocationAddFormComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-location-add-form',
        template: __importDefault(__webpack_require__(/*! raw-loader!./location-add.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/location-add-modal/location-add.component.html")).default
    }),
    __metadata("design:paramtypes", [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormBuilder"], _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__["NgbActiveModal"], _shared_services_storelocation_service__WEBPACK_IMPORTED_MODULE_4__["StoreLocationService"], _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__["MatSnackBar"]])
], LocationAddFormComponent);



/***/ }),

/***/ "./src/app/shared/components/modals/location-edit-modal/location-edit.component.ts":
/*!*****************************************************************************************!*\
  !*** ./src/app/shared/components/modals/location-edit-modal/location-edit.component.ts ***!
  \*****************************************************************************************/
/*! exports provided: LocationEditFormComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LocationEditFormComponent", function() { return LocationEditFormComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _shared_models_storeLocation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../shared/models/storeLocation */ "./src/app/shared/models/storeLocation.ts");
/* harmony import */ var _shared_models_state__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../shared/models/state */ "./src/app/shared/models/state.ts");
/* harmony import */ var _shared_services_storelocation_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../shared/services/storelocation.service */ "./src/app/shared/services/storelocation.service.ts");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _services_validation_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../services/validation.service */ "./src/app/shared/services/validation.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};








let LocationEditFormComponent = class LocationEditFormComponent {
    constructor(formBuilder, activeModal, storeLocationService, notification) {
        this.formBuilder = formBuilder;
        this.activeModal = activeModal;
        this.storeLocationService = storeLocationService;
        this.notification = notification;
        this.submitted = false;
        this.stateList = _shared_models_state__WEBPACK_IMPORTED_MODULE_4__["STATES"]; // bind list of states
    }
    // on component load
    ngOnInit() {
        this.editForm = this.formBuilder.group({
            brandId: [this.location.brandId, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            storeId: [this.location.storeId],
            name: [this.location.name, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            address1: [this.location.address1, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            address2: [this.location.address2],
            city: [this.location.city, [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required, _services_validation_service__WEBPACK_IMPORTED_MODULE_7__["ValidationService"].alphaNumericSpecialCharactersValidator]],
            state: [this.location.state, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            zipCode: [this.location.zipCode, [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required, _services_validation_service__WEBPACK_IMPORTED_MODULE_7__["ValidationService"].zipCodeValidator]],
            email: [this.location.email, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].email],
            phone: [this.location.phone, _services_validation_service__WEBPACK_IMPORTED_MODULE_7__["ValidationService"].phoneValidator],
            hours: [this.location.hours],
            url: [this.location.url, _services_validation_service__WEBPACK_IMPORTED_MODULE_7__["ValidationService"].urlValidator]
        });
    }
    // handle form submit 
    onSubmit() {
        this.submitted = true;
        // stop here if form is invalid
        if (this.editForm.invalid) {
            return;
        }
        this.storeLocationService.update(this.location.id, this.editForm.value).subscribe(storeLocation => {
            //this.eventEmitter.emit(this.editForm.value);
            this.activeModal.close(true);
            this.showNotification(`The store location ${storeLocation.name} was successuly updated!`, 'Okay!');
        });
    }
    decline() {
        this.activeModal.close(false);
    }
    dismiss() {
        this.activeModal.dismiss();
    }
    // display notifications
    showNotification(msg, action) {
        this.notification.open(msg, action, { duration: 5000, panelClass: ['snackbar-success'] });
    }
};
LocationEditFormComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormBuilder"] },
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__["NgbActiveModal"] },
    { type: _shared_services_storelocation_service__WEBPACK_IMPORTED_MODULE_5__["StoreLocationService"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_6__["MatSnackBar"] }
];
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Object)
], LocationEditFormComponent.prototype, "title", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", _shared_models_storeLocation__WEBPACK_IMPORTED_MODULE_3__["StoreLocation"])
], LocationEditFormComponent.prototype, "location", void 0);
LocationEditFormComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-location-edit-form',
        template: __importDefault(__webpack_require__(/*! raw-loader!./location-edit.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/location-edit-modal/location-edit.component.html")).default
    }),
    __metadata("design:paramtypes", [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormBuilder"], _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__["NgbActiveModal"], _shared_services_storelocation_service__WEBPACK_IMPORTED_MODULE_5__["StoreLocationService"], _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_6__["MatSnackBar"]])
], LocationEditFormComponent);



/***/ }),

/***/ "./src/app/shared/components/modals/location-override-modal/location-override-form.component.ts":
/*!******************************************************************************************************!*\
  !*** ./src/app/shared/components/modals/location-override-modal/location-override-form.component.ts ***!
  \******************************************************************************************************/
/*! exports provided: LocationOverrideFormComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LocationOverrideFormComponent", function() { return LocationOverrideFormComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _services_storelocation_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../services/storelocation.service */ "./src/app/shared/services/storelocation.service.ts");
/* harmony import */ var _shared_models_state__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../shared/models/state */ "./src/app/shared/models/state.ts");
/* harmony import */ var _services_storelocationOverride_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../services/storelocationOverride.service */ "./src/app/shared/services/storelocationOverride.service.ts");
/* harmony import */ var _models_storeLocationOverride__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../models/storeLocationOverride */ "./src/app/shared/models/storeLocationOverride.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};








const storeLocationValidator = (fg) => {
    const source = fg.get('sourceStoreLocationId').value;
    const destination = fg.get('destinationStoreLocationId').value;
    return source !== null && destination !== null && source != destination
        ? null
        : { storeLocation: true };
};
let LocationOverrideFormComponent = class LocationOverrideFormComponent {
    constructor(formBuilder, activeModal, storeLocationOverrideService, storeLocationService, notification) {
        this.formBuilder = formBuilder;
        this.activeModal = activeModal;
        this.storeLocationOverrideService = storeLocationOverrideService;
        this.storeLocationService = storeLocationService;
        this.notification = notification;
        this.eventEmitter = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
        this.submitted = false;
        this.stateList = _shared_models_state__WEBPACK_IMPORTED_MODULE_5__["STATES"]; // bind list of states
    }
    // on component load
    ngOnInit() {
        // bind store locations dropdown
        this.storeLocationService.getAll(this.inputModel.brandId).subscribe(locationResult => {
            this.storeLocationList = locationResult;
        });
        //const dateReg = /^\d{2}([./-])\d{2}\1\d{4}$/;
        // init dates
        this.startDate = this.inputModel.startDate ? new Date(this.inputModel.startDate) : '';
        this.endDate = this.inputModel.endDate ? new Date(this.inputModel.endDate) : '';
        this.modelForm = this.formBuilder.group({
            id: [this.inputModel.id],
            brandId: [this.inputModel.brandId, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            sourceStoreLocationId: [this.inputModel.sourceStoreLocationId, [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].min(1)]],
            destinationStoreLocationId: [this.inputModel.destinationStoreLocationId, [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].min(1)]],
            startDate: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required]],
            endDate: ['', [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required]]
        }, { validator: storeLocationValidator });
    }
    // handle form submit  
    onSubmit() {
        this.submitted = true;
        // stop here if form is invalid
        if (this.modelForm.invalid) {
            return;
        }
        let formValues = this.modelForm.value;
        formValues.brandId = +this.modelForm.value['brandId'];
        formValues.sourceStoreLocationId = +this.modelForm.value['sourceStoreLocationId'];
        formValues.destinationStoreLocationId = +this.modelForm.value['destinationStoreLocationId'];
        //add
        if (formValues.id == 0) {
            this.storeLocationOverrideService.add(formValues).subscribe(newItem => {
                this.eventEmitter.emit(this.modelForm.value);
                this.activeModal.close(newItem);
                this.showNotification(`The new item was successuly added!`, 'Okay!');
            });
            // update
        }
        else {
            this.storeLocationOverrideService.update(formValues.id, formValues).subscribe(newItem => {
                this.eventEmitter.emit(this.modelForm.value);
                this.activeModal.close(newItem);
                this.showNotification(`The item was successuly updated!`, 'Okay!');
            });
        }
    }
    decline() {
        this.activeModal.close(false);
    }
    dismiss() {
        this.activeModal.dismiss();
    }
    // display notifications
    showNotification(msg, action) {
        this.notification.open(msg, action, { duration: 5000, panelClass: ['snackbar-success'] });
    }
};
LocationOverrideFormComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormBuilder"] },
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__["NgbActiveModal"] },
    { type: _services_storelocationOverride_service__WEBPACK_IMPORTED_MODULE_6__["StoreLocationOverrideService"] },
    { type: _services_storelocation_service__WEBPACK_IMPORTED_MODULE_4__["StoreLocationService"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_3__["MatSnackBar"] }
];
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Object)
], LocationOverrideFormComponent.prototype, "title", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", _models_storeLocationOverride__WEBPACK_IMPORTED_MODULE_7__["StoreLocationOverride"])
], LocationOverrideFormComponent.prototype, "inputModel", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"])(),
    __metadata("design:type", _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"])
], LocationOverrideFormComponent.prototype, "eventEmitter", void 0);
LocationOverrideFormComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-location-override-form',
        template: __importDefault(__webpack_require__(/*! raw-loader!./location-override-form.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/location-override-modal/location-override-form.component.html")).default
    }),
    __metadata("design:paramtypes", [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormBuilder"],
        _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__["NgbActiveModal"],
        _services_storelocationOverride_service__WEBPACK_IMPORTED_MODULE_6__["StoreLocationOverrideService"],
        _services_storelocation_service__WEBPACK_IMPORTED_MODULE_4__["StoreLocationService"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_3__["MatSnackBar"]])
], LocationOverrideFormComponent);



/***/ }),

/***/ "./src/app/shared/components/modals/mailing-record-edit-modal/mailing-record-edit.component.ts":
/*!*****************************************************************************************************!*\
  !*** ./src/app/shared/components/modals/mailing-record-edit-modal/mailing-record-edit.component.ts ***!
  \*****************************************************************************************************/
/*! exports provided: MailingRecordEditFormComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MailingRecordEditFormComponent", function() { return MailingRecordEditFormComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _shared_models_mailingRecord__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../shared/models/mailingRecord */ "./src/app/shared/models/mailingRecord.ts");
/* harmony import */ var _shared_services_mailingRecord_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../shared/services/mailingRecord.service */ "./src/app/shared/services/mailingRecord.service.ts");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _services_storelocation_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../services/storelocation.service */ "./src/app/shared/services/storelocation.service.ts");
/* harmony import */ var _services_brand_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../services/brand.service */ "./src/app/shared/services/brand.service.ts");
/* harmony import */ var _shared_models_state__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../../shared/models/state */ "./src/app/shared/models/state.ts");
/* harmony import */ var _services_campaignType_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../services/campaignType.service */ "./src/app/shared/services/campaignType.service.ts");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _services_validation_service__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../../services/validation.service */ "./src/app/shared/services/validation.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};












let MailingRecordEditFormComponent = class MailingRecordEditFormComponent {
    constructor(formBuilder, activeModal, mailingRecordService, brandService, storeLocationService, campaignTypeService, notification) {
        this.formBuilder = formBuilder;
        this.activeModal = activeModal;
        this.mailingRecordService = mailingRecordService;
        this.brandService = brandService;
        this.storeLocationService = storeLocationService;
        this.campaignTypeService = campaignTypeService;
        this.notification = notification;
        this.submitted = false;
        this.genderList = ['F', 'M'];
        this.stateList = _shared_models_state__WEBPACK_IMPORTED_MODULE_8__["STATES"]; // bind list of states
    }
    // on component load
    ngOnInit() {
        //bind brand dropdown
        this.brandService.getAll().subscribe(brandResult => {
            this.brandList = brandResult;
        });
        // bind store locations dropdown
        this.storeLocationService.getAll(this.mailingRecord.brandId).subscribe(locationResult => {
            this.storeLocationList = locationResult;
        });
        // bind campaign types
        this.campaignTypeService.getAll().subscribe(campaignResult => {
            this.campaignTypeList = campaignResult;
        });
        const dateReg = /^\d{2}([./-])\d{2}\1\d{4}$/;
        this.editForm = this.formBuilder.group({
            id: [this.mailingRecord.id],
            patientId: [this.mailingRecord.patientId],
            clxPatientId: [this.mailingRecord.clxPatientId],
            firstName: [this.mailingRecord.firstName, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            lastName: [this.mailingRecord.lastName, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            address1: [this.mailingRecord.address1, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            address2: [this.mailingRecord.address2],
            city: [this.mailingRecord.city, [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required, _services_validation_service__WEBPACK_IMPORTED_MODULE_11__["ValidationService"].alphaNumericSpecialCharactersValidator]],
            state: [this.mailingRecord.state, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            zipCode: [this.mailingRecord.zipCode, [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required, _services_validation_service__WEBPACK_IMPORTED_MODULE_11__["ValidationService"].zipCodeValidator]],
            gender: [this.mailingRecord.gender, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            //dateOfBirth: [this.mailingRecord.dateOfBirth, Validators.pattern(dateReg)],
            dateOfBirth: [(this.mailingRecord.dateOfBirth !== null ? Object(_angular_common__WEBPACK_IMPORTED_MODULE_10__["formatDate"])(this.mailingRecord.dateOfBirth, 'MM/dd/yyyy', 'en-US') : null), _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].pattern(dateReg)],
            lastExamDate: [(this.mailingRecord.lastExamDate !== null ? Object(_angular_common__WEBPACK_IMPORTED_MODULE_10__["formatDate"])(this.mailingRecord.lastExamDate, 'MM/dd/yyyy', 'en-US') : null), [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].pattern(dateReg)]],
            //lastExamDate: [this.mailingRecord.lastExamDate, Validators.pattern(dateReg)],
            phone: [this.mailingRecord.phone, _services_validation_service__WEBPACK_IMPORTED_MODULE_11__["ValidationService"].phoneValidator],
            email: [this.mailingRecord.email, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].email],
            brandId: [this.mailingRecord.brandId, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            campaignTypeId: [this.mailingRecord.campaignTypeId, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            storeLocationId: this.mailingRecord.storeLocationId,
            custom1: [this.mailingRecord.custom1],
            custom2: [this.mailingRecord.custom2],
            custom3: [this.mailingRecord.custom3],
            custom4: [this.mailingRecord.custom4],
            custom5: [this.mailingRecord.custom5],
        });
    }
    // format date  
    formatDate(e, fieldName) {
        if (e.target.value === null) {
            this.editForm.get(fieldName).setValue('', {
                onlyself: true
            });
        }
        else {
            var convertDate = new Date(e.target.value);
            this.editForm.get(fieldName).setValue(convertDate, {
                onlyself: true
            });
        }
    }
    transformDate(dateStr) {
        const dateSendingToServer = new _angular_common__WEBPACK_IMPORTED_MODULE_10__["DatePipe"]('en-US').transform(dateStr, 'dd/MM/yyyy');
        return dateSendingToServer;
    }
    // handle form submit  
    onSubmit() {
        this.submitted = true;
        // stop here if form is invalid
        if (this.editForm.invalid) {
            return;
        }
        const model = this.editForm.value;
        model.brandId = +this.editForm.value['brandId'];
        model.campaignTypeId = +this.editForm.value['campaignTypeId'];
        model.months = +this.editForm.value['months'];
        model.storeLocationId = +this.editForm.value['storeLocationId'];
        model.dateOfBirth = this.editForm.value['dateOfBirth'];
        model.lastExamDate = this.editForm.value['lastExamDate'];
        this.mailingRecordService.update(+this.mailingRecord.id, model).subscribe(mailingRecord => {
            //this.eventEmitter.emit(this.editForm.value);
            this.activeModal.close(true);
            this.showNotification(`The entry was successuly updated!`, 'Okay!');
        });
    }
    decline() {
        this.activeModal.close(false);
    }
    dismiss() {
        this.activeModal.dismiss();
    }
    // display notifications
    showNotification(msg, action) {
        this.notification.open(msg, action, { duration: 5000, panelClass: ['snackbar-success'] });
    }
};
MailingRecordEditFormComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormBuilder"] },
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__["NgbActiveModal"] },
    { type: _shared_services_mailingRecord_service__WEBPACK_IMPORTED_MODULE_4__["MailingRecordService"] },
    { type: _services_brand_service__WEBPACK_IMPORTED_MODULE_7__["BrandService"] },
    { type: _services_storelocation_service__WEBPACK_IMPORTED_MODULE_6__["StoreLocationService"] },
    { type: _services_campaignType_service__WEBPACK_IMPORTED_MODULE_9__["CampaignTypeService"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__["MatSnackBar"] }
];
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Object)
], MailingRecordEditFormComponent.prototype, "title", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", _shared_models_mailingRecord__WEBPACK_IMPORTED_MODULE_3__["MailingRecord"])
], MailingRecordEditFormComponent.prototype, "mailingRecord", void 0);
MailingRecordEditFormComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-mailing-record-edit-form',
        template: __importDefault(__webpack_require__(/*! raw-loader!./mailing-record-edit.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/mailing-record-edit-modal/mailing-record-edit.component.html")).default,
    }),
    __metadata("design:paramtypes", [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormBuilder"],
        _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__["NgbActiveModal"],
        _shared_services_mailingRecord_service__WEBPACK_IMPORTED_MODULE_4__["MailingRecordService"],
        _services_brand_service__WEBPACK_IMPORTED_MODULE_7__["BrandService"],
        _services_storelocation_service__WEBPACK_IMPORTED_MODULE_6__["StoreLocationService"],
        _services_campaignType_service__WEBPACK_IMPORTED_MODULE_9__["CampaignTypeService"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__["MatSnackBar"]])
], MailingRecordEditFormComponent);



/***/ }),

/***/ "./src/app/shared/components/modals/modal/modal.component.ts":
/*!*******************************************************************!*\
  !*** ./src/app/shared/components/modals/modal/modal.component.ts ***!
  \*******************************************************************/
/*! exports provided: ModalComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModalComponent", function() { return ModalComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};


let ModalComponent = class ModalComponent {
    constructor(activeModal) {
        this.activeModal = activeModal;
    }
};
ModalComponent.ctorParameters = () => [
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_1__["NgbActiveModal"] }
];
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Object)
], ModalComponent.prototype, "title", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Object)
], ModalComponent.prototype, "content", void 0);
ModalComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-modal',
        template: `
    <div class="modal-header">
      <h4 class="modal-title">{{title}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      {{content}}
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('Close click')">Close</button>
    </div>
  `
    }),
    __metadata("design:paramtypes", [_ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_1__["NgbActiveModal"]])
], ModalComponent);



/***/ }),

/***/ "./src/app/shared/components/modals/month-conversion-modal/month-conversion-form.component.ts":
/*!****************************************************************************************************!*\
  !*** ./src/app/shared/components/modals/month-conversion-modal/month-conversion-form.component.ts ***!
  \****************************************************************************************************/
/*! exports provided: MonthConversionFormComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MonthConversionFormComponent", function() { return MonthConversionFormComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _models_brandMonthConversion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../models/brandMonthConversion */ "./src/app/shared/models/brandMonthConversion.ts");
/* harmony import */ var _services_brandMonthConversion_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../services/brandMonthConversion.service */ "./src/app/shared/services/brandMonthConversion.service.ts");
/* harmony import */ var _services_campaignType_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../services/campaignType.service */ "./src/app/shared/services/campaignType.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};







let MonthConversionFormComponent = class MonthConversionFormComponent {
    constructor(formBuilder, activeModal, brandMonthConversionService, notification, campaignTypeService) {
        this.formBuilder = formBuilder;
        this.activeModal = activeModal;
        this.brandMonthConversionService = brandMonthConversionService;
        this.notification = notification;
        this.campaignTypeService = campaignTypeService;
        this.eventEmitter = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
        this.submitted = false;
    }
    // on component load
    ngOnInit() {
        // bind campaign types
        this.campaignTypeService.getAll().subscribe(campaignResult => {
            this.campaignTypeList = campaignResult;
        });
        this.modelForm = this.formBuilder.group({
            id: this.inputModel.id,
            brandId: [this.inputModel.brandId, [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required]],
            campaignTypeId: [this.inputModel.campaignTypeId, [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].min(1)]],
            fromMonth: [this.inputModel.fromMonth, [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].min(1)]],
            toMonth: [this.inputModel.toMonth, [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].min(1)]],
            convertMonth: [this.inputModel.convertMonth, [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].min(1)]]
        });
    }
    // handle form submit 
    onSubmit() {
        this.submitted = true;
        // stop here if form is invalid
        if (this.modelForm.invalid) {
            return;
        }
        let formValues = this.modelForm.value;
        // add
        if (formValues.id == 0) {
            this.brandMonthConversionService.add(formValues).subscribe(brandMonthConversion => {
                this.eventEmitter.emit(this.modelForm.value);
                this.activeModal.close(brandMonthConversion);
                this.showNotification(`The new month conversion ${brandMonthConversion.convertMonth} was successuly added!`, 'Okay!');
            });
            // update
        }
        else {
            this.brandMonthConversionService.update(formValues.id, formValues).subscribe(brandMonthConversion => {
                this.eventEmitter.emit(this.modelForm.value);
                this.activeModal.close(brandMonthConversion);
                this.showNotification(`The new month conversion ${brandMonthConversion.convertMonth} was successuly updated!`, 'Okay!');
            });
        }
    }
    // display notifications
    showNotification(msg, action) {
        this.notification.open(msg, action, { duration: 5000, panelClass: ['snackbar-success'] });
    }
};
MonthConversionFormComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormBuilder"] },
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__["NgbActiveModal"] },
    { type: _services_brandMonthConversion_service__WEBPACK_IMPORTED_MODULE_5__["BrandMonthConversionService"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_3__["MatSnackBar"] },
    { type: _services_campaignType_service__WEBPACK_IMPORTED_MODULE_6__["CampaignTypeService"] }
];
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Object)
], MonthConversionFormComponent.prototype, "title", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", _models_brandMonthConversion__WEBPACK_IMPORTED_MODULE_4__["BrandMonthConversion"])
], MonthConversionFormComponent.prototype, "inputModel", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"])(),
    __metadata("design:type", _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"])
], MonthConversionFormComponent.prototype, "eventEmitter", void 0);
MonthConversionFormComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-month-conversion-form',
        template: __importDefault(__webpack_require__(/*! raw-loader!./month-conversion-form.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/month-conversion-modal/month-conversion-form.component.html")).default
    }),
    __metadata("design:paramtypes", [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormBuilder"],
        _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__["NgbActiveModal"],
        _services_brandMonthConversion_service__WEBPACK_IMPORTED_MODULE_5__["BrandMonthConversionService"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_3__["MatSnackBar"],
        _services_campaignType_service__WEBPACK_IMPORTED_MODULE_6__["CampaignTypeService"]])
], MonthConversionFormComponent);



/***/ }),

/***/ "./src/app/shared/components/modals/note-modal/note-form.component.ts":
/*!****************************************************************************!*\
  !*** ./src/app/shared/components/modals/note-modal/note-form.component.ts ***!
  \****************************************************************************/
/*! exports provided: NoteFormComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NoteFormComponent", function() { return NoteFormComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _models_Note__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../models/Note */ "./src/app/shared/models/Note.ts");
/* harmony import */ var _services_note_service__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../services/note.service */ "./src/app/shared/services/note.service.ts");
/* harmony import */ var _api_authorization_authorize_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../../../api-authorization/authorize.service */ "./src/api-authorization/authorize.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};







let NoteFormComponent = class NoteFormComponent {
    constructor(formBuilder, activeModal, noteService, notification, authorizeService) {
        this.formBuilder = formBuilder;
        this.activeModal = activeModal;
        this.noteService = noteService;
        this.notification = notification;
        this.authorizeService = authorizeService;
        this.editMode = false;
        this.eventEmitter = new _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();
        this.submitted = false;
    }
    // on component load
    ngOnInit() {
        // get current user
        this.authorizeService.getUser().subscribe(result => {
            this.userName = result.name;
            this.userId = result.sub;
            // allow only original creator to modify note.
            if (this.userName == this.inputModel.createdBy || this.inputModel.createdBy.length === 0) {
                this.editMode = true;
            }
        });
        this.modelForm = this.formBuilder.group({
            id: this.inputModel.id,
            contentId: [this.inputModel.contentId, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            contentType: [this.inputModel.contentType, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            description: [this.inputModel.description, [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].maxLength(500)]]
        });
    }
    // handle form submit 
    onSubmit() {
        this.submitted = true;
        // stop here if form is invalid
        if (this.modelForm.invalid) {
            return;
        }
        let formValues = this.modelForm.value;
        // add
        if (formValues.id == 0) {
            this.noteService.add(formValues).subscribe(brandMonthConversion => {
                this.eventEmitter.emit(this.modelForm.value);
                this.activeModal.close(brandMonthConversion);
                this.showNotification(`The new note was successuly added!`, 'Okay!');
            });
            // update
        }
        else {
            this.noteService.update(formValues.id, formValues).subscribe(brandMonthConversion => {
                this.eventEmitter.emit(this.modelForm.value);
                this.activeModal.close(brandMonthConversion);
                this.showNotification(`The new note was successuly updated!`, 'Okay!');
            });
        }
    }
    // display notifications
    showNotification(msg, action) {
        this.notification.open(msg, action, { duration: 5000, panelClass: ['snackbar-success'] });
    }
};
NoteFormComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormBuilder"] },
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__["NgbActiveModal"] },
    { type: _services_note_service__WEBPACK_IMPORTED_MODULE_5__["NoteService"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_3__["MatSnackBar"] },
    { type: _api_authorization_authorize_service__WEBPACK_IMPORTED_MODULE_6__["AuthorizeService"] }
];
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Object)
], NoteFormComponent.prototype, "title", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", _models_Note__WEBPACK_IMPORTED_MODULE_4__["Note"])
], NoteFormComponent.prototype, "inputModel", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Output"])(),
    __metadata("design:type", _angular_core__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"])
], NoteFormComponent.prototype, "eventEmitter", void 0);
NoteFormComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-note-form',
        template: __importDefault(__webpack_require__(/*! raw-loader!./note-form.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/note-modal/note-form.component.html")).default
    }),
    __metadata("design:paramtypes", [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormBuilder"],
        _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__["NgbActiveModal"],
        _services_note_service__WEBPACK_IMPORTED_MODULE_5__["NoteService"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_3__["MatSnackBar"],
        _api_authorization_authorize_service__WEBPACK_IMPORTED_MODULE_6__["AuthorizeService"]])
], NoteFormComponent);



/***/ }),

/***/ "./src/app/shared/components/modals/override-rule-add-modal/override-rule-add.component.ts":
/*!*************************************************************************************************!*\
  !*** ./src/app/shared/components/modals/override-rule-add-modal/override-rule-add.component.ts ***!
  \*************************************************************************************************/
/*! exports provided: OverrideRuleAddFormComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OverrideRuleAddFormComponent", function() { return OverrideRuleAddFormComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _shared_models_overrideRule__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../shared/models/overrideRule */ "./src/app/shared/models/overrideRule.ts");
/* harmony import */ var _shared_services_overrideRule_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../shared/services/overrideRule.service */ "./src/app/shared/services/overrideRule.service.ts");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _services_ageRange_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../services/ageRange.service */ "./src/app/shared/services/ageRange.service.ts");
/* harmony import */ var _services_storelocation_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../services/storelocation.service */ "./src/app/shared/services/storelocation.service.ts");
/* harmony import */ var _services_campaignType_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../services/campaignType.service */ "./src/app/shared/services/campaignType.service.ts");
/* harmony import */ var _services_validation_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../services/validation.service */ "./src/app/shared/services/validation.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};










let OverrideRuleAddFormComponent = class OverrideRuleAddFormComponent {
    constructor(formBuilder, activeModal, overrideRuleService, ageRangeService, storeLocationService, notification, campaignTypeService) {
        this.formBuilder = formBuilder;
        this.activeModal = activeModal;
        this.overrideRuleService = overrideRuleService;
        this.ageRangeService = ageRangeService;
        this.storeLocationService = storeLocationService;
        this.notification = notification;
        this.campaignTypeService = campaignTypeService;
        this.submitted = false;
        this.genderList = ['F', 'M'];
        this.fieldNames = ['FrontImage', 'FrontCTA', 'FrontOffer', 'FrontLogo', 'BackLogo', 'BackCTA', 'BackBackground', 'BackBottomLeftCopy', 'BackOfferBlock', 'BackStoreBlock', 'Style', 'Custom1', 'Custom2', 'Custom3', 'Custom4', 'Custom5', 'StoreDescription'];
    }
    // on component load
    ngOnInit() {
        // bind age ranges dropdown
        this.ageRangeService.getAll().subscribe(result => {
            this.ageRangeList = result;
        });
        // bind campaign dropdown
        this.campaignTypeService.getAll().subscribe(result => {
            this.campaignTypeList = result;
        });
        // bind store locations dropdown
        this.storeLocationService.getAll(this.brandId).subscribe(result => {
            this.storeLocationList = result;
        });
        if (this.model === undefined) {
            // build empty form model
            this.editForm = this.formBuilder.group({
                gender: null,
                months: ['', _services_validation_service__WEBPACK_IMPORTED_MODULE_9__["ValidationService"].numericValidator],
                brandId: this.brandId,
                campaignTypeId: 0,
                storeLocationId: 0,
                ageRangeId: [0, [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].min(1)]],
                priority: [0, [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].min(0)]],
                startDate: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
                endDate: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
                custom1: null,
                custom2: null,
                custom3: null,
                custom4: null,
                custom5: null,
                fields: this.formBuilder.array([this.createItem()])
            });
        }
        else {
            // build form model from copy
            // init dates
            this.startDate = new Date(this.model.startDate);
            this.endDate = new Date(this.model.endDate);
            const formGroups = this.model.fields.map(x => this.formBuilder.group({
                name: [x.name, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
                value: [x.value, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required]
            }));
            this.editForm = this.formBuilder.group({
                gender: this.model.gender || null,
                months: [this.model.months || '', _services_validation_service__WEBPACK_IMPORTED_MODULE_9__["ValidationService"].numericValidator],
                brandId: this.brandId,
                campaignTypeId: this.model.campaignTypeId || 0,
                storeLocationId: this.model.storeLocationId || 0,
                ageRangeId: [this.model.ageRangeId || 0, [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].min(1)]],
                priority: [this.model.priority || 0, [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].min(0)]],
                startDate: [this.startDate, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
                endDate: [this.endDate, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
                custom1: this.model.custom1 || null,
                custom2: this.model.custom2 || null,
                custom3: this.model.custom3 || null,
                custom4: this.model.custom4 || null,
                custom5: this.model.custom5 || null,
                fields: this.formBuilder.array(formGroups)
            });
        }
    }
    createItem() {
        return this.formBuilder.group({
            name: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            value: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required]
        });
    }
    // handle form submit 
    onSubmit() {
        this.submitted = true;
        // stop here if form is invalid
        if (this.editForm.invalid) {
            return;
        }
        const model = this.editForm.value;
        model.brandId = +this.editForm.value['brandId'];
        model.campaignTypeId = +this.editForm.value['campaignTypeId'];
        model.storeLocationId = +this.editForm.value['storeLocationId'];
        model.ageRangeId = +this.editForm.value['ageRangeId'];
        model.months = +this.editForm.value['months'];
        model.priority = +this.editForm.value['priority'];
        this.overrideRuleService.add(model).subscribe(overrideRule => {
            //this.eventEmitter.emit(this.editForm.value);
            this.activeModal.close(true);
            this.showNotification(`The entry was successuly updated!`, 'Okay!');
        });
    }
    decline() {
        this.activeModal.close(false);
    }
    dismiss() {
        this.activeModal.dismiss();
    }
    // display notifications
    showNotification(msg, action) {
        this.notification.open(msg, action, { duration: 5000, panelClass: ['snackbar-success'] });
    }
    // remove field
    removeFieldName(i) {
        this.fields.removeAt(i);
    }
    // add field
    addFieldName() {
        this.fields = this.editForm.get('fields');
        this.fields.push(this.createItem());
    }
};
OverrideRuleAddFormComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormBuilder"] },
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__["NgbActiveModal"] },
    { type: _shared_services_overrideRule_service__WEBPACK_IMPORTED_MODULE_4__["OverrideRuleService"] },
    { type: _services_ageRange_service__WEBPACK_IMPORTED_MODULE_6__["AgeRangeService"] },
    { type: _services_storelocation_service__WEBPACK_IMPORTED_MODULE_7__["StoreLocationService"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__["MatSnackBar"] },
    { type: _services_campaignType_service__WEBPACK_IMPORTED_MODULE_8__["CampaignTypeService"] }
];
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Object)
], OverrideRuleAddFormComponent.prototype, "title", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Number)
], OverrideRuleAddFormComponent.prototype, "brandId", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", _shared_models_overrideRule__WEBPACK_IMPORTED_MODULE_3__["OverrideRule"])
], OverrideRuleAddFormComponent.prototype, "model", void 0);
OverrideRuleAddFormComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-override-rule-add-form',
        template: __importDefault(__webpack_require__(/*! raw-loader!./override-rule-add.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/override-rule-add-modal/override-rule-add.component.html")).default
    }),
    __metadata("design:paramtypes", [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormBuilder"],
        _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__["NgbActiveModal"],
        _shared_services_overrideRule_service__WEBPACK_IMPORTED_MODULE_4__["OverrideRuleService"],
        _services_ageRange_service__WEBPACK_IMPORTED_MODULE_6__["AgeRangeService"],
        _services_storelocation_service__WEBPACK_IMPORTED_MODULE_7__["StoreLocationService"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__["MatSnackBar"],
        _services_campaignType_service__WEBPACK_IMPORTED_MODULE_8__["CampaignTypeService"]])
], OverrideRuleAddFormComponent);



/***/ }),

/***/ "./src/app/shared/components/modals/override-rule-edit-modal/override-rule-edit.component.ts":
/*!***************************************************************************************************!*\
  !*** ./src/app/shared/components/modals/override-rule-edit-modal/override-rule-edit.component.ts ***!
  \***************************************************************************************************/
/*! exports provided: OverrideRuleEditFormComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OverrideRuleEditFormComponent", function() { return OverrideRuleEditFormComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @ng-bootstrap/ng-bootstrap */ "./node_modules/@ng-bootstrap/ng-bootstrap/fesm2015/ng-bootstrap.js");
/* harmony import */ var _shared_models_overrideRule__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../shared/models/overrideRule */ "./src/app/shared/models/overrideRule.ts");
/* harmony import */ var _shared_services_overrideRule_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../shared/services/overrideRule.service */ "./src/app/shared/services/overrideRule.service.ts");
/* harmony import */ var _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @angular/material/snack-bar */ "./node_modules/@angular/material/esm2015/snack-bar.js");
/* harmony import */ var _services_ageRange_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../../services/ageRange.service */ "./src/app/shared/services/ageRange.service.ts");
/* harmony import */ var _services_storelocation_service__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../../services/storelocation.service */ "./src/app/shared/services/storelocation.service.ts");
/* harmony import */ var _services_campaignType_service__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../../services/campaignType.service */ "./src/app/shared/services/campaignType.service.ts");
/* harmony import */ var _services_validation_service__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../../services/validation.service */ "./src/app/shared/services/validation.service.ts");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};











let OverrideRuleEditFormComponent = class OverrideRuleEditFormComponent {
    constructor(formBuilder, activeModal, overrideRuleService, ageRangeService, storeLocationService, notification, datepipe, campaignTypeService) {
        this.formBuilder = formBuilder;
        this.activeModal = activeModal;
        this.overrideRuleService = overrideRuleService;
        this.ageRangeService = ageRangeService;
        this.storeLocationService = storeLocationService;
        this.notification = notification;
        this.datepipe = datepipe;
        this.campaignTypeService = campaignTypeService;
        this.submitted = false;
        this.genderList = ['F', 'M'];
        this.fieldNames = ['FrontImage', 'FrontCTA', 'FrontOffer', 'FrontLogo', 'BackLogo', 'BackCTA', 'BackBackground', 'BackBottomLeftCopy', 'BackOfferBlock', 'BackStoreBlock', 'Style', 'Custom1', 'Custom2', 'Custom3', 'Custom4', 'Custom5', 'StoreDescription'];
    }
    // on component load
    ngOnInit() {
        // bind campaign types
        this.campaignTypeService.getAll().subscribe(campaignResult => {
            this.campaignTypeList = campaignResult;
        });
        // bind age ranges dropdown
        this.ageRangeService.getAll().subscribe(result => {
            this.ageRangeList = result;
        });
        // bind store locations dropdown
        this.storeLocationService.getAll(this.overrideRule.brandId).subscribe(result => {
            this.storeLocationList = result;
        });
        // create a form group for each item in the fields array model
        const formGroups = this.overrideRule.fields.map(x => this.formBuilder.group({
            name: [x.name, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            value: [x.value, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required]
        }));
        // init dates
        this.startDate = new Date(this.overrideRule.startDate);
        this.endDate = new Date(this.overrideRule.endDate);
        // build form
        this.editForm = this.formBuilder.group({
            gender: [(this.overrideRule.gender === null || this.overrideRule.gender === '') ? null : this.overrideRule.gender],
            months: [this.overrideRule.months, _services_validation_service__WEBPACK_IMPORTED_MODULE_9__["ValidationService"].numericValidator],
            brandId: [this.overrideRule.brandId || 0],
            campaignTypeId: [this.overrideRule.campaignTypeId || 0],
            storeLocationId: [this.overrideRule.storeLocationId || 0],
            ageRangeId: [this.overrideRule.ageRangeId || 0, [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].min(1)]],
            priority: [this.overrideRule.priority, [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required, _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].min(0)]],
            startDate: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            endDate: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            //[this.datepipe.transform(this.overrideRule.endDate, 'MM/dd/yyyy') || '', Validators.required],
            custom1: this.overrideRule.custom1 || '',
            custom2: this.overrideRule.custom2 || '',
            custom3: this.overrideRule.custom3 || '',
            custom4: this.overrideRule.custom4 || '',
            custom5: this.overrideRule.custom5 || '',
            fields: this.formBuilder.array(formGroups)
        });
    }
    createItem() {
        return this.formBuilder.group({
            name: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required],
            value: ['', _angular_forms__WEBPACK_IMPORTED_MODULE_1__["Validators"].required]
        });
    }
    // remove field
    removeFieldName(i) {
        const fa = this.editForm.get('fields');
        fa.removeAt(i);
    }
    // add field
    addFieldName() {
        const fa = this.editForm.get('fields');
        fa.push(this.createItem());
    }
    // handle form submit 
    onSubmit() {
        this.submitted = true;
        // stop here if form is invalid
        if (this.editForm.invalid) {
            return;
        }
        const model = this.editForm.value;
        model.brandId = +this.editForm.value['brandId'];
        model.campaignTypeId = +this.editForm.value['campaignTypeId'];
        model.storeLocationId = +this.editForm.value['storeLocationId'];
        model.ageRangeId = +this.editForm.value['ageRangeId'];
        model.months = +this.editForm.value['months'];
        model.priority = +this.editForm.value['priority'];
        this.overrideRuleService.update(+this.overrideRule.id, model).subscribe(overrideRule => {
            //this.eventEmitter.emit(this.editForm.value);
            this.activeModal.close(true);
            this.showNotification(`The entry was successuly updated!`, 'Okay!');
        });
    }
    decline() {
        this.activeModal.close(false);
    }
    dismiss() {
        this.activeModal.dismiss();
    }
    // display notifications
    showNotification(msg, action) {
        this.notification.open(msg, action, { duration: 5000, panelClass: ['snackbar-success'] });
    }
    // format date
    formatDate(e, fieldName) {
        if (e.target.value === null) {
            this.editForm.get(fieldName).setValue('', {
                onlyself: true
            });
        }
        else {
            console.log(e.target);
            var convertDate = new Date(e.target.value);
            this.editForm.get(fieldName).setValue(convertDate, {
                onlyself: true
            });
        }
    }
};
OverrideRuleEditFormComponent.ctorParameters = () => [
    { type: _angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormBuilder"] },
    { type: _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__["NgbActiveModal"] },
    { type: _shared_services_overrideRule_service__WEBPACK_IMPORTED_MODULE_4__["OverrideRuleService"] },
    { type: _services_ageRange_service__WEBPACK_IMPORTED_MODULE_6__["AgeRangeService"] },
    { type: _services_storelocation_service__WEBPACK_IMPORTED_MODULE_7__["StoreLocationService"] },
    { type: _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__["MatSnackBar"] },
    { type: _angular_common__WEBPACK_IMPORTED_MODULE_10__["DatePipe"] },
    { type: _services_campaignType_service__WEBPACK_IMPORTED_MODULE_8__["CampaignTypeService"] }
];
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Object)
], OverrideRuleEditFormComponent.prototype, "title", void 0);
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", _shared_models_overrideRule__WEBPACK_IMPORTED_MODULE_3__["OverrideRule"])
], OverrideRuleEditFormComponent.prototype, "overrideRule", void 0);
OverrideRuleEditFormComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-override-rule-edit-form',
        template: __importDefault(__webpack_require__(/*! raw-loader!./override-rule-edit.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/modals/override-rule-edit-modal/override-rule-edit.component.html")).default
    }),
    __metadata("design:paramtypes", [_angular_forms__WEBPACK_IMPORTED_MODULE_1__["FormBuilder"],
        _ng_bootstrap_ng_bootstrap__WEBPACK_IMPORTED_MODULE_2__["NgbActiveModal"],
        _shared_services_overrideRule_service__WEBPACK_IMPORTED_MODULE_4__["OverrideRuleService"],
        _services_ageRange_service__WEBPACK_IMPORTED_MODULE_6__["AgeRangeService"],
        _services_storelocation_service__WEBPACK_IMPORTED_MODULE_7__["StoreLocationService"],
        _angular_material_snack_bar__WEBPACK_IMPORTED_MODULE_5__["MatSnackBar"],
        _angular_common__WEBPACK_IMPORTED_MODULE_10__["DatePipe"],
        _services_campaignType_service__WEBPACK_IMPORTED_MODULE_8__["CampaignTypeService"]])
], OverrideRuleEditFormComponent);



/***/ }),

/***/ "./src/app/shared/components/spinner/spinner.component.scss":
/*!******************************************************************!*\
  !*** ./src/app/shared/components/spinner/spinner.component.scss ***!
  \******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".spinner-container {\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  overflow: hidden;\n  z-index: 999999;\n  background-color: white; }\n\n.spinner {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  height: 30px;\n  width: 30px;\n  margin: 0px auto;\n  -webkit-animation: rotation .6s infinite linear;\n  animation: rotation .6s infinite linear;\n  border-left: 4px solid rgba(3, 102, 214, 0.15);\n  border-right: 4px solid rgba(3, 102, 214, 0.15);\n  border-bottom: 4px solid rgba(3, 102, 214, 0.15);\n  border-top: 4px solid rgba(3, 102, 214, 0.8);\n  border-radius: 100%;\n  margin-left: -15px;\n  margin-top: -15px; }\n\n.spinner-message {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  height: 30px;\n  width: 100px;\n  margin: 0px auto;\n  border-radius: 100%;\n  margin-left: -50px;\n  margin-top: 20px;\n  text-align: center; }\n\n@-webkit-keyframes rotation {\n  from {\n    -webkit-transform: rotate(0deg); }\n  to {\n    -webkit-transform: rotate(359deg); } }\n\n@keyframes rotation {\n  from {\n    transform: rotate(0deg); }\n  to {\n    transform: rotate(359deg); } }\n\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/shared/components/spinner/spinner.component.ts":
/*!****************************************************************!*\
  !*** ./src/app/shared/components/spinner/spinner.component.ts ***!
  \****************************************************************/
/*! exports provided: SpinnerComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SpinnerComponent", function() { return SpinnerComponent; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};

let SpinnerComponent = class SpinnerComponent {
};
__decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Input"])(),
    __metadata("design:type", Object)
], SpinnerComponent.prototype, "message", void 0);
SpinnerComponent = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Component"])({
        selector: 'app-spinner',
        template: __importDefault(__webpack_require__(/*! raw-loader!./spinner.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/components/spinner/spinner.component.html")).default,
        styles: [__importDefault(__webpack_require__(/*! ./spinner.component.scss */ "./src/app/shared/components/spinner/spinner.component.scss")).default]
    })
], SpinnerComponent);



/***/ }),

/***/ "./src/app/shared/components/spinner/spinner.service.ts":
/*!**************************************************************!*\
  !*** ./src/app/shared/components/spinner/spinner.service.ts ***!
  \**************************************************************/
/*! exports provided: SpinnerService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SpinnerService", function() { return SpinnerService; });
/* harmony import */ var _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/cdk/overlay */ "./node_modules/@angular/cdk/esm2015/overlay.js");
/* harmony import */ var _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/cdk/portal */ "./node_modules/@angular/cdk/esm2015/portal.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _spinner_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./spinner.component */ "./src/app/shared/components/spinner/spinner.component.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};




let SpinnerService = class SpinnerService {
    constructor(overlay) {
        this.overlay = overlay;
        this.overlayRef = null;
    }
    show(message = '') {
        // Returns an OverlayRef (which is a PortalHost)
        if (!this.overlayRef) {
            this.overlayRef = this.overlay.create();
        }
        // Create ComponentPortal that can be attached to a PortalHost
        const spinner = new _angular_cdk_portal__WEBPACK_IMPORTED_MODULE_1__["ComponentPortal"](_spinner_component__WEBPACK_IMPORTED_MODULE_3__["SpinnerComponent"]);
        // run in async context for triggering "tick", thus avoid ExpressionChangedAfterItHasBeenCheckedError
        setTimeout(() => {
            if (this.overlayRef.hasAttached()) {
                this.overlayRef.detach();
            }
            const component = this.overlayRef.attach(spinner); // Attach ComponentPortal to PortalHost
            // TODO: set message
            component.instance.message = message;
        });
    }
    hide() {
        if (!!this.overlayRef) {
            this.overlayRef.detach();
        }
    }
};
SpinnerService.ctorParameters = () => [
    { type: _angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_0__["Overlay"] }
];
SpinnerService = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["Injectable"])({
        providedIn: 'root'
    }),
    __metadata("design:paramtypes", [_angular_cdk_overlay__WEBPACK_IMPORTED_MODULE_0__["Overlay"]])
], SpinnerService);



/***/ }),

/***/ "./src/app/shared/models/BrandSeed.ts":
/*!********************************************!*\
  !*** ./src/app/shared/models/BrandSeed.ts ***!
  \********************************************/
/*! exports provided: BrandSeed */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BrandSeed", function() { return BrandSeed; });
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
class BrandSeed {
}


/***/ }),

/***/ "./src/app/shared/models/Note.ts":
/*!***************************************!*\
  !*** ./src/app/shared/models/Note.ts ***!
  \***************************************/
/*! exports provided: Note */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Note", function() { return Note; });
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
class Note {
}


/***/ }),

/***/ "./src/app/shared/models/brandMonthConversion.ts":
/*!*******************************************************!*\
  !*** ./src/app/shared/models/brandMonthConversion.ts ***!
  \*******************************************************/
/*! exports provided: BrandMonthConversion */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BrandMonthConversion", function() { return BrandMonthConversion; });
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
class BrandMonthConversion {
}


/***/ }),

/***/ "./src/app/shared/models/creativeTemplate.ts":
/*!***************************************************!*\
  !*** ./src/app/shared/models/creativeTemplate.ts ***!
  \***************************************************/
/*! exports provided: CreativeTemplate */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CreativeTemplate", function() { return CreativeTemplate; });
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
class CreativeTemplate {
}


/***/ }),

/***/ "./src/app/shared/models/mailingRecord.ts":
/*!************************************************!*\
  !*** ./src/app/shared/models/mailingRecord.ts ***!
  \************************************************/
/*! exports provided: MailingRecord */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MailingRecord", function() { return MailingRecord; });
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
class MailingRecord {
}


/***/ }),

/***/ "./src/app/shared/models/operators.ts":
/*!********************************************!*\
  !*** ./src/app/shared/models/operators.ts ***!
  \********************************************/
/*! exports provided: Operator, OPERATORS */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Operator", function() { return Operator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OPERATORS", function() { return OPERATORS; });
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
class Operator {
}
const OPERATORS = [
    { name: 'is equal to', value: '==' },
    { name: 'is not equal to', value: '!=' },
];


/***/ }),

/***/ "./src/app/shared/models/overrideRule.ts":
/*!***********************************************!*\
  !*** ./src/app/shared/models/overrideRule.ts ***!
  \***********************************************/
/*! exports provided: OverrideRule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OverrideRule", function() { return OverrideRule; });
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
class OverrideRule {
    constructor() {
        this.fields = [];
    }
}


/***/ }),

/***/ "./src/app/shared/models/queryBuilder.ts":
/*!***********************************************!*\
  !*** ./src/app/shared/models/queryBuilder.ts ***!
  \***********************************************/
/*! exports provided: QueryBuilder */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QueryBuilder", function() { return QueryBuilder; });
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
class QueryBuilder {
    constructor() {
        this.rules = [];
    }
}


/***/ }),

/***/ "./src/app/shared/models/queryBuilderUpdate.ts":
/*!*****************************************************!*\
  !*** ./src/app/shared/models/queryBuilderUpdate.ts ***!
  \*****************************************************/
/*! exports provided: QueryBuilderUpdate */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QueryBuilderUpdate", function() { return QueryBuilderUpdate; });
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
class QueryBuilderUpdate {
    constructor() {
        this.ids = [];
    }
}


/***/ }),

/***/ "./src/app/shared/models/rule.ts":
/*!***************************************!*\
  !*** ./src/app/shared/models/rule.ts ***!
  \***************************************/
/*! exports provided: Rule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Rule", function() { return Rule; });
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
class Rule {
    constructor() {
        this.values = [];
    }
}


/***/ }),

/***/ "./src/app/shared/models/state.ts":
/*!****************************************!*\
  !*** ./src/app/shared/models/state.ts ***!
  \****************************************/
/*! exports provided: State, STATES */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "State", function() { return State; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STATES", function() { return STATES; });
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
class State {
}
const STATES = [
    { name: 'Alabama', abbreviation: 'AL' },
    { name: 'Alaska', abbreviation: 'AK' },
    { name: 'Arizona', abbreviation: 'AZ' },
    { name: 'Arkansas', abbreviation: 'AR' },
    { name: 'California', abbreviation: 'CA' },
    { name: 'Colorado', abbreviation: 'CO' },
    { name: 'Connecticut', abbreviation: 'CT' },
    { name: 'Delaware', abbreviation: 'DE' },
    { name: 'Florida', abbreviation: 'FL' },
    { name: 'Georgia', abbreviation: 'GA' },
    { name: 'Hawaii', abbreviation: 'HI' },
    { name: 'Idaho', abbreviation: 'ID' },
    { name: 'Illinois', abbreviation: 'IL' },
    { name: 'Indiana', abbreviation: 'IN' },
    { name: 'Iowa', abbreviation: 'IA' },
    { name: 'Kansas', abbreviation: 'KS' },
    { name: 'Kentucky', abbreviation: 'KY' },
    { name: 'Louisiana', abbreviation: 'LA' },
    { name: 'Maine', abbreviation: 'ME' },
    { name: 'Maryland', abbreviation: 'MD' },
    { name: 'Massachusetts', abbreviation: 'MA' },
    { name: 'Michigan', abbreviation: 'MI' },
    { name: 'Minnesota', abbreviation: 'MN' },
    { name: 'Mississippi', abbreviation: 'MS' },
    { name: 'Missouri', abbreviation: 'MO' },
    { name: 'Montana', abbreviation: 'MT' },
    { name: 'Nebraska', abbreviation: 'NE' },
    { name: 'Nevada', abbreviation: 'NV' },
    { name: 'New Hampshire', abbreviation: 'NH' },
    { name: 'New Jersey', abbreviation: 'NJ' },
    { name: 'New Mexico', abbreviation: 'NM' },
    { name: 'New York', abbreviation: 'NY' },
    { name: 'North Carolina', abbreviation: 'NC' },
    { name: 'North Dakota', abbreviation: 'ND' },
    { name: 'Ohio', abbreviation: 'OH' },
    { name: 'Oklahoma', abbreviation: 'OK' },
    { name: 'Oregon', abbreviation: 'OR' },
    { name: 'Pennsylvania', abbreviation: 'PA' },
    { name: 'Rhode Island', abbreviation: 'RI' },
    { name: 'South Carolina', abbreviation: 'SC' },
    { name: 'South Dakota', abbreviation: 'SD' },
    { name: 'Tennessee', abbreviation: 'TN' },
    { name: 'Texas', abbreviation: 'TX' },
    { name: 'Utah', abbreviation: 'UT' },
    { name: 'Vermont', abbreviation: 'VT' },
    { name: 'Virginia', abbreviation: 'VA' },
    { name: 'Washington', abbreviation: 'WA' },
    { name: 'West Virginia', abbreviation: 'WV' },
    { name: 'Wisconsin', abbreviation: 'WI' },
    { name: 'Wyoming', abbreviation: 'WY' },
    { name: 'Oregon', abbreviation: 'OR' }
];


/***/ }),

/***/ "./src/app/shared/models/storeLocation.ts":
/*!************************************************!*\
  !*** ./src/app/shared/models/storeLocation.ts ***!
  \************************************************/
/*! exports provided: StoreLocation */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StoreLocation", function() { return StoreLocation; });
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
class StoreLocation {
}


/***/ }),

/***/ "./src/app/shared/models/storeLocationOverride.ts":
/*!********************************************************!*\
  !*** ./src/app/shared/models/storeLocationOverride.ts ***!
  \********************************************************/
/*! exports provided: StoreLocationOverride */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StoreLocationOverride", function() { return StoreLocationOverride; });
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
class StoreLocationOverride {
}


/***/ }),

/***/ "./src/app/shared/pipes/excludeDuplicates.pipe.ts":
/*!********************************************************!*\
  !*** ./src/app/shared/pipes/excludeDuplicates.pipe.ts ***!
  \********************************************************/
/*! exports provided: ExcludeDuplicatesPipe */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExcludeDuplicatesPipe", function() { return ExcludeDuplicatesPipe; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};

let ExcludeDuplicatesPipe = class ExcludeDuplicatesPipe {
    transform(items, excludeItems) {
        if (!items)
            return [];
        if (excludeItems.length <= 1) {
            return items;
        }
        // parse controls into string array
        let excludeStrings = excludeItems.controls.map(x => {
            return x.value["name"].toLowerCase();
        });
        // now exclude those from the list
        items = items.filter(it => {
            return !excludeStrings.includes(it.toLowerCase());
        });
        return items;
    }
};
ExcludeDuplicatesPipe = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Pipe"])({ name: 'excludeDuplicates' })
], ExcludeDuplicatesPipe);



/***/ }),

/***/ "./src/app/shared/pipes/filter.pipe.ts":
/*!*********************************************!*\
  !*** ./src/app/shared/pipes/filter.pipe.ts ***!
  \*********************************************/
/*! exports provided: FilterPipe */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FilterPipe", function() { return FilterPipe; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};

let FilterPipe = class FilterPipe {
    transform(items, searchText) {
        if (!items)
            return [];
        if (!searchText)
            return items;
        searchText = searchText.toLowerCase();
        return items.filter(it => {
            return it.name.toLowerCase().includes(searchText);
        });
    }
};
FilterPipe = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Pipe"])({ name: 'filter' })
], FilterPipe);



/***/ }),

/***/ "./src/app/shared/pipes/filterMonthsByCampaign.pipe.ts":
/*!*************************************************************!*\
  !*** ./src/app/shared/pipes/filterMonthsByCampaign.pipe.ts ***!
  \*************************************************************/
/*! exports provided: FilterMonthsByCampaignPipe */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FilterMonthsByCampaignPipe", function() { return FilterMonthsByCampaignPipe; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};

let FilterMonthsByCampaignPipe = class FilterMonthsByCampaignPipe {
    transform(items, campaignTypeId) {
        if (!items)
            return [];
        console.log(campaignTypeId);
        if (!campaignTypeId)
            return items;
        return items.filter(it => {
            return it.campaignTypeId === campaignTypeId;
        });
    }
};
FilterMonthsByCampaignPipe = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Pipe"])({ name: 'filterMonthsByCampaign' })
], FilterMonthsByCampaignPipe);



/***/ }),

/***/ "./src/app/shared/pipes/truncateString.pipe.ts":
/*!*****************************************************!*\
  !*** ./src/app/shared/pipes/truncateString.pipe.ts ***!
  \*****************************************************/
/*! exports provided: TruncateStringPipe */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TruncateStringPipe", function() { return TruncateStringPipe; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};

let TruncateStringPipe = class TruncateStringPipe {
    transform(value, maxLengthAllowed) {
        if (value.length > maxLengthAllowed) {
            return value.slice(0, maxLengthAllowed) + '...';
        }
        return value;
    }
};
TruncateStringPipe = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Pipe"])({ name: 'truncateString' })
], TruncateStringPipe);



/***/ }),

/***/ "./src/app/shared/pipes/yesno.pipe.ts":
/*!********************************************!*\
  !*** ./src/app/shared/pipes/yesno.pipe.ts ***!
  \********************************************/
/*! exports provided: YesNoPipe */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "YesNoPipe", function() { return YesNoPipe; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};

let YesNoPipe = class YesNoPipe {
    transform(value) {
        return value ? 'Yes' : 'No';
    }
};
YesNoPipe = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Pipe"])({ name: 'yesNo' })
], YesNoPipe);



/***/ }),

/***/ "./src/app/shared/services/ageRange.service.ts":
/*!*****************************************************!*\
  !*** ./src/app/shared/services/ageRange.service.ts ***!
  \*****************************************************/
/*! exports provided: AgeRangeService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AgeRangeService", function() { return AgeRangeService; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _message_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./message.service */ "./src/app/shared/services/message.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};





let AgeRangeService = class AgeRangeService {
    constructor(http, messageService, baseUrl) {
        this.http = http;
        this.messageService = messageService;
        this._ENDPOINT = '';
        this.httpOptions = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpHeaders"]({ 'Content-Type': 'application/json' })
        };
        this._ENDPOINT = baseUrl + 'api/ageranges';
    }
    getAll() {
        return this.http.get(this._ENDPOINT + '');
    }
    getById(id) {
        const url = this._ENDPOINT + '/' + id;
        return this.http.get(url);
    }
    /** POST: add a new ageRange to the server */
    add(ageRange) {
        return this.http.post(this._ENDPOINT, ageRange, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])((newAgeRange) => this.log('added ageRange w/ id=${newAgeRange.id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('add')));
    }
    /** DELETE: delete the ageRange from the server */
    delete(id) {
        const url = this._ENDPOINT + '/' + id;
        return this.http.delete(url, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(_ => this.log('deleted ageRange id=${id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('delete')));
    }
    /** PUT: update the ageRange on the server */
    update(id, ageRange) {
        return this.http.put(this._ENDPOINT + "/" + id, ageRange, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(_ => this.log('updated ageRange id=${ageRange.Id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('update')));
    }
    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    handleError(operation = 'operation', result) {
        return (error) => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead
            // TODO: better job of transforming error for user consumption
            this.log('${operation} failed: ${error.message}');
            // Let the app keep running by returning an empty result.
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(result);
        };
    }
    /** Log a AgeRangeService message with the MessageService */
    log(message) {
        this.messageService.add('AgeRangeService: ${message}');
    }
};
AgeRangeService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"] },
    { type: _message_service__WEBPACK_IMPORTED_MODULE_4__["MessageService"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: ['BASE_URL',] }] }
];
AgeRangeService = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"])({ providedIn: 'root' }),
    __param(2, Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"])('BASE_URL')),
    __metadata("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"],
        _message_service__WEBPACK_IMPORTED_MODULE_4__["MessageService"], Object])
], AgeRangeService);



/***/ }),

/***/ "./src/app/shared/services/brand.service.ts":
/*!**************************************************!*\
  !*** ./src/app/shared/services/brand.service.ts ***!
  \**************************************************/
/*! exports provided: BrandService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BrandService", function() { return BrandService; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _message_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./message.service */ "./src/app/shared/services/message.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};





let BrandService = class BrandService {
    constructor(http, messageService, baseUrl) {
        this.http = http;
        this.messageService = messageService;
        this._ENDPOINT = '';
        this.httpOptions = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpHeaders"]({ 'Content-Type': 'application/json' })
        };
        this._ENDPOINT = baseUrl + 'api/brands';
    }
    getAll() {
        return this.http.get(this._ENDPOINT + '');
    }
    getActiveBrands() {
        return this.http.get(this._ENDPOINT + '?isActive=true');
    }
    getInactiveBrands() {
        return this.http.get(this._ENDPOINT + '?isActive=false');
    }
    getMostRecent() {
        return this.http.get(this._ENDPOINT + '?isActive=true&total=5');
    }
    getAllMaster() {
        return this.http.get(this._ENDPOINT + '?isActive=true&brandId=0');
    }
    getChildren(id) {
        return this.http.get(this._ENDPOINT + `?isActive=true&brandId=${id}`);
    }
    getById(id) {
        const url = this._ENDPOINT + '/' + id;
        return this.http.get(url);
    }
    /** POST: add a new brand to the server */
    add(brand) {
        return this.http.post(this._ENDPOINT, brand, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])((newBrand) => this.log('added brand w/ id=${newBrand.id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('add')));
    }
    /** DELETE: delete the brand from the server */
    delete(brand) {
        const id = typeof brand === 'number' ? brand : brand.id;
        const url = this._ENDPOINT + '/' + id;
        return this.http.delete(url, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(_ => this.log('deleted brand id=${id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('delete')));
    }
    /** PUT: update the brand on the server */
    update(id, brand) {
        return this.http.put(this._ENDPOINT + "/" + id, brand, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(_ => this.log('updated brand id=${brand.Id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('update')));
    }
    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    handleError(operation = 'operation', result) {
        return (error) => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead
            // TODO: better job of transforming error for user consumption
            this.log('${operation} failed: ${error.message}');
            // Let the app keep running by returning an empty result.
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(result);
        };
    }
    /** Log a BrandService message with the MessageService */
    log(message) {
        this.messageService.add('BrandService: ${message}');
    }
};
BrandService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"] },
    { type: _message_service__WEBPACK_IMPORTED_MODULE_4__["MessageService"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: ['BASE_URL',] }] }
];
BrandService = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"])({ providedIn: 'root' }),
    __param(2, Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"])('BASE_URL')),
    __metadata("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"],
        _message_service__WEBPACK_IMPORTED_MODULE_4__["MessageService"], Object])
], BrandService);



/***/ }),

/***/ "./src/app/shared/services/brandMonthConversion.service.ts":
/*!*****************************************************************!*\
  !*** ./src/app/shared/services/brandMonthConversion.service.ts ***!
  \*****************************************************************/
/*! exports provided: BrandMonthConversionService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BrandMonthConversionService", function() { return BrandMonthConversionService; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _message_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./message.service */ "./src/app/shared/services/message.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};





let BrandMonthConversionService = class BrandMonthConversionService {
    constructor(http, messageService, baseUrl) {
        this.http = http;
        this.messageService = messageService;
        this._ENDPOINT = '';
        this.httpOptions = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpHeaders"]({ 'Content-Type': 'application/json' })
        };
        this._ENDPOINT = baseUrl + 'api/brandMonthConversions';
    }
    getAll(id) {
        const url = this._ENDPOINT + '/?brandId=' + id;
        return this.http.get(url);
    }
    getById(id) {
        const url = this._ENDPOINT + '/' + id;
        return this.http.get(url);
    }
    /** POST: add a new brandMonthConversion to the server */
    add(brandMonthConversion) {
        return this.http.post(this._ENDPOINT, brandMonthConversion, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])((newBrandMonthConversion) => this.log('added month conversion w/ id=${newBrandMonthConversion.id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('add')));
    }
    /** DELETE: delete the brandMonthConversion from the server */
    delete(id) {
        const url = this._ENDPOINT + '/' + id;
        return this.http.delete(url, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(_ => this.log('deleted brandMonthConversion id=${id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('deleteBrandMonthConversion')));
    }
    /** PUT: update the brandMonthConversion on the server */
    update(id, brandMonthConversion) {
        return this.http.put(this._ENDPOINT + "/" + id, brandMonthConversion, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(_ => this.log('updated brandMonthConversion id=${brandMonthConversion.Id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('updateBrandMonthConversion')));
    }
    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    handleError(operation = 'operation', result) {
        return (error) => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead
            // TODO: better job of transforming error for user consumption
            this.log(`${operation} failed: ${error.message}`);
            // Let the app keep running by returning an empty result.
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(result);
        };
    }
    /** Log a BrandMonthConversionService message with the MessageService */
    log(message) {
        this.messageService.add(`BrandMonthConversionService: ${message}`);
    }
};
BrandMonthConversionService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"] },
    { type: _message_service__WEBPACK_IMPORTED_MODULE_4__["MessageService"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: ['BASE_URL',] }] }
];
BrandMonthConversionService = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"])({ providedIn: 'root' }),
    __param(2, Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"])('BASE_URL')),
    __metadata("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"],
        _message_service__WEBPACK_IMPORTED_MODULE_4__["MessageService"], Object])
], BrandMonthConversionService);



/***/ }),

/***/ "./src/app/shared/services/brandSeed.service.ts":
/*!******************************************************!*\
  !*** ./src/app/shared/services/brandSeed.service.ts ***!
  \******************************************************/
/*! exports provided: BrandSeedService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BrandSeedService", function() { return BrandSeedService; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _message_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./message.service */ "./src/app/shared/services/message.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};





let BrandSeedService = class BrandSeedService {
    constructor(http, messageService, baseUrl) {
        this.http = http;
        this.messageService = messageService;
        this._ENDPOINT = '';
        this.httpOptions = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpHeaders"]({ 'Content-Type': 'application/json' })
        };
        this._ENDPOINT = baseUrl + 'api/brandSeeds';
    }
    getAll(brandId) {
        return this.http.get(this._ENDPOINT + '?brandId=' + brandId);
    }
    getById(id) {
        const url = this._ENDPOINT + '/' + id;
        return this.http.get(url);
    }
    /** POST: add a new brandSeed to the server */
    add(brandSeed) {
        return this.http.post(this._ENDPOINT, brandSeed, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])((newBrandSeed) => this.log('added brandSeed w/ id=${newBrandSeed.id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('add')));
    }
    /** DELETE: delete the brandSeed from the server */
    delete(brandSeed) {
        const id = typeof brandSeed === 'number' ? brandSeed : brandSeed.id;
        const url = this._ENDPOINT + '/' + id;
        return this.http.delete(url, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(_ => this.log('deleted brandSeed id=${id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('delete')));
    }
    /** PUT: update the brandSeed on the server */
    update(id, brandSeed) {
        return this.http.put(this._ENDPOINT + "/" + id, brandSeed, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(_ => this.log('updated brandSeed id=${brandSeed.Id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('update')));
    }
    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    handleError(operation = 'operation', result) {
        return (error) => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead
            // TODO: better job of transforming error for user consumption
            this.log('${operation} failed: ${error.message}');
            // Let the app keep running by returning an empty result.
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(result);
        };
    }
    /** Log a BrandSeedService message with the MessageService */
    log(message) {
        this.messageService.add('BrandSeedService: ${message}');
    }
};
BrandSeedService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"] },
    { type: _message_service__WEBPACK_IMPORTED_MODULE_4__["MessageService"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: ['BASE_URL',] }] }
];
BrandSeedService = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"])({ providedIn: 'root' }),
    __param(2, Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"])('BASE_URL')),
    __metadata("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"],
        _message_service__WEBPACK_IMPORTED_MODULE_4__["MessageService"], Object])
], BrandSeedService);



/***/ }),

/***/ "./src/app/shared/services/campaignType.service.ts":
/*!*********************************************************!*\
  !*** ./src/app/shared/services/campaignType.service.ts ***!
  \*********************************************************/
/*! exports provided: CampaignTypeService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CampaignTypeService", function() { return CampaignTypeService; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _message_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./message.service */ "./src/app/shared/services/message.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};





let CampaignTypeService = class CampaignTypeService {
    constructor(http, messageService, baseUrl) {
        this.http = http;
        this.messageService = messageService;
        this._ENDPOINT = '';
        this.httpOptions = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpHeaders"]({ 'Content-Type': 'application/json' })
        };
        this._ENDPOINT = baseUrl + 'api/campaigntypes';
    }
    getAll() {
        return this.http.get(this._ENDPOINT);
    }
    getById(id) {
        const url = this._ENDPOINT + '/' + id;
        return this.http.get(url);
    }
    /** POST: add a new campaignType to the server */
    add(campaignType) {
        return this.http.post(this._ENDPOINT, campaignType, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])((newCampaignType) => this.log('added campaignType w/ id=${newCampaignType.id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('add')));
    }
    /** DELETE: delete the campaignType from the server */
    delete(campaignType) {
        const id = typeof campaignType === 'number' ? campaignType : campaignType.id;
        const url = this._ENDPOINT + '/' + id;
        return this.http.delete(url, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(_ => this.log('deleted campaignType id=${id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('delete')));
    }
    /** PUT: update the campaignType on the server */
    update(id, campaignType) {
        return this.http.put(this._ENDPOINT + "/" + id, campaignType, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(_ => this.log('updated campaignType id=${campaignType.Id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('update')));
    }
    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    handleError(operation = 'operation', result) {
        return (error) => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead
            // TODO: better job of transforming error for user consumption
            this.log('${operation} failed: ${error.message}');
            // Let the app keep running by returning an empty result.
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(result);
        };
    }
    /** Log a CampaignTypeService message with the MessageService */
    log(message) {
        this.messageService.add('CampaignTypeService: ${message}');
    }
};
CampaignTypeService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"] },
    { type: _message_service__WEBPACK_IMPORTED_MODULE_4__["MessageService"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: ['BASE_URL',] }] }
];
CampaignTypeService = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"])({ providedIn: 'root' }),
    __param(2, Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"])('BASE_URL')),
    __metadata("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"],
        _message_service__WEBPACK_IMPORTED_MODULE_4__["MessageService"], Object])
], CampaignTypeService);



/***/ }),

/***/ "./src/app/shared/services/creativeTemplate.service.ts":
/*!*************************************************************!*\
  !*** ./src/app/shared/services/creativeTemplate.service.ts ***!
  \*************************************************************/
/*! exports provided: CreativeTemplateService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CreativeTemplateService", function() { return CreativeTemplateService; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _message_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./message.service */ "./src/app/shared/services/message.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};





let CreativeTemplateService = class CreativeTemplateService {
    constructor(http, messageService, baseUrl) {
        this.http = http;
        this.messageService = messageService;
        this._ENDPOINT = '';
        this.httpOptions = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpHeaders"]({ 'Content-Type': 'application/json' })
        };
        this._ENDPOINT = baseUrl + 'api/creativeTemplates';
    }
    getAll(brandId) {
        return this.http.get(this._ENDPOINT + '?brandId=' + brandId);
    }
    getQuery(query) {
        return this.http.post(this._ENDPOINT + "/GetQuery", query, this.httpOptions);
    }
    getById(id) {
        const url = this._ENDPOINT + '/' + id;
        return this.http.get(url);
    }
    /** POST: add a new creativeTemplate to the server */
    add(creativeTemplate) {
        return this.http.post(this._ENDPOINT, creativeTemplate, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])((newCreativeTemplate) => this.log('added creativeTemplate w/ id=${newCreativeTemplate.id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('add')));
    }
    /** POST: update the creativeTemplate on the server */
    addBulk(id, creativeTemplates) {
        return this.http.post(this._ENDPOINT + "/" + id, creativeTemplates, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('addBulk')));
    }
    /** DELETE: delete the creativeTemplate from the server */
    delete(id) {
        const url = this._ENDPOINT + '/' + id;
        return this.http.delete(url, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(_ => this.log('deleted creativeTemplate id=${id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('delete')));
    }
    /** DELETE: delete the creativeTemplate from the server */
    deleteAll(id) {
        const url = this._ENDPOINT + '/deleteAll/' + id;
        return this.http.delete(url, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(_ => this.log('deleted creativeTemplate id=${id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('delete')));
    }
    /** PUT: update the creativeTemplate on the server */
    update(id, creativeTemplate) {
        return this.http.put(this._ENDPOINT + "/" + id, creativeTemplate, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(_ => this.log('updated creativeTemplate id=${creativeTemplate.Id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('update')));
    }
    /** PUT: update the creativeTemplate on the server */
    updateBulk(updateModel) {
        return this.http.put(this._ENDPOINT + "/updateBulk", updateModel, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('updateBulk')));
    }
    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    handleError(operation = 'operation', result) {
        return (error) => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead
            // TODO: better job of transforming error for user consumption
            this.log('${operation} failed: ${error.message}');
            // Let the app keep running by returning an empty result.
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(result);
        };
    }
    /** Log a CreativeTemplateService message with the MessageService */
    log(message) {
        this.messageService.add('CreativeTemplateService: ${message}');
    }
};
CreativeTemplateService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"] },
    { type: _message_service__WEBPACK_IMPORTED_MODULE_4__["MessageService"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: ['BASE_URL',] }] }
];
CreativeTemplateService = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"])({ providedIn: 'root' }),
    __param(2, Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"])('BASE_URL')),
    __metadata("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"],
        _message_service__WEBPACK_IMPORTED_MODULE_4__["MessageService"], Object])
], CreativeTemplateService);



/***/ }),

/***/ "./src/app/shared/services/file.service.ts":
/*!*************************************************!*\
  !*** ./src/app/shared/services/file.service.ts ***!
  \*************************************************/
/*! exports provided: FileService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FileService", function() { return FileService; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};

let FileService = class FileService {
    downloadFile(data, fields, filename = 'data') {
        let csvData = this.convertToCSV(data, fields);
        let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
        let dwldLink = document.createElement("a");
        let url = URL.createObjectURL(blob);
        let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
        if (isSafariBrowser) { //if Safari open in new window to save file with random filename.
            dwldLink.setAttribute("target", "_blank");
        }
        dwldLink.setAttribute("href", url);
        dwldLink.setAttribute("download", filename + ".csv");
        dwldLink.style.visibility = "hidden";
        document.body.appendChild(dwldLink);
        dwldLink.click();
        document.body.removeChild(dwldLink);
    }
    capitalizeFirst(s) {
        if (typeof s !== 'string')
            return '';
        if (s.length === 2) {
            return s.toUpperCase();
        }
        return s.charAt(0).toUpperCase() + s.slice(1);
    }
    convertToCSV(objArray, headerList) {
        let array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
        let str = '';
        let row = '';
        for (let index in headerList) {
            row += this.capitalizeFirst(headerList[index]) + ',';
        }
        str += row + '\r\n';
        for (let i = 0; i < array.length; i++) {
            let line = '';
            for (let index in headerList) {
                let head = headerList[index];
                if (array[i][head] !== null)
                    line += '"' + array[i][head] + '"' + ',';
                else {
                    line += '"",';
                }
            }
            str += line + '\r\n';
        }
        return str;
    }
};
FileService = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"])({ providedIn: 'root' })
], FileService);



/***/ }),

/***/ "./src/app/shared/services/mailing.service.ts":
/*!****************************************************!*\
  !*** ./src/app/shared/services/mailing.service.ts ***!
  \****************************************************/
/*! exports provided: MailingService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MailingService", function() { return MailingService; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _message_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./message.service */ "./src/app/shared/services/message.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};





let MailingService = class MailingService {
    constructor(http, messageService, baseUrl) {
        this.http = http;
        this.messageService = messageService;
        this._ENDPOINT = '';
        this._PROCESSRECALLENDPOINT = '';
        this.httpOptions = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpHeaders"]({ 'Content-Type': 'application/json' })
        };
        this._ENDPOINT = baseUrl + 'api/mailings';
        this._PROCESSRECALLENDPOINT = baseUrl + 'api/processrecall';
    }
    getAll(filter) {
        return this.http.get(this._ENDPOINT + '?dateFilter=' + filter);
    }
    getMostRecent() {
        let filterValue = new Date();
        filterValue.setMonth(filterValue.getMonth() - 12);
        return this.http.get(this._ENDPOINT + '?dateFilter=' + filterValue.toDateString() + '&total=5');
    }
    getById(id) {
        const url = this._ENDPOINT + '/' + id;
        return this.http.get(url);
    }
    /** POST: add a new campaign to the server */
    add(campaign) {
        return this.http.post(this._ENDPOINT, campaign, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])((newMailing) => this.log('added campaign w/ id=${newMailing.id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('add')));
    }
    /** DELETE: delete the campaign from the server */
    delete(id) {
        const url = this._ENDPOINT + '/' + id;
        return this.http.delete(url, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(_ => this.log('deleted campaign id=${id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('delete')));
    }
    /** PUT: update the campaign on the server */
    update(id, campaign) {
        return this.http.put(this._ENDPOINT + "/" + id, campaign, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(_ => this.log('updated campaign id=${campaign.Id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('update')));
    }
    getProcessRecall(id) {
        return this.http.get(this._PROCESSRECALLENDPOINT + '/?id=' + id);
    }
    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    handleError(operation = 'operation', result) {
        return (error) => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead
            // TODO: better job of transforming error for user consumption
            this.log('${operation} failed: ${error.message}');
            // Let the app keep running by returning an empty result.
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(result);
        };
    }
    /** Log a MailingService message with the MessageService */
    log(message) {
        this.messageService.add('MailingService: ${message}');
    }
};
MailingService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"] },
    { type: _message_service__WEBPACK_IMPORTED_MODULE_4__["MessageService"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: ['BASE_URL',] }] }
];
MailingService = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"])({ providedIn: 'root' }),
    __param(2, Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"])('BASE_URL')),
    __metadata("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"],
        _message_service__WEBPACK_IMPORTED_MODULE_4__["MessageService"], Object])
], MailingService);



/***/ }),

/***/ "./src/app/shared/services/mailingFile.service.ts":
/*!********************************************************!*\
  !*** ./src/app/shared/services/mailingFile.service.ts ***!
  \********************************************************/
/*! exports provided: MailingFileService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MailingFileService", function() { return MailingFileService; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _message_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./message.service */ "./src/app/shared/services/message.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};





let MailingFileService = class MailingFileService {
    constructor(http, messageService, baseUrl) {
        this.http = http;
        this.messageService = messageService;
        this._ENDPOINT = '';
        this.httpOptions = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpHeaders"]({ 'Content-Type': 'application/json' })
        };
        this._ENDPOINT = baseUrl + 'api/mailingfiles';
    }
    getAll(id) {
        return this.http.get(this._ENDPOINT + '?mailingId=' + id);
    }
    getById(id) {
        const url = this._ENDPOINT + '/' + id;
        return this.http.get(url);
    }
    /** POST: add a new mailing to the server */
    add(mailingFile) {
        return this.http.post(this._ENDPOINT, mailingFile, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])((newMailingFile) => this.log('added mailing w/ id=${newMailingFile.id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('add')));
    }
    /** DELETE: delete the mailing from the server */
    delete(id) {
        const url = this._ENDPOINT + '/' + id;
        return this.http.delete(url, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(_ => this.log('deleted mailing file id=${id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('delete')));
    }
    /** PUT: update the mailing on the server */
    update(id, mailingFile) {
        return this.http.put(this._ENDPOINT + "/" + id, mailingFile, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(_ => this.log('updated mailing file id=${mailing.Id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('update')));
    }
    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    handleError(operation = 'operation', result) {
        return (error) => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead
            // TODO: better job of transforming error for user consumption
            this.log('${operation} failed: ${error.message}');
            // Let the app keep running by returning an empty result.
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(result);
        };
    }
    /** Log a MailingFileService message with the MessageService */
    log(message) {
        this.messageService.add('MailingFileService: ${message}');
    }
};
MailingFileService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"] },
    { type: _message_service__WEBPACK_IMPORTED_MODULE_4__["MessageService"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: ['BASE_URL',] }] }
];
MailingFileService = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"])({ providedIn: 'root' }),
    __param(2, Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"])('BASE_URL')),
    __metadata("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"],
        _message_service__WEBPACK_IMPORTED_MODULE_4__["MessageService"], Object])
], MailingFileService);



/***/ }),

/***/ "./src/app/shared/services/mailingRecord.service.ts":
/*!**********************************************************!*\
  !*** ./src/app/shared/services/mailingRecord.service.ts ***!
  \**********************************************************/
/*! exports provided: MailingRecordService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MailingRecordService", function() { return MailingRecordService; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _message_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./message.service */ "./src/app/shared/services/message.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};





let MailingRecordService = class MailingRecordService {
    constructor(http, messageService, baseUrl) {
        this.http = http;
        this.messageService = messageService;
        this._ENDPOINT = '';
        this.httpOptions = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpHeaders"]({ 'Content-Type': 'application/json' })
        };
        this._ENDPOINT = baseUrl + 'api/mailingRecords';
    }
    getAll(id) {
        return this.http.get(this._ENDPOINT + "/" + id);
    }
    getById(id) {
        const url = this._ENDPOINT + '/?id=' + id;
        return this.http.get(url);
    }
    /** POST: add a new mailingRecord to the server */
    add(mailingRecord) {
        return this.http.post(this._ENDPOINT, mailingRecord, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])((newMailingRecord) => this.log('added mailingRecord w/ id=${newMailingRecord.id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('add')));
    }
    /** POST: add a new mailingRecord to the server */
    addBulk(id, mailingRecords) {
        return this.http.post(this._ENDPOINT + "/" + id, mailingRecords, this.httpOptions).pipe(
        // tap((newMailingRecord: MailingRecord) => this.log('added mailingRecord w/ id=${newMailingRecord.id}')),
        Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('add')));
    }
    /** DELETE: delete the mailingRecord from the server */
    delete(mailingRecord) {
        const id = typeof mailingRecord === 'number' ? mailingRecord : mailingRecord.id;
        const url = this._ENDPOINT + '/' + id;
        return this.http.delete(url, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(_ => this.log('deleted mailingRecord id=${id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('delete')));
    }
    /** PUT: update the mailingRecord on the server */
    update(id, mailingRecord) {
        return this.http.put(this._ENDPOINT + "/" + id, mailingRecord, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(_ => this.log('updated mailingRecord id=${mailingRecord.Id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('update')));
    }
    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    handleError(operation = 'operation', result) {
        return (error) => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead
            // TODO: better job of transforming error for user consumption
            this.log(`${operation} failed: ${error.message}`);
            // Let the app keep running by returning an empty result.
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(result);
        };
    }
    /** Log a MailingRecordService message with the MessageService */
    log(message) {
        this.messageService.add('MailingRecordService: ${message}');
    }
};
MailingRecordService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"] },
    { type: _message_service__WEBPACK_IMPORTED_MODULE_4__["MessageService"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: ['BASE_URL',] }] }
];
MailingRecordService = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"])({ providedIn: 'root' }),
    __param(2, Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"])('BASE_URL')),
    __metadata("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"],
        _message_service__WEBPACK_IMPORTED_MODULE_4__["MessageService"], Object])
], MailingRecordService);



/***/ }),

/***/ "./src/app/shared/services/message.service.ts":
/*!****************************************************!*\
  !*** ./src/app/shared/services/message.service.ts ***!
  \****************************************************/
/*! exports provided: MessageService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MessageService", function() { return MessageService; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};

let MessageService = class MessageService {
    constructor() {
        this.messages = [];
    }
    add(message) {
        this.messages.push(message);
    }
    clear() {
        this.messages = [];
    }
};
MessageService = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"])({ providedIn: 'root' })
], MessageService);



/***/ }),

/***/ "./src/app/shared/services/note.service.ts":
/*!*************************************************!*\
  !*** ./src/app/shared/services/note.service.ts ***!
  \*************************************************/
/*! exports provided: NoteService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NoteService", function() { return NoteService; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _message_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./message.service */ "./src/app/shared/services/message.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};





let NoteService = class NoteService {
    constructor(http, messageService, baseUrl) {
        this.http = http;
        this.messageService = messageService;
        this._ENDPOINT = '';
        this.httpOptions = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpHeaders"]({ 'Content-Type': 'application/json' })
        };
        this._ENDPOINT = baseUrl + 'api/notes';
    }
    /** GETALL: get all records from the server */
    getAll(contentId, contentType, total) {
        return this.http.get(this._ENDPOINT + '?contentId=' + contentId + '&contentType=' + contentType + '&total=' + total);
    }
    /** GETBYID: get single record from the server */
    getById(id) {
        const url = this._ENDPOINT + '/' + id;
        return this.http.get(url);
    }
    /** POST: add a new note to the server */
    add(note) {
        return this.http.post(this._ENDPOINT, note, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])((newNote) => this.log('added note w/ id=${newNote.id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('add')));
    }
    /** DELETE: delete the note from the server */
    delete(note) {
        const id = typeof note === 'number' ? note : note.id;
        const url = this._ENDPOINT + '/' + id;
        return this.http.delete(url, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(_ => this.log('deleted note id=${id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('delete')));
    }
    /** PUT: update the note on the server */
    update(id, note) {
        return this.http.put(this._ENDPOINT + "/" + id, note, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(_ => this.log('updated note id=${note.Id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('update')));
    }
    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    handleError(operation = 'operation', result) {
        return (error) => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead
            // TODO: better job of transforming error for user consumption
            this.log('${operation} failed: ${error.message}');
            // Let the app keep running by returning an empty result.
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(result);
        };
    }
    /** Log a NoteService message with the MessageService */
    log(message) {
        this.messageService.add('NoteService: ${message}');
    }
};
NoteService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"] },
    { type: _message_service__WEBPACK_IMPORTED_MODULE_4__["MessageService"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: ['BASE_URL',] }] }
];
NoteService = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"])({ providedIn: 'root' }),
    __param(2, Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"])('BASE_URL')),
    __metadata("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"],
        _message_service__WEBPACK_IMPORTED_MODULE_4__["MessageService"], Object])
], NoteService);



/***/ }),

/***/ "./src/app/shared/services/overrideRule.service.ts":
/*!*********************************************************!*\
  !*** ./src/app/shared/services/overrideRule.service.ts ***!
  \*********************************************************/
/*! exports provided: OverrideRuleService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OverrideRuleService", function() { return OverrideRuleService; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _message_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./message.service */ "./src/app/shared/services/message.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};





let OverrideRuleService = class OverrideRuleService {
    constructor(http, messageService, baseUrl) {
        this.http = http;
        this.messageService = messageService;
        this._ENDPOINT = '';
        this.httpOptions = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpHeaders"]({ 'Content-Type': 'application/json' })
        };
        this._ENDPOINT = baseUrl + 'api/overrideRules';
    }
    getAll(brandId) {
        return this.http.get(this._ENDPOINT + '?brandId=' + brandId);
    }
    getById(id) {
        const url = this._ENDPOINT + '/' + id;
        return this.http.get(url);
    }
    /** POST: add a new overrideRule to the server */
    add(overrideRule) {
        return this.http.post(this._ENDPOINT, overrideRule, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])((newOverrideRule) => this.log('added overrideRule w/ id=${newOverrideRule.id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('add')));
    }
    /** DELETE: delete the overrideRule from the server */
    delete(id) {
        const url = this._ENDPOINT + '/' + id;
        return this.http.delete(url, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(_ => this.log('deleted overrideRule id=${id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('delete')));
    }
    /** PUT: update the overrideRule on the server */
    update(id, overrideRule) {
        console.log(overrideRule);
        return this.http.put(this._ENDPOINT + "/" + id, overrideRule, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(_ => this.log('updated overrideRule id=${overrideRule.Id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('update')));
    }
    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    handleError(operation = 'operation', result) {
        return (error) => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead
            // TODO: better job of transforming error for user consumption
            this.log('${operation} failed: ${error.message}');
            // Let the app keep running by returning an empty result.
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(result);
        };
    }
    /** Log a OverrideRuleService message with the MessageService */
    log(message) {
        this.messageService.add('OverrideRuleService: ${message}');
    }
};
OverrideRuleService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"] },
    { type: _message_service__WEBPACK_IMPORTED_MODULE_4__["MessageService"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: ['BASE_URL',] }] }
];
OverrideRuleService = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"])({ providedIn: 'root' }),
    __param(2, Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"])('BASE_URL')),
    __metadata("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"],
        _message_service__WEBPACK_IMPORTED_MODULE_4__["MessageService"], Object])
], OverrideRuleService);



/***/ }),

/***/ "./src/app/shared/services/report.service.ts":
/*!***************************************************!*\
  !*** ./src/app/shared/services/report.service.ts ***!
  \***************************************************/
/*! exports provided: ReportService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReportService", function() { return ReportService; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var _message_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./message.service */ "./src/app/shared/services/message.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};




let ReportService = class ReportService {
    constructor(http, messageService, baseUrl) {
        this.http = http;
        this.messageService = messageService;
        this._ENDPOINT = '';
        this.httpOptions = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpHeaders"]({ 'Content-Type': 'application/json' })
        };
        this._ENDPOINT = baseUrl + 'api/reports';
    }
    getMailingErrorReport(id) {
        return this.http.get(this._ENDPOINT + '/?id=' + id);
    }
    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    handleError(operation = 'operation', result) {
        return (error) => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead
            // TODO: better job of transforming error for user consumption
            this.log('${operation} failed: ${error.message}');
            // Let the app keep running by returning an empty result.
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(result);
        };
    }
    /** Log a MailingService message with the MessageService */
    log(message) {
        this.messageService.add('MailingService: ${message}');
    }
};
ReportService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"] },
    { type: _message_service__WEBPACK_IMPORTED_MODULE_3__["MessageService"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: ['BASE_URL',] }] }
];
ReportService = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"])({ providedIn: 'root' }),
    __param(2, Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"])('BASE_URL')),
    __metadata("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"],
        _message_service__WEBPACK_IMPORTED_MODULE_3__["MessageService"], Object])
], ReportService);



/***/ }),

/***/ "./src/app/shared/services/storelocation.service.ts":
/*!**********************************************************!*\
  !*** ./src/app/shared/services/storelocation.service.ts ***!
  \**********************************************************/
/*! exports provided: StoreLocationService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StoreLocationService", function() { return StoreLocationService; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _message_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./message.service */ "./src/app/shared/services/message.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};





let StoreLocationService = class StoreLocationService {
    constructor(http, messageService, baseUrl) {
        this.http = http;
        this.messageService = messageService;
        this._ENDPOINT = '';
        this.httpOptions = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpHeaders"]({ 'Content-Type': 'application/json' })
        };
        this._ENDPOINT = baseUrl + 'api/storeLocations';
    }
    getAll(id) {
        const url = this._ENDPOINT + '/?brandId=' + id;
        return this.http.get(url);
    }
    getById(id) {
        const url = this._ENDPOINT + '/' + id;
        return this.http.get(url);
    }
    /** POST: add a new storeLocation to the server */
    add(storeLocation) {
        return this.http.post(this._ENDPOINT, storeLocation, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])((newStoreLocation) => this.log('added store location w/ id=${newStoreLocation.id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('add')));
    }
    /** DELETE: delete the storeLocation from the server */
    delete(id) {
        const url = this._ENDPOINT + '/' + id;
        return this.http.delete(url, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(_ => this.log('deleted storeLocation id=${id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('deleteStoreLocation')));
    }
    /** PUT: update the storeLocation on the server */
    update(id, storeLocation) {
        return this.http.put(this._ENDPOINT + "/" + id, storeLocation, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(_ => this.log('updated storeLocation id=${storeLocation.Id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('updateStoreLocation')));
    }
    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    handleError(operation = 'operation', result) {
        return (error) => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead
            // TODO: better job of transforming error for user consumption
            this.log(`${operation} failed: ${error.message}`);
            // Let the app keep running by returning an empty result.
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(result);
        };
    }
    /** Log a StoreLocationService message with the MessageService */
    log(message) {
        this.messageService.add(`StoreLocationService: ${message}`);
    }
};
StoreLocationService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"] },
    { type: _message_service__WEBPACK_IMPORTED_MODULE_4__["MessageService"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: ['BASE_URL',] }] }
];
StoreLocationService = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"])({ providedIn: 'root' }),
    __param(2, Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"])('BASE_URL')),
    __metadata("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"],
        _message_service__WEBPACK_IMPORTED_MODULE_4__["MessageService"], Object])
], StoreLocationService);



/***/ }),

/***/ "./src/app/shared/services/storelocationOverride.service.ts":
/*!******************************************************************!*\
  !*** ./src/app/shared/services/storelocationOverride.service.ts ***!
  \******************************************************************/
/*! exports provided: StoreLocationOverrideService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StoreLocationOverrideService", function() { return StoreLocationOverrideService; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _message_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./message.service */ "./src/app/shared/services/message.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};





let StoreLocationOverrideService = class StoreLocationOverrideService {
    constructor(http, messageService, baseUrl) {
        this.http = http;
        this.messageService = messageService;
        this._ENDPOINT = '';
        this.httpOptions = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpHeaders"]({ 'Content-Type': 'application/json' })
        };
        this._ENDPOINT = baseUrl + 'api/storeLocationOverrides';
    }
    getAll(id) {
        const url = this._ENDPOINT + '/?brandId=' + id;
        return this.http.get(url);
    }
    getById(id) {
        const url = this._ENDPOINT + '/' + id;
        return this.http.get(url);
    }
    /** POST: add a new storeLocationOverride to the server */
    add(storeLocationOverride) {
        return this.http.post(this._ENDPOINT, storeLocationOverride, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])((newStoreLocationOverride) => this.log('added store location override w/ id=${newStoreLocationOverride.id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('add')));
    }
    /** DELETE: delete the storeLocationOverride from the server */
    delete(id) {
        const url = this._ENDPOINT + '/' + id;
        return this.http.delete(url, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(_ => this.log('deleted storeLocationOverride id=${id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('deleteStoreLocationOverride')));
    }
    /** PUT: update the storeLocationOverride on the server */
    update(id, storeLocationOverride) {
        return this.http.put(this._ENDPOINT + "/" + id, storeLocationOverride, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(_ => this.log('updated storeLocationOverride id=${storeLocationOverride.Id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('updateStoreLocationOverride')));
    }
    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    handleError(operation = 'operation', result) {
        return (error) => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead
            // TODO: better job of transforming error for user consumption
            this.log(`${operation} failed: ${error.message}`);
            // Let the app keep running by returning an empty result.
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(result);
        };
    }
    /** Log a StoreLocationOverrideService message with the MessageService */
    log(message) {
        this.messageService.add(`StoreLocationOverrideService: ${message}`);
    }
};
StoreLocationOverrideService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"] },
    { type: _message_service__WEBPACK_IMPORTED_MODULE_4__["MessageService"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: ['BASE_URL',] }] }
];
StoreLocationOverrideService = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"])({ providedIn: 'root' }),
    __param(2, Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"])('BASE_URL')),
    __metadata("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"],
        _message_service__WEBPACK_IMPORTED_MODULE_4__["MessageService"], Object])
], StoreLocationOverrideService);



/***/ }),

/***/ "./src/app/shared/services/template.service.ts":
/*!*****************************************************!*\
  !*** ./src/app/shared/services/template.service.ts ***!
  \*****************************************************/
/*! exports provided: TemplateService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TemplateService", function() { return TemplateService; });
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! rxjs */ "./node_modules/rxjs/_esm2015/index.js");
/* harmony import */ var rxjs_operators__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! rxjs/operators */ "./node_modules/rxjs/_esm2015/operators/index.js");
/* harmony import */ var _message_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./message.service */ "./src/app/shared/services/message.service.ts");
var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (undefined && undefined.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (undefined && undefined.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};





let TemplateService = class TemplateService {
    constructor(http, messageService, baseUrl) {
        this.http = http;
        this.messageService = messageService;
        this._ENDPOINT = '';
        this.httpOptions = {
            headers: new _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpHeaders"]({ 'Content-Type': 'application/json' })
        };
        this._ENDPOINT = baseUrl + 'api/templates';
    }
    getAll() {
        return this.http.get(this._ENDPOINT + '');
    }
    getById(id) {
        const url = this._ENDPOINT + '/' + id;
        return this.http.get(url);
    }
    /** POST: add a new template to the server */
    add(template) {
        return this.http.post(this._ENDPOINT, template, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])((newTemplate) => this.log('added template w/ id=${newTemplate.id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('add')));
    }
    /** DELETE: delete the template from the server */
    delete(id) {
        const url = this._ENDPOINT + '/' + id;
        return this.http.delete(url, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(_ => this.log('deleted template id=${id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('delete')));
    }
    /** PUT: update the template on the server */
    update(id, template) {
        return this.http.put(this._ENDPOINT + "/" + id, template, this.httpOptions).pipe(Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["tap"])(_ => this.log('updated template id=${template.Id}')), Object(rxjs_operators__WEBPACK_IMPORTED_MODULE_3__["catchError"])(this.handleError('update')));
    }
    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    handleError(operation = 'operation', result) {
        return (error) => {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead
            // TODO: better job of transforming error for user consumption
            this.log('${operation} failed: ${error.message}');
            // Let the app keep running by returning an empty result.
            return Object(rxjs__WEBPACK_IMPORTED_MODULE_2__["of"])(result);
        };
    }
    /** Log a TemplateService message with the MessageService */
    log(message) {
        this.messageService.add('TemplateService: ${message}');
    }
};
TemplateService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"] },
    { type: _message_service__WEBPACK_IMPORTED_MODULE_4__["MessageService"] },
    { type: undefined, decorators: [{ type: _angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"], args: ['BASE_URL',] }] }
];
TemplateService = __decorate([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Injectable"])({ providedIn: 'root' }),
    __param(2, Object(_angular_core__WEBPACK_IMPORTED_MODULE_0__["Inject"])('BASE_URL')),
    __metadata("design:paramtypes", [_angular_common_http__WEBPACK_IMPORTED_MODULE_1__["HttpClient"],
        _message_service__WEBPACK_IMPORTED_MODULE_4__["MessageService"], Object])
], TemplateService);



/***/ }),

/***/ "./src/app/shared/services/validation.service.ts":
/*!*******************************************************!*\
  !*** ./src/app/shared/services/validation.service.ts ***!
  \*******************************************************/
/*! exports provided: ValidationService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ValidationService", function() { return ValidationService; });
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
class ValidationService {
    static dateValidator(control) {
        const dateReg = '[0-9]{4}-[0-9]{2}-[0-9]{2}'; ///^\d{2}([./-])\d{2}\1\d{4}$/; //2020-06-11 
        if (control && control.value) {
            return { "date": true };
        }
        return null;
    }
    static date(control) {
        let value = control.value;
        if (value && typeof value === "string") {
            let match = value.match(/^([0-9]{4})\/([0-9]{1,2})\/([0-9]{1,2})$/); //value.match(/^([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/);
            if (!match) {
                return { 'date': true };
            }
            else if (match && match[0] !== value) {
                return { 'date': true };
            }
        }
        return null;
        //const dateReg = new RegExp(/^02\/(?:[01]\d|2\d)\/(?:19|20)(?:0[048]|[13579][26]|[2468][048])|(?:0[13578]|10|12)\/(?:[0-2]\d|3[01])\/(?:19|20)\d{2}|(?:0[469]|11)\/(?:[0-2]\d|30)\/(?:19|20)\d{2}|02\/(?:[0-1]\d|2[0-8])\/(?:19|20)\d{2}$/); 
        //if (dateReg.test(control.value) || control.value === null || control.value === "") {
        //  return null
        //}
        //return { "date": true };
    }
    static zipCodeValidator(control) {
        const zipReg = '[0-9]{5}';
        if (control.value) {
            const regEx = new RegExp(/[0-9]{5}/);
            if (!regEx.test(control.value)) {
                return { 'zipCode': true };
            }
        }
        return null;
        //if (control.value.match(zipReg) || control.value === "" || control.value === null) {
        //  return null;
        //} else {
        //  return { "zipCode": true };
        //}
    }
    static alphaNumericValidator(control) {
        if (control.value) {
            //const regEx = new RegExp(/^[a-zA-Z0-9]*$/); // no spaces
            const regEx = new RegExp(/^[a-zA-Z0-9\d\-_\s]+$/i);
            if (!regEx.test(control.value)) {
                return { 'alphaNumeric': true };
            }
        }
        return null;
    }
    static alphaNumericSpecialCharactersValidator(control) {
        if (control.value) {
            const regEx = new RegExp(/^[a-zA-Z.-]+(?:[\s-][/a-zA-Z.]+)*$/);
            if (!regEx.test(control.value)) {
                return { 'alphaNumericSpecialCharacters': true };
            }
        }
        return null;
    }
    static numericValidator(control) {
        if (control.value) {
            const reg = new RegExp('^-?[0-9]\\d*(\\.\\d{1,2})?$');
            if (!reg.test(control.value)) {
                return { "numeric": true };
            }
        }
        return null;
    }
    static phoneValidator(control) {
        if (control.value) {
            //const phoneRegex = /^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$/;
            const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
            if (!phoneRegex.test(control.value)) {
                return { 'phone': true };
            }
        }
        return null;
    }
    static urlValidator(control) {
        if (control.value) {
            const URL_REGEXP = /^(http?|https):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
            //control.markAsTouched();
            //if (!URL_REGEXP.test(control.value)) { 
            //  return {
            //    "url": true
            //  };
            //} 
        }
        return null;
    }
}


/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
const environment = {
    production: false,
    flatFileLicenseKey: '39011dc5-6c0c-4717-a543-8054ffef882c'
};
/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! exports provided: getBaseUrl */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBaseUrl", function() { return getBaseUrl; });
/* harmony import */ var hammerjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! hammerjs */ "./node_modules/hammerjs/hammer.js");
/* harmony import */ var hammerjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(hammerjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");
var __importDefault = (undefined && undefined.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};





function getBaseUrl() {
    return document.getElementsByTagName('base')[0].href;
}
const providers = [
    { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
];
if (_environments_environment__WEBPACK_IMPORTED_MODULE_4__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_2__["platformBrowserDynamic"])(providers).bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_3__["AppModule"])
    .catch(err => console.log(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! I:\Work Space\Projects\DI_TFS\J19-4882 Opti Port DM Automation\OPDM\OptiPort.Web\ClientApp\src\main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map